(function() {

  'use strict';

  angular
    .module('mpos', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages',
      'ngAria', 'ngResource', 'ui.router', 'ngMaterial', 'toastr', 'ngStorage',
      'angularFileUpload', 'ngTable', 'ngFullscreen', 'ng-drag-scroll', 'angular-virtual-keyboard', 
      'ngTagsInput', 'angularModalService', 'angular-loading-bar', 'tmh.dynamicLocale', 'pascalprecht.translate']);
    //.module('mpos', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ngMaterial', 'toastr', 'ngStorage']);

})();

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:stopTouchEvent
 * @description
 * # stopTouchEvent
 */
angular.module('mpos')
  .directive('stopTouchEvent', function () {
     return {
       restrict: 'A',
       link: function (scope, element) {
        element.on('touchmove', function (evt) {
          evt.stopPropagation();
        });

        scope.$on('$destroy', function() {
          element.off('touchmove');
        });
       }
    };
  });

'use strict';
/**
 * @ngdoc filter
 * @name mpos.filter:startFrom
 * @function
 * @description
 * # startFrom
 * Filter in the mpos.
 */
angular.module('mpos')
  .filter('startFrom', function () {
    return function (input, start) {
      start = +start; //parse to int      
      return input.slice(start);
    };
  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.soundEffect
 * @description
 * # soundEffect
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('soundEffectFactory', function ($log) {
    var service = {};

    var sound = {
      keypress: 'assets/sound/btn01.mp3',
      decision: 'assets/sound/decision.mp3',
      warning: 'assets/sound/warning.mp3'
    };

    service.playSound = function (src) {
      $log.debug('[soundEffect] Play sound:' + src);
      var soundSrc = sound[src] || sound.keypress;
      // Browser on Android/iOS not suppot
      //var _sound = new Audio(soundSrc);
      //_sound.play();
      var audio = angular.element('<audio/>')
          .attr('src', soundSrc);
      angular.element(document.body).append(audio);


      var audios = angular.element(document).find('audio');
      //var _sound = angular.element(document).find('audio').last();
      var _sound = audios[audios.length - 1];
      for (var i=0, len=audio.length; i<len; i++) {
        audios[i].remove();
      }
      _sound.play();
    }

    return service;

  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:selectOnClick
 * @description
 * # selectOnClick
 */
angular.module('mpos')
  .directive('selectOnClick', function () {
    return {
      restrict: 'A',
      link: function(scope, element) {
        element.on('click', function(){
          this.select();
        });
        scope.$on('$destroy', function(){
          element.off('click');
        })
      }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:printCanvas
 * @description
 * # printCanvas
 */
angular.module('mpos')
  .directive('printCanvas', function ($log, $localStorage, $document, $timeout) {
    return {
      templateUrl: 'app/printCanvas/printCanvas.html',
      restrict: 'E',
      scope: {
        content: "@",
        name: "@",
        company: "@",
        event: "@",
        width: "@",
        height: "@"
      },
      link: function(scope, element, attrs) {
        //Dpi is the pixel density or dots per inch.
        //96 dpi means there are 96 pixels per inch.
        //1 inch is equal to 2.54 centimeters.
        $timeout(function(){
          
          var img = new Image(160, 160);
          var name = scope.name;
          var company = scope.company;
          var event = scope.event;
          //var c = element[0].children[0];
          var c = $document[0].getElementById('myCanvas'); 
          var ctx = c.getContext("2d");
          var yPos = 24;
          var xPos = 24;
          img.src = './assets/images/qrcode.png';
          img.onload = function() {

            //ctx.canvas.height = img.height + 100;
            ctx.font = "bold 48px Arial";
            var metrics = ctx.measureText(name);
            xPos = ctx.canvas.width-metrics.width;
            yPos = yPos + 30;
            // Write Name
            ctx.fillText(name, xPos/2, yPos);
            ctx.save();

            //Write company
            yPos = yPos + 30;
            ctx.font = "bold 44px Arial";
            ctx.textBaseline = 'middle';
            ctx.fillStyle = 'black';
            metrics = ctx.measureText(company);
            xPos = ctx.canvas.width-metrics.width;
            ctx.fillText(company, xPos/2, yPos);
            ctx.save();

            //draw image
            ctx.drawImage(img, (ctx.canvas.width - img.width) / 2, yPos + 50, img.width, img.height);
          }

          
        }, 1000);
        
        /*
        setTimeout(function(){
          var business = $localStorage.business;
          var img = new Image();
          var name = scope.name;
          var company = scope.company;
          var event = scope.event;
          var c = element[0].children[0];
          var ctx = c.getContext("2d");
          var maxImgHeight = 30;
          var ratio = 1;
          var yPos = 0;
          var xPos = 0;
          
          // Logo
          if (business && business.logo) {
            img.src = business.logo;
            ratio = (business.logo) ? img.height / maxImgHeight : img.height ;
            ctx.drawImage(img,2,2, img.width/ratio, img.height/ratio);
            yPos = c.height/2 + 10;
          }else {
            yPos = c.height/2;
          }
          
          ctx.font = "28px Arial";
          var metrics = ctx.measureText(name);
          xPos = c.width-metrics.width;

          // Write Name
          ctx.fillText(name, xPos/2, yPos);
          ctx.save();

          // Create gradient
          //yPos = c.height/2;
          var grd = ctx.createLinearGradient(0,0,c.width,0);
          grd.addColorStop(0,"red");
          grd.addColorStop(1,"white");
          ctx.fillStyle = grd;
          yPos = yPos + 2;
          ctx.fillRect(0, yPos, c.width, 3);

          //Write company
          yPos = yPos + 12;
          ctx.font = "16px Arial";
          ctx.textBaseline = 'middle';
          ctx.fillStyle = 'black';
          metrics = ctx.measureText(company);
          xPos = c.width-metrics.width;
          ctx.fillText(company, xPos/2, yPos);
          ctx.save();

          //Write event
          ctx.font = "14px Arial";
          ctx.textBaseline = 'middle';
          ctx.fillStyle = 'black';
          yPos = c.height - 10;
          //metrics = ctx.measureText(event);
          //xPos = c.width - metrics.width - 5;
          ctx.fillText(event, 5 , yPos); 
          ctx.save();
        }, 1000);
       */ 
      }
      
    };
  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.rewards
 * @description
 * # rewards
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('rewardsFactory', function ($log, $q, $localStorage, apiFactory, helperFactory) {
    var rewardItems = [];
    var toWhom = null;
    var selectedDynamicReward = null;
    var enableMultipleReward = true;
    var service = {
      getRewardShortcut: getRewardShortcut,
      getRewardCategory: getRewardCategory,
      getRewardList: getRewardList,
      setEnableMultipleReward: setEnableMultipleReward,
      getEnableMultipleReward: getEnableMultipleReward,
      setRewardItem: setRewardItem,
      getRewardItem: getRewardItem,
      removeRewardItem: removeRewardItem,
      clearRewardItem: clearRewardItem,
      getRewardPoints: getRewardPoints,
      clear: clear,
      setRewardTo: setRewardTo,
      getRewardTo: getRewardTo,
      getDynamicRewardList: getDynamicRewardList,
      getDynamicReward: getDynamicReward,
      setDynamicReward: setDynamicReward,
      clearDynamicReward: clearDynamicReward
    };

    return service;

    function getRewardShortcut() {
      var deferred = $q.defer();
      var refreshDuration = 60 * 60 * 1000;
      var currentTime = new Date().getTime();
      var diff;

      if ($localStorage.rewardShortcut && $localStorage.rewardShortcut_timestamp) {
        diff = currentTime - $localStorage.rewardShortcut_timestamp;
      } else {
        diff = null;
      }

      if (diff && diff <= refreshDuration && $localStorage.rewardShortcut.length > 0) {
        deferred.resolve($localStorage.rewardShortcut);
      }else {
        apiFactory.getShortcut(function(result){
          $log.log('get shortcut success');
          $localStorage.rewardShortcut = result;
          $localStorage.rewardShortcut_timestamp = new Date().getTime();
          deferred.resolve(result);
        }, function(err){
          $log.error('get shortcut failed:', err);
          if ($localStorage.rewardShortcut) {
            deferred.resolve($localStorage.rewardShortcut);
          }else {
            deferred.reject(err);
          }

        });
      }
      return deferred.promise;
    }

    function getRewardCategory() {
      var deferred = $q.defer();
      var refreshDuration = 60 * 60 * 1000;
      var currentTime = new Date().getTime();
      var diff;

      if ($localStorage.rewardCategories && $localStorage.rewardCategories_timestamp) {
        diff = currentTime - $localStorage.rewardCategories_timestamp;
      } else {
        diff = null;
      }

      if (diff && diff <= refreshDuration && $localStorage.rewardCategories.length > 0) {
        deferred.resolve($localStorage.rewardCategories);
      }else {
        apiFactory.getCategories(function(result){
          $log.log('get reward category success');
          $localStorage.rewardCategories = result;
          $localStorage.rewardCategories_timestamp = new Date().getTime();
          deferred.resolve(result);
        }, function(err){
          $log.error('get reward categories failed:', err);
          if ($localStorage.rewardCategories) {
            deferred.resolve($localStorage.rewardCategories);
          }else {
            deferred.reject(err);
          }

        });
      }
       return deferred.promise;
    }


    function getRewardList() {
      var deferred = $q.defer();
      var refreshDuration = 60 * 60 * 1000;
      var currentTime = new Date().getTime();
      var diff;

      if ($localStorage.rewardItems && $localStorage.rewardItems_timestamp) {
        diff = currentTime - $localStorage.rewardItems_timestamp;
      } else {
        diff = null;
      }

      if (diff && diff <= refreshDuration && $localStorage.rewardItems.length > 0) {
        deferred.resolve($localStorage.rewardItems);
      }else {
        apiFactory.getRewardList({dynamic:false}, function(result){
          $log.log('get reward list success');
          $localStorage.rewardItems = result;
          $localStorage.rewardItems_timestamp = new Date().getTime();
          deferred.resolve(result);
        }, function(err){
          $log.error('get reward list failed:', err);
          if ($localStorage.rewardItems) {
            deferred.resolve($localStorage.rewardItems);
          }else {
            deferred.reject(err);
          }

        });
      }
       return deferred.promise;
    }

    function getEnableMultipleReward() {
      return enableMultipleReward;
    }

    function setEnableMultipleReward(enabled) {
      enableMultipleReward = enabled;
      if (enableMultipleReward === false) {
        clearRewardItem();
      }
    }

    function getRewardItem() {
      //$log.debug('reward items:', rewardItems);
      return rewardItems;
    }

    function setRewardItem(reward){
      $log.debug('[RewardsFactory] Add reward');
      //item = reward;
      if (angular.isUndefined(reward.qty)) {
        reward.qty = 1;
      }

      var isExist = false;
      for (var i = 0, len = rewardItems.length; i < len; i++) {
        if (rewardItems[i].id === reward.id) {
          isExist = true;
          rewardItems[i].qty += 1;
          break;
        }
      }

      if (!isExist)
        rewardItems = helperFactory.unshiftArray(rewardItems, reward);
        //rewardItems.unshift(reward);

    }

    function removeRewardItem(reward, clearAll){
      $log.debug('[RewardsFactory] Remove reward');
      for (var i = 0, len = rewardItems.length; i < len; i++) {
        if (rewardItems[i].id === reward.id) {
          if (clearAll) {
            rewardItems = helperFactory.spliceOne(rewardItems, i);
            //rewardItems.splice(i, 1);
          } else {
            if (rewardItems[i].qty > 1) {
              rewardItems[i].qty -= 1;
            }else {
              rewardItems = helperFactory.spliceOne(rewardItems, i);
              //rewardItems.splice(i, 1);
            }
          }

          break;
        }
      }
    }

    function clearRewardItem(){
      $log.debug('[RewardsFactory] Clear reward');
      rewardItems.length = 0;
    }

    function getRewardPoints() {
      var sum = 0;
      for (var i=0, len=rewardItems.length; i<len; i++) {
        sum += rewardItems[i].points * rewardItems[i].qty;

      }
      return sum;
    }

    function clear() {
      $log.debug('[RewardsFactory] Clear reward item and member');
      rewardItems = [];
      toWhom = null;
    }

    function getRewardTo() {
      return toWhom;
    }

    function setRewardTo(member){
      toWhom = member;
    }

    function getDynamicRewardList() {
      var deferred = $q.defer();
      apiFactory.getDynamicRewardList(null, function(result){
        $log.log('Get dynamic reward list success:', result);
        deferred.resolve(result);
      }, function(err){
        $log.error('Get dynamic reward list failed:', err)
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getDynamicReward(){
      return selectedDynamicReward || $localStorage.dynamicReward;
    }

    function setDynamicReward(dr){
      selectedDynamicReward = dr;
      $localStorage.dynamicReward = dr;
    }

    function clearDynamicReward() {
      selectedDynamicReward = null;
      delete $localStorage.dynamicReward;
    }

  });

//'use strict';
///**
// * @ngdoc function
// * @name mpos.controller:rewardsCtrl
// * @description
// * # rewardsCtrl
// * Controller of the mpos
// */
//angular.module('mpos')
//  .controller('rewardsCtrl', function ($scope, $log, $timeout, $location, $stateParams, $state, $mdBottomSheet,
//    $mdDialog, toastr, $localStorage, apiFactory, rewardsFactory) {
//    var vm = this;
//
//    vm.showCategoryItems = showCategoryItems;
//    vm.setEnableMultipleReward = setEnableMultipleReward;
//    vm.refresh = refresh;
//    //vm.updateQty = updateQty;
//    //vm.removeRewardItem = removeRewardItem;
//    //vm.addRewardItem = addRewardItem;
//    vm.enableMultipleReward = rewardsFactory.getEnableMultipleReward();
//    //vm.redeemPoints = redeemPoints;
//    //vm.disableRedeem = true;vm.rewardItems
//    vm.categories;
//
//    (function initController() {
//      vm.barcode = $stateParams.barcode;
//      var member = rewardsFactory.getRewardTo();
//      if (member)
//        vm.orgPoints = member.points;
//      else
//        $state.go('home.rewardpoint');
//
//      if (!vm.enableMultipleReward)
//        rewardsFactory.clearRewardItem();
//
//      vm.rewardItems = rewardsFactory.getRewardItem();
//      vm.rewardPoints = rewardsFactory.getRewardPoints();
//
//      var refreshDuration = 60 * 60 * 1000;
//      var currentTime = new Date().getTime();
//      var diff;
//
//      if ($localStorage.rewardCategories && $localStorage.rewardCategories_timestamp) {
//        diff =currentTime - $localStorage.rewardItems_timestamp;
//      } else {
//        diff = null;
//      }
//
//      if (diff && diff <= refreshDuration && $localStorage.rewardCategories.length > 0) {
//        vm.categories = $localStorage.rewardCategories;
//      }else {
//        apiFactory.getCategories(getCategoriesSuccess, getCategoriesError);
//      }
//
//    })();
//
//    function setEnableMultipleReward() {
//      if (vm.enableMultipleReward === false) {
//
//        $mdDialog.show({
//          templateUrl: 'app/main/dialog.multipleReward.html',
//          controller: DialogController,
//          controllerAs: 'ctrl'
//        }).then(function(answer){
//          vm.enableMultipleReward = !answer;
//          rewardsFactory.setEnableMultipleReward(vm.enableMultipleReward);
//        }, function() {
//          vm.enableMultipleReward = true;
//        })
//      }else {
//        rewardsFactory.setEnableMultipleReward(vm.enableMultipleReward);
//      }
//    }
//
//    function DialogController() {
//      var vm = this;
//
//      vm.answer = function(answer) {
//        $mdDialog.hide(answer);
//      };
//      vm.cancel = function(){
//        $mdDialog.cancel();
//      }
//    }
//
//    function showCategoryItems(category) {
//      $mdBottomSheet.show({
//        templateUrl: 'app/main/rewarditem-template.html',
//        controller: 'dialogrewarditemCtrl',
//        controllerAs: 'rewardlist',
//        // inject parameter to ctrl
//        locals: {
//          "selectedCategory": category
//        }
//      }).then(function(clickedItem) {
//        //$log.debug('click', clickedItem);
//        if (clickedItem) {
//          addRewardItem(clickedItem);
//          //vm.reward = clickedItem;
//          //redeemPoints();
//
//          if (vm.orgPoints - vm.rewardPoints >= 0){
//            //vm.disableRedeem = false;
//            //rewardsFactory.setRewardItem(vm.reward);
//            if (!vm.enableMultipleReward) {
//              $state.go('home.rewardpoint');
//            }
//
//          } else { // Should never happened
//
//            showAlertDialog('warning', '點數不足');
//            removeRewardItem(clickedItem);
//
//          }
//        }else {
//          toastr.error('無法取得兌換項目');
//        }
//      });
//    }
//
//    //function updateQty(item){
//
//    //  //$log.debug('debug:', vm.rewardItems);
//    //  //rewardsFactory.updateRewardQty(item);
//    //  vm.rewardPoints = rewardsFactory.getRewardPoints();
//    //  if (vm.orgPoints - vm.rewardPoints < 0){
//    //    showAlertDialog('warning', '點數不足');
//    //    removeRewardItem(item);
//    //  }
//
//    //}
//
//    function addRewardItem(item) {
//      var reward = angular.copy(item);
//      reward.qty = 1;
//      rewardsFactory.setRewardItem(reward);
//      vm.rewardPoints = rewardsFactory.getRewardPoints();
//      if (vm.orgPoints - vm.rewardPoints < 0){
//        showAlertDialog('warning', '點數不足');
//        removeRewardItem(reward);
//      }
//
//    }
//
//    function removeRewardItem(item, clearAll) {
//      var reward = angular.copy(item);
//      rewardsFactory.removeRewardItem(reward, clearAll);
//    }
//
//    function refresh() {
//      vm.rewardItems = rewardsFactory.getRewardItem();
//      vm.rewardPoints = rewardsFactory.getRewardPoints();
//      //vm.tableParams.count(vm.rewardItems.length);
//      //vm.tableParams.total(vm.rewardItems.length);
//      //vm.tableParams.reload();
//    }
//
//    function showAlertDialog(type, msg, time){
//      var myColor;
//      var icon;
//      var duration = time || 1000;
//
//      switch(type) {
//        case 'error':
//          icon = 'error_circle';
//          myColor= '#FFA2A2';
//          break;
//        case 'warning':
//          icon = 'warning';
//          myColor= '#FAED33';
//          break;
//        default:
//          icon = 'check_circle';
//          myColor = '#A4FFA2';
//          break;
//      }
//
//      $mdDialog.show({
//        template:
//          '<md-dialog aria-label="" style="min-width:300px; min-height:200px;' +
//          '  box-shadow:0 0 5px 0 rgba(0, 0, 0, 0.3); background-color:' + myColor + '">' +
//          '  <md-dialog-content style="text-align:center; margin:auto">'+
//          '    <div layout="row" layout-padding layout-margin layout-align="center center">' +
//          '      <md-icon md-svg-icon="' + icon +  '" aria-hidden="true" style="width:96px; height:96px;"></md-icon> ' +
//          '      <span class="md-display-1" style="float:center;background-color:'+ myColor +'">' + msg + '</span>' +
//          '    </div>' +
//          '  </md-dialog-content>' +
//          '</md-dialog>',
//        escapeToClose: false,
//        clickOutsideToClose: false,
//        onComplete: function(){
//          $timeout(function(){
//            $mdDialog.hide();
//            //vm.disableRedeem = true;
//
//            //vm.reward = [];
//          }, duration)
//        }
//      });
//    }
//
//    function getCategoriesSuccess(result) {
//      $log.log('get category success', result);
//      //vm.categories = result.filter(function(item){
//      //  $log.debug('test:', item);
//      //  return item.dynamic !== 1;
//      //});
//
//
//      vm.categories = result;
//      //$localStorage.rewardCategories = result;
//      $localStorage.rewardCategories = vm.categories;
//      $localStorage.rewardCategories_timestamp = new Date().getTime();
//    }
//
//    function getCategoriesError(result) {
//      $log.error('get category error', result);
//      if ($localStorage.rewardCategories)
//        vm.categories = $localStorage.rewardCategories;
//    }
//
//    //function getRewardListSuccess(result) {
//    //  $log.log('get reward list success', result);
//    //}
//
//    //function getRewardListError(result) {
//    //  $log.error('get reward list error', result);
//    //}
//    //function handlePointsSuccess() {
//    //  $log.log('handle points success');
//    //
//    //  var p = vm.orgPoints - vm.reward.points;
//    //  showConfirmDialog(p);
//    //}
//    //
//    //function handlePointsError(result) {
//    //  $log.error('handle points error', result);
//    //}
//
//
//  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:numericKeyboardInput
 * @description
 * # numericKeyboardInput
 */
angular.module('mpos')
  .directive('numericKeyboardInput', function (numericKeyboardFactory) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        init:"="
      },
      link: function(scope, element, attrs, ctrl) {
        //element.text('this is the numericKeyboardInput directive');
        ctrl.$viewValue = scope.init || "";
        ctrl.$render();
        ctrl.$commitViewValue();
        numericKeyboardFactory.setModel(ctrl); // set ng-model controller

      }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:rewardList
 * @description
 * # rewardList
 */
angular.module('mpos')
  .directive('rewardList', function ($log, toastr, NgTableParams, rewardsFactory, soundEffectFactory) {
    return {
      templateUrl: 'app/rewardList/rewardList.html',
      restrict: 'E',
      scope: {
        rewardItems: '=',
        add: '=',
        remove: '=',
        delete: '=',
        callback: '&'
      },
      link: function(scope) {

        scope.tableParams = new NgTableParams({
            page: 1,
            count: 10, //initial page size
            noPager: true // hides pager
          }, {
            counts: [],
            paginationMaxBlocks: 10,
            getData: function() {
              var data = angular.copy(scope.rewardItems);
              return data;
            }

        });

        scope.actions = {
          add: scope.add || false,
          remove: scope.remove || false,
          delete: scope.delete || false
        }

        scope.addRewardItem = function(item) {
          var reward = angular.copy(item);
          reward.qty = 1;
          rewardsFactory.setRewardItem(reward);
          scope.rewardItems = rewardsFactory.getRewardItem();
          var rewardTo = rewardsFactory.getRewardTo();
          var rewardPoints = rewardsFactory.getRewardPoints();

          var temp = (rewardTo.points - rewardPoints < 0) ? true: false
          //console.log(temp);
          if (temp){
            toastr.warning('點數不足');
            soundEffectFactory.playSound('warning');
            scope.removeRewardItem(reward);
          } else {
            reloadTable();
          }

        }

        scope.removeRewardItem = function(item, clearAll) {
          var reward = angular.copy(item);
          rewardsFactory.removeRewardItem(reward, clearAll);
          reloadTable();
        }

        function reloadTable() {
          $log.debug('[rewardlist]reload ', scope.rewardItems);
          scope.rewardItems = rewardsFactory.getRewardItem();

          scope.tableParams.count(scope.rewardItems.length);
          scope.tableParams.total(scope.rewardItems.length);
          scope.tableParams.reload();

          if (scope.callback) scope.callback();
        }

        var unbindWatch = scope.$watch('rewardItems', function(){
          $log.debug('[rewardlist]:', scope.rewardItems);
          reloadTable();
        });

        scope.$on('destroy', function(){
          unbindWatch();
        });



      }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:readonlyFocus
 * @description
 * # readonlyFocus
 */
angular.module('mpos')
  .directive('readonlyFocus', function ($log, $document, $timeout) {
    return {
      scope: {
        readonlyFocus: '='
      },
      link: function(scope, element, attrs) {
        if (attrs.focusColor) {
          scope._color = attrs.focusColor;
        }else {
          scope._color = 'lightskyblue'
        }

        if (scope.readonlyFocus)
          element.css("background-color", scope._color);

        var stopWatching = scope.$watch(function(){return scope.readonlyFocus}, function(val){
          //$log.debug('watch:', scope.readonlyFocus);
          if (val){
            $timeout(function(){
              element[0].focus();
              element[0].select();
            }, 10)
          }else {
            $timeout(function(){
              element[0].blur();
            }, 10)
          }
        })

        element.on('focus', function(){
          element.css("background-color", scope._color);
          scope.$evalAsync(function(){
            scope.readonlyFocus = true;
          });
        })


        element.on('blur', function(){
          element.css("background-color", '');
          scope.$evalAsync(function(){
            scope.readonlyFocus = false;
          });
        })

        scope.$on('$destroy', function(){
          element.off('focus');
          element.off('blur');
          stopWatching();
        });


      }
    };
  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:pointsCtrl
 * @description
 * # pointsCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('pointsCtrl', function ($scope, $window, $log, $timeout, $mdBottomSheet, $filter, $document,
        $mdDialog, $localStorage, $mdMedia, $state, $interval, toastr, apiFactory, rewardsFactory, depositFactory,
        soundEffectFactory, colorTableFactory, $mdSidenav, helperFactory){
    var vm = this;
    var currentState = $state.current.name;
    //var incorrectInputType = false;
    //vm.$mdMedia = $mdMedia;
    //vm.selectedMember = null;
    vm.searchedMember = [];
    vm.multipleMember = false;
    vm.changeSelectedMember = changeSelectedMember;
    vm.toggleRight = toggleRight;
    vm.resendBarcode = resendBarcode;
    vm.getRewardSelectOptions = getRewardSelectOptions;
    vm.getDepositSelectOptions = getDepositSelectOptions;
    //vm.setEnableMultipleReward = setEnableMultipleReward;
    //vm.showRewardShortcut = showRewardShortcut;
    //vm.showRewardList = showRewardList;
    vm.getRewardItemsCount = getRewardItemsCount;
    vm.toggleMemberInfo = toggleMemberInfo;
    vm.toggleProductInfo = toggleProductInfo;
    //vm.checkInputChange = checkInputChange;
    //vm.removeReward = removeReward;
    vm.addReward = addReward;
    vm.changeFocus = changeFocus;
    vm.confirmAction = confirmAction;
    vm.getBackgroundColor = getBackgroundColor;
    vm.clear = clear;
    vm.addDeposit = addDeposit;
    //vm.redirect = redirect;
    //vm.reloadTable = reloadTable;
    vm.refresh = refresh;
    var businessConfig = $localStorage.businessConfig;
    var moneyToPoints = angular.isDefined(businessConfig) && !angular.equals({}, businessConfig) ? businessConfig.purchase/businessConfig.points : 100;
    vm.displayRewards = false;
    vm.isRequired = {
      'barcodeMessage': true,
      'phoneNumber': false
    };
    vm.isProcessing = {
      'barcodeMessage': '',
      'phoneNumber': '',
      'points': ''
    };
    vm.isFocus = {
      exchange: false,
      remark: false
    };

    vm.scanMode = true;
    vm.money = 0;
    vm.newPoints = 0;
    vm.rewardPoints = 0;
    vm.redeemPoints = 0;
    vm.refundPoints = 0;
    vm.rewardCounts = 0;
    vm.depositPoints = 0;
    vm.depositPurchase = 0;
    vm.depositCounts = 0;
    vm.remark = '';
    //vm.nameColor = "blue";
    //vm.pointStyle = {
    //  color: "red"
    //};
    vm.enableMultipleReward = rewardsFactory.getEnableMultipleReward() || false;
    //vm.enableMultipleItems = depositFactory.getEnableMultipleItems() || false;
    vm.enableMultipleItems = false;
    vm.expandMemberInfo = true;
    vm.expandProductInfo = false;
    vm.rewardShortcut = [];
    vm.rewardOptionsRaw = [];
    vm.rewardOptions = [];
    vm.depositOptions = [];

    vm.filterRewardOpions = filterRewardOpions;
    vm.numberOfPages = numberOfPages;
    vm.currentPage = 0;
    vm.pageSize = $mdMedia('lg') ? 3*3 : 2*3 ;
    vm.itemWidth = $mdMedia('lg') ? '30%' : '45%' ;
    vm.itemHeight = Math.floor(angular.element($window)[0].innerHeight * 0.9 * 0.7 * 0.3) + 'px';
    vm.showRewardShortcut = true;
    //var tooLongInput = false;
    var backgroundColor = [];
    var g_timer = null;
    (function initController() {
      //delete $localStorage.currentMember;
      vm.member = rewardsFactory.getRewardTo();
      vm.rewardItems = rewardsFactory.getRewardItem();
      vm.rewardPoints = rewardsFactory.getRewardPoints();
      vm.rewardCounts = getRewardItemsCount();
      vm.dynamicReward = rewardsFactory.getDynamicReward();
      vm.depositItems = depositFactory.getDepositItem();
      vm.depositPoints = depositFactory.getDepositPoints();
      vm.depositPurchase = depositFactory.getDepositPurchase();
      vm.depositCounts = getDepositItemsCount();

      if (currentState === 'home.redeempoint' && angular.isUndefined(vm.dynamicReward)) {
        $state.go('home');
      }
      if (currentState === 'home.rewardpoint') {
        vm.getRewardSelectOptions(true);
      }
      if (currentState === 'home.deposit') {
        vm.getDepositSelectOptions();
      }
      if (vm.member) {
        vm.keyboard = {
          label: '兌換點數',
          value: vm.rewardPoints || 0,
          numeric: true
        };

        if (vm.rewardItems.length > 0) {
          vm.expandMemberInfo = false;
          vm.expandProductInfo = true;
        }

      }else {

        vm.member =  {
          barcodeMessage: '',
          phoneNumber: '',
          points: 0
        };

        vm.keyboard = {
          label: '',
          value: '',
          numeric: false
        };

      }
    })();

    angular.element($window).on('resize', function(){
      $scope.$apply(function(){
        vm.pageSize = $mdMedia('lg') ? 3*3 : 2*3 ;
        vm.itemWidth = $mdMedia('lg') ? '30%' : '45%' ;
        vm.itemHeight = Math.floor(angular.element($window)[0].innerHeight * 0.9 * 0.7 * 0.3) + 'px';
        //vm.getRewardSelectOptions(vm.showRewardShortcut);
      });
    });

    $scope.$on('$destroy', function () {
      unbindWatchPaste();
      unbindWatchKeyPress();
      unbindWatchPoints();
      angular.element($window).off('resize');
      rewardsFactory.clearDynamicReward();
      colorTableFactory.resetColorIndex();
      depositFactory.clear();
      //clearEventListener();
      vm.isRequired = null;
      vm.isProcessing = null;
      vm.isFocus = null;
      vm.rewardShortcut = null;
      vm.rewardOptionsRaw = null;
      vm.rewardOptions = null;
      vm.depositOptions = null;
      vm.dynamicReward = null;
      vm.backgroundColor = null;
    });

    var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {
      
      if (vm.isRequired.phoneNumber && !vm.member.barcodeMessage) {
        if (vm.isProcessing.phoneNumber) {
          return;
        }else {
          //clearEventListener();
          vm.keyboard.value = vm.keyboard.value + data;
          $scope.$apply();
        }
      }else {
        return;
      }
    });

    // catch keypress event for barcode scanner
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
      evt.stopPropagation();
      var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (vm.isProcessing.barcodeMessage || vm.isProcessing.phoneNumber || vm.isProcessing.points || isDialogOpen) return;
      
      if (obj.keyCode === 8)
        evt.preventDefault();

      $scope.$apply(function () {
        if (vm.isRequired.barcodeMessage && !vm.member.phoneNumber) {
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.member.barcodeMessage))
                vm.member.barcodeMessage = vm.member.barcodeMessage.slice(0, -1);
              break;
            case 10:
              if (isMobile && vm.member.barcodeMessage.length) {
                apiFactory.searchDists({barcodeMessage: vm.member.barcodeMessage.toUpperCase()}, getBarcodeMsgSuccess, getBarcodeMsgError);
                vm.isProcessing.barcodeMessage = 'indeterminate';
              }
              break;
            case 13:
              if (vm.member.barcodeMessage.length) {
                apiFactory.searchDists({barcodeMessage: vm.member.barcodeMessage.toUpperCase()}, getBarcodeMsgSuccess, getBarcodeMsgError);
                vm.isProcessing.barcodeMessage = 'indeterminate';
              }
              break;
            default:
              if (angular.isDefined(vm.member.barcodeMessage))
                vm.member.barcodeMessage = vm.member.barcodeMessage + key.toUpperCase();
              else
                vm.member.barcodeMessage = key.toUpperCase();
              break;
          }
        }else if (vm.isRequired.phoneNumber && !vm.member.barcodeMessage) {
          ////clearEventListener();
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.keyboard.value))
                vm.keyboard.value = vm.keyboard.value.slice(0, -1);
              break;
            case 10:
              if (isMobile) searchBarcodeByPhone();
              break;
            case 13:
                searchBarcodeByPhone();
              break;
            default:
              if (angular.isDefined(vm.keyboard.value))
                vm.keyboard.value = vm.keyboard.value + key;
              else
                vm.keyboard.value = key;
              break;
          }
        }
        else {
          // for chinese input, can't set readonly property
          //clearEventListener();
          if (currentState === 'home.redeempoint'
                || currentState === "home.memberpoint"
                || currentState === "home.refundpoint"){
            var focusedElm = angular.element($document[0].activeElement).attr('id');
            if (focusedElm === 'remark') {
              switch (obj.keyCode) {
                case 8:
                  if (angular.isDefined(vm.remark))
                    vm.remark = vm.remark.slice(0, -1);
                  break;
                case 10: // for mobile device
                case 13:
                default:
                  if (angular.isDefined(vm.remark))
                    vm.remark = vm.remark + key;
                  else
                    vm.remark = key;
                  break;
              }// end of switch
            } else {// if (focusedElm === 'exchange') {
              switch (obj.keyCode) {
                case 8: // update keyboard value & redeempoints
                  if (angular.isDefined(vm.keyboard.value))
                    vm.keyboard.value = vm.keyboard.value.slice(0, -1);
                  //if (vm.keyboard.value.length <= 8) tooLongInput = false;
                  break;
                case 10:
                case 13:
                  //if (!incorrectInputType) {
                    if (currentState === 'home.redeempoint') {
                      vm.confirmAction('REDEEM');
                    }else if (currentState === 'home.memberpoint' || currentState === 'home.deposit'){
                      vm.confirmAction('ADD');
                    }else if (currentState === 'home.refundpoint'){
                      if (vm.refundPoints <= 0) {
                        toastr.warning('退還點數小於或等於0');
                      }else {
                        vm.confirmAction('REFUND');
                      }
                    }
                  //}else{
                  //  // 重覆掃碼
                  //  showAlert('warning', '偵測到不合法字元，請重新輸入消費金額');
                  //  vm.keyboard.value = '';
                  //}
                  //incorrectInputType = false;
                  break;
                default:
                  if (obj.keyCode >= 48 && obj.keyCode <=57) {
                    if (angular.isDefined(vm.keyboard.value)) {
                      vm.keyboard.value = vm.keyboard.value + key;
                      ////prevent input infinitely
                      //if (vm.keyboard.value.length < 8) {
                      //  vm.keyboard.value = vm.keyboard.value + key;
                      //}else {
                      //if (!tooLongInput) showAlert('warning', '輸入金額過大', {"preventDuplicates": true});
                      //  //showAlertDialog('warning', '輸入金額過大', 2000, false);
                      //  
                      //  tooLongInput = true;
                      //  return;
                      //}
                    } else {
                      vm.keyboard.value = key;
                    }
                  }
                  //else {
                  //  //input other characters
                  //  incorrectInputType = true;
                  //}
                  break;
              }
            }
          }

        }

        //return;
      });
    });

    // catch keyboard simulator for phone
    var unbindWatchPoints = $scope.$watch(function watchPoints(){
      return vm.keyboard.value;
      }, function(newVal){
      /*
       * If member info is not ready, keyboard value apply to phoneNumber
       */
      
      if (vm.isProcessing.barcodeMessage || vm.isProcessing.phoneNumber || vm.isProcessing.points) return;

      //if (newVal === '') {
      //  incorrectInputType = false;
      //}

      ////clearEventListener();
      if (vm.isRequired.phoneNumber) {
        if (vm.member.barcodeMessage) {
          // For point add
          vm.money = parseInt(newVal);
          vm.newPoints = Math.floor(newVal / moneyToPoints);
          // For point redeem
          vm.redeemPoints = parseInt(newVal);
          // For refund point
          vm.refundPoints = parseInt(newVal);
        } else {
          vm.member.phoneNumber = newVal;
        }
      }else if (vm.isRequired.barcodeMessage) {
        if (vm.member.phoneNumber) {
          // For point add
          vm.money = parseInt(newVal);
          vm.newPoints = Math.floor(newVal / moneyToPoints);
          // For point redeem
          vm.redeemPoints = parseInt(newVal);
          // For refund point
          vm.refundPoints = parseInt(newVal);
        }else {
          vm.keyboard.value = '';
        }
      }
      
      return;
    });

    //function redirect (path) {
    //  $log.debug('redirect');
    //  //$localStorage.currentMember = vm.member;
    //  //rewardsFactory.setRewardTo(vm.member);
    //  $state.go(path, {
    //    barcode: vm.member.barcodeMessage
    //  });
    //}
    
    function changeSelectedMember(){
      //$log.debug('change:', vm.selectedMember);
      //vm.member = vm.selectedMember;
      showMemberInfo();

      //clear selected rewards
      clear()
      
    }

    function isAccountActive(data) {
      vm.member = data;
      
      if (angular.isDefined(data.status) && data.status === 'inactive') {
        //vm.nameColor = "red";
        vm.member.displayName = "未開卡";
      }

    }

    function toggleMemberInfo() {
      //$log.log('toggleMemberInfo')
      vm.expandMemberInfo = !vm.expandMemberInfo;
      //$log.debug('toogle:', vm.expandMemberInfo)
    }

    function toggleProductInfo() {
      vm.expandProductInfo = !vm.expandProductInfo;
    }

    function getRewardItemsCount() {
      var total = 0;
      for (var i=0, len=vm.rewardItems.length; i<len; i++) {
        total += vm.rewardItems[i].qty;
      }
      return total;
    }
    
    function getDepositItemsCount() {
      var total = 0;
      for (var i=0, len=vm.depositItems.length; i<len; i++) {
        total += vm.depositItems[i].qty;
      }
      return total;
    }

    function numberOfPages(){
      return Math.ceil(vm.rewardOptions.length/vm.pageSize);
    }

    function filterRewardOpions(){
      console.log('filter reward list', vm.rewardOptionsRaw);
      if ( vm.member && vm.member.barcodeMessage && vm.member.phoneNumber ) {
        if (vm.member.hasOwnProperty('userType')) {
          var userType = vm.member.userType;
          console.log('userType: ' + userType);
          if (userType !== "") {
            vm.rewardOptions = [];
            angular.forEach(vm.rewardOptionsRaw, function(obj, key){
              
              if (obj.hasOwnProperty('targets') && obj['targets']){
                if (typeof(obj['targets']) == 'string') {
                  obj['targets'] = JSON.parse(obj['targets']);
                }
 
                if ( (obj['targets'].hasOwnProperty(userType) == false) || (obj['targets'].hasOwnProperty(userType) && obj['targets'][userType] !== 'hidden') ){
                  vm.rewardOptions.push(obj);
                }
              }else{
                vm.rewardOptions.push(obj);
              }
            })
            console.log('filter done', vm.rewardOptions)
          }else{
            vm.rewardOptions = vm.rewardOptionsRaw;
          }
        }else {
          vm.rewardOptions = vm.rewardOptionsRaw;
        }
      }else {
        vm.rewardOptions = vm.rewardOptionsRaw;
      }
      vm.currentPage = 0;
      vm.numberOfPages();
    }
    function getRewardSelectOptions(shortcut) {
      //$log.debug('options:', shortcut);;
      if (shortcut) {
        rewardsFactory.getRewardShortcut()
        .then(function(result){
          $log.log(['[points-controller] getRewardShortcut done:', result]);
          vm.rewardShortcut = result;
          vm.rewardOptionsRaw = result;
          // vm.rewardOptions = result;
          //vm.showMoreRewards = false;
          //$log.debug('reward select options - shortcut: ', vm.rewardOptions);
        }, function(){
          $log.error('無法取得兌換項目清單');
          //vm.showMoreRewards = false;
        });

      }else {
        rewardsFactory.getRewardList()
        .then(function(result){
          $log.log(['[points-controller] getRewardList done:', result]);
          vm.rewardList = result;
          vm.rewardOptionsRaw = $filter('orderBy')(result, 'category');
          //vm.rewardOptions = $filter('orderBy')(result, 'category');
          //vm.showMoreRewards = true;
          //$log.debug('reward select options - all: ', vm.rewardOptions);
        }, function(){
          $log.error('無法取得兌換項目清單');
          //vm.showMoreRewards = false;
        });
      }
      vm.filterRewardOpions();
      // vm.currentPage = 0;
      // vm.numberOfPages();

    }
    
    function getDepositSelectOptions() {      
      depositFactory.getDepositList()
      .then(function(result){
        vm.depositList = result;
        vm.depositOptions = $filter('orderBy')(result, 'points');
       
      }, function(){
        $log.error('無法取得儲值項目清單');
      });
      
      vm.currentPage = 0;
      vm.numberOfPages();

    }

    // sidenav
    function toggleRight(open) {
      
      var toggleMode = 'toggle';
      if(open===true) {
        toggleMode = 'open';
      } else if(open===false) {
        toggleMode = 'close';
      }
      
      $mdSidenav('right')
      // .toggle()
      [toggleMode]()
      .then(function () {
        $log.debug("toggle: " + toggleMode + " is done");
      });

      
    }

    //function isOpenRight() {
    //  $log.debug('isOpenRight', $mdSidenav('right').isOpen());
    //  return $mdSidenav('right').isOpen();
    //}
    
    function getBackgroundColor(item) {
      if (vm.showRewardShortcut) return;
      if (backgroundColor.hasOwnProperty(item.category)) {
        return backgroundColor[item.category];
      } else {
        backgroundColor[item.category] = colorTableFactory.getColor();
        return backgroundColor[item.category];
      }
    }

    function showAlert(type, msg, opts) {
      switch (type.toLowerCase()) {
        case 'error':
          toastr.error(msg, opts);
          break;
        case 'warning':
          toastr.warning(msg, opts);
          break;
        case 'success':
          toastr.success(msg, opts);
          break;
      }
    }

    function showAlertDialog(type, msg, time, focus){

      //var myColor = '#ffff80';
      //var myColor;
      //var icon;
      var duration = time || 2000;

      //switch(type) {
      //  case 'error':
      //    icon = 'error_circle';
      //    myColor= '#FFA2A2';
      //    break;
      //  case 'warning':
      //    icon = 'warning';
      //    myColor= '#FAED33';
      //    break;
      //  default:
      //    icon = 'check_circle';
      //    myColor = '#A4FFA2';
      //    break;
      //}

      $mdDialog.show({
        templateUrl: "app/main/dialog.message.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          msg: msg,
          type: type
        },
        controller: function DialogController($log, $scope, $mdDialog, msg, type ){
          var vm = this;
          var alert = type;
          vm.msg = msg;
          vm.enableCloseBtn = true;
          vm.close = $mdDialog.hide;
          switch(alert) {
            case 'error':
              vm.icon = 'error_circle';
              vm.myColor= '#FFA2A2';
              break;
            case 'warning':
              vm.icon = 'warning';
              vm.myColor= '#FAED33';
              break;
            default:
              vm.icon = 'check_circle';
              vm.myColor = '#A4FFA2';
              break;
          }
        },
        controllerAs: 'msgCtrl',
        onComplete: function(){
          if (type !== 'error') {
            $timeout(function(){
              $mdDialog.hide();
              if (focus) {
                changeFocus('barcodeMessage');
              }
            }, duration);
          }
        }
      });

    }

    function showCreateDialog(phone){
      // Appending dialog to document.body to cover sidenav in docs app
      //var myColor = '#ffff80';
      $mdDialog.show({
        templateUrl: 'app/main/dialog.create.html',
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          phoneNumber: phone
        },
        controller: function DialogController($log, $scope, $mdDialog, apiFactory, phoneNumber ){
          var phone = phoneNumber
          $scope.cancel = function () {
            $log.log('cancel create:', phone);
            $mdDialog.cancel();
            changeFocus('barcodeMessage');
          };

          $scope.confirm = function (){
            $mdDialog.hide();
            var data = { "phoneNumber": phone};
            $log.log('[pointsCtrl] create barcode', data);
            apiFactory.createBarcode(data, createBarcodeSuccess, createBarcodeError);
          };

          function createBarcodeSuccess(result) {
            $log.log('[pointsCtrl] create barcode success', result);
            showAlertDialog('success', '加入會員成功', null, true);
            changeFocus('barcodeMessage');
          }

          function createBarcodeError(result) {
            $log.error('[pointsCtrl] create barcode error', result);
            if (result && result.error) {
              showAlert('error', result.error.message, null);
            }else {
              showAlert('error', '無法加入會員', null);
            }
          }

        }
      });
    }

    function resendBarcode() {
      var data = { "phoneNumber": vm.member.phoneNumber};
      $log.log('[pointsCtrl] resend barcode', data);
      apiFactory.sendBarcode(data, resendBarcodeSuccess, resendBarcodeError);
    }

    function removeReward(item, clearAll) {
      rewardsFactory.removeRewardItem(item, clearAll);
      refresh();
   }

    function addReward(item) {
      if (!vm.enableMultipleReward && vm.rewardCounts === 1) return;
      
      var reward = angular.copy(item);
      reward.qty = 1;
      rewardsFactory.setRewardItem(reward);
      vm.rewardPoints = rewardsFactory.getRewardPoints();

      if (vm.member.points - vm.rewardPoints < 0) {
        soundEffectFactory.playSound('warning');
        toastr.warning('點數不足');
        removeReward(item);
      } else {
        refresh();
      }
    }

    function refresh(){
      vm.rewardItems = rewardsFactory.getRewardItem();
      vm.rewardCounts = getRewardItemsCount();
      vm.rewardPoints = rewardsFactory.getRewardPoints();

      vm.depositItems = depositFactory.getDepositItem();
      vm.depositCounts = getDepositItemsCount();
      vm.depositPoints = depositFactory.getDepositPoints();
      vm.depositPurchase = depositFactory.getDepositPurchase();
      if (!vm.expandProductInfo){
        vm.expandMemberInfo = false;
        vm.expandProductInfo = true;
      }

      if (vm.member.barcodeMessage && vm.member.phoneNumber) {
        vm.keyboard.value = vm.rewardPoints || '0';
      }
    }

    function removeDeposit(item, clearAll) {
      depositFactory.removeDepositItem(item, clearAll);
      refresh();
   }

    function addDeposit(item) {
      if (!vm.enableMultipleItems && vm.depositCounts === 1) return;
      var deposit = angular.copy(item);
      deposit.qty = 1;
      depositFactory.setDepositItem(deposit);
      vm.depositPoints = depositFactory.getDepositPoints();
      vm.depositPurchase = depositFactory.getDepositPurchase();

      refresh();
    }
    
    function changeFocus(elem){

      if (vm.isProcessing.barcodeMessage || vm.isProcessing.phoneNumber || vm.isProcessing.points) {
        return;
      }

      
      $log.debug('[pointsCtrl] changeFocus', elem);
      //clearEventListener();
      vm.member = {
        barcodeMessage: '',
        phoneNumber: '',
        points: 0
      };

      rewardsFactory.clear();
      vm.multipleMember = false;
      //vm.selectedMember = null;
      vm.searchedMember.length = 0;
      vm.money = 0;
      vm.newPoints = 0;
      vm.rewardPoints = 0;
      vm.depositPoints = 0;
      vm.depositPurchase = 0;
      vm.redeemPoints = 0;
      vm.refundPoints = 0;
      vm.remark = '';
      vm.rewardItems = rewardsFactory.getRewardItem();
      vm.rewardCounts = getRewardItemsCount();
      vm.depositItems = depositFactory.getDepositItem();
      vm.depositCounts = getDepositItemsCount();
      vm.expandMemberInfo = true;
      vm.expandProductInfo = false;
      vm.currentPage = 0;
      vm.getRewardSelectOptions(true);
      vm.getDepositSelectOptions();
      
      vm.isFocus.exchange = false;
      vm.isFocus.remark = false;
      //incorrectInputType = false;
      //tooLongInput = false;
      
      if (elem === 'barcodeMessage') {
        vm.scanMode = true;
        toggleRight(false);
        vm.isRequired.phoneNumber = false;
        vm.keyboard.label = '';
        vm.keyboard.value = '';
        vm.displayList = '';
        vm.keyboard.numeric = false;
        
      }else {
        vm.scanMode = false;
        toggleRight(true);
        vm.isRequired.barcodeMessage = false;
        vm.keyboard.label = '會員電話';
        vm.keyboard.value = '';
        vm.displayList = '';
        vm.keyboard.numeric = false
      }

      vm.isRequired[elem] = true;
      // Not focus if no $timeout
      //angular.element('#' + elem)[0].focus();

      $timeout(function(){
        angular.element('#' + elem)[0].focus();
      }, 10);
    }

    function confirmAction(act){
      /*
       * Detect member info and then do action
       * 1. member info exist --> add/redeem
       * 2. member info not exist --> search
       */

      if (vm.isProcessing.barcodeMessage || vm.isProcessing.phoneNumber || vm.isProcessing.points) {
        return;
      }

      if (vm.member.barcodeMessage && vm.member.phoneNumber) {
        handlePoints(act);
      // both barcode message and phonenumber is null
      } else if (!vm.member.barcodeMessage && !vm.member.phoneNumber) {
        showAlert('warning', '會員資料不得為空', null);
      }else {
        // add or redeem points
        if (vm.isRequired.barcodeMessage) {
          handlePoints(act);
        }else if (vm.isRequired.phoneNumber) {
          // search barcode message
          if (!vm.member.barcodeMessage) {
            searchBarcodeByPhone();
          }else {
            handlePoints(act);
          }
        }

      }
    }

    function searchBarcodeByPhone(){
      var isPhoneMatch = vm.member.phoneNumber.match(/^09[0-9]{8}$/) || vm.member.phoneNumber.match(/^\+886[0-9]{9}$/);
      //$log.debug('[pointsCtrl] phone format:' + isPhoneMatch);
      if (isPhoneMatch) {
        vm.isProcessing.phoneNumber = 'indeterminate';
        toggleRight(false);
        apiFactory.searchDists({phoneNumber: vm.member.phoneNumber}, getBarcodeMsgSuccess, getBarcodeMsgError);
      } else {
        showAlert('warning', '會員電話格式錯誤', null);
        vm.member.phoneNumber = '';
        vm.keyboard.value = '';
      }

    }

    function handlePoints(action){
      //clearEventListener();
      vm.isProcessing.points = 'indeterminate';
      var data = [];
      var act = action.toUpperCase();
      $log.debug('[pointsCtrl] ' + action + ' point start ');

      toggleRight(false);
      // add points
      switch(act) {
        case 'ADD':
          if ( vm.money > 0 || vm.depositPoints > 0) { // check point > 0
            if (currentState === 'home.memberpoint') {
              data[0] = {
                "method": act,
                "barcodeMessage": vm.member.barcodeMessage,
                "timestamp": new Date().getTime(),
                "points": vm.newPoints,
                "remark": vm.remark,
                "purchase": vm.money, 
                "sn": helperFactory.getCounter()
              };
            } else if(currentState === 'home.deposit') {
              data[0] = {
                "method": act,
                "barcodeMessage": vm.member.barcodeMessage,
                "timestamp": new Date().getTime(),
                "points": vm.depositPoints,
                "label": vm.depositItems[0].label,
                "remark": vm.remark,
                "purchase": vm.depositPurchase, 
                "sn": helperFactory.getCounter()
              };
            }
            apiFactory.handlePoints(data, handlePointsSuccess, handlePointsError);
          }else {
            vm.isProcessing.points = '';
            if(currentState === 'home.deposit') {
              showAlertDialog('warning', '請選擇儲值項目', null, false);
              vm.keyboard.value = '';
            }
          }
          break;
        case 'REDEEM':
          if (currentState === 'home.rewardpoint') {
            vm.rewardItems = rewardsFactory.getRewardItem();
            vm.rewardCounts = getRewardItemsCount();
            vm.rewardPoints = rewardsFactory.getRewardPoints();
            if (vm.rewardItems.length <= 0) {
              showAlertDialog('warning', '請選擇兌換項目', null, false);
              vm.keyboard.value = '';
              vm.isProcessing.points = '';
            }else if (vm.member.points - vm.rewardPoints < 0) {
              showAlertDialog('warning', '點數不足', null, false);
              rewardsFactory.clearRewardItem();
              //rewardsFactory.clearRewardPoints();
              vm.rewardItems = rewardsFactory.getRewardItem();
              vm.rewardCounts = getRewardItemsCount();
              vm.rewardPoints = rewardsFactory.getRewardPoints();
              vm.keyboard.value = '';
              vm.isProcessing.points = '';
            } else {
              angular.forEach(vm.rewardItems, function(obj) {
                if (obj.qty && obj.qty > 1) {
                  for (var i=0; i<obj.qty; i++) {
                    data[data.length] = {
                      "method": act,
                      "barcodeMessage": vm.member.barcodeMessage,
                      "timestamp": new Date().getTime(),
                      "rewardId":  obj.id, 
                      "sn": helperFactory.getCounter()
                      
                    }
                  }
                } else {
                   data[data.length] = {
                      "method": act,
                      "barcodeMessage": vm.member.barcodeMessage,
                      "timestamp": new Date().getTime(),
                      "rewardId":  obj.id, 
                      "sn": helperFactory.getCounter()
                    }
                }

              });

              apiFactory.handlePoints(data, handlePointsSuccess, handlePointsError);
            }
          // Dynamic redeem
          } else if (currentState === 'home.redeempoint') {
            if ( vm.redeemPoints >= 0) {
              if (vm.member.points - vm.redeemPoints < 0) {
                showAlertDialog('warning', '點數不足', null, false);
                vm.keyboard.value = '';
                vm.isProcessing.points = '';
              } else {
                data[0] = {
                  "method": act,
                  "barcodeMessage": vm.member.barcodeMessage,
                  "timestamp": new Date().getTime(),
                  "points": vm.redeemPoints,
                  "remark": vm.remark,
                  "label": vm.dynamicReward.label, 
                  "sn": helperFactory.getCounter()
                };
                apiFactory.handlePoints(data, handlePointsSuccess, handlePointsError);
              }
            }else {
              vm.isProcessing.points = '';
            }
          } //end of dynamic redeem

          break;
        case 'REFUND':
          if ( vm.refundPoints > 0) { // check point > 0
            $mdDialog.show({
              templateUrl: 'app/main/dialog.confirmRefund.html',
              escapeToClose: false,
              clickOutsideToClose: false,
              locals: {
                refund: vm.refundPoints
              },
              controller: function DialogController($log, $scope, $mdDialog, refund){
                $scope.refund = refund;
                $scope.cancel = function () {
                  $mdDialog.cancel();
                };
                $scope.confirm = function () {
                  $mdDialog.hide(true);
                }
             }
            })
            .then(function(answer){
              if (answer) {
                data[0] = {
                  "method": act,
                  "barcodeMessage": vm.member.barcodeMessage,
                  "timestamp": new Date().getTime(),
                  "points": vm.refundPoints,
                  "remark": vm.remark, 
                  "sn": helperFactory.getCounter()
                };
                apiFactory.handlePoints(data, handlePointsSuccess, handlePointsError);
              }

            }, function() {
              vm.isProcessing.points = '';
              vm.isFocus.exchange = true;
            });

          }else {
              toastr.warning('退還點數小於或等於0');
              vm.isProcessing.points = '';
              vm.isFocus.exchange = true;
            }

         break;
        default:
          break;
      }

    }

    function showMemberInfo(){
      //if (currentState === 'home.redeempoint') {
      //  var timer = $interval(function(){
      //    if (g_timer) {
      //      clearEventListener();
      //    }else {
      //      checkEventListener();
      //      $interval.cancel(timer)
      //    }
      //  }, 500)
      //}
      
      rewardsFactory.setRewardTo(vm.member);
      depositFactory.setDepositTo(vm.member);
      vm.displayList = vm.member.fields;

      //detect account status
      isAccountActive(vm.member); 

                    
      //filter reward list options
      vm.filterRewardOpions()

      switch(currentState) {
        case 'home.memberpoint':
          vm.keyboard.label = '消費金額 $ ';
          vm.isFocus.exchange = true;
          break;
        case 'home.deposit':
          vm.keyboard.label = '儲值點數';
          break;
        case 'home.rewardpoint':
          vm.keyboard.label = '兌換點數';
          break;
        case 'home.redeempoint':
          vm.keyboard.label = '兌換點數';
          vm.isFocus.exchange = true;
          break;
        case 'home.refundpoint':
          vm.keyboard.label = '退還點數';
          vm.isFocus.exchange = true;
          break;
        default:
          break;
      }

      vm.keyboard.value = '';
      vm.keyboard.numeric = true;
      
      // When search result > 1, the sidenav won't be display automatically
      // Therefore, user can select member first. And too
      if (!vm.multipleMember) 
        toggleRight(true);


    }
    
    // Back to search page if no event happened
    function checkEventListener(){
      
      if (currentState === 'home.redeempoint') {
        $log.debug('[pointsCtrl] check event listener')
        g_timer = $timeout(function(){
          if (vm.isRequired.barcodeMessage) {
            changeFocus('barcodeMessage');
          }else {
            changeFocus('phoneNumber');
          }
        }, 15000)
      }
    }
    
    function clearEventListener(){
      if (g_timer){
        $log.debug('[pointsCtrl] clear event listener')
        $timeout.cancel(g_timer);
        g_timer = null;
      }
    }
    
    function getBarcodeMsgSuccess(result){
      $log.info('[pointsCtrl] get barcode msg success', result);
      vm.isProcessing.points = '';
      vm.isProcessing.barcodeMessage = '';
      vm.isProcessing.phoneNumber = '';
      //result.push({
      //  "barcodeMessage":"A160500000000105",
      //  "status":"active",
      //  "points":94,
      //  "displayName":"kkkk",
      //  "fields":[{"label":"顯示名稱","key":"displayName","value":"kkkk","order":0},{"label":"電子郵件","key":"email","value":"k@iiot.io","order":4},{"label":"地區","key":"location","value":"Taipei","order":5}],"phoneNumber":"+886921185084","cardId":"+886921185084"})
      
      // for multiple member
      switch(result.length) {
        case 0:
          if (vm.isRequired.barcodeMessage) {
            vm.member.barcodeMessage = '';
            vm.member.phoneNumber = '';
            showAlert('error', '查無資料', null);

            vm.keyboard = {
              label: '',
              value: '',
              numeric: false
            };
          } else if (vm.isRequired.phoneNumber) {
            showCreateDialog(vm.member.phoneNumber);
            }
          
          vm.multipleMember = false;
          break;
        case 1:
          vm.searchedMember = result;
          vm.member = result[0];
          vm.multipleMember = false;
          showMemberInfo();
          //checkEvent();
          break;
        default:  // length > 1
          vm.searchedMember = result;
          //vm.selectedMember = result[0];
          vm.member = result[0];
          vm.multipleMember = true;
          showMemberInfo();
          //checkEvent();
          break;
      }
      
      //if (angular.equals({}, result)) {
      //  // not a member
      //  if (vm.isRequired.barcodeMessage) {
      //    vm.member.barcodeMessage = '';
      //    vm.member.phoneNumber = '';
      //    showAlert('error', '查無資料', null);
      //
      //    vm.keyboard = {
      //      label: '',
      //      value: '',
      //      numeric: false
      //    };
      //  }else if (vm.isRequired.phoneNumber) {
      //    showCreateDialog(vm.member.phoneNumber);
      //  }
      //} else {
      //  rewardsFactory.setRewardTo(result);
      //  vm.displayList = result.fields;
      //
      //  //detect account status
      //  isAccountActive(result); 
      //  
      //  switch(currentState) {
      //    case 'home.memberpoint':
      //      vm.keyboard.label = '消費金額 $ ';
      //      vm.isFocus.exchange = true;
      //      break;
      //    case 'home.rewardpoint':
      //      vm.keyboard.label = '兌換點數';
      //      break;
      //    case 'home.redeempoint':
      //      vm.keyboard.label = '兌換點數';
      //      vm.isFocus.exchange = true;
      //      break;
      //    case 'home.refundpoint':
      //      vm.keyboard.label = '退還點數';
      //      vm.isFocus.exchange = true;
      //      break;
      //    default:
      //      break;
      //  }
      //
      //  vm.keyboard.value = '';
      //  vm.keyboard.numeric = true;
      //  
      //  toggleRight(true);
      //
      //}

    }

    function getBarcodeMsgError(result){
      $log.error('[pointsCtrl] get barcode msg error', result);
      vm.isProcessing.barcodeMessage = '';
      vm.isProcessing.phoneNumber = '';
      vm.isProcessing.points = '';
      if (result && result.error)
        showAlert('error', result.error.message, null);
      else
        showAlert('error', '無法取得資料', null);
      vm.member.barcodeMessage = '';
      vm.member.phoneNumber = '';
      vm.keyboard.value = '';
    }

    function handlePointsSuccess(result) {
      $log.log('[pointsCtrl] handle points success', result);
      //vm.member.points += result[0].points;

      soundEffectFactory.playSound('decision');
      // Redeem
      switch(currentState) {
        case 'home.memberpoint':
          vm.member.points += vm.newPoints;
          if (vm.newPoints > 0) {
            showAlertDialog('success', '儲值點數成功', null, true);
          }else {
            showAlertDialog('success', '本次消費無新增積點', null, true);
          }
          break;
        case 'home.deposit':
          vm.member.points += vm.depositPoints;
          showAlertDialog('success', '儲值點數成功', null, true);
          break;
        case 'home.rewardpoint':
          vm.member.points -= vm.rewardPoints;
          //vm.rewardItems = rewardsFactory.getRewardItem();
          showAlertDialog('success', '兌換點數成功', null, true);
          break;
        case 'home.redeempoint':
          vm.member.points -= vm.redeemPoints;
          if (vm.redeemPoints > 0) {
            showAlertDialog('success', '兌換點數成功', null, true);
          }else {
            showAlertDialog('success', '本次兌換無扣除點數', null, true);
          }
          break;
       case 'home.refundpoint':
          vm.member.points += vm.refundPoints;
          showAlertDialog('success', '退還點數成功', null, true);
          break;
        default:
          break;
      }

      rewardsFactory.clear();
      depositFactory.clear();
      vm.keyboard.value = '';
      vm.money = 0;
      vm.newPoints = 0;
      vm.redeemPoints = 0;
      vm.depositPoints = 0;
      vm.refundPoints = 0;
      vm.isProcessing.points = '';
      vm.rewardItems = rewardsFactory.getRewardItem();
      vm.rewardCounts = getRewardItemsCount();
      vm.rewardPoints = rewardsFactory.getRewardPoints();
      vm.depositItems = depositFactory.getDepositItem();
      vm.depositCounts = getDepositItemsCount();
      vm.depositPoints = depositFactory.getDepositPoints();
    }

    function handlePointsError(result) {
      $log.error('[pointsCtrl] handle points error, resend later', result);
      // Show success and resend request in background
      // every 30s until success

      //soundEffectFactory.playSound('decision');
      soundEffectFactory.playSound('warning');
      //Fake message
      switch(currentState) {
        case 'home.memberpoint':
        case 'home.deposit':
          showAlertDialog('error', '儲值點數失敗', null, true);
          /*
          vm.member.points += vm.newPoints;
          if (vm.newPoints > 0) {
            showAlertDialog('success', '儲值點數成功', null, true);
          }else {
            showAlertDialog('success', '本次消費無新增積點', null, true);
          }
          */
          break;
        case 'home.rewardpoint':
          showAlertDialog('error', '兌換點數失敗', null, true);
          /*
          vm.member.points -= vm.rewardPoints;
          //vm.rewardItems = rewardsFactory.getRewardItem();
          showAlertDialog('success', '兌換點數成功', null, true);
          */
          break;
        case 'home.redeempoint':
          showAlertDialog('error', '兌換點數失敗', null, true);
          /*
          vm.member.points -= vm.redeemPoints;
          if (vm.redeemPoints > 0) {
            showAlertDialog('success', '兌換點數成功', null, true);
          }else {
            showAlertDialog('success', '本次兌換無扣除點數', null, true);
          }
          */
          break;
       case 'home.refundpoint':
          showAlertDialog('error', '退還點數失敗', null, true);
          /*
          vm.member.points += vm.refundPoints;
          showAlertDialog('success', '退還點數成功', null, true);
          */
          break;
        default:
          break;
      }

      // rewardsFactory.clear();
      // vm.keyboard.value = '';
      // vm.money = 0;
      // vm.newPoints = 0;
      // vm.redeemPoints = 0;
      // vm.refundPoints = 0;
      vm.isProcessing.points = '';
      vm.rewardItems = rewardsFactory.getRewardItem();
      vm.rewardCounts = getRewardItemsCount();
      vm.rewardPoints = rewardsFactory.getRewardPoints();
    }

    function resendBarcodeSuccess(result) {
      $log.log('[pointsCtrl] resend barcode success', result);
      showAlertDialog('success', '重新發卡成功', null, true);
      changeFocus('barcodeMessage');
    }

    function resendBarcodeError(result) {
      $log.error('[pointsCtrl] resend barcode error', result);
      if (result && result.error) {
        showAlert('error', result.error.message || '重新發卡失敗', null);
      }else {
        showAlert('error', '重新發卡失敗', null);
      }
    }


    function clear(){
      //if (!angular.equals({}, vm.reward)) {
      if (vm.rewardItems.length > 0 ) {
        vm.keyboard.value = '';
        rewardsFactory.clearRewardItem();
        vm.rewardItems = rewardsFactory.getRewardItem();
        vm.rewardCounts = getRewardItemsCount();
        vm.rewardPoints = rewardsFactory.getRewardPoints();
        //rewardsFactory.setRewardItem(null);
      }
      
      if (vm.depositItems.length > 0 ) {
        vm.keyboard.value = '';
        depositFactory.clearDepositItems();
        vm.depositItems = depositFactory.getDepositItem();
        vm.depositCounts = getDepositItemsCount();
        vm.depositPoints = depositFactory.getDepositPoints();
        vm.depositPurchase = depositFactory.getDepositPurchase();
      }
    }
   
  });
  
  

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:mostockoutCtrl
 * @description
 * # mostockoutCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('mostockoutCtrl', function ($scope, $log, $q, $mdDialog, $filter, toastr, 
  NgTableParams, ModalService, apiFactory, counterService, helperFactory) {
    var vm = this;
    var _translate = $filter('translate');
    var counter = counterService.getCounter();
    vm.changePageSize = changePageSize;
    vm.getReturnProducts = getReturnProducts;
    vm.returnProducts = returnProducts;
    vm.showConfirmDialog = showConfirmDialog;
    vm.showDeleteDialog = showDeleteDialog;
    vm.getFilterDataAsync = getFilterDataAsync;
    vm.toggle = toggle;
    vm.exists = exists;
    vm.isIndeterminate = isIndeterminate;
    vm.isChecked = isChecked;
    vm.toggleAll = toggleAll;
    vm.getIndex = getIndex;
    vm.products = [];
    vm.orderedProducts = [];
    vm.currentProducts = [];
    vm.selected = [];
    vm.isProcessing = false;
    vm.availablePageSizes = [ 50, 100, 150, 200, 'ALL'];
    vm.selectedPageSize = 'ALL';
    vm.tableParams = new NgTableParams({
        page: 1,
        count: vm.selectedPageSize //initial page size
      }, {
      // page size buttons (right set of buttons in demo)
        counts: [],
        // determines the pager buttons (left set of buttons in demo)
        paginationMaxBlocks: 10,
        getData: function(params) {
          var data = angular.copy(vm.products);
          var filterObj = params.filter();
          //var filterObjFinal = [];
          var filterMatch = [];
          var filterEqual = [];
          //$log.debug('filter obj:', filterObj);
          // Wordaround for select blank option
          for(var key in filterObj) {
            if(filterObj[key]  !== '') {
              //filterObjFinal[key] = filterObj[key];
               //$log.debug('filter key:'+ key);
              if (key === 'supplier' || key === 'operator') {
                filterEqual[key] = filterObj[key];
              }else {
                filterMatch[key] = filterObj[key];
              }
              
            }
          }
          //$log.debug('filter equal:', filterEqual);
          //$log.debug('filter match:', filterMatch);
          //var filteredData = $filter('filter')(data, filterObjFinal, true);
          var filteredData = $filter('filter')(data, filterEqual, true);
          filteredData = $filter('filter')(filteredData, filterMatch);
          
          var sortObj = params.orderBy();
          var orderedData = $filter('orderBy')(filteredData, sortObj);
          vm.orderedProducts = orderedData;
          orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
          vm.currentProducts = orderedData;
          // reset select all
          vm.selected = [];
          //if (vm.selected.length === vm.currentProducts.length) {
          //  vm.selected = [];
          //}
          //$defer.resolve(vm.products.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          return orderedData;
        }

    });

    var filter = {
      supplier: [{id: "", title: ""}],
      //product: [{id: "", title: ""}],
      operator: [{id: "", title: ""}]
    };

    (function initController(){
      getReturnProducts();
    })();

    $scope.$on('destroy', function(){
      for (var key in filter) {
        filter[key] = null;
      }
      filter = null;
      vm.products = null;
      vm.currentProducts = null;
      vm.selected = null;
    });


    function getFilterDataAsync(id) {
      return $q.when(filter[id]);
    }

    function changePageSize(){
      $log.debug('change page size:', vm.selectedPageSize);
      if (vm.selectedPageSize === 'ALL') {
        vm.tableParams.count(vm.products.length)
      }else {
        vm.tableParams.count(vm.selectedPageSize);
      }

    }

    function getIndex(idx) {
      if (vm.selectedPageSize === 'ALL')
        return idx + 1;
      else
        return (vm.tableParams.page()-1) * vm.selectedPageSize + (idx+1);
    
    }

    
    function toggle(item) {
      var idx = vm.selected.indexOf(item);
      if (idx > -1) {
        //vm.selected.splice(idx, 1);
        vm.selected = helperFactory.spliceOne(vm.selected, idx);
      }else {
        vm.selected.push(item);
      }
    }

    function exists(item) {
      return vm.selected.indexOf(item) > -1;
    }

    function isIndeterminate() {
      return (vm.selected.length !== 0 &&
                  vm.selected.length !== vm.currentProducts.length);
    }

    function isChecked() {
      return vm.currentProducts.length >0 && vm.selected.length === vm.currentProducts.length;
    }

    function toggleAll() {
      if (vm.selected.length === vm.currentProducts.length) {
        vm.selected = [];
      } else if (vm.selected.length === 0 || vm.selected.length > 0) {
        vm.selected = vm.currentProducts.slice(0);
      }
    }

    function getReturnProducts() {
      vm.products.length = 0 ;
      vm.isProcessing = true;
      apiFactory.getReturnProducts(counter.id, getProductsSuccess, getProductsFail );
      //vm.tableParams = new NgTableParams({
      //    page: 1,
      //    count: 1  //initial page size
      //  }, {
      //    // page size buttons (right set of buttons in demo)
      //    counts: [],
      //    // determines the pager buttons (left set of buttons in demo)
      //    paginationMaxBlocks: 10,
      //    getData: function($defer, params) {
      //      apiFactory.getReturnProducts(counter.id, function(data){
      //          $log.debug('get Data success');
      //          vm.products = data;
      //          params.total(data.inlineCount); // recal. page nav controls
      //          $defer.resolve(vm.products.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      //       }, function(){
      //          $log.error('get Data failed');
      //          vm.products.length = 0 ;
      //          $defer.reject();
      //       });
      //    }

      //});

    }

    function showDeleteDialog(id){
      vm.isProcessing = true;
      ModalService.showModal({
        templateUrl: "app/main/modal.remark.html",
        controller: 'modalremarkCtrl',
        inputs: {
          title: _translate('title.remark')
        }
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(function(result) {
          if (result.remark)
            apiFactory.deleteReturnProduct(counter.id, id, {remark: result.remark}, 
              function(){
                deleteReturnProductSuccess(id)
              }, deleteReturnProductFail);
          else
            vm.isProcessing = false;
        });
      });

    }

    function deleteReturnProductSuccess(id){
      toastr.success(_translate('msg.mostockout.delete.success'));
      vm.isProcessing = false;
      vm.products = $filter('filter')(vm.products, function (item) {
        return item.id !== id;
      });
      vm.tableParams.total(vm.products.length);
      vm.tableParams.reload();
    }

    function deleteReturnProductFail(err){
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockout.delete.error'));
      else
        toastr.error(_translate('msg.mostockout.delete.error'));
      vm.isProcessing = false;

    }
    
    function showConfirmDialog() {
      //apiFactory.getStockInProducts(counter.id, function(result){
      //  if (result.length > 0) {
      //    $mdDialog.show({
      //      templateUrl: "app/main/dialog.confirmAutoStockin.html",
      //      fullscreen: false,
      //      locals: {
      //        data: result
      //      },
      //      controller: function($scope, data){
      //         $scope.products = data;
      //         $scope.selectedProduct = $scope.products[0];
      //         $scope.cancel = function() {
      //           $mdDialog.cancel();
      //         };
      //         $scope.confirm = function() {
      //           $mdDialog.hide($scope.selectedProduct);
      //         }
      //      }
      //    }).then(function(answer){
      //      //$log.debug('Return product supplier and type:', answer);
      //      returnProducts(true, answer);
      //    });
      //  }
      //}, function(err){
      //  $log.debug('err:', err);
      //})
              
      $mdDialog.show({
         templateUrl: "app/main/dialog.confirmAutoStockin.html",
         fullscreen: false,
         controller: function($scope){
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.confirm = function() {
              $mdDialog.hide();
            }
         }
      }).then(function(){
        returnProducts(true);
      });
    }

    function returnProducts(stockin){
      //$log.debug(vm.selected);
      var params = {
        'products': [],
        'autoStockin': stockin
      };

      //if (answer) {
      //  params.supplier = answer.supplier;
      //  params.product = answer.product;
      //}
      
      
      for (var i=0, len=vm.selected.length; i<len; i++) {
        params.products.push({id: vm.selected[i].id, status: 'STOCKOUT'});
      }
      
      vm.isProcessing = true;
      apiFactory.updateReturnProducts(counter.id, params, updateProductsSuccess, updateProductsFail );

    }

    function updateProductsSuccess(result) {
      $log.log('Update products success:', result);
      vm.selected.length = 0;
      vm.isProcessing = false;
      toastr.success(_translate('msg.mostockout.update.success'));
      getReturnProducts();
    }

    function updateProductsFail(err){
      $log.error('Update products failed:', err)
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockout.update.error'));
      else
        toastr.error(_translate('msg.mostockout.update.error'));
      //vm.selected.length = 0;
    }

    function getProductsSuccess(result){
      $log.log('Get return products success:', result);
      vm.products = result;
      if (vm.selectedPageSize === 'ALL')
        vm.tableParams.count(vm.products.length);
      // filter vendor data;
      for (var i=0, len=vm.products.length; i<len; i++) {
        var supplier = vm.products[i].supplier;
        var operator = vm.products[i].operator;
        //var product = vm.products[i].product;
        var isSupplierExist = $filter('filter')(filter.supplier, {id: supplier}, true);
        if (isSupplierExist.length === 0 && supplier !== null) {
          filter.supplier.push({
            id: supplier,
            title: supplier
          });
        }

        var isOperatorExist = $filter('filter')(filter.operator, {id: operator}, true);
        if (isOperatorExist.length === 0 && operator !== null) {
          filter.operator.push({
            id: operator,
            title: operator
          });
        }

        //var isProductExist = $filter('filter')(filter.product, {id: product});
        //if (isProductExist.length === 0 && product !== null) {
        //  filter.product.push({
        //    id: product,
        //    title: product
        //  });
        //}

      }

      vm.tableParams.filter({});
      vm.tableParams.total(vm.products.length);
      vm.tableParams.reload();
      vm.isProcessing = false;
    }

    function getProductsFail(err) {
      $log.error('Get return products failed:', err)
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockout.getProduct.error'));
      else
        toastr.error(_translate('msg.mostockout.getProduct.error'));
      //toastr.error('無法取得還機列表');
      vm.products.length = 0;
    }
  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.numericKeyboard
 * @description
 * # numericKeyboard
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('numericKeyboardFactory', function () {
    var model = null;
    var service = {
      clear: clear,
      append: append,
      remove: remove,
      setModel: setModel
    };

    return service;

    function setModel(newModel){
      model = newModel;
    }

    function clear(){
      if (model) {
        model.$viewValue = "";
        model.$render();
        model.$commitViewValue();
      }else {
        return;
      }
    }

    function remove(){
      if (model) {
        var current = model.$viewValue;
        model.$viewValue = current.slice(0, -1);
        model.$render();
        model.$commitViewValue();
      }else {
        return;
      }
    }


    function append(key){
      if (model) {
        model.$viewValue += key;
        model.$render();
        model.$commitViewValue();
      }else {
        return;
      }
    }

  });



'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:numericKeyboard
 * @description
 * # numericKeyboard
 */
angular.module('mpos')
  .directive('numericKeyboard', function (numericKeyboardFactory, soundEffectFactory) {
    return {
      templateUrl: 'app/numericKeyboard/numericKeyboard.html',
      restrict: 'E',
      scope: {
        callback: '&',
        clearCallback: '&',
        type: '@'  // 'full', 'fn'
      },
      link: function(scope) {
        scope.done = function () {
          soundEffectFactory.playSound();
          scope.callback();
        };

        scope.append = function(key){
          soundEffectFactory.playSound();
          numericKeyboardFactory.append(key);
        };

        scope.remove = function(){
          soundEffectFactory.playSound();
          numericKeyboardFactory.remove();

          // scope.clearCallback();
        };

        scope.clear = function(){
          soundEffectFactory.playSound();
          numericKeyboardFactory.clear();

          // for clear reward items
          scope.clearCallback();
        };

        scope.stopPropagation = function(event){

          event.preventDefault();
          // prevent trigger ng-click by enter event
          if (event.keyCode == 13 || event.keyCode === 10) {
            //console.log("Enter pressed ");
            //event.preventDefault();
            return;
          } else {

            event.stopPropagation();
          }
        };
      }
    };
  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:mocheckoutCtrl
 * @description
 * # mocheckoutCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('mocheckoutCtrl', function ($scope, $document, $log, $timeout, $mdDialog, $sce, toastr, 
    apiFactory, counterService, helperFactory, soundEffectFactory, $filter) {
    var vm = this;
    var _translate = $filter('translate');
    var counter = counterService.getCounter();
    vm.trustAsHtml = $sce.trustAsHtml;
    vm.changeFocus = changeFocus;
    vm.showProductStatus = showRemarkFormDialog;
    vm.confirmProduct = confirmProduct;
    vm.getRemark = getRemark;
    //vm.confirmDamageProduct = confirmDamageProduct;
    vm.product = {
      productSerialNo: '',
      merchantOrderNo: '',
      phoneNumber: ''
    };
    vm.products = [];

    //var remarkFormAnswer = null;
    vm.displayRemarkFormAnswer = null;
    vm.multipleProducts = false;
    vm.isRequired = {
      'productCode': true,
      //'phoneNumber': false
      'queryString': false
    };
    vm.isProcessing = {
      'productCode': '',
      //'phoneNumber': '',
      'queryString': '',
      'confirmProduct': ''
    };

    /*
     *
     * Events
     *
     */

    $scope.$on('$destroy', function () {
      unbindWatchPaste();
      unbindWatchKeyPress();
      unbindWatchShortcut();
      //counterService.clearCounter();
      vm.product = null;
      vm.products = null;

      //remarkFormAnswer = null;
      vm.displayRemarkFormAnswer = null;
      vm.isRequired = null;
      vm.isProcessing = null;
    });

    var unbindWatchShortcut = $scope.$on('shortcutEvents', function (evt, obj) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function () {
        //var isRemarkFormOpen = (angular.element(document).find('md-dialog').length > 0) ? true : false;
        var isRemarkFormOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
        if (vm.product.merchantOrderNo && !isRemarkFormOpen) {
          switch (obj.keyCode) {
            case 83: //ctrl+s
              confirmProduct();
              break;
            case 70: //ctrl+f
              showRemarkFormDialog();
              break;
            default:
              break;
          }
        }
      });
    });


    var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {
      var isRemarkFormOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (isRemarkFormOpen) return;
      if (vm.isRequired.productCode && !vm.product.merchantOrderNo) {
        if (vm.isProcessing.productCode) {
          return;
        }else {
          vm.product.productSerialNo = vm.product.productSerialNo + data.toUpperCase();
          $scope.$apply();
        }
      }else if (vm.isRequired.queryString && !vm.product.merchantOrderNo) {
        if (vm.isProcessing.queryString) {
          return;
        }else {
          vm.queryString = vm.queryString + data;
          $scope.$apply();
        }
      }else {
        return;
      }
    });

    // catch keypress event for barcode scanner
    var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
      evt.stopPropagation();

      var isRemarkFormOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (isRemarkFormOpen) return;
      if (vm.isProcessing.prodcutCode || vm.isProcessing.queryString || vm.isProcessing.confirmProduct) return;

      if (obj.keyCode === 8)
        evt.preventDefault();


      $scope.$apply(function () {

        if (vm.isRequired.productCode && !vm.product.merchantOrderNo) {
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.product.productSerialNo))
                vm.product.productSerialNo = vm.product.productSerialNo.slice(0, -1);
              break;
            case 10:
            case 13:

              if (vm.product.productSerialNo !== '') {
                apiFactory.searchCheckOutOrder(counter.appId, {productSerialNo: vm.product.productSerialNo}, searchOrderSuccess, searchOrderError);
                vm.isProcessing.productCode = 'indeterminate';
              }
              break;
            default:

              if (angular.isDefined(vm.product.productSerialNo))
                vm.product.productSerialNo = vm.product.productSerialNo + key.toUpperCase();
              else
                vm.product.productSerialNo = key.toUpperCase();
              break;
          }
        }else if (vm.isRequired.queryString && !vm.product.merchantOrderNo) {
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.queryString))
                vm.queryString = vm.queryString.slice(0, -1);
              break;
            case 10:
            case 13:
              if (vm.queryString !== '') {
                apiFactory.searchCheckOutOrder(counter.appId, {queryString: vm.queryString}, searchOrderSuccess, searchOrderError);
                vm.isProcessing.queryString = 'indeterminate';
              }

              break;
            default:
              if (angular.isDefined(vm.queryString))
                vm.queryString = vm.queryString + key;
              else
                vm.queryString = key;
              break;
          }
        }else {
          return;
        }

      });
    });


    /*
     *
     * Public function
     *
     */

    function changeFocus(elem) {
      if (vm.isProcessing.productCode || vm.isProcessing.queryString ||
          vm.isProcessing.confirmProduct) {
            return;
      }

      $log.debug('changeFocus', elem);

      resetParams();
      if (elem === 'productCode') {
        vm.isRequired.queryString = false;
      }else {
        vm.isRequired.productCode = false;
      }

      vm.isRequired[elem] = true;

      $timeout(function(){
        angular.element('#' + elem)[0].focus();
      }, 10);
    }

    function getRemark(remark){

      if (remark) {
        return remark.replace(/\n/g, "<br/>");
      }else {
        return '';
      }

    }
    
    function showRemarkFormDialog(){
      $log.debug('show remark form');
      var focusedElm = angular.element($document[0].activeElement).attr('id');

      // blur focused button to avoid enter event propagate...
      if (focusedElm) {
        $timeout(function(){
          angular.element('#' + focusedElm)[0].blur();
        }, 0);
      }

      $mdDialog.show({
         controller: DialogRemarkFormCtrl,
         controllerAs: 'ctrl',
         templateUrl: "app/main/dialog.remarkForm.html",
         locals: {
             product: vm.product,
             appId: counter.appId,
             email: vm.product.email
         },
         fullscreen: false
      }).then(function(answer){
        $log.debug('remark form answer:', answer);

        if (answer) {
          //remarkFormAnswer = answer.form;
          vm.displayRemarkFormAnswer = answer.remark;
        }else {
          //remarkFormAnswer = null;
          vm.displayRemarkFormAnswer = '';
        }
        //$log.debug(vm.remarkFormAnswer);
        //vm.remarkFormAnswer = answer;
      });
    }

    function confirmProduct() {
      vm.isProcessing.confirmProduct = "indeterminate";
      apiFactory.updateCheckOutOrder(counter.appId, vm.product.productSerialNo, {'form': null, 'remark': null}, updateOrderSuccess, updateOrderError);

    }
    /*
     *
     * Private function
     *
     */
    function resetParams( ) {
      vm.product = {
        productSerialNo: '',
        merchantOrderNo: '',
        phoneNumber: ''
      };
      vm.queryString = '';
      vm.products = [];
      //remarkFormAnswer = null;
      vm.displayRemarkFormAnswer = null;
      vm.multipleProducts = false;
      vm.isRequired = {
        'productCode': true,
        //'phoneNumber': false
        'queryString': false
      };
      vm.isProcessing = {
        'productCode': '',
        //'phoneNumber': '',
        'queryString': '',
        'confirmProduct': ''
      };

    }

    function showAlertDialog(type, msg, reset, time){

      //var myColor;
      //var icon;
      var duration = time || 2000;

      $mdDialog.show({
        templateUrl: "app/main/dialog.message.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          msg: msg,
          type: type
        },
        controller: function DialogController($log, $scope, $mdDialog, msg, type ){
          var vm = this;
          var alert = type;
          vm.msg = msg;
          switch(alert) {
            case 'error':
              vm.icon = 'error_circle';
              vm.myColor= '#FFA2A2';
              break;
            case 'warning':
              vm.icon = 'warning';
              vm.myColor= '#FAED33';
              break;
            default:
              vm.icon = 'check_circle';
              vm.myColor = '#A4FFA2';
              break;
          }
        },

        controllerAs: 'msgCtrl',
        onComplete: function(){
          $timeout(function(){
            $mdDialog.hide();
            if (reset)
              resetParams();
          }, duration)
        }
      });

    }

    function DialogRemarkFormCtrl($scope, $document, $q, toastr, product, appId, email, $mdDialog, apiFactory){
      var vm = this;
      vm.email = email;
      vm.product = product;
      vm.selected = []; // for store checkbox checked item
      vm.isProcessing = 'indeterminate';
      vm.isUpdateing = '';
      vm.isProductDamage = false;
      var timer;
      var selectedItems = [];  // for display checked item content in main window
      //var answer;

      (function initController() {
        apiFactory.getRemarkForm(appId, vm.product.productSerialNo, function(result){
          $log.log('Get remark form:', result);
          vm.list = result.form;
          vm.payment = result.payment;
         // filter array with type = checkbox
         var tempArray = vm.list.filter(function(el){
            return el.type == 'checkbox';
         });

         var i, len, itemName = '';
         for (i=0, len=tempArray.length; i<len; i++) {
            itemName = tempArray[i].name;
            if (angular.isUndefined(vm.selected[itemName])) {
              vm.selected[itemName] = [];
              selectedItems[itemName] = [];
            }

            if (angular.isDefined(tempArray[i].checked)
                  && tempArray[i].checked === true) {
              vm.selected[itemName].push(tempArray[i].value);
              selectedItems[itemName].push(tempArray[i].label);
            }
         }

         // filter array with type = texxt
         if (angular.isDefined(vm.list)) {
           tempArray = vm.list.filter(function(el){
            return el.type == 'text';
           });

           for (i=0, len=tempArray.length; i<len; i++) {
             itemName = tempArray[i].name;
              if (angular.isUndefined(vm.selected[itemName])) {
                vm[itemName] = tempArray[i].value;
              }
           }
         }


          vm.isProcessing = '';
        }, function(err) {
          //toastr.warning('無法取得還機狀態表');
          if (err)
            vm.errmsg = err.error.message || '無法取得設備狀態表';
          else
            vm.errmsg = '無法取得設備狀態表';
          vm.isProcessing = '';
          timer = $timeout(function(){
            $mdDialog.hide();
          }, 2000);
          //$mdDialog.hide();
        });
      })()

      $scope.$on('$destroy', function () {
        unbindWatchKeyPress();
        //unbindWatchShortcut();
        for(var key in vm.selected) {
          vm.selected[key] = null;
          selectedItems[key] = null;
        }
        vm.selected = null;
        selectedItems = null;
        if(angular.isDefined(timer))
          $timeout.cancel(timer);
      });

      //var unbindWatchShortcut = $scope.$on('shortcutEvents', function (evt, obj) {
      //  evt.preventDefault();
      //  evt.stopPropagation();
      //  $scope.$apply(function () {
      //    //var isRemarkFormOpen = (angular.element(document).find('md-dialog').length > 0) ? true : false;
      //    var isRemarkFormOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      //    if (isRemarkFormOpen) {
      //      switch (obj.keyCode) {
      //        case 67: //ctrl+c
      //          vm.cancel();
      //          break;
      //        case 80: //ctrl+p
      //          vm.updateCheckOutPayment();
      //          break;
      //        case 83: //ctrl+s
      //          vm.updateCheckOutOrder();
      //          break;
      //        default:
      //          $log.debug('shortcut default:', obj.keyCode);
      //        break;
      //      }
      //    }
      //  });
      //});


      var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
        evt.stopPropagation();
        evt.preventDefault();

        var focusedElm = angular.element($document[0].activeElement).attr('id');

        $scope.$apply(function(){
          switch (obj.keyCode) {
            case 8:
              vm[focusedElm] = vm[focusedElm].slice(0, -1);
              break;
            case 13:
              //break;
            default:
              if (angular.isDefined(vm[focusedElm]))
                vm[focusedElm] = vm[focusedElm] + key;
              else
                vm[focusedElm] = key;
              break;

          }
        });
      });

      // Check if any checkbox is checked --> damaged product
      var isDamaged = function(obj) {
        if (Object.keys(obj).length > 0)
          return false;
        else
          return true;
      }

      var checkAnswer = function(){
        $log.debug('check remark form answer:');
        var deferred = $q.defer();

        var formData = {};
        var displayData = {
          selected: selectedItems, // for display usage, type=checkbox
          text: {},  // for display usage, type=text
          //email: {} // for display usage, type=email
        };

        // Form data (checkbox)
        var key, i, len, displayRemarkFormAnswer = null;
        for (key in vm.selected) {
          formData[key] = vm.selected[key];
        }

        // filter array with type = text
        var tempArray;
        if (angular.isDefined(vm.list)) {
          tempArray = vm.list.filter(function(el){
           return el.type == 'text';
          });

          for (i=0, len=tempArray.length; i<len; i++) {
            formData[tempArray[i].name] = vm[tempArray[i].name];
            displayData.text[tempArray[i].name] = {
              label: tempArray[i].label,
              value: vm[tempArray[i].name]
            }
          }
        }

         // filter array with type = email
        var tempArray;
        if (angular.isDefined(vm.list)) {
          tempArray = vm.list.filter(function(el){
           return el.type == 'email';
          });

          for (i=0, len=tempArray.length; i<len; i++) {
            formData[tempArray[i].name] = vm[tempArray[i].name];
            // displayData.email[tempArray[i].name] = {
            //   label: tempArray[i].label,
            //   value: vm[tempArray[i].name]
            // }
          }
        }
        
        //$log.debug('displayData:', displayData);
        // display text for remark
        for (key in displayData.selected) {
          var temp = displayData.selected[key];
          for (i=0, len=temp.length; i<len; i++){
            if (i === 0)
              displayRemarkFormAnswer = temp[i] + '\r';
            else
              displayRemarkFormAnswer = displayRemarkFormAnswer + temp[i] + '\r';
          }
        }

        // for text input
        for (key in displayData.text) {

          if (angular.isDefined(displayData.text[key].value)) {
            if (displayRemarkFormAnswer) {
              displayRemarkFormAnswer = displayRemarkFormAnswer + '\r'
                + displayData.text[key].label + ': \r'
                + displayData.text[key].value;
            } else {
              displayRemarkFormAnswer = displayData.text[key].label + ': \r'
                + displayData.text[key].value;
            }
          }
        }
        

        //$log.debug(displayRemarkFormAnswer);
        var answer = {
          form: formData,
          remark: displayRemarkFormAnswer
          //displayData: displayRemarkFormAnswer
        };

        //$log.log(answer)
        deferred.resolve(answer);

        return deferred.promise;
      };

      function updateOrderSuccess(result) {
        $log.log('update checkout order success');
        vm.isUpdateing = '';

        //$mdDialog.hide(answer);
        $mdDialog.hide();
        if (result.status === 'RETURN_OVERDUE')
          showAlertDialog('warning', '還機逾期', true, 1500);
        else
          showAlertDialog('success', '還機成功', true, 1500);
      }



      function updateOrderError(err) {
        $log.error('update checkout order failed', err);
        vm.isUpdateing = '';
        var msg = err.error.message || '無法更新資料';
        showAlertDialog('error', msg, false, 1500);
        //if (err)
        //  toastr.error(err.error.message || '無法更新資料', null);
        //else
        //  toastr.error('無法更新資料', null);

      }

      function setPaymentSuccess(result) {
        $log.log('set payment success', result);
        vm.isUpdateing = '';

        //$mdDialog.hide(answer);
        $mdDialog.hide();
        showAlertDialog('success', '還機付款成功', true, 1500);
      }


      function setPaymentError(err) {
        $log.error('set payment failed', err);
        vm.isUpdateing = '';
        if (err)
          toastr.error(err.error.message || '無法更新資料', null);
        else
          toastr.error(_translate('msg.mocheckout.payment.error'), null);

      }


      vm.toggle = function (item) {
        var idx = vm.selected[item.name].indexOf(item.value);
        if (idx > -1) {
          vm.selected[item.name] = helperFactory.spliceOne(vm.selected[item.name], idx);
          selectedItems[item.name] = helperFactory.spliceOne(selectedItems[item.name], idx);
          //vm.selected[item.name].splice(idx, 1);
          //selectedItems[item.name].splice(idx, 1);
        }else {
          vm.selected[item.name].push(item.value);
          selectedItems[item.name].push(item.label);
        }
        vm.isProductDamage = !isDamaged(vm.selected[item.name]);
      }

      vm.exists = function (item) {
        vm.isProductDamage = !isDamaged(vm.selected[item.name]);
        return vm.selected[item.name].indexOf(item.value) > -1;
      }

      vm.updateCheckOutOrder = function(sendPaymentLink) {
        vm.isUpdateing = "indeterminate";
        checkAnswer()
          .then(function(data){
            data['sendPaymentLink'] = sendPaymentLink || false;
            $log.debug('Update checkout order:', data);
            apiFactory.updateCheckOutOrder(counter.appId, vm.product.productSerialNo, data, updateOrderSuccess, updateOrderError);
          })
      }

      vm.updateCheckOutPayment = function() {
        vm.isUpdateing = "indeterminate";
        checkAnswer()
          .then(function(data){
            $log.debug('Update checkout order - payment:', data);
            apiFactory.setPayment(counter.appId, vm.product.productSerialNo, data, setPaymentSuccess, setPaymentError);
          })
      }

      vm.cancel = function() {
          //vm.product.serialNos = [];
          $mdDialog.cancel();
      };


    } //Dialogremarkformctrl

    function showAbnormalDialog(){
      var focusedElm = angular.element($document[0].activeElement).attr('id');

      // blur focused button to avoid enter event propagate...
      if (focusedElm) {
        $timeout(function(){
          angular.element('#' + focusedElm)[0].blur();
        }, 0);
      }

      $mdDialog.show({
         controller: DialogAbnormalCtrl,
         controllerAs: 'ctrl',
         templateUrl: "app/main/dialog.abnormal.html",
         locals: {
             product: vm.product.productSerialNo,
             appId: counter.appId,
             remark: vm.product.remark
         },
         fullscreen: false
      }).then(function(){
        //vm.product.productSerialNo = '';
      });
    }

    function DialogAbnormalCtrl($scope, $window, toastr, product, appId, remark, $mdDialog, apiFactory){
      var vm = this;
      vm.productSN = product;
      vm.isProcessing = 'indeterminate';
      vm.isUpdateing = '';
      vm.suppliers= [];
      vm.selectedSupplier = null ;
      vm.remark = remark || '';

      (function initController() {
        apiFactory.getSuppliers(appId, null, function(result){
          $log.log('Get suppliers:', result);
          vm.suppliers = result;
          vm.selectedSupplier = result[0] ;
          vm.isProcessing = '';
        },function onError(err){
          $log.error('Get suppliers failed:', err);
          $mdDialog.cancel();
          vm.isProcessing = '';
        });
       })();

      $scope.$on('$destroy', function () {
        unbindWatchKeyPress();
        unbindWatchPaste();
      });

      var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {

        var focusedElm = angular.element($document[0].activeElement).attr('id');
        if (focusedElm === 'remark') {
          vm.remark = vm.remark + data;
          $scope.$apply();
        }else {
          return;
        }
      });
      var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
        evt.stopPropagation();
        evt.preventDefault();
        $scope.$apply(function(){
          switch (obj.keyCode) {
            case 8:
              //var sel = $window.getSelection();
              //var value = sel.toString().trim();
              //if (value !== '') {
              //  $log.debug('empty:', sel.empty);
              //  vm.remark = '';
              //}else{
              //  vm.remark = vm.remark.slice(0, -1);
              //}
              vm.remark = vm.remark.slice(0, -1);
              break;
            default:
              vm.remark = vm.remark + key;
              break;
          }
        });
      });

      vm.cancel = function() {
         $mdDialog.hide();
      };

      vm.updateCheckOutOrder = function() {
        vm.isUpdateing = "indeterminate";
        var params = {
          form: null,
          status: null,
          remark: vm.remark,
          supplier: vm.selectedSupplier,
          norecord: true
        };
        $log.debug('Update checkout order:', params);
        apiFactory.updateCheckOutOrder(counter.appId, vm.productSN, params, updateOrderSuccess, updateOrderError);
      }

      function updateOrderSuccess(result) {
        $log.log('update abnormal checkout order success');
        vm.isUpdateing = '';
        soundEffectFactory.playSound('decision');
        $mdDialog.hide();
        if (result.status === 'RETURN_OVERDUE')
          showAlertDialog('warning', _translate('msg.mocheckout.update.overdue'), true, 1500);
        else
          showAlertDialog('success', _translate('msg.mocheckout.update.success'), true, 1500);
      }

      function updateOrderError(err) {
        $log.error('update abnormal checkout order failed', err);
        vm.isUpdateing = '';
        var msg = err.error.message || _translate('msg.mocheckout.update.error');
        soundEffectFactory.playSound('warning');
        showAlertDialog('error', msg, false, 1500);

      }
    } //Dialogabnormalctrl

    function searchOrderSuccess(result){
      $log.info('Search checkout order success', result);
      vm.isProcessing.productCode = '';
      vm.isProcessing.queryString = '';

      switch(result.length) {
        case 0:
          //vm.product.productSerialNo = '';
          vm.product.merchantOrderNo = '';
          vm.product.phoneNumber = '';
          vm.queryString = '';
          //toastr.error('查無訂單資料', null);
          vm.multipleProducts = false;
          showAbnormalDialog();
          break;
        case 1:
          vm.products = result;
          vm.product = result[0];
          vm.multipleProducts = false;
          if (vm.product.merchantOrderNo === null) {
            showAbnormalDialog();
          }
          break;
          //if (vm.product.status !== 'READY')
          //  showRemarkFormDialog();
          //break;
        default:  // length > 1, result for search by phonenumber
          vm.products = result;
          vm.product = result[0];
          vm.multipleProducts = true;
          //if (vm.product.status !== 'READY')
          //  showRemarkFormDialog();
          break;
      }
    }

    function searchOrderError(err) {
      $log.error('Search checkout order failed', err);
      vm.isProcessing.productCode = '';
      vm.isProcessing.queryString = '';

      if (err)
        toastr.error(err.error.message || _translate('msg.mocheckout.search.error'), null);
      else
        toastr.error(_translate('msg.mocheckout.search.error'), null);

      vm.product.productSerialNo = '';
      vm.product.merchantOrderNo = '';
      vm.product.phoneNumber = '';
      vm.queryString = '';
    }

    function updateOrderSuccess(result) {
      $log.log('update checkout order success');
      vm.isProcessing.confirmProduct = '';
      soundEffectFactory.playSound('decision');
      if (result.status === 'RETURN_OVERDUE')
        showAlertDialog('warning', _translate('msg.mocheckout.update.overdue'), true, 1500);
      else
        showAlertDialog('success', _translate('msg.mocheckout.update.success'), true, 1500);
    }



    function updateOrderError(err) {
      $log.error('update checkout order failed', err);
      vm.isProcessing.confirmProduct = '';
      var msg = err.error.message || _translate('msg.mocheckout.update.error');
      soundEffectFactory.playSound('warning');
      showAlertDialog('error', msg, false, 1500);
      //if (err)
      //  toastr.error(err.error.message || '無法更新資料', null);
      //else
      //  toastr.error('無法更新資料', null);

    }

  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:mostockCtrl
 * @description
 * # mostockCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('mostockCtrl', function ($scope, $log, $q, $filter, $mdDialog, $sce, toastr, NgTableParams,
    FileUploader, ModalService, apiFactory, counterService) {
    var vm = this;
    var _translate = $filter('translate');
    var counter = counterService.getCounter();
    vm.trustAsHtml = $sce.trustAsHtml;
    //vm.downloadDetail = downloadDetail;
    vm.updateStockIn = updateStockIn;
    vm.getStockInHistory = getStockInHistory;
    //vm.getDetail = getDetail;
    vm.changeQty = changeQty;
    vm.showHistoryByBatchId = showHistoryByBatchId;
    //vm.showDeleteDialog = showDeleteDialog;
    vm.getFilterDataAsync = getFilterDataAsync;
    vm.changeProduct = changeProduct;
    vm.checkTag = checkTag;
    vm.tagToUpperCase = tagToUpperCase;
    vm.uploadFile = uploadFile
    vm.isProcessing = false;
    vm.removable = true;
    vm.products = [];
    vm.productSerialNos = [];
    vm.stocks = [];
    vm.qty = 0;
    vm.currentBatchId = null;
    //vm.currentId = null;

    vm.tableParams = new NgTableParams({
        page: 1,
        count: 1 //initial page size
      }, {
      // page size buttons (right set of buttons in demo)
        counts: [],
        // determines the pager buttons (left set of buttons in demo)
        paginationMaxBlocks: 10,
        getData: function(params) {
          var data = angular.copy(vm.stocks);
          var filterObj = params.filter();
          //var filterObjFinal = [];
          //var filterMatch = [];
          var filterEqual = [];
          // Wordaround for select blank option
          for(var key in filterObj) {

            if(filterObj[key]  !== '') {
              //filterObjFinal[key] = filterObj[key];
               filterEqual[key] = filterObj[key];
              //if (key === 'type' || key === 'operator' || key === 'supplier') {
              //  filterEqual[key] = filterObj[key];
              //}else {
              //  filterMatch[key] = filterObj[key];
              //}
            }
          }

          //var filteredData = $filter('filter')(data, filterObjFinal, true);
          var filteredData = $filter('filter')(data, filterEqual, true);
          //filteredData = $filter('filter')(filteredData, filterMatch);

          var sortObj = params.orderBy();
          var orderedData = $filter('orderBy')(filteredData, sortObj);
          orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());

          //$defer.resolve(vm.products.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          return orderedData;
        }

    });

    vm.uploader = new FileUploader({
        queueLimit: 1,
        //url: 'https://php-ws.iiot.io/import/excel2json',
        url: 'https://ws.wifiotg.com/api/import/excel2json',
        alias: 'excelFile',
        removeAfterUpload: true,
        onSuccessItem: function(item, response){
          $log.log('Upload success', response);
          if (response.uuid) {
            var params = {
              uuid: response.uuid
            }
            apiFactory.importStockIn(counter.id, params, importSuccess, importFail );
          }
        },
        onErrorItem: function(item, response){
          $log.error('Upload failed:', response);
        }
      });

    var filter = {
      supplier: [{id: "", title: ""}],
      type: [{id: "", title: ""}],
      operator: [{id: "", title: ""}]
    };

    var filterInDetail = {
      product: [{id: "", title: ""}],
      supplier: [{id: "", title: ""}],
      operator: [{id: "", title: ""}]
    };


    (function initController(){
      getProducts();
    })();

    $scope.$on('destroy', function(){
      for (var key in filter) {
        filter[key] = null;
      }

      for (key in filterInDetail) {
        filterInDetail[key] = null;
      }

      filter = null;
      filterInDetail = null;
      vm.products = null;
      vm.productSerialNos = null;
      vm.stocks = null;
    });

    function uploadFile(item){
      vm.isProcessing = true;
      vm.uploader.uploadItem(item);
    }
    function getFilterDataAsync(id) {
      return $q.when(filter[id]);
    }

    function changeProduct() {
      vm.productSerialNos.length = 0 ;
    }

    function changeQty() {
      if (vm.productSerialNos.length > vm.qty)
        vm.productSerialNos.length = vm.qty;

    }

    function tagToUpperCase(tag) {
      tag.text = tag.text.toUpperCase();
      return;
    }

    function checkTag(tag){
      if (vm.productSerialNos.indexOf(tag) !== -1) {
        vm.productSerialNos.splice(vm.productSerialNos.length, 1);
      }
    }

    function updateStockIn(){
      var params = {
        product: vm.selectedProduct.product,
        supplier: vm.selectedProduct.supplier,
        serialNos: []
      };

      vm.isProcessing = true;
      vm.stocks.length = 0;
      for(var i=0, len=vm.productSerialNos.length; i<len; i++) {
        params.serialNos.push(vm.productSerialNos[i].text);
      }
      apiFactory.updateStockIn(counter.id, params, updateStockInSuccess, updateStockInFail );
    }

    function getProducts(){
      vm.products.length = 0 ;
      vm.isProcessing = true;
      apiFactory.getStockInProducts(counter.id, getProductsSuccess, getProductsFail );
    }

    function getStockInHistory(){
      vm.stocks.length = 0 ;
      vm.isProcessing = true;
      apiFactory.getStockInHistory(counter.id, null, getStockInSuccess, getStockInFail );
    }

    function showHistoryByBatchId(id){
      vm.isProcessing = true;
      if (id)
        vm.currentBatchId = id;
      var _id = id || vm.currentBatchId;
      $log.debug('batch id:', _id);
      apiFactory.getStockInHistory(counter.id, {batch_id: _id}, getHistorySuccess, getHistoryFail );

    }



    function updateStockInSuccess(result){
      $log.log('Update stockin success:', result);
      //vm.isProcessing = false;
      vm.productSerialNos.length = 0;
      vm.selectedProduct = vm.products[0];
      vm.qty = 0;
      getStockInHistory();
    }


    function updateStockInFail(err) {
      $log.error('Update stockin failed:', err)
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockin.update.error'));
      else
        toastr.error(_translate('msg.mostockin.update.error'));
    }


    function getProductsSuccess(result){
      $log.log('Get products success:', result);
      //vm.isProcessing = false;
      vm.products = result;
      vm.selectedProduct = vm.products[0];
      getStockInHistory();
    }

    function getProductsFail(err) {
      $log.error('Get products failed:', err)
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockin.getProduct.error'));
      else
        toastr.error(_translate('msg.mostockin.getProduct.error'));
      vm.products.length = 0;
    }

    function getStockInSuccess(result){
      $log.log('Get stockin history success:', result);
      vm.stocks = result;
      for (var i=0, len=vm.stocks.length; i<len; i++) {
        var supplier = vm.stocks[i].supplier;
        var operator = vm.stocks[i].operator;
        var type = vm.stocks[i].type;
        //var product = vm.stocks[i].product;
        var isSupplierExist = $filter('filter')(filter.supplier, {id: supplier}, true);
        if (isSupplierExist.length === 0 && supplier !== null) {
          filter.supplier.push({
            id: supplier,
            title: supplier
          });
        }

        var isOperatorExist = $filter('filter')(filter.operator, {id: operator}, true);
        if (isOperatorExist.length === 0 && operator !== null) {
          filter.operator.push({
            id: operator,
            title: operator
          });
        }

        var isTypeExist = $filter('filter')(filter.type, {id: type}, true);
        if (isTypeExist.length === 0 && type !== null) {
          filter.type.push({
            id: type,
            title: type
          });
        }

        //var isProductExist = $filter('filter')(filter.product, {id: product}, true);
        //if (isProductExist.length === 0 && product !== null) {
        //  filter.product.push({
        //    id: product,
        //    title: product
        //  });
        //}

     }

      vm.tableParams.filter({});

      vm.tableParams.count(vm.stocks.length);
      //vm.tableParams.total(vm.stocks.length);
      vm.tableParams.reload();
      vm.tableParams.sorting('updatedTs', 'desc');
      vm.isProcessing = false;

    }

    function getStockInFail(err) {
      $log.error('Get stock in failed:', err)
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockin.getStockin.error'));
      else
        toastr.error(_translate('msg.mostockin.getStockin.error'));
      vm.stocks.length = 0;
    }


    function importSuccess(){
      $log.debug('import success');
      vm.isProcessing = false;
      getStockInHistory();
    }

    function importFail(err){
      $log.debug('import failed');
      if (err)
        toastr.error(err.error.message || _translate('msg.file.import.error'));
      else
        toastr.error(_translate('msg.file.import.error'));
      vm.isProcessing = false;
    }

    function getHistorySuccess(result){
      $log.debug('Get History by bacth ID success:', result);
      for (var key in filterInDetail) {
        filterInDetail[key].length = 1;
      }

      for (var i=0, len=result.length; i<len; i++) {
        var product = result[i].product;
        var supplier = result[i].supplier;
        var operator = result[i].operator;

        var isSupplierExist = $filter('filter')(filterInDetail.supplier, {id: supplier}, true);
        if (isSupplierExist.length === 0 && supplier !== null) {
          filterInDetail.supplier.push({
            id: supplier,
            title: supplier
          });
        }

        var isProductExist = $filter('filter')(filterInDetail.product, {id: product}, true);
        if (isProductExist.length === 0 && product !== null) {
          filterInDetail.product.push({
            id: product,
            title: product
          });
        }

        var isOperatorExist = $filter('filter')(filterInDetail.operator, {id: operator}, true);
        if (isOperatorExist && isOperatorExist.length === 0 && operator !== null) {
          filterInDetail.operator.push({
            id: operator,
            title: operator
          });
        }
      }
      vm.isProcessing = false;

      $mdDialog.show({
        templateUrl: 'app/main/dialog.stockinHistory.html',
        escapeToClose: false,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          data: result,
          batchId: vm.currentBatchId
        },
        controller: DialogHistoryCtrl,
        controllerAs: 'history'
      }).then(function(){
        vm.isProcessing = false;
      });
    }

    function getHistoryFail(err){
      $log.debug('Get History by bacth ID failed');
      vm.currentBatchId = null;
      if (err)
        toastr.error(err.error.message || _translate('msg.mostockin.getHistory.error'));
      else
        toastr.error(_translate('msg.mostockin.getHistory.error'));
      vm.isProcessing = false;
    }


    function DialogHistoryCtrl($scope, $mdDialog, $sce, $log, $filter, FileUploader, NgTableParams, ModalService, toastr, data, batchId, helperFactory, apiFactory) {
      var vm = this;
      vm.isProcessing = false;
      vm.showProductDetail = false;
      vm.trustAsHtml = $sce.trustAsHtml;
      vm.toggleShowProductDetail = toggleShowProductDetail;
      vm.getFilterDataAsync = getFilterDataAsync;
      vm.showCompareDialog = showCompareDialog;
      vm.getDetail = getDetail;
      vm.getStockInDetail = getStockInDetail;
      vm.showDeleteDialog = showDeleteDialog;
      vm.showBatchDeleteDialog = showBatchDeleteDialog;
      vm.downloadDetail = downloadDetail;
      vm.changePageSize = changePageSize;
      vm.selected = [];
      vm.currentItem;
      var tableData = data;
      var detailTableData;
      //var current = null;

      vm.availablePageSizes = [50, 100, 150, 200, 'ALL'];
      vm.selectedPageSize = 'ALL';

      vm.tableParams = new NgTableParams({
          page: 1,
          count: tableData.length //initial page size
        }, {
          counts: [],
          paginationMaxBlocks: 10,
          getData: function(params) {
            var filterObj = params.filter();
            //var filterMatch = [];
            var filterEqual = [];

            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                filterEqual[key] = filterObj[key];

              }
            }

            var filteredData = $filter('filter')(tableData, filterEqual, true);
            //filteredData = $filter('filter')(filteredData, filterMatch);

            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);
            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            return orderedData;
          }
          //dataset: vm.tableData
      });

      vm.cancel = function (){
        $mdDialog.hide();
      }

      // For Compare
      var filterDiff = {
          found: [{id: "", title: ""}]
      };
      vm.getDiffFilterDataAsync = getDiffFilterDataAsync;
      vm.showResult = false;
      //var diffTableData = [];
      vm.diffTableCols = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.product'), field: 'serial_no', show: true, sortable: 'serial_no', filter:{'serial_no': 'text'}, getValue: htmlValue},
        {title: _translate('table.field.status'), field: 'found', show: true, sortable: 'found', filter:{'found': 'select'}, filterData: getDiffFilterDataAsync('found'),  getValue: htmlValue}
      ];


      vm.uploader = new FileUploader({
        queueLimit: 1,
        //url: 'https://php-ws.iiot.io/import/excel2json',
        url: 'https://ws.wifiotg.com/api/import/excel2json',
        alias: 'excelFile',
        //removeAfterUpload: true,
        onSuccessItem: function(item, response){
          $log.log('Upload success', response);
          if (response.uuid) {
            var params = {
              uuid: response.uuid,
              supplier: vm.currentItem.supplier,
              product: vm.currentItem.product
            }
            apiFactory.compareStockIn(counter.id, vm.currentItem.id, params, compareSuccess, compareFail );
          }
        },
        onErrorItem: function(item, response){
          $log.error('Upload failed:', response);
        }
      });

      vm.close = function (){
        $mdDialog.hide();
      }

      vm.uploadFile = function(item){
        //vm.uploader.url = 'https://php-ws.iiot.io:8080/import/excel2json';
        vm.isProcessing = true;
        vm.uploader.uploadItem(item);
      }

      function initDiffTable(data){
        vm.diffTableParams = new NgTableParams({
          page: 1,
          count: data.length //initial page size
        }, {
          counts: [],
          paginationMaxBlocks: 10,
          getData: function(params) {
            //var data = angular.copy(diffTableData);
            var filterObj = params.filter();
            var filterMatch = [];
            var filterEqual = [];

            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                if (key === 'found') {
                  filterEqual[key] = filterObj[key];
                }else {
                  filterMatch[key] = filterObj[key];
                }
              }
            }

            var filteredData = $filter('filter')(data, filterEqual, true);
            filteredData = $filter('filter')(filteredData, filterMatch);
            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);

            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            return orderedData;
          }
        });
      }

      function getDiffFilterDataAsync(id) {
        return $q.when(filterDiff[id]);
      }


      function htmlValue($scope, row, index) {
        var value;
        var html;
        var vm = this;
        switch (vm.field) {
         case '#':
            html = index+1;
            break;
          default:
            value = row[vm.field];
            html = value;
            break;
        }
        return html;
      }

      function compareSuccess(result){
        $log.debug('compare success:', result);
        vm.isProcessing = false;
        vm.showResult = true;
        initDiffTable(result);
        for (var i=0, len=result.length; i<len; i++) {
          var found = result[i].found;
          var isFoundExist = $filter('filter')(filterDiff.found, {id: found});
          if (isFoundExist.length === 0 && found !== null) {
            filterDiff.found.push({
              id: found,
              title: found
            });
          }
        }
      }

      function compareFail(err) {
        $log.error('Compare stock error:', err);
        vm.isProcessing = false;
        vm.showResult = false;
        if (err)
          toastr.error(err.error.message || _translate('msg.mostockin.compare.error'));
        else
          toastr.error(_translate('msg.mostockin.compare.error'));
      }
      //End of Compare

      function getFilterDataAsync(id) {
        return $q.when(filterInDetail[id]);
      }

      function changePageSize(){
        if (vm.selectedPageSize === 'ALL') {
          vm.tableParams.count(tableData.length)
        }else {
          vm.tableParams.count(vm.selectedPageSize);
        }
      }

      function getStockInDetail(item, type){
        if (vm.isProcessing) return;
        vm.isProcessing = true;
        vm.currentItem = item;
        apiFactory.getStockInDetail(counter.id, item.id, type, function(result) {
          getSIDetailSuccess(result, item.id, type);
        }, getSIDetailFail );
      }

      function getDetail(item){
        if (vm.isProcessing) return;
        vm.isProcessing = true;
        vm.currentItem = item;
        apiFactory.getStockInSN(counter.id, item.id, getDetailSuccess, getDetailFail );
      }

      function downloadDetail(id) {
        vm.isProcessing = true;
        apiFactory.getStockInExcel(counter.id, id, function(result){
          $log.info('Get download URL', result);
          var temp = result.downloadURL.split('/');
          var filename = temp[temp.length - 1];
          var link = document.createElement("a");
          link.setAttribute("display",  'none');
          link.setAttribute("href",  result.downloadURL);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF
          link.click(); // This will download the data file named "download_name.pdf"
          link.remove();
          link = null;
          vm.isProcessing = false;
        }, function(err){
          $log.error('Get download URL failed', err);
          toastr.error(_translate('msg.file.download.url.error'));
          vm.isProcessing = false;
        })

      }

      function showDetailDialog(data){
        //$log.log('showDetailDialog', current);

        ModalService.showModal({
          templateUrl: "app/main/modal.stockinDetail.html",
          controller: 'modalstockinCtrl',
          inputs: {
            data: data,
            filterData: filter
          }
        }).then(function(modal) {
          modal.element.modal();
          vm.isProcessing = false;
          modal.close.then(function() {
            vm.currentItem = null;
          });
        });

      }

      function showDeleteDialog(item){
        vm.currentItem = item;
        vm.isProcessing = true;
        ModalService.showModal({
          templateUrl: "app/main/modal.remark.html",
          controller: 'modalremarkCtrl',
          inputs: {
            title: _translate("title.remark")
          }
        }).then(function(modal) {
          modal.element.modal();
          modal.close.then(function(result) {
            if (result.remark)
              apiFactory.deleteStockIn(counter.id, item.id, {remark: result.remark}, deleteStockInSuccess, deleteStockInFail);
          });
          modal.closed.then(function() {
            vm.isProcessing = false;
          });
        });

      }

      function showCompareDialog(item){
        vm.currentItem = item;
        vm.showCompare = true;
        //$mdDialog.show({
        //  templateUrl: 'app/main/dialog.diff.html',
        //  escapeToClose: true,
        //  clickOutsideToClose: false,
        //  fullscreen: true,
        //  locals: {
        //    id: vm.currentItem.id,
        //    supplier: vm.currentItem.supplier,
        //    product: vm.currentItem.product
        //  },
        //  controller: DialogCompareCtrl,
        //  controllerAs: 'diff'
        //}).then(function(){
        //  showHistoryByBatchId();
        //});
      }

      function deleteStockInSuccess(){
        toastr.success(_translate('msg.mostockin.delete.success'));
        tableData = $filter('filter')(tableData, function (item) {
          return item.id !== vm.currentItem.id;
        });
        vm.tableParams.reload();

        vm.isProcessing = false;
      }

      function deleteStockInFail(err){
        if (err)
          toastr.error(err.error.message || _translate('msg.mostockin.delete.error'));
        else
          toastr.error(_translate('msg.mostockin.delete.error'));
        vm.isProcessing = false;

      }

      function getDetailSuccess(result){
        $log.log('Get stockin SN success:', result);
        vm.isProcessing = false;
        if (result.length > 0) {
          showDetailDialog(result);
        }else {
          toastr.warning(_translate('msg.mostockin.getSN.nodata'));
          vm.isProcessing = false;
          //current = null;
        }

      }

      function getDetailFail(err) {
        $log.error('Get stockin SN failed:', err)
        vm.isProcessing = false;
        if (err)
          toastr.error(err.error.message || _translate('msg.mostockin.getSN.error'));
        else
          toastr.error(_translate('msg.mostockin.getSN.error'));
        //current = null;
      }

      function getHistorySuccess(result){
        $log.debug('Get History by bacth ID success:', result);
        tableData = result;
        vm.tableParams.reload();
        vm.isProcessing = false;

      }

      function getHistoryFail(err){
        $log.debug('Get History by bacth ID failed');
        if (err)
          toastr.error(err.error.message || _translate('msg.mostockin.getHistory.error'));
        else
          toastr.error(_translate('msg.mostockin.getHistory.error'));
        vm.isProcessing = false;
      }

      function toggleShowProductDetail(){
        vm.showCompare = false;
        vm.showProductDetail = false;
        vm.showCheckbox = false;
        vm.operatorFilter = [{ id: '', title: ''}];
        vm.selected.length = 0;
        detailTableData = null;
        vm.diffTableParams = null
        vm.detailTableParams = null;
        apiFactory.getStockInHistory(counter.id, {batch_id: batchId}, getHistorySuccess, getHistoryFail );

      }

      vm.toggle = function(item) {
        var idx = vm.selected.indexOf(item);
        if (idx > -1) {
          vm.selected = helperFactory.spliceOne(vm.selected, idx);
        }else {
          vm.selected.push(item);
        }
      }

      vm.exists = function(item) {
        return vm.selected.indexOf(item) > -1;
      }

      vm.isIndeterminate = function() {
        return (vm.selected.length !== 0 &&
                    vm.selected.length !== detailTableData.length);
      }

      vm.isChecked = function() {
        return detailTableData.length > 0 && vm.selected.length === detailTableData.length;
      }

      vm.toggleAll = function() {
        if (vm.selected.length === detailTableData.length) {
          vm.selected.length = 0;
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = detailTableData.slice(0);
        }
      }

      function showBatchDeleteDialog(){
        ModalService.showModal({
          templateUrl: "app/main/modal.remark.html",
          controller: 'modalremarkCtrl',
          inputs: {
            title: _translate("title.remark")
          }
        }).then(function(modal) {
          modal.element.modal();
          modal.close.then(function(result) {
            var serialNoArray = [];
            for (var i=0, len=vm.selected.length; i<len; i++) {
              serialNoArray.push(vm.selected[i].productSerialNo);
            }

            $log.debug('confirmed selected product:', serialNoArray);
            if (result.remark) {
              vm.isProcessing = true;
              apiFactory.batchDeleteStockIn(counter.id, vm.currentItem.id, {serialNos: serialNoArray, remark: result.remark, version: 'v0.4.8'}, deleteStockSuccess, deleteStockFail);
            }
          });
        });
      }

      function deleteStockSuccess(){
        vm.isProcessing = false;
        toastr.success(_translate('msg.mostockin.delete.success'));

        angular.forEach(vm.selected, function(value){
          detailTableData = $filter('filter')(detailTableData, function (item) {
            return item.productSerialNo !== value.productSerialNo;
          });
        })

        vm.selected.length = 0;
        initDetailTable(detailTableData);

      }

      function deleteStockFail(err){
        vm.isProcessing = false;
        var msg = _translate('msg.mostockin.delete.error');

        if (err)
          toastr.error(err.error.message || msg);
        else
          toastr.error(msg);
      }

      function initDetailTable(data) {
        vm.operatorFilter = [{ id: '', title: ''}];
        detailTableData = data;

        for (var i=0, len=data.length; i<len; i++) {
          var operator = data[i].operator;
          var isOperatorExist = $filter('filter')(vm.operatorFilter, {id: operator}, true);
          if (isOperatorExist.length === 0 && operator !== null) {
            vm.operatorFilter.push({
              id: operator,
              title: operator
            });
          }
        }
        vm.detailTableParams = new NgTableParams({
          page: 1,
          count: data.length //initial page size
        }, {
          // page size buttons (right set of buttons in demo)
          counts: [],
          // determines the pager buttons (left set of buttons in demo)
          paginationMaxBlocks: 10,
          getData: function(params) {
            var filterObj = params.filter();
            var filterMatch = [];
            var filterEqual = [];

            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                if (key === 'product' || key === 'supplier' || key === 'operator') {
                  filterEqual[key] = filterObj[key];
                }else {
                  filterMatch[key] = filterObj[key];
                }
              }
            }

            var filteredData = $filter('filter')(data, filterEqual, true);
            filteredData = $filter('filter')(filteredData, filterMatch);

            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);

            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            return orderedData;
          }

        });
      }

      function getSIDetailSuccess(result, id, type){
        $log.log('Get stockin detail success:', result);
        vm.isProcessing = false;
        if (result.length > 0) {
          vm.showProductDetail = true;

          var tableData = $filter('filter')(result, {
            supplier: vm.currentItem.supplier,
            product: vm.currentItem.product}, true);

          initDetailTable(tableData, id);

          if (type === 'stock')
            vm.showCheckbox = true;
          else
            vm.showCheckbox = false
        }else {
          toastr.warning(_translate('msg.mostockin.getDetail.nodata'));
          vm.isProcessing = false;
          vm.showProductDetail = false;
        }

      }

      function getSIDetailFail(err) {
        $log.error('Get stockin detail failed:', err)
        vm.isProcessing = false;
        vm.showProductDetail = false;
        if (err)
          toastr.error(err.error.message || _translate('msg.mostockin.getDetail.error'));
        else
          toastr.error(_translate('msg.mostockin.getDetail.error'));
      }
    } // End of DialogHistoryCtrl


    //function DialogCompareCtrl($scope, $mdDialog, $log, toastr, FileUploader, NgTableParams, id, supplier, product) {
    //  var vm = this;
    //  var filter = {
    //    found: [{id: "", title: ""}]
    //  };
    //  vm.isProcessing = false;
    //  vm.showResult = false;
    //  vm.tableData = [];
    //  vm.cols = [
    //    {title: '#', field:'#', show:true, getValue: htmlValue},
    //    {title: '產品', field: 'serial_no', show: true, sortable: 'serial_no', filter:{'serial_no': 'text'}, getValue: htmlValue},
    //    {title: '狀態', field: 'found', show: true, sortable: 'found', filter:{'found': 'select'}, filterData: getFilterDataAsync('found'),  getValue: htmlValue}
    //  ];
    //  vm.tableParams = new NgTableParams({
    //      page: 1,
    //      count: 10 //initial page size
    //    }, {
    //      counts: [],
    //      paginationMaxBlocks: 10,
    //      getData: function(params) {
    //        var data = angular.copy(vm.tableData);
    //        var filterObj = params.filter();
    //        //var filterObjFinal = [];
    //        var filterMatch = [];
    //        var filterEqual = [];
    //
    //        for(var key in filterObj) {
    //
    //          if(filterObj[key]  !== '') {
    //            //filterObjFinal[key] = filterObj[key];
    //            if (key === 'found') {
    //              filterEqual[key] = filterObj[key];
    //            }else {
    //              filterMatch[key] = filterObj[key];
    //            }
    //          }
    //        }
    //
    //        //var filteredData = $filter('filter')(data, filterObjFinal, true);
    //        var filteredData = $filter('filter')(data, filterEqual, true);
    //        filteredData = $filter('filter')(filteredData, filterMatch);
    //        var sortObj = params.orderBy();
    //        var orderedData = $filter('orderBy')(filteredData, sortObj);
    //
    //        orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
    //        return orderedData;
    //      }
    //  });
    //
    //  vm.uploader = new FileUploader({
    //    //queueLimit: 1,
    //    url: 'https://php-ws.iiot.io/import/excel2json',
    //    alias: 'excelFile',
    //    //removeAfterUpload: true,
    //    onSuccessItem: function(item, response){
    //      $log.log('Upload success', response);
    //      if (response.uuid) {
    //        var params = {
    //          uuid: response.uuid,
    //          supplier: supplier,
    //          product: product
    //        }
    //        apiFactory.compareStockIn(counter.id, id, params, compareSuccess, compareFail );
    //      }
    //    },
    //    onErrorItem: function(item, response){
    //      $log.error('Upload failed:', response);
    //    }
    //  });
    //
    //  vm.close = function (){
    //    $mdDialog.hide();
    //  }
    //
    //  vm.uploadFile = function(item){
    //    //vm.uploader.url = 'https://php-ws.iiot.io:8080/import/excel2json';
    //    vm.isProcessing = true;
    //    vm.uploader.uploadItem(item);
    //  }
    //
    //  function getFilterDataAsync(id) {
    //    return $q.when(filter[id]);
    //  }
    //
    //
    //  function htmlValue($scope, row, index) {
    //    var value;
    //    var html;
    //    var vm = this;
    //    switch (vm.field) {
    //     case '#':
    //        html = index+1;
    //        break;
    //      default:
    //        value = row[vm.field];
    //        html = value;
    //        break;
    //    }
    //    return html;
    //  }
    //
    //  function compareSuccess(result){
    //    vm.isProcessing = false;
    //    vm.showResult = true;
    //    vm.tableData = result;
    //    vm.tableParams.total(vm.tableData.length);
    //    vm.tableParams.reload();
    //    vm.tableParams.count(vm.tableData.length);
    //    for (var i=0, len=vm.tableData.length; i<len; i++) {
    //      var found = vm.tableData[i].found;
    //      var isFoundExist = $filter('filter')(filter.found, {id: found});
    //      if (isFoundExist.length === 0 && found !== null) {
    //        filter.found.push({
    //          id: found,
    //          title: found
    //        });
    //      }
    //    }
    //  }
    //
    //  function compareFail(err) {
    //    $log.error('Compare stock error:', err);
    //    vm.isProcessing = false;
    //    vm.showResult = false;
    //    if (err)
    //      toastr.error(err.error.message || '無法分析差異資料');
    //    else
    //      toastr.error('無法分析差異資料');
    //  }
    //}

    //function DialogStockInDetailController($log, $scope, $sce, $mdDialog, data, NgTableParams, apiFactory ){
    //    var vm = this;
    //    vm.trustAsHtml = $sce.trustAsHtml;
    //    var tableData = data;
    //
    //    vm.tableParams = new NgTableParams({
    //      page: 1,
    //      count: tableData.length //initial page size
    //    }, {
    //      // page size buttons (right set of buttons in demo)
    //      counts: [],
    //      // determines the pager buttons (left set of buttons in demo)
    //      paginationMaxBlocks: 10,
    //      getData: function(params) {
    //        var data = angular.copy(vm.tableData);
    //        var filterObj = params.filter();
    //        var filterMatch = [];
    //        var filterEqual = [];
    //
    //        for(var key in filterObj) {
    //          if(filterObj[key]  !== '') {
    //            if (key === 'product' || key === 'supplier' || key === 'operator') {
    //              filterEqual[key] = filterObj[key];
    //            }else {
    //              filterMatch[key] = filterObj[key];
    //            }
    //          }
    //        }
    //
    //        var filteredData = $filter('filter')(tableData, filterEqual, true);
    //        filteredData = $filter('filter')(filteredData, filterMatch);
    //
    //        var sortObj = params.orderBy();
    //        var orderedData = $filter('orderBy')(filteredData, sortObj);
    //
    //        orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
    //        return orderedData;
    //      }
    //
    //    });
    //    vm.close = function() {
    //      $mdDialog.hide();
    //    }
    //  }

  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:menuCtrl
 * @description
 * # menuCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('menuCtrl', function ($scope, $localStorage, $window, $state, $log, $mdDialog, toastr, rewardsFactory) {
      var vm = this;
      (function initController() {
        var acl = $localStorage.user.acl[0].tpos;
        //vm.currentACL = acl.filter(function (el) {
        //    return el.businessId === $localStorage.business.id;
        //});
        vm.currentACL = acl;
        var aclLength = vm.currentACL.length;
        vm.gridItems = {
           md: (aclLength > 4)? 4: vm.currentACL.length,
           lg: (aclLength > 8)? 8: vm.currentACL.length,
           flex: Math.min(aclLength * 25, 100)
        }
      })();


      rewardsFactory.clear();
      rewardsFactory.clearDynamicReward()

      //vm.disable = {
      //  mocheckin: false,
      //  mocheckout: false
      //};

      vm.checkAuth = function(action) {
        //var el = vm.currentACL[0];
        //if (el.hasOwnProperty(action) && el[action][0] === "*")
        //  return true;
        //else
        //  return false;
        return (vm.currentACL.indexOf(action) > -1);

      }

      vm.redirect = function (path) {
        $state.go(path);
      }

      vm.openPpos = function(){
        //$window.open('https://event-dev.iiot.io/p', '_blank');
        $window.open('/p', '_blank');
      }
      
      vm.getDynamicRewardList = function(redirectPath) {
        $mdDialog.show({
          controller: DialogDRCtrl,
          templateUrl: "app/main/dialog.dynamicReward.html",
          controllerAs: 'dCtrl',
          fullscreen: false
        }).then(function(answer){
            $log.log('Select item:', answer);
            if (angular.isDefined(answer)) {
              rewardsFactory.setDynamicReward(answer);
              $state.go(redirectPath);
            }
        }, function(){
            $log.debug('Do not select item');
            //toastr.warning('請選擇動態核銷項目');
        })

        //rewardsFactory.getDynamicRewardList()
        //  .then(function(result){
        //    if (result.length > 0) {
        //      $mdDialog.show({
        //        controller: DialogDRCtrl,
        //        templateUrl: "app/main/dialog.dynamicReward.html",
        //        locals: {
        //          items: result //Should be an array.
        //        },
        //        controllerAs: 'dCtrl',
        //        fullscreen: false
        //      }).then(function(answer){
        //          $log.log('Select item:', answer);
        //          if (angular.isDefined(answer)) {
        //            rewardsFactory.setDynamicReward(answer);
        //            $state.go(redirectPath);
        //          }
        //      }, function(){
        //          $log.debug('Do not select item');
        //          //toastr.warning('請選擇動態核銷項目');
        //      })
        //    }else {
        //      toastr.warning('無動態核銷項目');
        //    }

        //  }, function(){
        //    toastr.warning('無法取得動態核銷項目');
        //  });


      }

      /**
      * A controller for the dialog that selects
      * target dynamic redeem item.
      */
      function DialogDRCtrl($scope, $mdDialog){
        var vm = this;
        vm.isProcessing = 'indeterminate';
        (function initController() {

           rewardsFactory.getDynamicRewardList()
           .then(function(result){
             if (result.length > 0) {
               vm.isProcessing = '';
               vm.selectedItem = result[0];
               vm.items = result;
             }else {
               $mdDialog.cancel();
               toastr.warning('無動態核銷項目');
             }
           }, function(){
             toastr.warning('無法取得動態核銷項目');
             $mdDialog.cancel();
           })
        })();



        //vm.selectedItem = items[0];
        //vm.items = items;
        vm.answer = function(){
            if(! vm.selectedItem || !("id" in vm.selectedItem))//If no selection made.
                $mdDialog.cancel();
            else
                $mdDialog.hide(vm.selectedItem);
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };
      }

  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:moreportCtrl
 * @description
 * # moreportCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('moreportCtrl', function ($scope, $log, $filter, $q, $sce, NgTableParams, toastr, $mdDialog, 
    apiFactory, counterService) {
    var vm = this;
    var _translate = $filter('translate');
    var counter = counterService.getCounter();
    vm.trustAsHtml = $sce.trustAsHtml;
    vm.changePageSize = changePageSize;
    //vm.getReports = getReports;
    vm.getDashBoard = getDashBoard;
    vm.onTabChanges = onTabChanges;
    vm.getDetail = getDetail;
    vm.getFilterDataAsync = getFilterDataAsync;
    //vm.showCompareDialog = showCompareDialog;
    vm.getIndex = getIndex;
    vm.selectedIndex = 0;
    vm.tableData = [];
    vm.isProcessing = false;
    vm.availablePageSizes = [50, 100, 150, 200, 'ALL'];
    vm.selectedPageSize = 'ALL';
    //For filter data with type select, null will be filter always
    var filter = {
      product: [{id: "", title: ""}],
      supplier: [{id: "", title: ""}]
    };

    var filterInDetail = {
      product: [{id: "", title: ""}],
      supplier: [{id: "", title: ""}],
      operator: [{id: "", title: ""}],
      status: [{id: "", title: ""}]
      //stockinOperator: [{id: "", title: ""}]
    };


    (function initController(){
      //getReports();
      //initTable();
      onTabChanges(0);
    })();

    $scope.$on('destroy', function(){
      for (var key in filter) {
        filter[key] = null;
        filterInDetail[key] = null;
      }
      filter = null;
      filterInDetail = null;
      vm.tableData = null;
    });

    function resetFilter(){
      for (var key in filter) {
        if (filter[key])
          filter[key].length = 1;
        //filterInDetail[key].length = 1;
      }
      
      for (key in filterInDetail) {
        if (filterInDetail[key])
          filterInDetail[key].length = 1;
      }
    }

    function getFilterDataAsync(id) {
      filter[id] = $filter('orderBy')(filter[id], ["+id"]);
      return $q.when(filter[id]);
      
    }

    function changePageSize(){
      $log.debug('change page size:', vm.selectedPageSize);
      if (vm.selectedPageSize === 'ALL') {
        vm.tableParams.count(vm.tableData.length);
      }else {
        vm.tableParams.count(vm.selectedPageSize);
      }
    }
  
    function getIndex(idx) {
      if (vm.selectedPageSize === 'ALL')
        return idx + 1;
      else
        return (vm.tableParams.page()-1) * vm.selectedPageSize + (idx+1);
    }
    
    function onTabChanges(tabIndex){
      vm.selectedIndex = tabIndex;
      resetFilter();
      if (vm.tableParams) {
        vm.tableParams.settings().dataset = [];
        vm.tableParams.reload();
      }
      initTable();
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
          page: 1,
          count: vm.selectedPageSize, //initial page size
          sorting: { departureDate: "asc" } 
        }, {
          // page size buttons (right set of buttons in demo)
          counts: [],
          // determines the pager buttons (left set of buttons in demo)
          paginationMaxBlocks: 10,
          getData: function(params) {
            var data = angular.copy(vm.tableData);
            var filterObj = params.filter();
            //var filterObjFinal = [];
            var filterMatch = [];
            var filterEqual = [];
          
            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                //filterObjFinal[key] = filterObj[key];
                if (key === 'product' || key === 'supplier' ) {
                  filterEqual[key] = filterObj[key];
                }else {
                  filterMatch[key] = filterObj[key];
                }
              }
            }

            //var filteredData = $filter('filter')(data, filterObjFinal, true);
            var filteredData = $filter('filter')(data, filterEqual, true);
            filteredData = $filter('filter')(filteredData, filterMatch);
          
            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);

            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            return orderedData;
          }

      });

      getDashBoard();
    }

    function getDashBoard() {
      vm.tableData.length = 0;
      vm.isProcessing = true;
      switch(vm.selectedIndex) {
        //case 0: //'stockin':
        //  apiFactory.getDashBoardStockIn(counter.id, getDashBoardSuccess, getDashBoardFail );
        //  break;
        case 0: //'pickup':
          apiFactory.getDashBoardPickup(counter.id, getDashBoardSuccess, getDashBoardFail );
          apiFactory.getDashBoardTodayPickup(counter.id, getTodayPickupSuccess, getTodayPickupFail );
          break;
        case 1://'return':
          apiFactory.getDashBoardReturn(counter.id, getDashBoardSuccess, getDashBoardFail );
          break;
        case 2: //'stock':
          apiFactory.getDashBoardStock(counter.id, getDashBoardSuccess, getDashBoardFail );
          break;
        default:
          break;
      }
    }


    //function getReports() {
    //  vm.products.length = 0;
    //  vm.isProcessing = true;
    //  apiFactory.getReports(counter.id, getReportsSuccess, getReportsFail );
    //}

    function getDetail(type, item) {
      vm.selectedDetailItem = item;
      switch(type) {
        //Checkin
        case 'reservation':
          $log.debug('reservation');
          apiFactory.getReportReservation(counter.id, {departure_date: item.departureDate}, function (result){ getDetailSuccess(result, 'reservation')}, getDetailFail );
          break;
        case 'ready':
          $log.debug('ready');
          //apiFactory.getReportReady(counter.id, null , getDetailReadySuccess, getDetailFail );
          apiFactory.getReportReady(counter.id, {departure_date: item.departureDate}, function (result){ getDetailSuccess(result, 'ready')}, getDetailFail );
          break;
        case 'pickup':
          $log.debug('pickup');
          apiFactory.getReportPickup(counter.id, {departure_date: item.departureDate}, function (result){ getDetailSuccess(result, 'pickup')}, getDetailFail );
          break;
        case 'agency':
          $log.debug('agency');
          apiFactory.getReportAgency(counter.id, {departure_date: item.departureDate}, function (result){ getDetailSuccess(result, 'agency')}, getDetailFail );
          break;
        case 'today-pickup':
          $log.debug('today-pickup');
          apiFactory.getReportTodayPickup(counter.id, null, function (result){ getDetailSuccess(result, 'today-pickup')}, getDetailFail );
          break;
        case 'today-agency':
          $log.debug('today-agency');
          apiFactory.getReportTodayAgency(counter.id, null, function (result){ getDetailSuccess(result, 'today-agency')}, getDetailFail );
          break;
        case 'other':
          $log.debug('other');
          apiFactory.getReportOther(counter.id, {departure_date: item.departureDate}, function (result){ getDetailSuccess(result, 'other')}, getDetailFail );
          break;
        //Checkout
        case 'return':
          $log.debug('return');
          //apiFactory.getReportReturn(counter.id, null, getDetailReturnSuccess, getDetailFail );
          apiFactory.getReportReturn(counter.id, null, function (result){ getDetailSuccess(result, 'return')}, getDetailFail );
          break;
        case 'norecord':
          $log.debug('norecord');
          apiFactory.getReportNorecord(counter.id, null, function (result){ getDetailSuccess(result, 'norecord')}, getDetailFail );
          break;
        //Stock
        case 'stockin':
          $log.debug('stockin');
          apiFactory.getReportStockIn(counter.id, null, function (result){ getDetailSuccess(result, 'stockin')}, getDetailFail );
          break;
        case 'stock':
          $log.debug('stock');
          apiFactory.getReportStock(counter.id, null, function (result){ getDetailSuccess(result, 'stock')}, getDetailFail );
          break;
        case 'stockout':
          $log.debug('stockout');
          apiFactory.getReportStockOut(counter.id, null, function (result){ getDetailSuccess(result, 'stockout')}, getDetailFail );
          break;
        default:
          break;
      }
    }

    function getDetailSuccess(result, type) {
      $log.debug('[moreport] Get detail - ' + type + ' - success', result);
      if (result.length > 0) {
        showDetail(type, result);
        // filter data;
        for (var key in filterInDetail) {
          filterInDetail[key].length = 1;
        }
        //filterInDetail = {
        //  product: [{id: "", title: ""}],
        //  supplier: [{id: "", title: ""}],
        //  operator: [{id: "", title: ""}],
        //  stockinOperator: [{id:"", title: ""}]
        //};
        for (var i=0, len=result.length; i<len; i++) {
          var product = result[i].product;
          var supplier = result[i].supplier;
          var operator = result[i].operator;
          var status = result[i].status;
          //var departureDate = result[i].departureDate;
          //var stockinOperator = result[i].stockinOperator;
          var isSupplierExist = $filter('filter')(filterInDetail.supplier, {id: supplier}, true);
          if (isSupplierExist.length === 0 && supplier !== null) {
            filterInDetail.supplier.push({
              id: supplier,
              title: supplier
            });
          }

          var isProductExist = $filter('filter')(filterInDetail.product, {id: product}, true);
          if (isProductExist.length === 0 && product !== null) {
            filterInDetail.product.push({
              id: product,
              title: product
            });
          }

          var isOperatorExist = $filter('filter')(filterInDetail.operator, {id: operator}, true);
          if (isOperatorExist && isOperatorExist.length === 0 && operator !== null) {
            filterInDetail.operator.push({
              id: operator,
              title: operator
            });
          }

          var isStatusExist = $filter('filter')(filterInDetail.status, {id: status}, true);
          if (isStatusExist && isStatusExist.length === 0 && status !== null) {
            filterInDetail.status.push({
              id: status,
              title: status
            });
          }

          //var isDepartureDateExist = $filter('filter')(filterInDetail.departureDate, {id: departureDate});
          //if (isDepartureDateExist && isDepartureDateExist.length === 0 && departureDate !== null) {
          //  filterInDetail.departureDate.push({
          //    id: departureDate,
          //    title: departureDate
          //  });
          //}

          //var isStockinOperatorExist = $filter('filter')(filterInDetail.stockinOperator, {id: stockinOperator});
          //if (isStockinOperatorExist && isStockinOperatorExist.length === 0 && stockinOperator !== null) {
          //  filterInDetail.stockinOperator.push({
          //    id: stockinOperator,
          //    title: stockinOperator
          //  });
          //}
        }


      }else {
        toastr.warning(_translate('msg.moreport.getDetail.nodata'));
      }
    }

    //function showCompareDialog(supplier, product){
    //  // prevent double click to open dialog twice
    //  var isDialogOpen = (angular.element(document).find('md-dialog').length > 0) ? true : false;
    //  if (isDialogOpen) return;
    //
    //   $mdDialog.show({
    //    templateUrl: 'app/main/dialog.compare.html',
    //    escapeToClose: true,
    //    clickOutsideToClose: false,
    //    fullscreen: true,
    //    locals: {
    //      supplier: supplier,
    //      product: product
    //    },
    //    controller: DialogCompareCtrl,
    //    controllerAs: 'diff'
    //  });
    //
    //}
    //
    //function DialogCompareCtrl($scope, $mdDialog, $log, toastr, FileUploader, NgTableParams, supplier, product) {
    //  var vm = this;
    //  var filter = {
    //    found: [{id: "", title: ""}]
    //  };
    //  vm.isProcessing = false;
    //  vm.showResult = false;
    //  vm.tableData = [];
    //  vm.cols = [
    //    {title: '#', field:'#', show:true, getValue: htmlValue},
    //    {title: '產品', field: 'serial_no', show: true, sortable: 'serial_no', filter:{'serial_no': 'text'}, getValue: htmlValue},
    //    {title: '狀態', field: 'found', show: true, sortable: 'found', filter:{'found': 'select'}, filterData: getFilterDataAsync('found'),  getValue: htmlValue}
    //  ];
    //  vm.tableParams = new NgTableParams({
    //      page: 1,
    //      count: 10 //initial page size
    //    }, {
    //      counts: [],
    //      paginationMaxBlocks: 10,
    //      getData: function(params) {
    //        var data = angular.copy(vm.tableData);
    //        var filterObj = params.filter();
    //        //var filterObjFinal = [];
    //        var filterMatch = [];
    //        var filterEqual = [];
    //      
    //        for(var key in filterObj) {
    //          
    //          if(filterObj[key]  !== '') {
    //            //filterObjFinal[key] = filterObj[key];
    //            if (key === 'found') {
    //              filterEqual[key] = filterObj[key];
    //            }else {
    //              filterMatch[key] = filterObj[key];
    //            }
    //          }
    //        }
    //
    //        //var filteredData = $filter('filter')(data, filterObjFinal, true);
    //        var filteredData = $filter('filter')(data, filterEqual, true);
    //        filteredData = $filter('filter')(filteredData, filterMatch);
    //        var sortObj = params.orderBy();
    //        var orderedData = $filter('orderBy')(filteredData, sortObj);
    //
    //        orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
    //        return orderedData;
    //      }
    //  });
    //
    //  vm.uploader = new FileUploader({
    //    //queueLimit: 1,
    //    url: 'https://php-ws.iiot.io/import/excel2json',
    //    alias: 'excelFile',
    //    //removeAfterUpload: true,
    //    onSuccessItem: function(item, response){
    //      $log.log('Upload success', response);
    //      if (response.uuid) {
    //        var params = {
    //          uuid: response.uuid,
    //          supplier: supplier,
    //          product: product
    //        }
    //        apiFactory.compareStock(counter.id, params, compareSuccess, compareFail );
    //      }
    //    },
    //    onErrorItem: function(item, response){
    //      $log.error('Upload failed:', response);
    //    }
    //  });
    //
    //  vm.close = function (){
    //    $mdDialog.cancel();
    //  }
    //
    //  vm.uploadFile = function(item){
    //    //vm.uploader.url = 'https://php-ws.iiot.io:8080/import/excel2json';
    //    vm.isProcessing = true;
    //    vm.uploader.uploadItem(item);
    //  }
    //
    //  function getFilterDataAsync(id) {
    //    return $q.when(filter[id]);
    //  }
    //
    //
    //  function htmlValue($scope, row, index) {
    //    var value;
    //    var html;
    //    var vm = this;
    //    switch (vm.field) {
    //     case '#':
    //        html = index+1;
    //        break;
    //      default:
    //        value = row[vm.field];
    //        html = value;
    //        break;
    //    }
    //    return html;
    //  }
    //
    //  function compareSuccess(result){
    //    vm.isProcessing = false;
    //    vm.showResult = true;
    //    vm.tableData = result;
    //    vm.tableParams.total(vm.tableData.length);
    //    vm.tableParams.reload();
    //    vm.tableParams.count(vm.tableData.length);
    //    for (var i=0, len=vm.tableData.length; i<len; i++) {
    //      var found = vm.tableData[i].found;
    //      var isFoundExist = $filter('filter')(filter.found, {id: found});
    //      if (isFoundExist.length === 0 && found !== null) {
    //        filter.found.push({
    //          id: found,
    //          title: found
    //        });
    //      }
    //    }
    //  }
    //
    //  function compareFail(err) {
    //    $log.error('Compare stock error:', err);
    //    vm.isProcessing = false;
    //    vm.showResult = false;
    //    if (err)
    //      toastr.error(err.error.message || '無法分析差異資料');
    //    else
    //      toastr.error('無法分析差異資料');
    //  }
    //}

    function showDetail(type, data){
      // prevent double click to open dialog twice
      var isDialogOpen = (angular.element(document).find('md-dialog').length > 0) ? true : false;
      if (isDialogOpen) return;

      $mdDialog.show({
        templateUrl: 'app/main/dialog.detail.html',
        escapeToClose: true,
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          type: type,
          data: data,
          item: vm.selectedDetailItem
        },
        controller: DialogDetailCtrl,
        controllerAs: 'detail'
      }).then(function(result){
        if (result)
          vm.getDashBoard();
        //vm.selectedDetailItem = null;
      });

    }

    function DialogDetailCtrl($scope, $mdDialog, $sce, $log, NgTableParams, ModalService, toastr, type, data, item, helperFactory) {
      var vm = this;
      vm.selected = [];
      vm.isProcessing = false;
      vm.category = item;
      vm.type = type;
      vm.changePageSize = changePageSize;
      vm.showDeleteDialog = showDeleteDialog;
      var deleteProduct = false;
      var tableData = data;
      vm.orderedTableData = data;
      vm.currentTableData = data;
      //vm.total = data.length;
      var colReady = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.order'), field: 'merchantOrderNo', show: true, sortable: 'merchantOrderNo', filter: {merchantOrderNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.departure.time'), field: 'departureTime', show: true, sortable: 'departureTime', getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        //{title: '產品', field: 'product', show: true, sortable: 'product', filter: {product: "select"}, filterData: getFilterDataAsync('product'), getValue: htmlValue},
        //{title: '領機日期', field: 'departureDate', show: true, sortable: 'departureDate', filter: {departureDate: "select"}, filterData: getFilterDataAsync('departureDate'), getValue: htmlValue},
        {title: _translate('table.field.quantity'), field: 'qty', show: true, sortable: 'qty', getValue: htmlValue},
        {title: _translate('table.field.lastUpdate'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue }
      ];
      var colPickup = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.order'), field: 'merchantOrderNo', show: true, sortable: 'merchantOrderNo', filter: {merchantOrderNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        //{title: '產品', field: 'product', show: true, sortable: 'product', filter: {product: "select"}, filterData: getFilterDataAsync('product'), getValue: htmlValue},
        //{title: '領機日期', field: 'departureDate', show: true, sortable: 'departureDate', filter: {departureDate: "select"}, filterData: getFilterDataAsync('departureDate'), getValue: htmlValue},
        {title: _translate('table.field.productSN'), field: 'productSerialNo', show: true, sortable: 'productSerialNo', filter: {productSerialNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.operator.pickup'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.status'), field: 'status', show: true, sortable: 'status', filter: {status: "select"}, filterData: getFilterDataAsync('status'), getValue: htmlValue},
        {title: _translate('table.field.remark'), field: 'remark', show: true, getValue: htmlValue},
        {title: _translate('table.field.lastUpdate'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue}
      ];
      var colReturn = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.order'), field: 'merchantOrderNo', show: true, sortable: 'merchantOrderNo', filter: {merchantOrderNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        {title: _translate('table.field.productSN'), field: 'productSerialNo', show: true, sortable: 'productSerialNo', filter: {productSerialNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.operator.return'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.status'), field: 'status', show: true, sortable: 'status', filter: {status: "select"}, filterData: getFilterDataAsync('status'), getValue: htmlValue},
        {title: _translate('table.field.remark'), field: 'remark', show: true, getValue: htmlValue},
        {title: _translate('table.field.lastUpdate'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue}
      ];
      var colNoRecord = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.order'), field: 'merchantOrderNo', show: true, sortable: 'merchantOrderNo', filter: {merchantOrderNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        {title: _translate('table.field.productSN'), field: 'productSerialNo', show: true, sortable: 'productSerialNo', filter: {productSerialNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.operator.return'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.status'), field: 'status', show: true, sortable: 'status', getValue: htmlValue},
        {title: _translate('table.field.remark'), field: 'remark', show: true, getValue: htmlValue},
        {title: _translate('table.field.lastUpdate'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue},
        {title: ' ', field: 'deleteProduct', show: true, getValue: htmlValue}
      ];
      var colStockIn = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        {title: _translate('table.field.product'), field: 'product', show: true, sortable: 'product', filter: {product: "select"}, filterData: getFilterDataAsync('product'), getValue: htmlValue},
        {title: _translate('table.field.operator'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.quantity'), field: 'count', show: true, getValue: htmlValue},
        {title: _translate('table.field.lastUpdate'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue}
      ];
      var colStockOut = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        {title: _translate('table.field.operator.stockout'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.productSN'), field: 'productSerialNo', show: true, sortable: 'productSerialNo', getValue: htmlValue},
        {title: _translate('table.field.stockout.time'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue}
      ];
      var colStock = [
        {title: '#', field:'#', show:true, getValue: htmlValue},
        {title: _translate('table.field.supplier'), field: 'supplier', show: true, sortable: 'supplier', filter: {supplier: "select"}, filterData: getFilterDataAsync('supplier'), getValue: htmlValue},
        {title: _translate('table.field.product'), field: 'product', show: true, sortable: 'product', filter: {product: "select"}, filterData: getFilterDataAsync('product'), getValue: htmlValue},
        {title: _translate('table.field.operator.stockin'), field: 'operator', show: true, sortable: 'operator', filter: {operator: "select"}, filterData: getFilterDataAsync('operator'), getValue: htmlValue},
        {title: _translate('table.field.productSN'), field: 'productSerialNo', show: true, sortable: 'productSerialNo', filter: {productSerialNo: "text"}, getValue: htmlValue},
        {title: _translate('table.field.stockin.time'), field: 'updatedTs', show: true, sortable: 'updatedTs', getValue: htmlValue}
        //{title: ' ', field: 'deleteProduct', show: true, getValue: htmlValue}
      ];


      vm.availablePageSizes = [50, 100, 150, 200, 'ALL'];
      vm.selectedPageSize = 'ALL';
      switch(type) {
        case 'reservation':
          vm.title = _translate('title.moreport.reservation'); //"待領機明細資料";
          vm.cols = colReady;
          apiFactory.getExcelReservation(counter.id, {departure_date: item.departureDate}, getExcelSuccess, getExcelFail );
          break;
        case 'ready':
          vm.title = _translate('title.moreport.ready'); //"待領機明細資料";
          vm.cols = colReady;
          apiFactory.getExcelReady(counter.id, {departure_date: item.departureDate}, getExcelSuccess, getExcelFail );
          break;
        case 'pickup':
          vm.title = _translate('title.moreport.pickup'); //"已領機明細資料";
          vm.cols = colPickup;
          apiFactory.getExcelPickup(counter.id, {departure_date: item.departureDate}, getExcelSuccess, getExcelFail );
          break;
        case 'agency':
          vm.title = _translate('title.moreport.agency'); //"換航廈明細資料";
          vm.cols = colPickup;
          apiFactory.getExcelAgency(counter.id, {departure_date: item.departureDate}, getExcelSuccess, getExcelFail );
          //vm.cols = colAgency;
          break;
        case 'today-pickup':
          vm.title = _translate('title.moreport.today.pickup'); //"今日總領機明細資料";
          vm.cols = colPickup;
          apiFactory.getExcelPickup(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        case 'today-agency':
          vm.title = _translate('title.moreport.today.agency'); //"今日換航廈明細資料";
          vm.cols = colPickup;
          apiFactory.getExcelAgency(counter.id, null, getExcelSuccess, getExcelFail );
          //vm.cols = colAgency;
          break;
        case 'other':
          vm.title = _translate('title.moreport.other'); //"其它領機明細資料";
          vm.cols = colPickup;
          apiFactory.getExcelOther(counter.id, {departure_date: item.departureDate}, getExcelSuccess, getExcelFail );
          //vm.cols = colAgency;
          break;
        case 'return':
          vm.title = _translate('title.moreport.return'); //"總還機明細資料";
          vm.cols = colReturn;
          apiFactory.getExcelReturn(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        case 'norecord':
          vm.title = _translate('title.moreport.norecord'); //"異常還機明細資料";
          tableData = $filter('filter')(tableData, {norecord: 1});
          vm.cols = colNoRecord;
          //vm.cols.push(
          //  {title: ' ', 
          //  field: 'deleteProduct', 
          //  show: true, 
          //  getValue: htmlValue});
          apiFactory.getExcelReturn(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        case 'stockin':
          vm.title = _translate('title.moreport.stockin'); //"入庫明細資料";
          vm.cols = colStockIn;
          apiFactory.getExcelStockIn(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        case 'stock':
          vm.title = _translate('title.moreport.stock'); //"庫存明細資料";
          vm.cols = colStock;
          apiFactory.getExcelStock(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        case 'stockout':
          vm.title = _translate('title.moreport.stockout'); //"出庫明細資料";
          vm.cols = colStockOut;
          apiFactory.getExcelStockOut(counter.id, null, getExcelSuccess, getExcelFail );
          break;
        default:
          vm.title = _translate('title.moreport.noDetails'); //"無明細資料";
          vm.downloadUrl = null;
          break;
      }

      $log.debug('test:', vm.category);
      vm.tableParams = new NgTableParams({
          page: 1,
          count: tableData.length, //initial page size
          filter: {
            supplier: vm.category ? vm.category.supplier : '',
            product: (vm.category && vm.type === 'stock')? vm.category.product : '',
            departureDate: vm.category ? vm.category.departureDate  : ''
          },
          sorting: {
            departureDate: "asc",
            departureTime: "asc"             
          }
        }, {
          counts: [],
          paginationMaxBlocks: 10,
          getData: function(params) {
            var filterObj = params.filter();
            //var filterObjFinal = [];
            var filterMatch = [];
            var filterEqual = [];
            
            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                //filterObjFinal[key] = filterObj[key];
                if (key === 'product' || key === 'operator'
                  || key === 'supplier' || key === 'status') {
                  filterEqual[key] = filterObj[key];
                }else {
                  filterMatch[key] = filterObj[key];
                }     
              }
            }

            //var filteredData = $filter('filter')(tableData, filterObjFinal, true);
            var filteredData = $filter('filter')(tableData, filterEqual, true);
            $log.debug('data1', filterEqual);
            filteredData = $filter('filter')(filteredData, filterMatch);
            
            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);
            vm.orderedTableData = orderedData;
            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            vm.currentTableData = orderedData;
            vm.selected.length = 0;
            params.total(vm.orderedTableData.length); //for pagniation
            return orderedData;
          }
          //dataset: vm.tableData
      });
      
      vm.cancel = function (){
        $mdDialog.hide(deleteProduct);
      }

      vm.toggle = function(item) {
        //$log.log('toggle item:', item);
        var idx = vm.selected.indexOf(item);
        if (idx > -1) {
          //vm.selected.splice(idx, 1);
          vm.selected = helperFactory.spliceOne(vm.selected, idx);
        }else {
          vm.selected.push(item);
        }
      }

      vm.exists = function(item) {
        return vm.selected.indexOf(item) > -1;
      }

      vm.isIndeterminate = function() {
        return (vm.selected.length !== 0 &&
                    vm.selected.length !== vm.currentTableData.length);
      }

      vm.isChecked = function() {
        return vm.currentTableData.length > 0 && vm.selected.length === vm.currentTableData.length;
      }

      vm.toggleAll = function() {
        if (vm.selected.length === vm.currentTableData.length) {
          vm.selected.length = 0;
        } else if (vm.selected.length === 0 || vm.selected.length > 0) {
          vm.selected = vm.currentTableData.slice(0);
        }
      }
      //function showDeleteDialog(product){
      function showDeleteDialog(){
        vm.isProcessing = true;

        ModalService.showModal({
          templateUrl: "app/main/modal.remark.html",
          controller: 'modalremarkCtrl',
          inputs: {
            title: _translate('title.remark')
          }
        }).then(function(modal) {
          modal.element.modal();
          modal.close.then(function(result) {
            var serialNoArray = [];
            for (var i=0, len=vm.selected.length; i<len; i++) {
              serialNoArray.push(vm.selected[i].productSerialNo);
            }
            $log.debug('confirmed selected product:', serialNoArray);
            if (result.remark) {
              if (vm.type === 'stock' ) {
                apiFactory.batchDeleteStock(counter.id, {serialNos: serialNoArray, remark: result.remark, version: 'v0.4.8'}, deleteStockSuccess, deleteStockFail);
              } else if (vm.type === 'norecord') {
                apiFactory.batchDeleteReturnProduct(counter.id, {serialNos: serialNoArray, remark: result.remark, version: 'v0.4.8'}, deleteStockSuccess, deleteStockFail);
              }
            }else {
              vm.isProcessing = false;
            }
          });
        });
        function deleteStockSuccess(){
          if (vm.type === 'stock' ) {
            toastr.success(_translate('msg.moreport.delete.stock.success'));
          } else if (vm.type === 'norecord') {
            toastr.success(_translate('msg.moreport.delete.norecord.success'));
          }
          
          deleteProduct = true;
          //panelref.hide(true);
          //getdetail(type, vm.selecteddetailitem);
          //tableData = $filter('filter')(tableData, function (item) {
          //  return item !== product;
          //});
          angular.forEach(vm.selected, function(value){
            //$log.debug(value)
            tableData = $filter('filter')(tableData, function (item) {
              return item.productSerialNo !== value.productSerialNo;
            });
            //$log.debug(tableData);
          })

          var _tableParams = vm.tableParams;
          _tableParams.settings().dataset = vm.tableData;
          _tableParams.reload().then(function(data) {
            if (data.length === 0 && _tableParams.total() > 0) {
              _tableParams.page(_tableParams.page() - 1);
              _tableParams.reload();
            }
          });

          vm.isProcessing = false;
        }

        function deleteStockFail(err){
          var msg;
          if (vm.type === 'stock' ) {
            msg = _translate('msg.moreport.delete.stock.error');
          } else if (vm.type === 'norecord') {
            msg = _translate('msg.moreport.delete.norecord.success');
          }
          if (err)
            toastr.error(err.error.message || msg);
          else
            toastr.error(msg);
          vm.isProcessing = false;
          //panelref.hide(true);
          //getdetail(type, vm.selecteddetailitem);
        }

      }


      function getExcelSuccess(result){
        vm.downloadUrl = result.downloadURL;
      }

      function getExcelFail(err) {
        $log.error('Get download url fail:', err);
      }

      function changePageSize(){
        if (vm.selectedPageSize === 'ALL') {
          vm.tableParams.count(tableData.length)
        }else {
          vm.tableParams.count(vm.selectedPageSize);
        }
      }

      function getFilterDataAsync(id) {
        return $q.when(filterInDetail[id]);
      }

      function htmlValue($scope, row, index, currentPage, pageSize) {
        var value;
        var html;
        var vm = this;
        switch (vm.field) {
          case 'uploadedAt':
          case 'updatedTs':
            if(angular.isNumber(row[vm.field]))
              value = new Date(row[vm.field]*1000);
            else
              value = row[vm.filed];

            //value = new Date(row[vm.field]*1000);
            html = $filter('date')(value, 'yyyy-MM-dd HH:mm:ss');
            // with timezone
            //html = $filter('date')(value, 'yyyy-MM-dd HH:mm:ss Z');
            break;
          case '#':
            if (pageSize === 'ALL')
              html = index + 1
            else
              html = (currentPage - 1 ) * pageSize + index + 1;
            break;
          case 'product':
            html = $sce.trustAsHtml(row[vm.field]);
            break;
          case 'deleteProduct':
            html = '';
            break;
          default:
            value = row[vm.field];
            html = value;
            break;
        }

        return html;
      }
    } // end of DialogDetailCtrl

    function getDetailFail(err) {
      $log.error('[moreport] Get detail failed:', err)
      if (err)
        toastr.error(err.error.message || _translate('msg.moreport.getDetail.error'));
      else
        toastr.error(_translate('msg.moreport.getDetail.error'));
    }

    function getTodayPickupSuccess(result){
      $log.log('Get today-pickup dashboard success:', result)
      vm.todayPickup = result
    }
    
    function getTodayPickupFail(err){
      $log.error('Get today-pickup dashboard failed:', err);
      vm.todayPickup = null;
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.moreport.getTodayPickup.error'));
      else
        toastr.error(_translate('msg.moreport.getTodayPickup.error'));
      vm.tableData.length = 0;
    }
    
    function getDashBoardSuccess(result){
      $log.log('Get dashboard success:', result);
      vm.tableData = result;

      if (vm.selectedPageSize === 'ALL')
        vm.tableParams.count(vm.tableData.length);
      // filter data;
      for (var i=0, len=vm.tableData.length; i<len; i++) {
        var product = vm.tableData[i].product;
        var supplier = vm.tableData[i].supplier;
        //var departureDate = vm.tableData[i].departureDate;
        var isSupplierExist = $filter('filter')(filter.supplier, {id: supplier}, true);
        if (isSupplierExist.length === 0 && supplier !== null) {
          filter.supplier.push({
            id: supplier,
            title: supplier
          });
        }
        
        
        var isProductExist = $filter('filter')(filter.product, {id: product}, true);
        if (isProductExist.length === 0 && product !== null) {
          filter.product.push({
            id: product,
            title: product
          });
        }
        
        //var isDepartureDateExist = $filter('filter')(filter.departureDate, {id: departureDate}, true);
        //if (isDepartureDateExist.length === 0 && departureDate !== null) {
        //  filter.departureDate.push({
        //    id: departureDate,
        //    title: departureDate
        //  });
        //}
        
      }
    
      //filter.supplier = $filter('orderBy')(filter.supplier, ["+id"]);
      //filter.product = $filter('orderBy')(filter.product, ["+id"]);
      //filter.departureDate = $filter('orderBy')(filter.departureDate, ["+id"]);
      
      vm.tableParams.filter({});
      vm.tableParams.total(vm.tableData.length);
      vm.tableParams.reload();
      vm.isProcessing = false;
    }

    function getDashBoardFail(err) {
      $log.error('Get dashboard failed:', err);
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || _translate('msg.moreport.getDashBoard.error'));
      else
        toastr.error(_translate('msg.moreport.getTodayPickup.error'));
      vm.tableData.length = 0;
    }

  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:moorderCtrl
 * @description
 * # moorderCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('moorderCtrl', function ($scope, $log, $filter, $window, $timeout, NgTableParams, toastr, $mdDialog, ModalService, apiFactory, counterService) {
     var vm = this;
    var counter = counterService.getCounter();
    vm.isProcessing = false;
    vm.print = print;
    vm.changePageSize = changePageSize;
    vm.getOrders = getOrders;
    vm.confirmPayment = confirmPayment;
    vm.getIndex = getIndex;
    vm.selectedOrder = null;
    vm.tableData = [];
    
    vm.availablePageSizes = [50, 100, 150, 200, 'ALL'];
    vm.selectedPageSize = 'ALL';

    (function initController(){
      initTable();
    })();
    
    function changePageSize(){
      $log.debug('change page size:', vm.selectedPageSize);
      if (vm.selectedPageSize === 'ALL') {
        vm.tableParams.count(vm.tableData.length);
      }else {
        vm.tableParams.count(vm.selectedPageSize);
      }
    }
  
    function getIndex(idx) {
      if (vm.selectedPageSize === 'ALL')
        return idx + 1;
      else
        return (vm.tableParams.page()-1) * vm.selectedPageSize + (idx+1);
    }
    
    function initTable() {
      vm.tableParams = new NgTableParams({
          page: 1,
          count: vm.selectedPageSize //initial page size
        }, {
          // page size buttons (right set of buttons in demo)
          counts: [],
          // determines the pager buttons (left set of buttons in demo)
          paginationMaxBlocks: 10,
          getData: function(params) {
            var data = angular.copy(vm.tableData);
            var filterObj = params.filter();
            var filterMatch = [];
            var filterEqual = [];
          
            for(var key in filterObj) {
              if(filterObj[key]  !== '') {
                if (key === 'product' || key === 'supplier' ) {
                  filterEqual[key] = filterObj[key];
                }else {
                  filterMatch[key] = filterObj[key];
                }
              }
            }
            var filteredData = $filter('filter')(data, filterEqual, true);
            filteredData = $filter('filter')(filteredData, filterMatch);
          
            var sortObj = params.orderBy();
            var orderedData = $filter('orderBy')(filteredData, sortObj);

            orderedData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            return orderedData;
          }

      });

      getOrders();
    }

    function print(data) {
      if (angular.isDefined(data)) {
        vm.selectedOrder = data;
        //vm.selectedOrder.paymentDate = new Date();
      }else {
        vm.selectedOrder = null;
      }

      
      $timeout(function(){
        $window.print();
      }, 300);
      //$mdDialog.show({
      //    templateUrl: "app/main/dialog.payment.html",
      //    fullscreen: true ,
      //    locals: {
      //      order: data
      //    },
      //    controller: function($scope, $mdDialog, order){
      //      $scope.order = order;
      //      $scope.cancel = function() {
      //        $mdDialog.cancel();
      //      };
      //      $scope.print = function() {
      //        $window.print();
      //      }
      //    }
      //  });
    }
    
    function getOrders() {
      vm.tableData.length = 0;
      vm.isProcessing = true;
      apiFactory.getOrders(counter.id, getOrdersSuccess, getOrdersFail);
    }
    
    function confirmPayment(orderId) {
      $log.info('confirm payment:', orderId);
      $mdDialog.show({
          templateUrl: "app/main/dialog.confirm.html",
          fullscreen: true ,
          locals: {
            title: '入倉管並出貨',
            msg: '請確認是否要入倉管並出貨',
            order: orderId,
            appId: counter.id
          },
          controller: function($scope, $mdDialog, $log, toastr, title, msg, order, appId){
            $scope.title = title;
            $scope.msg = msg;
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.confirm = function() {
              //$mdDialog.hide(true);
              //$scope.$parent.isProcessing = true;
              $scope.isProcessing = true;
              apiFactory.confirmPayment(appId, order, confirmPaymentSuccess, confirmPaymentFail);
            }
                    
            function confirmPaymentSuccess(result){
              $log.log('Confirm payment success:', result);
              toastr.success('訂單已入倉管 ');
              $scope.isProcessing = false;
              $mdDialog.hide();
            }

            function confirmPaymentFail(err) {
              $log.error('Get orders failed:', err);
              $scope.isProcessing = false;
              if (err)
                toastr.error(err.error.message || '無法取得訂單資料');
              else
                toastr.error('無法取得訂單資料');
              
              $mdDialog.hide();
            }
          }
        });
        //.then(function(){
        //  vm.isProcessing = true;
        //  apiFactory.confirmPayment(orderId, confirmPaymentSuccess, confirmPaymentFail);
        //});
      //vm.isProcessing = true;
      //apiFactory.confirmPayment(orderId, confirmPaymentSuccess, confirmPaymentFail);

    }
    function getOrdersSuccess(result){
      $log.log('Get orders success:', result);
      vm.tableData = result;

      if (vm.selectedPageSize === 'ALL')
        vm.tableParams.count(vm.tableData.length);
      
      vm.tableParams.total(vm.tableData.length);
      vm.tableParams.reload();
      vm.isProcessing = false;
    }

    function getOrdersFail(err) {
      $log.error('Get orders failed:', err);
      vm.isProcessing = false;
      if (err)
        toastr.error(err.error.message || '無法取得訂單資料');
      else
        toastr.error('無法取得訂單資料');
      vm.tableData.length = 0;
    }
    
  
  });

//'use strict';
///**
// * @ngdoc function
// * @name mpos.controller:mocreateCtrl
// * @description
// * # mocreateCtrl
// * Controller of the mpos
// */
//angular.module('mpos')
//  .controller('mocreateCtrl', function ($scope, $log, $timeout, $window, $document, toastr, FileUploader, apiFactory, 
//    counterService, helperFactory, $filter) {
//    var vm = this;
//    var _translate = $filter('translate');
//    var counter = counterService.getCounter();
//
//    vm.isDownloading = false;
//    vm.errorItems = [];
//    vm.uploader = new FileUploader({
//      removeAfterUpload: true,
//      //withCredentials: true,
//      //onBeforeUploadItem: function (item) {
//      //  $log.log('onbeforeuploaditem', item);
//      //  //apiFactory.uploadOrder(counter.appId, function(result){
//      //  //  $log.log('Get upload url:', result);
//      //  //  item.url = result.uploadUrl;
//      //  //}, function(){
//      //  //  $log.error('failed to get upload URL');
//      //  //  item.cancel();
//      //  //});
//      //},
//      //onProgressItem: function(item, progress) {
//      //  //$log.log('progress:', progress);
//      //},
//      //onSuccessItem: function(item, response, status, header){
//      onSuccessItem: function(item, response){
//        $log.log('Upload success', response);
//      },
//      //onErrorItem: function(item, response, status, header){
//      onErrorItem: function(item, response){
//        $log.error('Upload failed:', response);
//        vm.errorItems.push({
//          name: item.file.name,
//          message: response.error.message
//        });
//      }
//    });
//
//    vm.getTemplate = getTemplate;
//    vm.uploadFile = uploadFile;
//    vm.removeErrorItem = removeErrorItem;
//
//    //$scope.$on('$destroy', function () {
//    //  counterService.clearCounter();
//    //});
//
//
//    function uploadFile(item){
//      apiFactory.uploadOrder(counter.appId, item.file , function(result){
//        $log.log('Get upload url:', result);
//        vm.uploader.url = result.uploadUrl;
//        item.url = result.uploadUrl;
//        $log.log('Start upload');
//        vm.uploader.uploadItem(item);
//      }, function(err){
//        $log.error('failed to get upload URL');
//        if (err)
//          toastr.error(err.error.message || _translate('msg.file.upload.error'), null);
//        else
//          toastr.error(_translate('msg.file.upload.error'), null);
//      });
//
//    }
//
//    function getTemplate() {
//      apiFactory.getTemplate(counter.appId, function(result){
//        $log.log('Get template success');
//          var fileName = 'example.csv';
//          if ($window.navigator.msSaveOrOpenBlob) {
//              var blob = new Blob(result);  //csv data string as an array.
//              $window.navigator.msSaveBlob(blob, fileName);
//          } else {
//              var anchor = angular.element('<a/>');
//              anchor.css({display: 'none'}); // Make sure it's not visible
//              angular.element($document.body).append(anchor); // Attach to document for FireFox
//              anchor.attr({
//                  href: 'data:attachment/csv;charset=utf-8,' + encodeURI(result),
//                  target: '_blank',
//                  download: fileName
//              })[0].click();
//              anchor.remove();
//          }
//
//        }, function (err){
//          $log.error('Get template failed');
//          if (err)
//            toastr.error(err.error.message || _translate('msg.file.download.template.error'), null);
//          else
//            toastr.error(_translate('msg.file.download.template.error'), null);
//        });
//    }
//
//    function removeErrorItem(index){
//      vm.errorItems = helperFactory.spliceOne(vm.errorItem, index);
//      //vm.errorItems.splice(index, 1);
//    }
//  });
//
'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:mocheckinCtrl
 * @description
 * # mocheckinCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('mocheckinCtrl', function ($scope, $window, $document, $mdDialog, $log, $timeout, 
    $sce, toastr, apiFactory, counterService, soundEffectFactory, $filter, $localStorage) {
    var vm = this;
    var _translate = $filter('translate');
    var counter = counterService.getCounter();
    vm.business = $localStorage.business;
    console.log(vm.business)
    vm.counterName = counter.label;
    vm.print = print;
    vm.trustAsHtml = $sce.trustAsHtml;
    //vm.changeFocus = changeFocus
    vm.showAddonDialog = showAddonDialog;
    vm.showConfirmExitDialog = showConfirmExitDialog;
    //vm.showScanProductDialog = showScanProductDialog;
    vm.confirmOrder = confirmOrder;
    vm.showNewProductDialog = showNewProductDialog;
    vm.setLastOrder = setLastOrder;
    vm.changeSelectedOrder = changeSelectedOrder;
    vm.addRemark = addRemark;
    vm.transformChip = transformChip;
    vm.addChip = addChip;
    vm.removeChip = removeChip;
    vm.removeAll = removeAll;
    vm.hasPairing = false;
    vm.getOrderListInfo = getOrderListInfo;
    vm.order = {
      barcodeMessage: '',
      merchantOrderNo: '',
      phoneNumber: ''
    };
    vm.orders = [];
    vm.multipleOrders = false;
    vm.displayRemark = false;
    vm.urgent = false;
    //vm.addNewProduct = false;
    vm.isRequired = {
      'barcodeMessage': true,
      //'phoneNumber': false
      'queryString': false
    };
    vm.isProcessing = {
      'barcodeMessage': '',
      //'phoneNumber': '',
      'queryString': '',
      'confirmOrder': '',
      'addonsPopup': false,
    };

    //vm.productCodeBuffer = '';
    vm.productCodeBuffer = [];
    var updateChips = false;
    var lastOrder = null;
    
    /*
     *
     * Events
     *
     */

    $scope.$on('$destroy', function () {
      unbindWatchPaste();
      unbindWatchKeyPress();
      unbindWatchShortcut();
      unbindWatchProduct();
      //counterService.clearCounter();
      vm.order = null;
      vm.orders = null;
      vm.isRequired = null;
      vm.isProcessing = null;
      for (var key in vm.productCodeBuffer) {
        vm.productCodeBuffer[key ] = null;
      }
      vm.productCodeBuffer = null;


    });

    var unbindWatchProduct = $scope.$watch(function(){
      if (vm.order)
        return vm.order.products;
    }, function(){
      getProductAmount();
    }, true);
    
    var unbindWatchShortcut = $scope.$on('shortcutEvents', function (evt, obj) {
      evt.preventDefault();
      evt.stopPropagation();
      var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (isDialogOpen) return;
      $scope.$apply(function () {
        if (vm.order.barcodeMessage) {
          switch (obj.keyCode) {
            case 83: //ctrl+s
              confirmOrder();
              break;
            default:
              break;
          }
        }
      });
    });

    var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {
      var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (isDialogOpen) return;
      if (vm.isRequired.barcodeMessage && !vm.order.merchantOrderNo) {
        if (vm.isProcessing.barcodeMessage) {
          return;
        }else {
          vm.order.barcodeMessage = vm.order.barcodeMessage + data.toUpperCase();
          $scope.$apply();
        }
      }else if (vm.isRequired.queryString && !vm.order.merchantOrderNo) {
        if (vm.isProcessing.queryString) {
          return;
        }else {
          vm.queryString = vm.queryString + data;
          $scope.$apply();
        }
      }else {

        var pindex = angular.element($document[0].activeElement).attr('pindex');
        var focusedElm = angular.element($document[0].activeElement).attr('id');
        if (angular.isDefined(vm.order.products[pindex])) {
          if (angular.isDefined(vm.productCodeBuffer[pindex])) {
            vm.productCodeBuffer[pindex] = (vm.productCodeBuffer[pindex] + data).toUpperCase();
          }else {
            vm.productCodeBuffer[pindex] = data.toUpperCase();
          }
        } else if (focusedElm === 'remark') {
           if (angular.isDefined(vm.order.remark))
             vm.order.remark = vm.order.remark + data;
           else
             vm.order.remark = data;
        }
        $scope.$apply();

        return;
      }
    });

    // catch keypress event for barcode scanner
    var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
      evt.stopPropagation();
      if (vm.isProcessing.barcodeMessage || vm.isProcessing.queryString || vm.isProcessing.confirmOrder || vm.isProcessing.addonsPopup) return;

      var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      if (isDialogOpen) return;

      if (obj.keyCode === 8)
        evt.preventDefault();

      $scope.$apply(function () {
        if (vm.isRequired.barcodeMessage && !vm.order.merchantOrderNo) {
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.order.barcodeMessage))
                vm.order.barcodeMessage = vm.order.barcodeMessage.slice(0, -1);
              break;
            case 10:
            case 13:
              if (vm.order.barcodeMessage !== '' ) {
                apiFactory.searchCheckInOrder(counter.appId, {barcodeMessage: vm.order.barcodeMessage}, searchOrderSuccess, searchOrderError);
                vm.isProcessing.barcodeMessage = 'indeterminate';
              }
              break;
            default:
              if (angular.isDefined(vm.order.barcodeMessage))
                vm.order.barcodeMessage = vm.order.barcodeMessage + key.toUpperCase();
              else
                vm.order.barcodeMessage = key.toUpperCase();
              break;
          }
        }else if (vm.isRequired.queryString && !vm.order.merchantOrderNo) {
          switch (obj.keyCode) {
            case 8:
              if (angular.isDefined(vm.queryString))
                vm.queryString = vm.queryString.slice(0, -1);
              break;
            case 10:
            case 13:
              if (vm.queryString !== '') {
                apiFactory.searchCheckInOrder(counter.appId, {queryString: vm.queryString}, searchOrderSuccess, searchOrderError);
                vm.isProcessing.queryString = 'indeterminate';
              }
              break;
            default:
              if (angular.isDefined(vm.queryString))
                vm.queryString = vm.queryString + key;
              else
                vm.queryString = key;
              break;
          }
        }
        else if (vm.order.merchantOrderNo && vm.order.phoneNumber){
          //var focusedElm = angular.element($document[0].activeElement).attr('id');
          //vm.order.products[pindex].amount always equals to 1
          var pindex = angular.element($document[0].activeElement).attr('pindex');
          
          // products[pindex] already has existing SN
          // Below code are execute when chip is added
          //if (angular.isDefined(vm.order.products[pindex]) &&
          //    vm.order.products[pindex].serialNos.length >= 1) {
          //  var tempIdx = parseInt(pindex); 
          //  var i = tempIdx + 1;
          //  var len = vm.order.products.length;
          //
          //  // Find next products index that doesn't have SN
          //  for (; i<len; i++) {
          //    if (vm.order.products[i].serialNos.length < 1) {
          //      break;
          //    }
          //  }
          //
          //  if (i < len) {
          //    changeFocusToProduct(i);
          //    pindex =  i;
          //  } else {
          //    $timeout(function(){
          //      angular.element('#remark')[0].focus();
          //    }, 10);
          //    pindex = null;
          //    //return;
          //  }
          //}

          if (pindex) {
            evt.preventDefault();
            switch (obj.keyCode) {
              case 8:
                if (angular.isDefined(vm.productCodeBuffer[pindex]))
                  vm.productCodeBuffer[pindex] = vm.productCodeBuffer[pindex].slice(0, -1);
                break;
              case 13:
              default:
                if (angular.isDefined(vm.productCodeBuffer[pindex]))
                  vm.productCodeBuffer[pindex] = vm.productCodeBuffer[pindex] + key.toUpperCase();
                else
                  vm.productCodeBuffer[pindex] = key.toUpperCase();
                break;
            }
          } else { //remark
            switch (obj.keyCode) {
              case 8:
                if (angular.isDefined(vm.order.remark)) {
                  vm.order.remark = vm.order.remark.slice(0, -1);
                  //var sel = $window.getSelection();
                  //var value = sel.toString().trim();
                  //if (value !== '') {
                  //  //sel.empty(); //not work
                  //  vm.order.remark = '';
                  //}else{
                  //  vm.order.remark = vm.order.remark.slice(0, -1);
                  //}
                }
                break;
              case 13:
              default:
                if (angular.isDefined(vm.order.remark))
                  vm.order.remark = vm.order.remark + key;
                else
                  vm.order.remark = key;
                break;
            }
          }
        }
      });
    });

    /*
     *
     * Public function
     *
     */
     
    //function checkScanProduct(order){
    //  var scan = false;
    //  var check = angular.isDefined(order) ? order : vm.order;
    //  if (check.products) {
    //    for (var i = 0, len = check.products.length; i<len; i++) {
    //      var temp = check.products[i];
    //      for (var j=0, jLen = temp.serialNos.length; j<jLen; j++) {
    //        if (temp.serialNos[j]) {
    //          scan = true;
    //          break;
    //        }
    //      }
    //      
    //    }
    //  }
    //  
    //  return scan;
    //}

    function print() {
      $timeout(function(){
        $window.print();
      }, 300);

    }
    
    function setLastOrder() {
      lastOrder = angular.copy(vm.order);
    }
    
    function changeSelectedOrder(){
      //$log.debug('change select');
      //var alert = checkScanProduct(lastOrder);
      //$log.debug('alert:', alert);
      if (updateChips){
        $mdDialog.show({
          templateUrl: "app/main/dialog.confirmExit.html",
          fullscreen: false,
          controller: function($scope){
             $scope.cancel = function() {
               $mdDialog.cancel();
             };
             $scope.confirm = function() {
               $mdDialog.hide();
             }
          }
        }).then(function(){
          updateChips = false;
          doChangeSelect();
        }, function(){
          //vm.order = angular.copy(lastOrder);
          vm.selectedOrder = angular.copy(lastOrder);
          doChangeSelect();
        });
      }else {
        doChangeSelect();
      }
      
      ////vm.productCodeBuffer = '';
      //vm.productCodeBuffer = new Array(vm.order.products.length);
      //vm.urgent = vm.order.urgent;
      ////getProductAmount();
      ////vm.addNewProduct = false;
      //$timeout(function(){
      //  var focusedElm = angular.element($document[0].activeElement);
      //  focusedElm.blur();
      //  if (vm.order.popup) {
      //    showPopup(vm.order.popup);
      //  }else{
      //    changeFocusToProduct(0);
      //  }
      //}, 100)


    }

    function doChangeSelect() {
      //vm.productCodeBuffer = '';
      vm.order = vm.selectedOrder;
      vm.productCodeBuffer = new Array(vm.order.products.length);
      vm.urgent = vm.order.urgent;
      //getProductAmount();
      //vm.addNewProduct = false;
      $timeout(function(){
        var focusedElm = angular.element($document[0].activeElement);
        focusedElm.blur();
        if (vm.order.popup) {
          showPopup(vm.order.popup);
        }else{
          changeFocusToProduct(0);
        }
      }, 100)
    }
    
    function showAddonDialog(sn){
      vm.isProcessing.addonsPopup = true;
      var params = {
        //serialNo: vm.order.products[idx].serialNos[0].serialNo
        serialNo: sn
      };

      $log.log('show addon dialog:', sn);
      // $mdDialog.show({
      //     controller: DialogAddonsCtrl,
      //     controllerAs: 'notice',
      //     templateUrl: "app/main/dialog.addons.html",
      //     locals: {
      //       html: params.serialNo
      //     },
      //     fullscreen: false
      // }).then(function(){
      //   var needScan = false;
      //   var len = vm.order.products.length;
      //   for(var i=0; i<len; i++) {
      //     if(vm.order.products[i].serialNos.length < 1) {
      //       needScan=true;
      //       break;
      //     }
      //   }
      //   if (i < len) {
      //     //change focus to next product
      //     changeFocusToProduct(i);
      //   } else if (i === len && needScan) {
      //     changeFocusToProduct(len - 1);
      //   }else {
      //     $timeout(function(){
      //       angular.element('#remark')[0].focus();
      //     }, 100);
      //   }
        
      // })
      apiFactory.getAddons(counter.appId, vm.order.barcodeMessage, params, 
        function(data){
          console.log(data)
          vm.isProcessing.addonsPopup = false;
          $mdDialog.show({
              controller: DialogAddonsCtrl,
              controllerAs: 'notice',
              templateUrl: "app/main/dialog.addons.html",
              locals: {
                //html: data.formSchema[0].content,
                formContent: data.formSchema
              },
              fullscreen: false
          }).then(function(){
            var needScan = false;
            var len = vm.order.products.length;
            for(var i=0; i<len; i++) {
              if(vm.order.products[i].serialNos.length < 1) {
                needScan=true;
                break;
              }
            }
            if (i < len) {
              //change focus to next product
              changeFocusToProduct(i);
            } else if (i === len && needScan) {
              changeFocusToProduct(len - 1);
            }else {
              $timeout(function(){
                angular.element('#remark')[0].focus();
              }, 100);
            }
            
          })
        }, function(err){
          $log.error('Get addons failed', err);
          vm.isProcessing.addonsPopup = false;
          var msg = err.error.message || _translate('msg.mocheckin.addons.get.error');
          soundEffectFactory.playSound('warning');
          showAlertDialog('error', msg, false, 1500);
        });
      
    }

    function transformChip(chip) {
      //$log.debug('Transformchip:', chip);
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return {serialNo: chip}
    }

    function removeChip(){
      updateChips = true;
    }
    
    function addChip(chip){
      $log.debug('Add chip for product ',  chip);
      //$log.debug('Add chip for product ' + index);
      //$log.debug('Add chip for product - addon ', isAddon);
      //$log.debug('Add chip for product ', $scope.cin.order.products);
      updateChips = true;
      var needScan = false;
      //An expression which will be called when a chip has been added.
      //vm.order.products[index].amount always equals to 1
      var len = vm.order.products.length;
      for(var i=0; i<len; i++) {
        if(vm.order.products[i].serialNos.length < 1) {
          needScan = true;
          break;
        }

      }
      
      // For angular-material 1.0.9 
      //if (i < len) {
      //  //change focus to next product
      //  changeFocusToProduct(i);
      //} else if (i === len && needScan) {
      //  changeFocusToProduct(len - 1);
      //}else {
      //  $timeout(function(){
      //    angular.element('#remark')[0].focus();
      //  }, 10);
      //}

      var focusedElm = angular.element($document[0].activeElement);
      var temp = focusedElm[0].id.split('_');
      $log.debug('Add chip for product - addon ', temp);
      // For angular-material 1.1.4
      var isAddon = null;
      if (temp.length > 1) {
        isAddon = vm.order.products[temp[1]].addOnType;
      }
      $log.debug('Add chip for product - addon ', isAddon);
      if (isAddon && isAddon==='IP') {
        showAddonDialog(chip.serialNo);
      }else {
        
        if (i < len) {
          //change focus to next product
          changeFocusToProduct(i);
        } else if (i === len && needScan) {
          changeFocusToProduct(len - 1);
        }else {
          $timeout(function(){
            angular.element('#remark')[0].focus();
          }, 100);
        }
      }
      
      
      //if (vm.order.products[index].serialNos.length >= 1) {
      //  var i = index + 1;
      //  var len = vm.order.products.length;
      //  for(; i<len; i++) {
      //    if(vm.order.products[i].serialNos.length < 1) {
      //      needScan = true;
      //      break;
      //    }
      //
      //  }
      //  
      //  if (i < len) {
      //    //change focus to next product
      //    changeFocusToProduct(i);
      //  } else if (i === len && needScan) {
      //      changeFocusToProduct(len - 1);
      //  }else {
      //    $timeout(function(){
      //      angular.element('#remark')[0].focus();
      //    }, 10);
      //  }
      //}

    }

    function getOrderListInfo(info) {
      var order = '';
      for (var i=0, len=info.length; i<len; i++) {
        if (i === 0) {
          order += info[i];
        } else {
          order += '-' + info[i]
        }
      }
      
      return order;
    }
    function getProductAmount(){
      if (angular.isDefined(vm.order.products)) {
        var i = 0;
        var len = vm.order.products.length;
        var sum = 0;
        for(; i<len; i++) {
          sum += vm.order.products[i].serialNos.length;
        }
        vm.totalProduct = sum;
        if (sum === 0) {
          vm.hasPairing = false;
        }else {
          vm.hasPairing = true;
        }
      }else {
        vm.hasPairing = false;
        return;
      }
    }
    
    function changeFocus(elem) {
      if (vm.isProcessing.barcodeMessage || vm.isProcessing.queryString || vm.isProcessing.confirmOrder) {
        return;
      }

      //$log.debug('changeFocus', elem);

      resetParams();

      if (elem === 'barcodeMessage') {
        vm.isRequired.queryString = false;
      }else {
        vm.isRequired.barcodeMessage = false;
      }

      vm.isRequired[elem] = true;

      $timeout(function(){
        angular.element('#' + elem)[0].focus();
      }, 10);
    }

    function addRemark(type, product){
      switch(type) {
        case 'urgent':
          //var msg = "急單!!!\r";
          var msg = _translate('table.field.urgentOrder') + "!!!\r";
          var msg_uni = toUnicode(msg);
          var remark_uni = toUnicode(vm.order.remark);
          var re = new RegExp(escapeRegExp(msg_uni), 'g');
          if(vm.urgent) {
            vm.order.remark= msg + vm.order.remark;
          }else { //unchecked
            if (remark_uni) { // remark is not empty
              vm.order.remark = unUnicode(remark_uni.replace(re, ''));
              //msg = "急單!!!\n";
              msg = _translate('table.field.urgentOrder') + "!!!\n";
              msg_uni = toUnicode(msg);
              remark_uni = toUnicode(vm.order.remark);
              re = new RegExp(escapeRegExp(msg_uni), 'g');
              vm.order.remark = unUnicode(remark_uni.replace(re, ''));
            }else { // remark is empty
              vm.order.remark = '';
            }
          }
          break;
        case 'agency':
          if(vm.order.agency && vm.order.remark === '') {
            vm.order.remark= _translate('Change counter') + ": [" + vm.order.originalCounter + "] " + _translate('Change to') + " [" + counter.name + "]\n" + vm.order.remark;
          }
          break;
        case 'addNew':
          if (product) {
            var label = product.label ? product.label.replace(/<[^>]+>/gm, '') : '';
            vm.order.remark= _translate('Add machine') + " - " + product.provider + " [" + label + "] \n" + vm.order.remark;
          } else {
            vm.order.remark= _translate('Add machine') + " \n" + vm.order.remark;
          }
          //if(vm.addNewProduct) {
          //  vm.order.remark= "加機器 \n" + vm.order.remark;
          //}
          break;
        default:
          break;

      }

    }

    function confirmOrder(){
      if (vm.order.barcodeMessage == '') return;
      vm.isProcessing.confirmOrder = 'indeterminate';
      checkOrderMerchant();
    }

    function updateOrder() {
      //if(vm.urgent) {
      //  vm.order.remark= "急單 \n" + vm.order.remark;
      //}
      //
      //if(vm.order.agency) {
      //  vm.order.remark= "換櫃檯: 原 [ " + vm.order.originalCounter + " ] 改為 [ " + counter.name + " ]\n" + vm.order.remark;
      //}
      //
      //
      //if(vm.addNewProduct) {
      //  vm.order.remark= "加機器 \n" + vm.order.remark;
      //}

      var params = {
        products: vm.order.products,
        remark: vm.order.remark,
        urgent: vm.urgent
      };

      apiFactory.updateCheckInOrder(counter.appId, vm.order.barcodeMessage, params, updateOrderSuccess, updateOrderError);
    }

    function checkOrderMerchant() {
      var unpicked = [];

      angular.forEach(vm.order.products, function(item){
        //$log.debug(item);
        if (item.serialNos.length < parseInt(item.amount)) {
          unpicked.push(item);
        }
      })

      if (unpicked.length === 0) {
        updateOrder();
      }else {
        showUnpickedDialog(unpicked);
      }

    }

    function showUnpickedDialog(data){
      $log.debug('show unpicker product dialog');
      $mdDialog.show({
         controller: DialogUnpickedCtrl,
         controllerAs: 'unpicked',
         templateUrl: "app/main/dialog.product.html",
         locals: {
          unpicked: data
         },
         fullscreen: false
      }).then(function(){
        updateOrder();
      }, function(){
        $log.log('Close unpicked dialog');
        vm.isProcessing.confirmOrder = '';
      })

    }


    function showNewProductDialog(){
      $log.debug('show new product dialog');
      var focusedElm = angular.element($document[0].activeElement);
      focusedElm.blur();
      //$log.debug(vm.order);
      $mdDialog.show({
         controller: DialogNewProductCtrl,
         controllerAs: 'prod',
         //isolateScope: true,
         locals: {
          appId: counter.appId,
          defaultProduct: vm.order.defaultProduct
         },
         templateUrl: "app/main/dialog.newProduct.html",
         fullscreen: false,
         onComplete: function afterShowAnimation(scope, element){
           $timeout(function(){
             var focusedElm = element.find('#productSerialNo');
             focusedElm.focus();
           }, 200);
         }
      }).then(function(answer){
          $log.log('add prodcut complete:', answer);
          vm.order.products.push(answer);
          //vm.addNewProduct = true;
          addRemark('addNew', answer);
          updateChips = true;
          //getProductAmount();
      }, function(){
          $log.log('close dialog without add product.');
          //vm.addNewProduct = false;
      })

    }

    function showConfirmExitDialog(type){
      //var alert = checkScanProduct();
      //$log.debug('alert:', alert);  
      
      if (updateChips) {
        $log.debug('show confirm exit dialog');
        $mdDialog.show({
          templateUrl: "app/main/dialog.confirmExit.html",
          fullscreen: false,
          controller: function($scope){
             $scope.cancel = function() {
               $mdDialog.cancel();
             };
             $scope.confirm = function() {
               $mdDialog.hide();
             }
          }
        }).then(function(){
          if (type) {
            changeFocus(type);
          }
        });
      }else {
        if (type) {
          changeFocus(type);
        }
      }

    }
    
    function removeAll(){

      $mdDialog.show({
        templateUrl: "app/main/dialog.confirm.html",
        fullscreen: false,

        controller: function($scope, $filter){
          var _translate = $filter('translate');
          $scope.title = _translate('btn.cancelAllPairing');
          $scope.msg = _translate('msg.mocheckin.cancelAllPairing');
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
          $scope.confirm = function() {
            $mdDialog.hide();
          }
        }
      }).then(function(){
        
        for (var i=0, len=vm.order.products.length; i<len; i++) {
          vm.order.products[i].serialNos.length = 0;
        }
        
        for (var key in vm.productCodeBuffer) {
          vm.productCodeBuffer[key] = '';
        }
        changeFocusToProduct(0);
      });
    }
    
    /*
     *
     * Private function
     *
     */
    function changeFocusToProduct(index, delay) {
      var time = delay || 100;
      var focusedElm = angular.element($document[0].activeElement);
      focusedElm.blur();
      //$log.debug('change to product ', index);
      $timeout(function(){
        //$log.debug('changeFocusToProduct', index);
        angular.element('#product_' + index)[0].focus();
      }, time);

    }


    function resetParams( ) {
      updateChips = false;
      lastOrder = null;
      vm.selectedOrder = null;
      vm.order = {
        barcodeMessage: '',
        merchantOrderNo: '',
        phoneNumber: ''
      };
      vm.queryString = '';
      vm.orders = [];
      vm.multipleOrders = false;
      vm.displayRemark = false;
      vm.urgent = false;
      vm.isRequired = {
        'barcodeMessage': true,
        'queryString': false
      };
      vm.isProcessing = {
        'barcodeMessage': '',
        'queryString': '',
        'confirmOrder': ''
      };

      //vm.productCodeBuffer = '';
      vm.productCodeBuffer = [];
    }

    function showAlertDialog(type, msg, reset, time){

      //var myColor;
      //var icon;
      var duration = time || 2000;

      $mdDialog.show({
        templateUrl: "app/main/dialog.message.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          msg: msg,
          type: type
        },
        controller: function DialogController($log, $scope, $mdDialog, msg, type ){
          var vm = this;
          var alert = type;
          vm.msg = msg;
          switch(alert) {
            case 'error':
              vm.icon = 'error_circle';
              vm.myColor= '#FFA2A2';
              break;
            case 'warning':
              vm.icon = 'warning';
              vm.myColor= '#FAED33';
              break;
            default:
              vm.icon = 'check_circle';
              vm.myColor = '#A4FFA2';
              break;
          }
        },
        controllerAs: 'msgCtrl',
        onComplete: function(){
          $timeout(function(){
            $mdDialog.hide();
            if(reset) resetParams();
          }, duration)
        }
      });

    }

    function DialogUnpickedCtrl($scope, unpicked, $sce){
      var vm = this;
      vm.products = unpicked;
      vm.trustAsHtml = $sce.trustAsHtml;
      
      vm.confirm = function(){
        $mdDialog.hide();
      };

      vm.cancel = function() {
        $mdDialog.cancel();
      }
    }

    function DialogNewProductCtrl($scope, $timeout, $log, $sce, apiFactory, appId, defaultProduct){
      var vm = this;
      vm.trustAsHtml = $sce.trustAsHtml;
      vm.resetProductLabel = resetProductLabel;
      vm.productProvider = "";
      
      // For product label with HTML tag.....TBD
      vm.productLabel = defaultProduct ? defaultProduct.replace(/<[^>]+>/gm, '') : '';
      //vm.productLabel = defaultProduct || "";
      vm.productSerialNo = "";
      vm.suppliers = [];
      vm.resetLabel = false;
      vm.isFocus = {
        productProvider: false,
        productLabel: false,
        productSerialNo: false
      };
      //vm.originLabel = defaultProduct;

      (function initController() {
        apiFactory.getSuppliers(appId, null, function(result){
          $log.log('Get suppliers:', result);
          vm.suppliers = result;
          vm.productProvider = result[0] ;
          vm.isProcessing = '';
        },function onError(err){
          $log.error('Get suppliers failed:', err);
          $mdDialog.cancel();
          vm.isProcessing = '';
        });

      })();

      $scope.$on('$destroy', function () {
        unbindWatchKeyPress();
        //unbindWatchShortcut();
        unbindWatchPaste();
      });

      var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {
        evt.stopPropagation();
        evt.preventDefault();

        //var isDialogOpen = (angular.element(document.body).hasClass('md-dialog-is-showing')) ? true : false;
        var focusedElm = angular.element($document[0].activeElement).attr('id');
        if (angular.isUndefined(focusedElm)) {
          focusedElm = 'productProvider';
        }

        $scope.$apply(function(){
          vm[focusedElm] = vm[focusedElm] + data;
          if (focusedElm === 'productProvider') {
            changeFocus('productLabel');
          } else if (focusedElm === 'productLabel') {
            changeFocus('productSerialNo');
          } else if (focusedElm === 'productSerialNo') {
            //changeFocus('productProvider');
          }
        });

        //vm[focusElm] = vm[focusElm] + data;
        //$scope.$apply();
      });


      var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
        evt.stopPropagation();
        evt.preventDefault();

        //var isDialogOpen = (angular.element(document.body).hasClass('md-dialog-is-showing')) ? true : false;
        var focusedElm = angular.element($document[0].activeElement).attr('id');
        
        if (angular.isUndefined(focusedElm)) {
          focusedElm = 'productProvider';
        }

        $scope.$apply(function(){
          switch (obj.keyCode) {
            case 8:
              vm[focusedElm] = vm[focusedElm].slice(0, -1);
              break;
            case 13:
              if (focusedElm === 'productLabel' && vm[focusedElm] !== '') {
                changeFocus('productSerialNo');
              }
              //if (vm[focusedElm] !== '') {
              //  if (focusedElm === 'productProvider') {
              //    changeFocus('productLabel');
              //  } else if (focusedElm === 'productLabel') {
              //    changeFocus('productSerialNo');
              //  } else if (focusedElm === 'productSerialNo') {
              //    //changeFocus('productProvider');
              //  }
              //}
              break;
            default:
              if ( focusedElm === 'productSerialNo' ) {
                if (angular.isDefined(vm[focusedElm]))
                  vm[focusedElm] = vm[focusedElm] + key.toUpperCase();
                else
                  vm[focusedElm] = key.toUpperCase();
              }else if ( focusedElm === 'productLabel') {
                if (angular.isDefined(vm[focusedElm]))
                  vm[focusedElm] = vm[focusedElm] + key;
                else
                  vm[focusedElm] = key;
              }
              break;

          }
        });
      });

      function changeFocus(elem){

        $log.debug('changeFocus', elem);

        for (var key in vm.isFocus) {
          if (key === elem)
            vm.isFocus[key] = true;
          else
            vm.isFocus[key] = false;
        }

        //$timeout(function(){
        //  angular.element('#' + elem)[0].focus();
        //}, 10);
      }

      function resetProductLabel() {
        vm.productLabel = '';
        vm.resetLabel = true;
        changeFocus('productLabel');
      }

      vm.addProduct = function () {
        $mdDialog.hide({
          provider: vm.productProvider,
          supplier: vm.productProvider,
          label: vm.productLabel,
          productLabel: vm.productLabel,
          serialNos: [{ serialNo: vm.productSerialNo}],
          amount: 1,
          qty: 1
        })
      }

      vm.reset = function() {
        vm.resetLabel = false;
        vm.productProvider = vm.suppliers[0];
        vm.productLabel = defaultProduct;
        vm.productSerialNo = "";
        changeFocus('productSerialNo');
        //changeFocus('productProvider');
      }

      vm.cancel = function() {
          $mdDialog.cancel();
      };

    }

    function showPopup(msg){
      $mdDialog.show({
         controller: DialogNoticeCtrl,
         controllerAs: 'notice',
         templateUrl: "app/main/dialog.notice.html",
         locals: {
          msg: msg
         },
         fullscreen: false
      }).then(function(){
        changeFocusToProduct(0);
      })
      //ModalService.showModal({
      //  templateUrl: "app/main/modal.notice.html",
      //  controller: function($scope, $element, msg, close){
      //    $scope.content = msg;
      //    $scope.close = function(){
      //      $element.modal('hide');
      //      close(null, 500);
      //    };
      //  },
      //  inputs: {
      //    msg: msg
      //  }
      //}).then(function(modal) {
      //  modal.element.modal();
      //  modal.closed.then(function() {
      //    changeFocusToProduct(0);
      //  });
      //});
    }
    
    function DialogNoticeCtrl($scope, msg){
      var vm = this;
      vm.content = msg;  
      vm.close = function(){
        $mdDialog.hide();
      };

    }

    function DialogAddonsCtrl($scope, formContent){
      var vm = this;
      vm.formSchema = formContent;   
	    vm.isReset = false;
      vm.close = function(){
        $mdDialog.hide();
      };
      vm.reset = function(item){
        $log.log('reset........')
        vm.isReset = true;

        $mdDialog.show({
          controller: function DialogController($scope, $mdDialog) {
            $scope.msg =  _translate('Are you sure to mark the device as abnormal and replace it with a new one?' );
            $scope.title =  _translate('Reset');
            
            $scope.confirm = function() {
              $mdDialog.hide();
            };

            $scope.cancel = function() {
              $mdDialog.cancel();
            };

          },
          multiple: true,
          templateUrl: 'app/main/dialog.confirm.html',
          //parent: vm,
          clickOutsideToClose:false,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
        .then(function() {
          apiFactory.resetAddons(item.url, item.body,
            function(data){
              $log.info('Reset addons done', data);
              vm.formSchema = data.formSchema;
              vm.isReset = false;
            }, 
            function(err){
              $log.error('Reset addons failed', err);
              vm.isProcessing.confirmOrder = '';
              var msg = err.error.message || _translate('msg.mocheckin.addons.reset.error');
              soundEffectFactory.playSound('warning');
              showAlertDialog('error', msg, false, 1500);
              vm.isReset = false;
            });  
        }, function() {
          vm.isReset = false;
        });
    
        // apiFactory.resetAddons(item.url, item.body,
        // function(data){
        //   $log.info('Reset addons done', data);
        //   vm.formSchema = data.formSchema;
        //   vm.isReset = false;
        // }, 
        // function(err){
        //   $log.error('Reset addons failed', err);
        //   vm.isProcessing.confirmOrder = '';
        //   var msg = err.error.message || _translate('msg.mocheckin.addons.reset.error');
        //   soundEffectFactory.playSound('warning');
        //   showAlertDialog('error', msg, false, 1500);
        //   vm.isReset = false;
        // });  
      }

    }

    function searchOrderSuccess(result){
      $log.info('Search checkin order success', result);
      vm.isProcessing.barcodeMessage = '';
      vm.isProcessing.queryString = '';

      for (var i=0, len=result.length; i<len; i++) {
        var productLength = result[i].products ? result[i].products.length : 0;
        if (angular.isUndefined(result[i].remark))
          result[i].remark = '';

        for (var j=0; j<productLength; j++) {
          if (angular.isUndefined(result[i].products[j].serialNos))
            result[i].products[j].serialNos = [];
          else{
            vm.hasPairing = true;
          } 
        }
      }

      switch(result.length) {
        case 0:
          vm.order.barcodeMessage = '';
          vm.order.phoneNumber = '';
          vm.queryString = '';
          toastr.error(_translate('msg.mocheckin.search.nodata'), null);
          vm.multipleOrders = false;
          break;
        case 1:
          vm.orders = result;
          vm.order = result[0];
          vm.multipleOrders = false;
          vm.displayRemark = true;
          vm.urgent = vm.order.urgent;
          vm.productCodeBuffer = new Array(vm.order.products.length);
          //changeFocusToProduct(0);
          addChip(); // Change focus to empty product
          addRemark('agency');
          //getProductAmount();
          break;
        default:  // length > 1
          vm.orders = result;
          vm.order = result[0];
          vm.selectedOrder = result[0];
          lastOrder = result[0];
          vm.urgent = vm.order.urgent;
          vm.multipleOrders = true;
          vm.displayRemark = true;
          vm.productCodeBuffer = new Array(vm.order.products.length);
          //changeFocusToProduct(0);
          addChip(); // Change focus to empty product
          addRemark('agency');
          //getProductAmount();
          break;
      }

      updateChips = false; //reset updateChips to false
      if (vm.order.popup) {
        showPopup(vm.order.popup);
      }
      //if (!angular.equals({}, vm.order) && vm.order.products && vm.order.products.length > 0) {
      //  for (var i=0, len=vm.order.products.length; i<len; i++) {
      //    vm.order.products[i].productCode = [];
      //  }
      //}

   }

    function searchOrderError(err) {
      $log.error('Search checkin order failed', err);
      vm.isProcessing.barcodeMessage = '';
      vm.isProcessing.queryString = '';
      updateChips = false;
      if (err)
        toastr.error(err.error.message || _translate('Unable to retrieve data') , null);
      else
        toastr.error(_translate('Unable to retrieve data'), null);

      vm.order.barcodeMessage = '';
      vm.order.phonenumber = '';
      vm.queryString = '';

    }

    function updateOrderSuccess(result){
      $log.log('Update order success:', result);
      vm.isProcessing.confirmOrder = '';
      soundEffectFactory.playSound('decision');
      //showAlertDialog('success', '領機成功', true, 1500);
      showAlertDialog('success', _translate('msg.mocheckin.update.success'), true, 1500);
    }

    function updateOrderError(err) {
      $log.error('Update order failed', err);
      vm.isProcessing.confirmOrder = '';
      //var msg = err.error.message || '無法更新訂單';
      var msg = err.error.message || _translate('msg.mocheckin.update.error');
      soundEffectFactory.playSound('warning');
      showAlertDialog('error', msg, false, 1500);
      //if (err)
      //  toastr.error(err.error.message, null);
      //else
      //  toastr.error('無法更新訂單', null);

    }

    function toUnicode(string) {
      if (string)
        return escape(string).replace(/%/g,"\\").toLowerCase();
        //return encodeURIComponent(string);
      else
        return '';
    }

    function unUnicode(string) {
      if (string)
        return unescape(string.replace(/\\/g, "%"));
        //return decodeURIComponent(string);
      else
        return '';
    }

    function escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }

  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.locale
 * @description
 * # locale
 * Service in the mpos.
 */
angular.module('mpos')
  .service('localeService', function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $log) {
  'use strict';
  // PREPARING LOCALES INFO
  var localesObj = LOCALES.locales;

  // locales and locales display names
  var _LOCALES = Object.keys(localesObj);
  if (!_LOCALES || _LOCALES.length === 0) {
    $log.error('There are no _LOCALES provided');
  }
  var _LOCALES_DISPLAY_NAMES = [];
  _LOCALES.forEach(function (locale) {
    _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
  });

  // STORING CURRENT LOCALE
  var currentLocale = $translate.proposedLanguage() || $translate.use();// because of async loading

  // METHODS
  var checkLocaleIsValid = function (locale) {
    return _LOCALES.indexOf(locale) !== -1;
  };

  var setLocale = function (locale) {
    if (!checkLocaleIsValid(locale)) {
      $log.error('Locale name "' + locale + '" is invalid');
      return;
    }
    currentLocale = locale;// updating current locale

    // asking angular-translate to load and apply proper translations
    $translate.use(locale)
    .catch(function () {
      $translate.use($translate.fallbackLanguage());
    });
  };  

  // EVENTS
  // on successful applying translations by angular-translate
  $rootScope.$on('$translateChangeSuccess', function (event, data) {
    document.documentElement.setAttribute('lang', data.language);// sets "lang" attribute to html

     // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
    tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
  });

  return {
    getLocaleName: function () {
      return currentLocale;
    },
    getLocaleDisplayName: function () {
      //console.log(currentLocale);
      return localesObj[currentLocale];
    },
    setLocaleByDisplayName: function (localeDisplayName) {
      setLocale(
        _LOCALES[
          _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)// get locale index
          ]
      );
    },
    getLocalesDisplayNames: function () {
      return _LOCALES_DISPLAY_NAMES;
    }
  };
});

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:loginCtrl
 * @description
 * # loginCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('loginCtrl', function ($scope, $log, $q, $localStorage, $state, $mdDialog, toastr, 
    apiFactory, counterService, $filter, $location, LOCALES) {
    var vm = this;
    var _translate = $filter('translate');
    vm.authenicate = login;
    vm.isLocaleSupport = isLocaleSupport;
    vm.isProcessing = false;
    //var currnetLocale = $translate.proposedLanguage();
    //changeLanguage('zh-tw');
    //function changeLanguage (langKey) {
    //  $translate.use(langKey);
    //}
    
    function isLocaleSupport(){
      return true;
      //var host = $location.host();
      //if (LOCALES.hosts.indexOf(host) > -1) {
      //  return true;
      //}else {
      //  return false;
      //}
    }
    
    function login() {
      vm.isProcessing = true;
      apiFactory.login(vm.user, loginSuccessCallback, loginErrorCallback);
    }

    function selectBusinessesDialog(businesses){

      $mdDialog.show({
        templateUrl: "app/main/dialog.businessId.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          businesses: businesses
        },
        controller: DialogBizController,
        controllerAs: 'biz'
      })
      .then(function(answer){

        if (angular.isUndefined($localStorage.user.selectApi) || $localStorage.user.selectApi === null) {
          if (answer.isLoginSuccess) {
            $state.go('home.menu');
            $localStorage.isLogin = true;
          } else {
            showLoginError();
          }
        } else {
          if (answer.isLoginSuccess) {
            //$log.debug($localStorage.user.selectApi)
            checkSelectApi();
         } else {
            showLoginError();
          }
        }


      });

    }

    function DialogBizController($log, $scope, $q, $localStorage, $state, toastr, businesses){
      var vm = this;
      vm.businesses = businesses
      vm.selectedBusiness = vm.businesses[0].id;
      vm.disableBtn = false;

      vm.close = function () {
        $mdDialog.hide({isLoginSuccess: false})
        //toastr.error('登入失敗');
      };

      vm.getBusinessInfo = function () {
        vm.disableBtn = true;
        getBusinessInfo(vm.selectedBusiness, successCallback, errorCallback);
      }

      function successCallback(){
        $log.info('Get business info success');
        vm.disableBtn = false;
        $mdDialog.hide({isLoginSuccess: true})

      }

      function errorCallback() {
        $log.error('Get business info failed');
        $mdDialog.hide({isLoginSuccess: false});
        vm.disableBtn = false;
      }
    }

    function checkSelectApi() {
      switch($localStorage.user.selectApi) {

        case 'opage_checkios': //機場取還機
          counterService.getCounterList()
          .then(function(result){
            if (result.length > 1) {
              //showCounterDialog(result, '請選擇機場核銷櫃檯');
              showCounterDialog(result, 'msg.select.counter');
            }else if (result.length === 1){ // skip select counter
              $localStorage.isLogin = true;
              counterService.setCounter(result[0]);
              $state.go('home.menu');
            }else {
              $log.debug('No counter information');
              showLoginError();
            }
          }, showLoginError);
          break;
        default:
          break;
      }

    }

    function getBusinessInfo(id, success, error) {
      vm.disableBtn = true;
      $q.all([getBusinessProfile(id), getBusinessConfig(id)])
      .then(success, error);

    }


    function getBusinessProfile(id) {
      var defer = $q.defer();
      // get business profile
      apiFactory.getBusinessProfile({id: id}, function(result){
        $log.log('get business profile success:', result);
        $localStorage.business = result;
        defer.resolve();
        //$mdDialog.hide({isLoginSuccess: true})

      }, function(err){
        $log.error('get business profile error:', err);
        defer.reject();
      });

      return defer.promise;
    }

    function getBusinessConfig(id) {
      var defer = $q.defer();
      // get business config
      apiFactory.getBusinessConfig({id: id}, function(result){
        $log.log('get business config success:', result)
        $localStorage.businessConfig = result;
        defer.resolve();
      }, function(err){
        $log.log('get business config error:', err);
        defer.reject();
      });

      return defer.promise;
    }

    function showCounterDialog (counter, msg){
      $log.debug('show counter');
      // speed up to show dialog
      $mdDialog.show({
        controller: DialogCounterCtrl,
        controllerAs: 'counter',
        templateUrl: "app/main/dialog.counters.html",
        locals: {
          counters: counter, //Should be an array.
          placeholder: msg
        },
        escapeToClose: false,
        clickOutsideToClose: false,
        //targetEvent: ev,
        fullscreen: false
      }).then(function(answer){
        $log.log('Select counter:', answer);
        vm.isProcessing = false;
        if (angular.isDefined(answer)) {
          $localStorage.isLogin = true;
          counterService.setCounter(answer);
          $state.go('home.menu');
        } else {
          showLoginError();
        }

       }, function(){
          $log.debug('Do not select counter');
          showLoginError();
          //toastr.warning('請選擇機場核銷/櫃檯報到核銷活動資訊');
      })

    }

    /**
    * A controller for the dialog that selects target business ID.
    */
    function DialogCounterCtrl($scope, $q, counters, placeholder, $mdDialog){
      var vm = this;
      //$log.debug(counters);
      vm.selectedCounter = counters[0];
      vm.counters = counters;
      vm.placeholder = placeholder;

      vm.answer = function(){
        if(! vm.selectedCounter || !("appId" in vm.selectedCounter))//If no selection made.
            $mdDialog.cancel();
        else
            $mdDialog.hide(vm.selectedCounter);
      };

      vm.cancel = function() {
          $mdDialog.cancel();
      };
    }


    function loginSuccessCallback(result){
      $log.debug('login success:', result);
      $localStorage.user = result;

      //get business list
      apiFactory.getBusinesses( function(result){
        $log.log('get businesses success:', result);

        if (result.length > 1) {
          selectBusinessesDialog(result);
        }else if (result.length === 1){ // skip select business
          getBusinessInfo(result[0].id, function(){
            $log.info('Get business info success');
            if (angular.isUndefined($localStorage.user.selectApi) || $localStorage.user.selectApi === null) {
              $localStorage.isLogin = true;
              $state.go('home.menu');
            }else {
              checkSelectApi();
            }
          }, function(){
            $log.info('Get business info failed');
            showLoginError();
          });
        }else {
          $log.debug('No business info');
          showLoginError();
        }
      }, function(err){
        $log.error('get businesses error:', err);
        //toastr.error('無法取得企業列表');
        toastr.error(_translate('Cannot get businesses list'));
      });

      //vm.isProcessing = false;
    }

    function loginErrorCallback(result){
      $log.debug('login error:', result);
      vm.isProcessing = false;
      if (result && result.error) {
        toastr.error(result.error.message || _translate('Login failed'));
      }else {
        toastr.error(_translate('Login failed'));
      }
      //$localStorage.$reset();
    }

    function showLoginError() {
      //$log.info($filter('translate')('Login failed'));
      toastr.error(_translate('Login failed'));
      //$localStorage.$reset();
      vm.isProcessing = false;
    }
  });


'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:languageSelect
 * @description
 * # languageSelect
 */
angular.module('mpos')
  .directive('languageSelect', function (localeService) { 
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        template: ''+
        '<div layout-padding class="language-select" ng-if="visible" layout="row">'+
          '<md-select aria-label="language-select" ng-model="currentLocaleDisplayName" ng-change="changeLanguage(currentLocaleDisplayName)"> ' +
          '  <md-optgroup>' +
          '   <md-option ng-repeat="localesDisplayName in localesDisplayNames" ng-value="localesDisplayName">{{localesDisplayName}}</md-option>' +
          '  </md-optgroup>' +
          '</md-select>' +
        '</div>'+
        '',
        //template: ''+
        //    '<div class="language-select" ng-if="visible">'+
        //        '<label>'+
        //            '{{"directives.language-select.Language" | translate}}:'+
        //            '<select ng-model="currentLocaleDisplayName"'+
        //                'ng-options="localesDisplayName for localesDisplayName in localesDisplayNames"'+
        //                'ng-change="changeLanguage(currentLocaleDisplayName)">'+
        //            '</select>'+
        //        '</label>'+
        //    '</div>'+
        //    '',
        controller: function ($scope) {
            $scope.currentLocaleDisplayName = localeService.getLocaleDisplayName();
            $scope.localesDisplayNames = localeService.getLocalesDisplayNames();
            $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

            $scope.changeLanguage = function (locale) {
                localeService.setLocaleByDisplayName(locale);
            };
        }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:keypressEvents
 * @description
 * # keypressEvents
 */
angular.module('mpos')
  //.directive('keypressEvents', function ($document, $rootScope) {
  .directive('keypressEvents', function ($window, $document) {
    return {
      restrict: 'A',
      link: function (scope) {
        $document.bind('keypress', handler);
        $document.bind('keydown', handler);
        $document.bind('paste', pasteHandler);

        scope.$on('$destroy', function() {
          $document.unbind('keypress', handler);
          $document.unbind('keydown', handler);
          $document.unbind('paste', pasteHandler);
        });

        function handler(e) {
          //$rootScope.$broadcast('keypress', e, String.fromCharCode(e.which));
          e.stopPropagation();
          //e.preventDefault();
          // prevent backspace previous page
          if (e.keyCode === 8) {
            e.preventDefault();
          }

          if (e.type === 'keydown' && e.ctrlKey) {
            switch (e.keyCode) {
              case 67:
              case 70:
              case 80:
              case 82:
              case 83: //s
                e.preventDefault();
                scope.$emit('shortcutEvents', e, String.fromCharCode(e.which));
                break;
              default:
                break;

            }
          }

          if (e.type === 'keydown' && e.keyCode === 8) {
            scope.$emit('keypressEvents', e, String.fromCharCode(e.which));
          }

          if (e.type === 'keypress' && !e.ctrlKey) {
            e.preventDefault();
            scope.$emit('keypressEvents', e, String.fromCharCode(e.which));
          }

        }

        function pasteHandler(e){
          e.stopPropagation();
          e.preventDefault();

          // plain text
          var pastedData = '';
          if (e.clipboardData || e.originalEvent.clipboardData) {
            pastedData = (e.originalEvent || e).clipboardData.getData('text/plain');
          } else if (window.clipboardData) {
            pastedData = window.clipboardData.getData('Text');
          }
          //var clipboardData = e.originalEvent.clipboardData || e.clipboardData || $window.clipboardData;
          //var pastedData = clipboardData.getData('Text');
          scope.$emit('pasteEvent', pastedData.trim());
          //var currentValue = ngModel.$modelValue;
          //ngModel.$setViewValue(currentValue + pastedData);
          //ngModel.$render();
          //ngModel.$commitViewValue();
          //element[0].value(pastedData);

        }


      }
    }
  });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:eventsCtrl
 * @description
 * # eventsCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('eventsCtrl', function ($rootScope, $scope, $log, $timeout, $document, $location, $stateParams, $state, 
    $filter, $localStorage, $mdDialog, toastr, apiFactory, $mdSidenav, $interval, iiotWebsocket) {

    var vm = this;
    var reconnectWSCount = 0;
    var myState = $state.current.name;
    var unbindWatchPaste = null;
    var unbindWatchKeyPress = null;
    var unbindWatchPoints = null;
    var eventId = $stateParams.eventId;
    //var eventLabel = getEventLabel(eventId);
    var messageMap = {
      'Missing required parameter - barcodeMessage': '條碼不得空白',
      'This barcode is been used.': '此條碼已有人使用，請重新輸入',
      'Missing required parameters': '缺乏必要參數，請洽工程人員',
      'Not Found': '查無資料，請現場報名或重新輸入'
    };
    var timerToggleRight = null;
    vm.selectedEvent = null;
    vm.latestCheckNo = 20;
    vm.latestCheckin = [];    // 儲存最後報到的幾筆資料
    vm.latestCandidates = []; // 儲存最後搜尋到的名單
    vm.memberList = null;     // 顯示用，指向 latestCheckin or latestCandidates
    vm.listType = null;       // 目前清單顯示最後報到 'checkin' or 搜尋結果 'candidate'
    
    vm.redirect = redirect;
    vm.changeFocus = changeFocus;
    vm.sendPass = sendPass;
    vm.searchBarcode = searchBarcode;
    vm.togglePairing = togglePairing;
    vm.toggleSearch = toggleSearch;
    vm.showMemberInfo = showMemberInfo;
    vm.reset = reset;
    vm.addPhoneNumber = addPhoneNumber;
    vm.printBadge = printBadge;
    vm.isPrefix = isPrefix;
    vm.updateProfile = updateProfile;
    
    vm.toggleRight = toggleRight;
    vm.toggleCounter = 0;
    vm.searchType = 'all';  // 'all': 搜尋姓名、公司或email, 'sn'：報到序號
    
    vm.newPhoneNumber = ''; // 如果沒有電話，可以新增（但不能修改！）
    vm.mposFields = {};     // 自定義欄位（以 'mpos' 為開頭的 key，例如：mposXXXX）
    vm.distFields = {};     // dist 具備的 profile 欄位
    vm.autoPrint = true;
    // websocket
    var wsConnection = null;
    var intervalWsTask = null;
    var reconnectWSTask = null;
    vm.queue = [];
    vm.websocket = $localStorage.ws || {"id":"","enabled":false};
    //vm.toggleWebsocket = toggleWebsocket;
    
    // var ePosDev = null; //new epson.ePOSDevice(); 
    // var printer = null;
    (function initController(){

      if (myState === 'home.events') {
        var refreshDuration = 60 * 60 * 1000;
        var currentTime = new Date().getTime();
        var diff;

        if ($localStorage.events && $localStorage.events_timestamp) {
          diff = currentTime - $localStorage.events_timestamp;
        } else {
          diff = null;
        }

        if (diff && diff <= refreshDuration && $localStorage.events.length > 0) {
          vm.eventList = $localStorage.events;
        }else {
          apiFactory.getEvents(getEventsSuccess, getEventsError);
        }
      }else if (myState === 'home.events.event') {
        vm.latestCheckin = [];
        if (eventId) {
          vm.isRequired = {
            query: true,
            newBarcode: false,
            newPhoneNumber: false,
          };
          vm.member = {};
          vm.newPhoneNumber = '';
          vm.mposFields = {};
          vm.newBarcode = '';
          vm.isProcessing = {
            'query': '',
            'newBarcode': '',
            'newPhoneNumber': ''
          };
          vm.selectedEvent = $filter('filter')($localStorage.events, {id: eventId})[0];
          vm.enableBarcodeUpdate = (vm.selectedEvent.changeBarcodeOn) ? vm.selectedEvent.changeBarcodeOn : false;
          vm.enablePhoneSearch = false;        // true: 查詢模式, false: 掃碼模式
          vm.enablePhoneSearchManual = vm.enablePhoneSearch;  // 記憶使用者手動切換的結果
		　    vm.autoPrint = false;
          changeFocus('query');
          handler();
          $timeout(function() {
            vm.toggleRight(true);
          }, 500);
          getEventDashboard();
          getDistFields();
          
          getBadgeDesign();
          $log.log('[event] websocket setting', vm.websocket);
          if (vm.websocket.enabled) {
            $log.log('[init] init websocket');
            initWebsocket();
          }
        }else {
          $state.go('home.events');
        }
      }

     })();

    $scope.$on('$destroy', function () {
      if (unbindWatchPaste) unbindWatchPaste();
      if (unbindWatchKeyPress) unbindWatchKeyPress();
      if (unbindWatchPoints) unbindWatchPoints();
      if (wsConnection) wsConnection.close();
      //if (intervalWsTask) $interval.cancel(intervalWsTask);
    });

    $rootScope.$on('websocket', function(event, data){
      $log.log(event, data);
      vm.websocket = data; //Rely on localStorage for "storage" only, not for communication.
      if (vm.websocket.enabled) {
        if (!wsConnection) {
          $log.log('[event] init websocket (currently no websocket connection)');
          initWebsocket();
        } else if (wsConnection.readyState === WebSocket.CLOSED) {
          $log.log('[event] init websocket (currently websocket has closed)');
          initWebsocket();
        }else {
          $log.log('[event] websocket already connected');
        }
      }else {
        if (wsConnection) wsConnection.close();
      }
       
    });
    
    function translateMessage (msg) {
      if (!msg) {
        return;
      }
      return messageMap[msg] || msg;
    }

    function toggleRight(open) {

      var toggleMode = 'toggle';
      if(open===true) {
        toggleMode = 'open';
      } else if(open===false) {
        toggleMode = 'close';
      }
      $mdSidenav('right')
        // .toggle()
        [toggleMode]()
        .then(function () {
          $log.debug("toggle: " + toggleMode + " is done");
        });
    }

    function isOpenRight() {
      $log.debug('isOpenRight', $mdSidenav('right').isOpen());
      return $mdSidenav('right').isOpen();
    }

    function handler() {
      // catch keypress event for barcode scanner
      unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {
        var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
          if (isDialogOpen) {
            var isPrinterInput = $document[0].getElementById('printerIP') ? true : false;
            
            $log.debug('isPrinterInput:', isPrinterInput);

            if (isPrinterInput) {
              return;
            }
          }
          
        if (vm.isRequired.query) {
          if (vm.isProcessing.query) {
            return;
          } else {
            if (vm.enablePhoneSearch) {
              vm.query = vm.query+ data;  // phone search
            }else {
              vm.query = vm.query+ data.toUpperCase(); // barcode scan
            }
            
            $scope.$apply();
          }
        } else if (vm.isRequired.newBarcode) {
            vm.newBarcode = vm.newBarcode+ data.toUpperCase();
        } else {
          return;
        }
      });

      unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
        $log.debug('keypressEvents', evt, obj, key, obj.key);
        //var shifton = false;
        //if (obj.shiftKey) {
        //    shifton = obj.shiftKey;
        //} else if (obj.modifiers) {
        //    shifton = !!(obj.modifiers & 4);
        //}
        //
        //$log.info('keypress keycode:', obj.keyCode, obj.key, obj.shiftKey, obj.modifiers, shifton)

        // 為了避免在提示對話框尚未關閉前，連續掃描 barcode，這邊會檢查是否有對話框，若有，返回。
        var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
        if (isDialogOpen) {
          var isNewBarcodeInput = $document[0].getElementById('newBarcode') ? true : false;
          var isPrinterInput = $document[0].getElementById('printerIP') ? true : false;
          
          $log.debug('isNewBarcodeInput:', isNewBarcodeInput);
          $log.debug('isPrinterInput:', isPrinterInput);
          // 但是如果對話裡頭有 new barcode input，那就繼續
          if (!isNewBarcodeInput) {
            return;
          }
          if (isPrinterInput) {
            return;
          }
        }

        //evt.stopPropagation();
        // if (vm.isProcessing.query ||
        //     vm.isProcessing.newBarcode ||
        //     vm.isProcessing.newPhoneNumber) return;
        var prop;
        for (prop in vm.isProcessing) {
          if (hasOwnProperty.call(vm.isRequired, prop)) {
            if (vm.isProcessing[prop]) {
              return;
            }
          }
        }

        if (obj.keyCode === 8) { // [BackSpace]
          evt.preventDefault();
        }

        $log.debug('isRequired', vm.isRequired);

        $scope.$apply(function () {
         if (vm.isRequired.query) {
            switch (obj.keyCode) {
              case 8: // backspace
                if (angular.isDefined(vm.query))
                  vm.query = vm.query.slice(0, -1);
                break;
              case 10:
              case 13:  // enter key event
                searchBarcode();
                break;
              default:
                if (vm.enablePhoneSearch) {
                  if (angular.isDefined(vm.query))
                    vm.query = vm.query + key;
                  else
                    vm.query = key;  
                  
                }else {
                  if (angular.isDefined(vm.query))
                    vm.query = vm.query.toUpperCase() + key.toUpperCase();
                  else
                    vm.query = key.toUpperCase();
                }     
                break; 
               
            }
          } else if (vm.isRequired.newBarcode) {
              switch (obj.keyCode) {
                case 8:
                  if (angular.isDefined(vm.newBarcode))
                    vm.newBarcode = vm.newBarcode.slice(0, -1);
                  break;
                case 10:
                case 13:  // enter key event
                  doUpdatePass();
                  break;
                default:
                  // only allow number, :, / , and alphabet 
                  if ((obj.keyCode >= 48 && obj.keyCode <=57) || (obj.keyCode >= 65 && obj.keyCode <=90) || (obj.keyCode >= 97 && obj.keyCode <=122) || obj.keyCode===92 || obj.keyCode===47) {
                    if (angular.isDefined(vm.newBarcode))
                      vm.newBarcode = vm.newBarcode + key.toUpperCase();
                    else
                      vm.newBarcode = key.toUpperCase();
                  } else{
                    return;
                  }
                  //if (angular.isDefined(vm.newBarcode))
                  //  vm.newBarcode = vm.newBarcode + key.toUpperCase();
                  //else
                  //  vm.newBarcode = key.toUpperCase();
                  break;
              }
          } else if (vm.isRequired.newPhoneNumber) {
              switch (obj.keyCode) {
                case 8: // backspace
                  if (angular.isDefined(vm.newPhoneNumber))
                    vm.newPhoneNumber = vm.newPhoneNumber.slice(0, -1);
                  break;
                case 10:
                case 13:  // enter key event
                  addPhoneNumber();
                  break;
                default:
                  // if (angular.isDefined(vm.newPhoneNumber))
                  //   vm.newPhoneNumber = vm.newPhoneNumber + key.toUpperCase();
                  // else
                  //   vm.newPhoneNumber = key.toUpperCase();
                  if (angular.isDefined(vm.newPhoneNumber)) {
                    if (vm.newPhoneNumber==='' && key === '+') {
                      vm.newPhoneNumber = vm.newPhoneNumber + key;
                    } else if (48 <= obj.keyCode && obj.keyCode <= 58) {
                      $log.log('yes',obj.keyCode);
                      vm.newPhoneNumber = vm.newPhoneNumber + key;
                    }
                  }
                  // vm.newPhoneNumber = vm.newPhoneNumber.replace(/\D/g, '');
                  break;
              }
          }

          for (prop in vm.isRequired) {
            if (hasOwnProperty.call(vm.isRequired, prop)) {
              if (prop !== 'query' && prop !== 'newBarcode' && prop !== 'newPhoneNumber' && vm.isRequired[prop]) {
                switch (obj.keyCode) {
                  case 8:
                    if (angular.isDefined(vm.mposFields[prop]))
                      vm.mposFields[prop] = vm.mposFields[prop].slice(0, -1);
                    break;
                  case 10:
                  case 13:  // enter key event
                    updateProfile(prop, vm.mposFields[prop]);
                    break;
                  default:
                    if (angular.isDefined(vm.mposFields[prop]))
                      vm.mposFields[prop] = vm.mposFields[prop] + key;
                    else
                      vm.mposFields[prop] = key;
                    break;
                }
              }
            }
          }

        });
      });

      // catch keyboard simulator for phone
      unbindWatchPoints = $scope.$watch(function watchPoints(){
        return vm.query;
      }, function(newVal){
        // if (vm.isProcessing.query ||
        //     vm.isProcessing.newBarcode ||
        //     vm.isProcessing.newPhoneNumber) return;
        var prop;
        for (prop in vm.isProcessing) {
          if (hasOwnProperty.call(vm.isRequired, prop)) {
            if (vm.isProcessing[prop]) {
              return;
            }
          }
        }

        /*
         * If member info is not ready, keyboard value apply to phoneNumber
         */
        if (vm.isRequired.query && angular.equals({}, vm.member)) {
            vm.query = newVal;
        }
        return;
      });
    }


    function showAlertDialog(type, msg, time, reset, print){

      //var myColor;
      //var icon;
      var duration = time || 2000;

      var dlg = $mdDialog.alert({
        templateUrl: "app/main/dialog.message.event.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          msg: msg,
          type: type,
          parent: vm
        },
        controller: ['$scope', '$mdDialog', '$sce', 'msg', 'type', 'parent', function ($scope, $mdDialog, $sce, msg, type, parent ){
          var vm = this;
          var alert = type;
          vm.type = type;
          vm.msg = $sce.trustAsHtml(msg);
          vm.parent = parent;
          $log.debug('showAlertDialog', msg, type, reset, parent);
          switch(alert) {
            case 'confirmError':
              vm.enableCloseBtn = true;
              vm.icon = 'error_circle';
              vm.myColor= '#FFA2A2';
              break;
            case 'error':
              vm.icon = 'error_circle';
              vm.myColor= '#FFA2A2';
              break;
            case 'warning':
              vm.icon = 'warning';
              vm.myColor= '#FAED33';
              break;
            default:
              vm.icon = 'check_circle';
              vm.myColor = '#A4FFA2';
              if (vm.parent.isRequired.newBarcode) {
                // vm.enableCloseBtn = true;
                vm.enableCloseBtn = false;  // 如果設並必須換碼，就一定要換碼後才能把限制名單搬到 pass2u-checkout
                // vm.isRequired.newBarcode = true;
              }
              break;
          }
          
          vm.close = function (){
            $mdDialog.hide();
          };
        }],
        controllerAs: 'msgCtrl',
        onComplete: function(){
          // vm.isProcessing.query= '';
          // vm.isProcessing.newBarcode = '';
          // vm.isProcessing.newPhoneNumber = '';
          var prop;
          for (prop in vm.isProcessing) {
            if (hasOwnProperty.call(vm.isRequired, prop)) {
              vm.isProcessing[prop] = '';
            }
          }

          if (type !== 'confirmError' && !vm.isRequired.newBarcode) {
            $timeout(function(){
              $mdDialog.hide();
            }, duration)
          }
          
        },
        onRemoving: function(){ 
          
          if (print) {
            printBadge(vm.member);
          }
          if (reset)
            changeFocus('query');
          
          // if (!reset && vm.enableBarcodeUpdate) {
          //   vm.isRequired.newBarcode = true;
          //   changeFocus('newBarcode');
          // }
        }
      });

      $mdDialog.show(dlg);

      if (vm.isRequired.newBarcode) {
        vm.lastAlertDialog = dlg;
      }

      // $timeout(function() {
      //   $mdDialog.hide(vm.lastAlertDialog);
      // }, 5000);

    }

    function togglePairing() {
      if (!vm.enableBarcodeUpdate) {
        vm.query = '';
        changeFocus('query');
      }
    }
    
    function toggleSearch() { // 手動切換模式
        vm.query = '';
        vm.enablePhoneSearchManual = vm.enablePhoneSearch;  // 記錄手動切換的模式

        // 把名單恢復為報到記錄
        vm.memberList = vm.latestCheckin;
        vm.listType = 'checkin';

        changeFocus('query');
    }
    
    function getBadgeDesign(){
      apiFactory.getBadgeDesign(eventId, null, getBadgeDesignSuccess, getBadgeDesignError);
    }

    function getBadgeDesignSuccess(data){
      // Parse data to replace some content
      $log.log('[event-controller] get badge design successfully');
      $log.log('[event-controller] template:', angular.copy(data));
      vm.badgeDesign = data
      $log.log('[event-controller] actual data:', data);
    }

    function getBadgeDesignError(err) {
      $log.error('[print badge] Get badge design failed:', err);
      toastr.error('Fail to get badge design');
    }

    function showMemberInfo(data){
      $log.debug('showMemberInfo', data);
      changeFocus('query');
      vm.enablePhoneSearch = false;
      vm.query = data.barcodeMessage;
      vm.member = data;
      vm.newPhoneNumber = data.profile.phoneNumber ? data.profile.phoneNumber : '';
      var prop;
      for (prop in data.profile) {
        if (hasOwnProperty.call(data.profile, prop)) {
          if (isPrefix(prop)) {
            vm.mposFields[prop] = data.profile[prop];
          }
        }
      }

      // async check checkin status
      apiFactory.eventCheckinStatus(eventId, { barcodeMessage: vm.query.toUpperCase() }, function(data) {
        $log.debug(data);
        $log.debug(data.order);
        vm.member.checkinTime = data.checkinTime;
        vm.member.order = data.order;
      }, function(err) {
        $log.error(err);
      });

      if (timerToggleRight) {
        $interval.cancel(timerToggleRight);
        vm.toggleCounter = 0;
      }
      timerToggleRight = $interval(function() {
        vm.toggleCounter++;
        if (vm.toggleCounter>=100) {
          toggleRight(true);
        }
      }, 30, 100);
    }
    
    //function getEventLabel(id) {
    //  if (id && $localStorage.events) {
    //    var event = $localStorage.events.filter(function(el){
    //      return el.id === id;
    //    });
    //    
    //    return event[0].label;
    //  }else {  
    //    return null;
    //  }
    //  
    //}
    
    function printBadge(member){

      $mdDialog.show({
        templateUrl: "app/main/dialog.printBadge.html",
        escapeToClose: false,
        clickOutsideToClose: false,
        preserveScope: true,
        locals: {
          member: member,
          event: eventId,
          auto: vm.autoPrint,
          badge: vm.badgeDesign
        },
        controller: function($scope, member, event, auto, badge){
          $scope.content = member; // print content
          $scope.name = member.displayName;
          $scope.company = member.profile.company || member.profile.iiotCompany;
          $scope.event = eventId;
          $scope.badge = badge;
          $scope.autoPrint = auto;
          // $scope.eposDev = ePosDev;
          // $scope.printer = printer;
          $log.debug('[printBadge]');
          $scope.close = function(){
            // ePosDev = $scope.eposDev;
            // printer = $scope.printer;
            $mdDialog.cancel()
          } 
          /*
          $scope.printerIP = '';
          var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
            evt.stopPropagation();
            evt.preventDefault();
            $scope.$apply(function(){
              switch (obj.keyCode) {
                case 8:
                  if (angular.isDefined($scope.printerIP))
                    $scope.printerIP = $scope.printerIP.slice(0, -1);
                  break;
                case 13:
                  break;
                default:
                
                  if (angular.isDefined($scope.printerIP))
                    $scope.printerIP = $scope.printerIP + key;
                  else
                    $scope.printerIP = key;
                  break;

              }
            });
          });
          
          $scope.$on('$destroy', function () {
            if (unbindWatchKeyPress) unbindWatchKeyPress();
          });
          */          
        }  
      })
    }
    
    // 搜尋票卡
    function searchBarcode() {
      var params;
      if (vm.isProcessing.query || vm.isProcessing.newBarcode) {
        return;
      }
      vm.member = {}
      vm.newPhoneNumber = '';
      vm.mposFields = {};
      
      if (vm.query === '') {
        return;
      } else if (vm.enablePhoneSearch && vm.query) { // 搜尋關鍵字
        $log.debug('searchBarcod by phone');

        // 搜尋電話+報到
        // var isPhoneMatch = vm.query.match(/^09[0-9]{8}$/) || vm.query.match(/^\+886[0-9]{9}$/);
        // if (isPhoneMatch) {
        //   params = {phoneNumber: vm.query};
        //   vm.isProcessing.query = 'indeterminate';
        // }else {
        //   toastr.warning('會員電話格式錯誤');
        //   //showAlertDialog('會員電話格式錯誤', true);
        //   return;
        // }

        // params = {queryString: vm.query};
        if(vm.searchType==='all') {
          params = {queryString: vm.query};
        } else {
          params = {iiotSn: vm.query};
        }
        vm.isProcessing.query = 'indeterminate';
        apiFactory.searchEventGuestCandidates(eventId, params, searchGuestSuccess, searchGuestError)
      } else if (!vm.enablePhoneSearch && vm.query){ // 用條碼報到
        $log.debug('searchBarcod by barcode');
        params = {
          barcodeMessage: vm.query.toUpperCase(),
          changeBarcodeOn: vm.enableBarcodeUpdate // 把動態核銷名單搬到 pass2u-checkout 的時機： (1) 如果不需配對，會在 checkin 後，(2) 如果需要配對，會在 barcode-mapping 後。
        };
        vm.isProcessing.query = 'indeterminate';
        // apiFactory.searchEventBarcode(eventId, params, searchBarcodeSuccess, searchBarcodeError);
        apiFactory.checkinEventBarcode(eventId, params, checkinBarcodeSuccess, checkinBarcodeError);
      } else {
        return;
      }
    }

    // 重新發卡
    function sendPass(member) {
      var params = {cardId: member.cardId};
      vm.isProcessing.newBarcode = 'indeterminate';

      apiFactory.sendEventPass(eventId, params, sendPassSuccess, sendPassError);
    }

    // 配對用
    function doUpdatePass() {

      if (!vm.newBarcode) {
        return;
      }

      $log.debug('update pass');
      var params = {
        barcodeMessage: vm.newBarcode,
        // phoneNumber: vm.member.phoneNumber
        cardId: vm.member.cardId,
        changeBarcodeOn: vm.enableBarcodeUpdate // 把動態核銷名單搬到 pass2u-checkout 的時機： (1) 如果不需配對，會在 checkin 後，(2) 如果需要配對，會在 barcode-mapping 後。
      };
      vm.isProcessing.newBarcode = 'indeterminate';

      //apiFactory.searchEventBarcode(eventId, {barcodeMessage: vm.newBarcode}, checkBarcode, searchBarcodeError)
      apiFactory.updateEventBarcode(eventId, params, updateBarcodeSuccess, updateBarcodeError);
    }

    function changeFocus(elem){

      if (vm.isProcessing.query || vm.isProcessing.newBarcode) {
        return;
      }

      var prop;
      for (prop in vm.isRequired) {
        if (hasOwnProperty.call(vm.isRequired, prop)) {
          if (prop === elem) {
            vm.isRequired[prop] = true;
          } else {
            vm.isRequired[prop] = false;
          }
        }
      }

      switch (elem) {
        case 'query':
          //vm.member = {
          //  barcodeMessage: '',
          //  phoneNumber: ''
          //};
          vm.query = '';
          vm.newBarcode = '';
          vm.displayList = '';
          vm.isRequired.query = true;
          vm.isRequired.newBarcode = false;
          vm.isRequired.newPhoneNumber = false;
          break;
        case 'newBarcode':
          vm.newBarcode = '';
          vm.isRequired.query = false;
          vm.isRequired.newBarcode = true;
          vm.isRequired.newPhoneNumber = false;
          break;
        case 'newPhoneNumber':
          vm.isRequired.query = false;
          vm.isRequired.newBarcode = false;
          vm.isRequired.newPhoneNumber = true;
          break;
        default:
          break;
      }

      vm.isRequired[elem] = true;

      angular.element('#' + elem)[0].focus();
  
    }

    function reset() {
      $log.debug('reset', vm.enablePhoneSearch, vm.isProcessing);
      vm.member = {};
      vm.newPhoneNumber = '';
      vm.mposFields = {};
      changeFocus('query');
    }

    function getEventDashboard(){
      
      apiFactory.getEventDashboard(eventId, {fields: 'dists,checkins'}, getEventDashboardSuccess, getEventDashboardError);
    }

    function getDistFields() {
      apiFactory.getDistFields(eventId, function(data) {
        if(data) {
          // vm.distFields = data.reduce((acc, cur) => {
          //   acc[cur.key] = cur.label;
          //   return acc;
          // }, {});
          vm.distFields = data.reduce(function (acc, cur) {
            acc[cur.key] = cur.label;
            return acc;
          }, {});
        }
      }, function(err) {
        $log.error(err);
      });
      
    }
    //function checkBarcode(result){
    //
    //  $log.log('check barcode success', result);
    //  var params = {
    //    barcodeMessage: vm.newBarcode,
    //    phoneNumber: vm.member.phoneNumber
    //  };
    //
    //  if (angular.equals({}, result)) {
    //    apiFactory.updateEventBarcode(eventId, params, updateBarcodeSuccess, updateBarcodeError);
    //  }else {
    //    showAlertDialog('此條碼已有人使用，請重新輸入');
    //    changeFocus('newBarcode');
    //    vm.isProcessing.newBarcode = '';
    //  }
    //
    //}

    //function searchBarcodeSuccess(result){
    //
    //  $log.log('search barcode success', result);
    //  if (angular.equals({}, result)) {
    //    showAlertDialog('confirmError', '查無資料，請您先去註冊', 1000, true);
    //  }else {
    //    vm.member = result;
    //    //vm.member.displayName = result.displayName;
    //    //vm.displayList = result.fields;
    //    vm.isProcessing.query = '';
    //    //vm.query = ''
    //    //vm.keyboard.value = '';
    //    
    //    var inList = $filter('filter')(vm.latestCheckin, {phoneNumber: result.phoneNumber});
    //    if (inList.length === 0) {
    //      // vm.member.checkinTime = $filter('date')(new Date(), 'HH:mm:ss');
    //      vm.latestCheckin.unshift(vm.member);
    //      //vm.latestCheckin.unshift({
    //      //  order: result.order,
    //      //  barcodeMessage: result.barcodeMessage,
    //      //  displayName: result.displayName,
    //      //  phoneNumber: result.phoneNumber,
    //      //  checkinTime: $filter('date')(new Date(), 'HH:mm:ss')
    //      //});
    //      
    //      if (vm.latestCheckin.length === vm.latestCheckNo) {
    //          vm.latestCheckin.pop();
    //      }
    //    }
    //    
    //    //if (vm.enableBarcodeUpdate) {
    //    //    vm.isRequired.query = false;
    //    //    vm.isRequired.newBarcode = true;
    //    //    changeFocus('newBarcode');
    //    //}
    //    
    //    if (vm.enableBarcodeUpdate) {
    //      vm.isRequired.newBarcode = true;
    //      vm.isRequired.query = false;
    //      vm.isRequired.newPhoneNumber = false;
    //    }
    //    if (result.checkinStatus) {
    //      // showAlertDialog('success', '報到成功，報到序號 : ' + result.order, 1000, !vm.enableBarcodeUpdate);
    //      showAlertDialog('success', '報到成功，報到序號 : ' + result.order, 1000, true);
    //    }else {
    //      // showAlertDialog('success', '已報到過，報到序號 : ' + result.order, 1000, !vm.enableBarcodeUpdate);
    //      showAlertDialog('success', '已報到過，報到序號 : ' + result.order, 1000, true);
    //    }
    //
    //    toggleRight(false);        
    //
    //    getEventDashboard();
    //  }
    //
    //}
    //
    //function searchBarcodeError(result) {
    //  $log.error('search barcode error', result);
    //  var msg = translateMessage(result.error.message);
    //  if (vm.enablePhoneSearch) {
    //    msg = '<span style="float:left">查詢關鍵字：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
    //  } else {
    //    msg = '<span style="float:left">掃描條碼：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
    //  }
    //  showAlertDialog('confirmError', msg, 1000, true);
    //  vm.isProcessing.newBarcode = '';
    //  vm.isProcessing.barcodeMessage = '';
    //  vm.isProcessing.phoneNumber = '';
    //}

    function checkinBarcodeSuccess(result){

      $log.log('checkin barcode success', result);
      if (angular.equals({}, result)) {
        showAlertDialog('confirmError', '查無資料，請您先去註冊', 1000, true);
      }else {

        vm.memberList = vm.latestCheckin;
        vm.listType = 'checkin';
        
        vm.member = result;
        //vm.member.displayName = result.displayName;
        //vm.displayList = result.fields;
        vm.isProcessing.query = '';
        //vm.query = ''
        //vm.keyboard.value = '';

        // update mposFields
        showMemberInfo(result);
        
        var inList = $filter('filter')(vm.latestCheckin, {phoneNumber: result.phoneNumber});
        if (inList.length === 0) {
          // vm.member.checkinTime = $filter('date')(new Date(), 'HH:mm:ss');
          vm.order = result.order;
          vm.latestCheckin.unshift(vm.member);
          //vm.latestCheckin.unshift({
          //  order: result.order,
          //  barcodeMessage: result.barcodeMessage,
          //  displayName: result.displayName,
          //  phoneNumber: result.phoneNumber,
          //  checkinTime: $filter('date')(new Date(), 'HH:mm:ss')
          //});
          
          if (vm.latestCheckin.length === vm.latestCheckNo) {
              vm.latestCheckin.pop();
          }
        }
        
        //if (vm.enableBarcodeUpdate) {
        //    vm.isRequired.query = false;
        //    vm.isRequired.newBarcode = true;
        //    changeFocus('newBarcode');
        //}
        
        if (vm.enableBarcodeUpdate && !vm.member.isBarcodeChanged) {
          vm.isRequired.newBarcode = true;
          vm.isRequired.query = false;
          vm.isRequired.newPhoneNumber = false;
        }
        if (result.checkinStatus) {
          // showAlertDialog('success', '報到成功，報到序號 : ' + result.order, 1000, !vm.enableBarcodeUpdate);
          if (vm.autoPrint) {
            showAlertDialog('success', '報到成功，報到順序 : ' + result.order + '，列印準備中', 200, true, true);
          }else {
            showAlertDialog('success', '報到成功，報到順序 : ' + result.order, 1000, true);
          }
          
          
        }else {
          showAlertDialog('success', '已報到過，報到序號 : ' + result.order, 1000, !vm.enableBarcodeUpdate)
          // if (vm.autoPrint) {
          //   showAlertDialog('success', '已報到過，報到順序 : ' + result.order + '，列印準備中', 200, true, true);
          // }else {
          //   showAlertDialog('success', '已報到過，報到順序 : ' + result.order, 1000, true);
          // }
          
        }

        // 切換回操作者設定的模式
        vm.enablePhoneSearch = vm.enablePhoneSearchManual;

        // toggleRight(false);

        getEventDashboard();
      }

    }

    function checkinBarcodeError(result) {
      $log.error('checkin barcode error', result);

      var msg = translateMessage(result.error.message);
      if (vm.enablePhoneSearch) {
        msg = '<span style="float:left">查詢關鍵字：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
      } else {
        msg = '<span style="float:left">掃描條碼：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
      }
      showAlertDialog('confirmError', msg, 1000, true);
      // vm.isProcessing.newBarcode = '';
      // vm.isProcessing.barcodeMessage = '';
      // vm.isProcessing.phoneNumber = '';
      var prop;
      for (prop in vm.isProcessing) {
        if (hasOwnProperty.call(vm.isRequired, prop)) {
          vm.isProcessing[prop] = '';
        }
      }

      // 切換回操作者設定的模式
      vm.enablePhoneSearch = vm.enablePhoneSearchManual;
    }

    function searchGuestSuccess(result){

      $log.debug('search guest success', result);

      if (!result || result.length <= 0 || !result[0].barcodeMessage) {
        showAlertDialog('warning', '查無資料，請您先去註冊', 1000, true);

        vm.latestCandidates = [];
      }else {
        showAlertDialog('success', '搜尋到 ' + result.length + ' 筆來賓資料', 1000, true);

        vm.latestCandidates = result;
      }
      vm.memberList = vm.latestCandidates;
      vm.listType = 'candidate';

      toggleRight(false);
    }

    function searchGuestError(result) {

      $log.debug('search guest error', result);

      var msg = result.error && result.error.message ? translateMessage(result.error.message): result;
      if (vm.enablePhoneSearch) {
        msg = '<span style="float:left">查詢關鍵字：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
      } else {
        msg = '<span style="float:left">掃描條碼：' + vm.query + '</span><br/><span style="float:left; font-size:smaller; color: darkred">' + msg + '</span>';
      }
      showAlertDialog('confirmError', msg, 1000, true);
      // vm.isProcessing.newBarcode = '';
      // vm.isProcessing.barcodeMessage = '';
      // vm.isProcessing.phoneNumber = '';
      var prop;
      for (prop in vm.isProcessing) {
        if (hasOwnProperty.call(vm.isRequired, prop)) {
          vm.isProcessing[prop] = '';
        }
      }
    }

    function sendPassSuccess(result){

      $log.log('send pass success', result);

      showAlertDialog('success', '寄送卡片成功', 1000, true);
      vm.isProcessing.newBarcode = '';
    }

    function sendPassError(result){
      $log.error('send pass error', result);
      vm.isProcessing.newBarcode = '';
      var msg = result.error.message || '寄送卡片失敗';
      showAlertDialog('confirmError', msg, 1000);
    }

    function updateBarcodeSuccess(result){

      $log.log('update barcode success', result);

      // 重設介面狀態
      vm.isProcessing.newBarcode = '';
      vm.member.newBarcode = result.barcodeMessage;
      vm.isRequired.newBarcode = false;
      vm.query = '';
      vm.newBarcode = '';

      // 更新最後報到清單內容
      var idx = _.findIndex(vm.latestCheckin, function(member){
        return (member.cardId === result.cardId);
      });
      $log.log('update barcode success > find member', idx, vm.latestCheckin[idx]);
      if(vm.enableBarcodeUpdate && idx>=0) {
        vm.latestCheckin[idx].isBarcodeChanged = true;
        vm.latestCheckin[idx].barcodeMessage = result.barcodeMessage;
      }

      // 在對話框中配對完以後，要先關閉這個對話框，再顯示成功對話框
      if (vm.lastAlertDialog) {
        $mdDialog.hide(vm.lastAlertDialog);
        vm.lastAlertDialog = null;
      }
      showAlertDialog('success', '換發卡片成功', 1000, true);

    }

    function updateBarcodeError(result){
      $log.error('update barcode error', result);
      vm.isProcessing.newBarcode = '';
      vm.newBarcode = '';
      //showAlertDialog('換發卡片失敗');
      var msg = translateMessage(result.error.message);
      showAlertDialog('confirmError', msg, 1000, false);
      //changeFocus('newBarcode');
    }

    function getEventsSuccess(result){
      $log.log('get events success', result);
      vm.eventList = result;
      if (result.length === 0) {
        toastr.warning('無活動列表');
      }
      $localStorage.events = result;
      $localStorage.events_timestamp = new Date().getTime();

    }

    function getEventsError(result){
      $log.error('get events error', result);
      var msg = result.error.message || '無法取得活動表列';
      toastr.warning(msg);
      if ($localStorage.events)
        vm.eventList = $localStorage.events;
    }

    function getEventDashboardSuccess(result){
      $log.log('get event dashboard success', result);
      vm.dashboard = result;
      // vm.updateTime = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
      vm.updateTime = new Date();
    }

    function getEventDashboardError(result){
      $log.error('get events error', result);
      if(!result) {
        return;
      }
      var msg = '無法取得活動報名資料';
      if (result.error && result.error.message) {
        msg = result.error.message;
      }
      toastr.warning(msg);
    }

    function redirect(event) {
      //$log.debug('redirect', event);
      $state.go('home.events.event', {eventId: event.id});
    }

    function addPhoneNumber() {

      if (vm.newPhoneNumber === vm.member.profile.phoneNumber) {
        return;
      }

      vm.isProcessing.newPhoneNumber = 'indeterminate';

      apiFactory.updatePhoneNumber(eventId, {
        cardId: vm.member.cardId,
        phoneNumber: vm.newPhoneNumber
      }, function (data) {
        $log.debug(data);
        vm.member.profile.phoneNumber = vm.newPhoneNumber;
        vm.isProcessing.newPhoneNumber = '';
        vm.isRequired.query = true;
        vm.isRequired.newBarcode = false;
        vm.isRequired.newPhoneNumber = false;

        showAlertDialog('success', '電話已更新成功！', 1000, false);  //修改電話和客製欄位不會清除條碼可以直接報到
      }, function (err) {
        $log.error(err);
        vm.isProcessing.newPhoneNumber = vm.member.profile.phoneNumber;
        vm.isRequired.query = true;
        vm.isRequired.newBarcode = false;
        vm.isRequired.newPhoneNumber = false;

        showAlertDialog('confirmError', '電話更新失敗！', 1000, false); //修改電話和客製欄位不會清除條碼可以直接報到
      });
    }

    function isPrefix(str, prefix) {
      return str.lastIndexOf(prefix || 'mpos', 0) === 0;
    }

    function updateProfile(key, value) {

      if (vm.mposFields[key] === vm.member.profile[key]) {
        return;
      }

      vm.isProcessing[key] = 'indeterminate';

      var data = {};
      data[key] = value;

      apiFactory.updateDistFields(eventId, {
        dists: [
          {
            barcodeMessage: vm.member.barcodeMessage,
            data: data
          }
        ]
      }, function (res) {
        $log.debug(res);
        vm.member.profile[key] = value;
        vm.isProcessing[key] = '';
        vm.isRequired.query = true;
        vm.isRequired.newBarcode = false;
        vm.isRequired.newPhoneNumber = false;
        vm.isRequired[key] = false;

        showAlertDialog('success', vm.distFields[key] + '更新成功！', 1000, false); //修改電話和客製欄位不會清除條碼可以直接報到

      }, function (err) {
        $log.error(err);
        vm.mposFields[key] = vm.member.profile[key];
        vm.isProcessing[key] = '';
        vm.isRequired.query = true;
        vm.isRequired.newBarcode = false;
        vm.isRequired.newPhoneNumber = false;
        vm.isRequired[key] = false;

        showAlertDialog('confirmError', vm.distFields[key] + '更新失敗！', 1000, false); //修改電話和客製欄位不會清除條碼可以直接報到
      });
    }

    
    //function toggleWebsocket() { 
    //  if (vm.enableWS) {
    //    initWebsocket();
    //  }else {
    //    if (wsConnection) wsConnection.close();
    //   
    //  }
    //}
    
    
    function checkQueue() {
      var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
      $log.log('check task queue', vm.queue.length, vm.queue[vm.queue.length-1], isDialogOpen, vm.isProcessing);
      if (vm.queue.length) {
        if (vm.isProcessing.query || isDialogOpen) {
          //$timeout(checkQueue, 3000);
          return;
        }else{
          vm.query = vm.queue[0];
          vm.autoPrint = true;
          vm.searchBarcode();
          
          // for auto print, need to wait some more seconds for print badge dialog
          intervalWsTask = $interval (function(){
            var isDialogOpen = (angular.element($document[0].body).hasClass('md-dialog-is-showing')) ? true : false;
            if (!isDialogOpen) {
              $interval.cancel(intervalWsTask);
              $log.log('finish check task queue', vm.query, vm.queue.length, isDialogOpen);
              vm.queue.shift(0);
              if (vm.queue.length) checkQueue();
            }else{
              $log.log('still processing');
            }
            
          }, 2000);
        }
      }
      
    }

    function initWebsocket(){

      if ($state.current.name !== 'home.events.event' || !vm.websocket.enabled) {
        if (reconnectWSTask) $interval.cancel(reconnectWSTask);
        reconnectWSCount = 0
        return;
      }
      //var uri = 'wss://' + userAgent.host + ':' + userAgent.port + userAgent.path + '?access_token=' + apiLogin.token;
      var uri =  iiotWebsocket.releaseUrl;
      
      var host = $location.host();
      if (iiotWebsocket.devHosts.indexOf(host) > -1) {
        uri = iiotWebsocket.devUrl;
      }else {
        uri = iiotWebsocket.releaseUrl;
      }
      
      $log.log('initWebsocket userAgent:', uri);
  
      if (vm.websocket.id) {
        uri += '?channel_id=' + vm.websocket.id;
      }
      if(window.WebSocket) {
        $log.log('[event] build ws connection...');

        // wsConnection = new WebSocket(uri, userAgent.subprotocol);
        wsConnection = new WebSocket(uri);
        wsConnection.binaryType = "arraybuffer";
        wsConnection.onopen = function() {
          // onopen
          $log.log('[event] WebSocket Open');
          if (vm.queue.length ) checkQueue();
          
          //$timeout(function(){
          //  wsConnection.send('E8610500000136');
          //}, 1000)
          //$timeout(function(){
          //  wsConnection.send('KK0001');
          //  wsConnection.send('E8610500000136');
          //}, 500)
          
        };
        wsConnection.onerror = function(err) {
          // onerror
          $log.error('[event] WebSocket Error', err);
        };
        wsConnection.onclose = function() {
          // onclose
          $log.log('[event] WebSocket Close');
          // if (intervalWsTask) $interval.cancel(intervalWsTask);

          //TBD, if need to clear queue
          vm.queue.length = 0;
          
          // reconnectWSTask = $interval(function(){
          //   //initWebsocket()
          //   console.log('reconnect websocket ' + reconnectWSCount);
            
          //   if (reconnectWSCount < 3 && wsConnection.readyState === 3) {
          //     //console.log('============', wsConnection.readyState)
          //     initWebsocket();
          //   }else {
          //     $interval.cancel(reconnectWSTask);
          //     reconnectWSCount = 0
          //     if (wsConnection.readyState === 3)
          //       showAlertDialog('confirmError', 'Websocket無法連線')
          //   }
          //   reconnectWSCount++;
          // }, 2000);
          
        };
        wsConnection.onmessage = function(message) {
          // onmessage
          $log.log(new Date());
          $log.log('[event] WebSocket OnMessage', message);
          // if (message.data) {
          //   var data = JSON.parse(message.data);
          //   if (data.barcodeMessage) {
          //     vm.queue.push(data.barcodeMessage);
          //   }
          // }
          if (message.data && vm.queue.length <1 ){
            var data = JSON.parse(message.data);
            if (data.barcodeMessage) {
              vm.queue.push(data.barcodeMessage);
            }

          }
        
          //console.log('-----------------', vm.queue.length);
          if (vm.queue.length === 1 ) checkQueue();
         
        }
        
       
      } else {
        console.warn('Websocket is not supported.');
      }
    }
  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.helper
 * @description
 * # helper
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('helperFactory', function ($localStorage) {
    var service = {
      spliceOne: spliceOne,
      unshiftArray: unshiftArray,
      getCounter: getCounter
    };

    var counter = $localStorage.counter || 0;

    function spliceOne(arr, index) {
      var len=arr.length;
      if (!len) { return }
      while (index<len) {
        arr[index] = arr[index+1];
        index++;
      }
      arr.length--;
      return arr;
    }

    function unshiftArray(arr, item) {
      var len=arr.length;
      while (len) {
        arr[len] = arr[len-1];
        len--;
      }
      arr[0] = item;
      return arr;
    }
    
    function getCounter() {
      counter++;
      $localStorage.counter = counter;
      return padZero(counter, 5);
    }
    
    function padZero(number, digits) {
      return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    }
    
    return service;
   });

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:modalstockinCtrl
 * @description
 * # modalstockinCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('modalstockinCtrl', function ($scope, $element, data, close) {
    $scope.serialNos = data;
    
    $scope.close = function() {
      close(null, 500); // close, but give 500ms for bootstrap to animate
    };

    $scope.cancel = function() {
      //  Manually hide the modal.
      $element.modal('hide');
      //  Now call close, returning control to the caller.
      close(null, 500); // close, but give 500ms for bootstrap to animate
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:epos
 * @description
 * <epos name="Melinda" company="Quanta" eventLabel="2017 event test" width="300" height="150"></epos>
 * # epos
 */

angular.module('mpos')
  .directive('epos', function ($log, $document, $timeout, $localStorage, toastr, apiFactory) {
    return {
      templateUrl: 'app/epos/epos.html',
      restrict: 'E',
      scope: {
        content: "@",
        name: "@",
        company: "@",
        event: "@",
        width: "@",
        height: "@",
        autoPrint: "@",
        badge: "@"
      },
      link: function(scope, element, attrs) {
        scope.printerIP = $localStorage.printerIP ? $localStorage.printerIP: '192.168.192.168';
        scope.isLoading = true;
        scope.isProcessing = false;
        scope.eventLabel = getEventLabel(scope.event);
        //$log.log('epos event:', scope.event);
        //$log.log('epos event label:', scope.eventLabel);
        var profile = JSON.parse(scope.content).profile;
        var barcodeMessage = JSON.parse(scope.content).barcodeMessage;
        var cardId = JSON.parse(scope.content).cardId;
        var passUrl = JSON.parse(scope.content).passUrl;
        var canvasWidth = 600, canvasHeight = 400;

        //var ePosDev = new epson.ePOSDevice();
        // Get ePosDev and printerObj form parent scope
        //var ePosDev = scope.$parent.eposDev || new epson.ePOSDevice();;
        //var printer = scope.$parent.printer || null;
        var ePosDev = new epson.ePOSDevice();;
        var printer = null;

        /* 1. Get canvas template
        *  2. Get QRCode text
        *  3. Get QRCode image
        *  4. Show expected canvas
        *  5. Print
        */

        // fabric test
        // Make sure element is ready
        element.ready( function(){
          getBadgeDesign();
        } );
        //getBadgeDesign();

        function getEventLabel(id) {
          if (id && $localStorage.events) {
            var event = $localStorage.events.filter(function(el){
              return el.id === id;
            });

            return event[0].label;
          }else {
            return null;
          }

        }

        function getBadgeDesign(){
          $log.log('[epos] start get badge design:', new Date())
          if (scope.badge) {
            getBadgeDesignSuccess(JSON.parse(scope.badge));
          }else {
            apiFactory.getBadgeDesign(scope.event, null, getBadgeDesignSuccess, getBadgeDesignError);
          }
          
          //apiFactory.getBadgeDesign(scope.event, null, getBadgeDesignSuccess, getBadgeDesignError);
         
        }

        function getBadgeDesignSuccess(data){
          // Parse data to replace some content
          $log.log('[epos] get badge design successfully');
          $log.log('[epos] template:', angular.copy(data));
          var key = '';

          for (var i in data.objects) {
            if (data.objects[i].type === 'i-text') {
              $log.log('iiotKey:', data.objects[i].iiotKey);
              if (angular.isDefined(data.objects[i].iiotKey)) {
                key = data.objects[i].iiotKey;
                //delete data.objects[i].iiotKey;
                if (angular.isDefined(profile[key]) && profile[key]) {
                  var temp = measureText(data.objects[i], profile[key], data.width);
                  //console.log(data.objects[i])
                  //console.log(temp)
                  data.objects[i].width = temp.newWidth;
                  data.objects[i].left = getNewLeft(data.objects[i], temp.oldWidth, temp.newWidth, data.width, profile[key]);
                  //measureText(data.objects[i], profile[key]);
                  data.objects[i].text = profile[key];
                  //data.objects[i].scaleX = 1;
                  //data.objects[i].scaleY = 1;
                  //data.objects[i].textBackgroundColor = '';
                }else {
                  if (key === 'iiotSn') {
                    var temp = measureText(data.objects[i], cardId, data.width);
                    data.objects[i].width = temp.newWidth;
                    data.objects[i].left = getNewLeft(data.objects[i], temp.oldWidth, temp.newWidth, data.width, cardId);
                    data.objects[i].text = cardId;
                  }else {
                    data.objects[i].text = '';
                    //data.objects[i].textBackgroundColor = '';
                    data.objects[i].width = 0
                  }
                  
                }

              }

            }else if (data.objects[i].type === 'image' ){

              if (angular.isDefined(data.objects[i].iiotKey)) {
                //$log.log('test:', element[0].querySelector('img').src);
                // Adjust x pos
                data.objects[i].left = getNewLeft(data.objects[i], data.objects[i].width, data.objects[i].width, data.width);

                // cross origin issue, and can't use toDataURL();
                data.objects[i].crossOrigin ='Anonymous';
                switch (data.objects[i].iiotKey) {
                  case 'passUrl':
                      data.objects[i].src = 'https://tools.iiot.io/barcode/qrcode/?text='+ passUrl;
                      break;
                  case 'qrcodeMessage':
                      data.objects[i].src = 'https://tools.iiot.io/barcode/qrcode/?text='+ barcodeMessage;
                      break;
                  default:
                      data.objects[i].src = 'https://tools.iiot.io/barcode/code128/?text='+ barcodeMessage;
                      break;
                }
                // if (data.objects[i].iiotKey === 'passUrl') {
                //   //qrcode
                //   data.objects[i].src = 'https://tools.iiot.io/barcode/qrcode/?text='+ passUrl;
                // }else {
                //   //TBD code 39
                //   data.objects[i].src = 'https://tools.iiot.io/barcode/code128/?text='+ barcodeMessage;
                // }
                
                //data.objects[i].src = './assets/images/qrcode.png';
                //delete data.objects[i].iiotKey;
              }else{
                data.objects[i].crossOrigin ='Anonymous';
              }
            }
          }

          $log.log('[epos] actual data:', data);
          $log.log('[epos] end get badge design:', new Date())
          showCanvas(data);
        }

        function getBadgeDesignError(err) {
          $log.error('[print badge] Get badge design failed:', err);
          toastr.error('Fail to get badge design');
          $timeout(function(){
            scope.$parent.close();
          }, 100);
        }


        function showCanvas(data){
          // Don't need any interactivity, then use StaticCanvas
          var canvas = new fabric.StaticCanvas('fabricCanvas');
          if (angular.isDefined(data.width)) {
            canvas.setWidth(data.width);
            canvasWidth = data.width;
            //delete data.width;
          }
          if (angular.isDefined(data.height)) {
            canvas.setHeight(data.height);
            canvasHeight = data.height;
            //delete data.height;
          }

          canvas.loadFromJSON(data, function(){
            canvas.renderAll.bind(canvas);
            $log.log('[epos] end src canvas loadFromJSON:', new Date())
            $timeout(function(){
              //scope.isLoading = false;
              preparePrintCanvas();
            });
          });
        }

        function preparePrintCanvas(){
          $log.log('[epos] prepare print canvas');
          //Get the printing data in canvas
          var srcCanvas = $document[0].getElementById('fabricCanvas');
          var destCanvas = $document[0].getElementById('printCanvas');
          var destCtx = destCanvas.getContext("2d");
          //var srcCtx = srcCanvas.getContext("2d");
          var image = new Image();

          $log.log('[epos] prepare print canvas - src: ', srcCanvas);
          $log.log('[epos] prepare print canvas - dest: ', destCanvas);

          destCanvas.width = canvasWidth; //srcCanvas.width is incorrect
          destCanvas.height = canvasHeight; //srcCanvas.height is incorrect
          //destCanvas.height = canvasHeight * 0.95; //srcCanvas.height is incorrect
          image.crossOrigin = "Anonymous";
          //HTML5 Canvas data containing image data downloaded from different domains
          //cannot be printed. A security error occurs due to the Same-Origin policy of JavaScript.
          image.crossOrigin="anonymous";
          image.src = srcCanvas.toDataURL("image/png");
          image.onload = function(){
            destCtx.drawImage(image, 0, 0, destCanvas.width, destCanvas.height);
            $log.log('[epos] end prepare print canvas:', new Date())
            $timeout(function(){
              scope.isLoading = false;
            });
            if (scope.autoPrint === "true") {
              $timeout(function(){
                scope.printContent()
              }, 300);
            }
          }
        }
        function measureText(obj, text, limit){
          var context= document.createElement("canvas").getContext("2d");
          var myFont =  obj.fontSize + 'px ' + obj.fontWeight + ' ' + obj.fontStyle + ' ' + obj.fontFamily ;
          if (obj.fontWeight !== 'normal' && obj.fontWeight !== 'bold') {
            myFont = obj.fontWeight + ' ' + obj.fontSize + 'px ' + obj.fontStyle + ' ' + obj.fontFamily ;
          }
          context.font = myFont;
          $log.log('font:', myFont);
          $log.log('canvas width:', canvasWidth);
          var maxWidth = limit;
          var margin = 10;
          var oldMetrics = context.measureText(obj.text.trim());
          var newMetrics = context.measureText(text.trim());
          //var rawWidth = oldMetrics.width ;
          $log.log('measureText"' +  obj.text.trim() + '" is ' + oldMetrics.width );
          $log.log('measureText: "' + text  + '" is ' + Math.round(newMetrics.width));
          
          //$log.log(newMetrics.width-maxWidth)
          
          // Adjust font size if content width > canvas width
          while (newMetrics.width * obj.scaleX - maxWidth > margin){
            obj.fontSize = obj.fontSize - 2;
            myFont =  obj.fontSize + 'px ' + obj.fontWeight + ' ' + obj.fontStyle + ' ' + obj.fontFamily ;
            if (obj.fontWeight !== 'normal' && obj.fontWeight !== 'bold') {
              myFont = obj.fontWeight + ' ' + obj.fontSize + 'px ' + obj.fontStyle + ' ' + obj.fontFamily ;
            }
            context.font = myFont;
            //oldMetrics = context.measureText(obj.text.trim());
            newMetrics = context.measureText(text.trim());
            $log.log('measureText: "' + text  + '" is ' + Math.round(newMetrics.width));
          }
          
          console.log(oldMetrics, newMetrics);
          return { oldWidth: oldMetrics.width, newWidth: Math.round(newMetrics.width)};
        }

        function getNewLeft(obj, oldWidth, newWidth, limit, text){
          var oldLeft = obj.left;
          oldLeft = Math.ceil(oldLeft / 10) * 10; 
          $log.log('[epos] calculat new left position');
          $log.log('[epos] origin left:', obj.left, Math.round(oldLeft / 10) * 10);
          $log.log('[epos] origin text width:', oldWidth);
          $log.log('[epos] new text width:', newWidth);
          $log.log('[epos] canvas limit:', limit);
          
          var newLeft = null;
          
          // canvas width - origin txt
          var canvasMinusOrigin = limit - (oldWidth * obj.scaleX);
          var canvasMinusNew = limit - (newWidth * obj.scaleX);
          $log.log('[epos] canvas - origin:', canvasMinusOrigin);
          $log.log('[epos] canvas - new:', canvasMinusNew);
          var alignLeft = true;
          var alignRight = false;
          var temp = null; 
          $log.log(canvasMinusOrigin/2 - 20, oldLeft, canvasMinusOrigin/2 + 20)
          if ((canvasMinusOrigin/2 - 20) <= oldLeft && oldLeft <= (canvasMinusOrigin/2 + 20)) {
            alignLeft = false;
            alignRight = false;
          }else if (limit / 2 - oldLeft <= 20) {
            alignLeft = false;
            alignRight = true;
          }
          // if ((canvasMinusOrigin/2 - 20) < oldLeft && oldLeft < (canvasMinusOrigin/2 + 20)) {
          //   alignLeft = false;
          // }

        
          $log.log('[epos] canvas - align left:', alignLeft);
          $log.log('[epos] canvas - align right:', alignRight);
          if (alignLeft) {
            if (canvasMinusNew > oldLeft){
              newLeft = oldLeft;
            }else {
              //newLeft = canvasMinusNew / 2;
              temp = measureText(obj, text, limit-oldLeft-30);
              newLeft = oldLeft;
            }              
          }else if (alignRight) {
            newLeft = limit - (newWidth * obj.scaleX) - 20
          }else{
            newLeft = canvasMinusNew / 2;
          }
          
          //if (newWidth < oldWidth) {
          //    newLeft = oldLeft;
          //  }else{
          //    var diff = (newWidth - oldWidth) / 2;
          //    if (oldLeft > 0 && oldLeft - diff > 0) {
          //      newLeft = oldLeft - diff;
          //      if (newLeft + newWidth > limit) { // detect if text width > canvas width
          //        newLeft = limit - newWidth; 
          //      }
          //
          //    }else { // when origin left <= 0 || oldLeft - diff<=0             
          //      newLeft = oldLeft;
          //    }
          //  }
          //}
          
          $log.log('[epos] new left:', Math.round(newLeft));
          return Math.round(newLeft);
        }

        
        // var unbindWatchPaste = scope.$on('pasteEvent', function (evt, data) {

        //   scope.$apply(function(){
        //     scope.printerIP = scope.printerIP + data;
        //   });
        // });
        // var unbindWatchKeyPress = scope.$on('keypressEvents', function (evt, obj, key) {
        //   evt.stopPropagation();
        //   evt.preventDefault();
        //   //$log.log('press:', obj.keyCode)
        //   scope.$apply(function(){
        //     switch (obj.keyCode) {
        //       case 8:
        //         if (angular.isDefined(scope.printerIP)) {
        //           scope.printerIP = scope.printerIP.slice(0, -1);
        //         }
        //         break;
        //       case 13:
        //         break;
        //       default:

        //         if (angular.isDefined(scope.printerIP))
        //           scope.printerIP = scope.printerIP + key;
        //         else
        //           scope.printerIP = key;
        //         break;

        //     }
        //   });
        // });

        // sometimes will find printerIP undefined.....
        //var unbindWatch = scope.$watch('printerIP', function (watch) {
        //  $log.log('printerIP:', watch);
        //})

        scope.$on('$destroy', function () {

          if (unbindWatchKeyPress) unbindWatchKeyPress();
          if (unbindWatchPaste) unbindWatchPaste();
          //if (unbindWatch) unbindWatch();
        });

        scope.printContent = function(){
          if (! scope.printerIP) {
            toastr.warning('Please input printer IP.');
          }else {
            $log.log('[epos] printContent');
            $localStorage.printerIP = scope.printerIP;
            $log.log('[epos] connenct status:', ePosDev.isConnected());
            if (!scope.isProcessing) {
              if (ePosDev.isConnected()) {
                if (printer) {
                  printFCanvas();
                } else {
                  ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER,
                    {'crypto' : true, 'buffer' : false}, callback_createDevice);
                }
              }else {
                connect();
              }
            }
          }
        };

        function connect(){
          //Connect to device
          $log.log('[epos] start print:', new Date())
          var ip = scope.printerIP;
          //ePosDev.connect(ip, 8008, callback_connect);
          ePosDev.connect(ip, 8043, callback_connect);
          scope.isProcessing = true;
        }

        function callback_connect(resultConnect){
          $log.log('[epos] connect printer:', resultConnect);
          if ((resultConnect == 'OK') || (resultConnect == 'SSL_CONNECT_OK')) {
            //Get the Printer object
            // assign eposDev to parent scope
            //scope.$parent.eposDev = ePosDev;
          
            ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER,
              {'crypto' : true, 'buffer' : false}, callback_createDevice);
            //ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER,
            //  {'crypto' : true, 'buffer' : false}, cbCreateDevice_printer);
          } else {
            //Display the error message
            $log.error('Error to connect to printer: ', resultConnect);
            toastr.error('Failed to connect to the printer.');
            $timeout(function() {
              scope.isProcessing = false;
              disconnect(); //To prevent pending for face recognition + auto print
            });
            //scope.$apply(function(){scope.isProcessing = false;});
          }
        }

        function callback_createDevice(deviceObj, retcode){
          $log.log('[epos] create device:', retcode);
          if( retcode == 'OK' ) {
            printer = deviceObj;

            //printer.addCut(printer.CUT_FEED); //CUT_FEED | CUT_NO_FEED | CUT_RESERVE;
            //printer.addFeedPosition(printer.FEED_PEELING); //FEED_NEXT_TOF | FEED_PEELING | FEED_CUTTING | FEED_CURRENT_TOF
            printer.timeout = 60000;
            //Register the printing complete event
            printer.onreceive = function (res) {
              $log.log('[epos] onreceive data:', res);
              //if (res.status === 'ASB_PRINT_SUCCESS') {
              //  disconnect();
              //}
              // Obtain the printer status
               // Obtain the print result and error code
              var msg = ' Print ' + (res.success ? ' Success ' : ' Failure ') + '\n Code:' + res.code + '\n Status:\n';
              var asb = res.status;
              $log.log('[epos] Printer status:\n' + msg );

              if (asb & printer.ASB_NO_RESPONSE) {
                msg = 'No printer response';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_PRINT_SUCCESS) {
                msg = 'Print complete';
                $log.log('[epos] Printer status: ' + msg );
                printSuccessfully();
              }
              if (asb & printer.ASB_DRAWER_KICK) {
                msg = 'Status of the drawer kick number 3 connector pin = "H"';
                $log.log('[epos] Printer status: ' + msg );
                //printSuccessfully();
              }
              if (asb & printer.ASB_OFF_LINE) {
                msg += 'Offline status';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_COVER_OPEN) {
                msg = 'Cover is open';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_PAPER_FEED) {
                msg = 'Paper feed switch is feeding paper';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_WAIT_ON_LINE) {
                msg = 'Waiting for online recovery';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_PANEL_SWITCH) {
                msg = 'Panel switch is ON';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_MECHANICAL_ERR) {
                msg = 'Mechanical error generated';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_AUTOCUTTER_ERR) {
                msg = 'Auto cutter error generated';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_UNRECOVER_ERR) {
                msg = 'Unrecoverable error generated';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_AUTORECOVER_ERR) {
                msg = 'Auto recovery error generated';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_RECEIPT_NEAR_END) {
                msg = 'No paper in the roll paper near end detector';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_RECEIPT_END) {
                msg = 'No paper in the roll paper end detector';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }
              if (asb & printer.ASB_SPOOLER_IS_STOPPED) {
                msg = 'Stop the spooler';
                $log.log('[epos] Printer status:' + msg );
                printError(msg);
              }



              //toastr.success('Print successfully.');
              //disconnect();
              //$timeout(function(){
              //  scope.isProcessing = false;
              //  scope.$parent.close();
              //}, 3000);

            };
            printer.onerror = function (err) {
              $log.error('[epos] onSendError:', err.status);
              toastr.error('Failed to print.', err.status);
              printError('Failed to print.');
              //toastr.error('Failed to print.');
              disconnect();
            };

            // assign printer to parent scope
            //scope.$parent.printer = printer;
            //createData();
            //printCanvas();
            printFCanvas();
          } else {
            $log.error('Error to create printer: ', retcode);
            toastr.error('Failed to create printer object.');
            $timeout(function() {
              scope.isProcessing = false;
            });
            //scope.$apply(function(){scope.isProcessing = false;});
            //alert(retcode);
          }
        }

        //function createData(){
        //  // addTextAlign() This API does not work in the page mode
        //  // ALIGN_CENTER|ALIGN_LEFT(default)|ALIGN_RIGHT
        //
        //  $log.log('[epos] createDate');
        //  printer.addTextLang('zh-tw');
        //
        //  printer.addFeedPosition(printer.FEED_NEXT_TOF);
        //  printer.addTextSmooth(true);
        //  printer.addTextFont(printer.FONT_A);
        //  printer.addTextSize(3, 3);
        //  printer.addTextAlign(printer.ALIGN_CENTER); //ALIGN_LEFT
        //  printer.addText(scope.name + '測試\n\n');
        //  printer.addTextSize(2, 2);
        //  printer.addTextAlign(printer.ALIGN_CENTER);
        //  printer.addText(scope.company + '\n\n');
        //  printer.addTextAlign(printer.ALIGN_CENTER);
        //  // In order to print a image data at a high speed,
        //  // set the parameter constant of addTextAlign method to ALIGN_LEFT
        //  // and the width parameter of the addImage method to a multiple of 8
        //  // which does not exceed the sheet width of the printer.
        //  //printer.addImage(context, 0, 0, canvas.width , canvas.height, printer.COLOR_1);
        //  printer.addCut(printer.CUT_FEED);
        //  //printer.addTextAlign(printer.ALIGN_CENTER);
        //  //printer.addText('Hello World');
        //  send();
        //}

        function send(){
          if (ePosDev.isConnected) {
            printer.send();

          }
        }

        // Fail to print text
        function printFCanvas(){
          $log.log('[epos] print canvas');
          //Get the printing data in canvas
          //var srcCanvas = $document[0].getElementById('fabricCanvas');
          //var destCanvas = $document[0].getElementById('fabricCanvas');
          var destCanvas = $document[0].getElementById('printCanvas');
          var destCtx = destCanvas.getContext("2d");
          //var srcCtx = srcCanvas.getContext("2d");
          //var image = new Image();

          //image.crossOrigin = "Anonymous";
          //HTML5 Canvas data containing image data downloaded from different domains
          //cannot be printed. A security error occurs due to the Same-Origin policy of JavaScript.
          //image.src = srcCanvas.toDataURL("image/png");
          //image.onload = function(){
          //  destCtx.drawImage(image, 0, 0, destCanvas.width, destCanvas.height);
          /* template
            printer.addFeedPosition(printer.FEED_CURRENT_TOF);
            printer.brightness = 1.0;
            printer.halftone = printer.HALFTONE_DITHER;
            printer.addImage(canvas.getContext('2d'), 0, 0, canvas.width, canvas.height, printer.COLOR_1, printer.MODE_MONO);
            printer.addFeedPosition(printer.FEED_CUTTING);
            printer.addCut(printer.CUT_NO_FEED);

            printer.send();
          */
         
            /* 針對不連續的紙捲，裁切位置不正確 */
            
            // $timeout(function(){
            //   var cut = true;
            //   var mode = printer.MODE_MONO;
            //   //printer.addLayout(printer.LAYOUT_LABEL, destCanvas.width, 0);
            //   //printer.addTextAlign(printer.ALIGN_CENTER);
            //   //printer.addLayout(printer.LAYOUT_LABEL, 750, 600, 0, 0, 3, 3);
            //   //printer.addFeedPosition(printer.FEED_NEXT_TOF); //FEED_NEXT_TOF | FEED_PEELING | FEED_CUTTING | FEED_CURRENT_TOF
            //   printer.print(destCanvas, cut, mode);
            // },500);
            
            
            $timeout(function(){
              var cut = true;
              var mode = printer.MODE_MONO;

              //printer.addTextLang('zh-tw');
              //printer.addCut(printer.CUT_RESERVE); //CUT_FEED | CUT_NO_FEED | CUT_RESERVE;
              printer.addFeedPosition(printer.FEED_CURRENT_TOF); //FEED_NEXT_TOF | FEED_PEELING | FEED_CUTTING | FEED_CURRENT_TOF
              //printer.addLayout(printer.LAYOUT_LABEL, destCanvas.width, 600);
              //printer.addTextSmooth();
              //printer.addTextAlign(printer.ALIGN_LEFT);
              printer.brightness = 1.0;
              printer.halftone = printer.HALFTONE_DITHER;
              //Send the printing data
              printer.addImage(destCtx, 0, 0, destCanvas.width , destCanvas.height, printer.COLOR_1, mode);
              //printer.addFeedLine(5);
              printer.addFeedPosition(printer.FEED_CUTTING);
              // Cut after print
              printer.addCut(printer.CUT_NO_FEED);
              send();
              //printer.print(destCanvas, cut, mode);
            },100);
            
          //};

          /*
          * print unknown character
          */
          //var cut = true;
          //var mode = printer.MODE_MONO;
          //printer.addTextLang('zh-tw');
          //printer.addFeedPosition(printer.FEED_CUTTING);
          //printer.addTextSmooth(true);
          //printer.addTextAlign(printer.ALIGN_LEFT);
          ////Send the printing data
          //printer.addImage(srcCtx, 0, 0, srcCanvas.width , srcCanvas.height, printer.COLOR_1);
          //send();
          //printer.print(srcCanvas, cut, mode);

        }

        //function printCanvas(){
        //  $log.log('[epos] print canvas');
        //  //Get the printing data in canvas
        //  var canvas = $document[0].getElementById('myCanvas');
        //  //var canvas = element[0].querySelector('canvas');
        //  var context = canvas.getContext('2d');
        //  //var cut = true;
        //  //var mode = printer.MODE_MONO;
        //  printer.addTextLang('zh-tw');
        //  printer.addFeedPosition(printer.FEED_NEXT_TOF);
        //  printer.addTextSmooth(true);
        //  printer.addTextAlign(printer.ALIGN_LEFT);
        //  //Send the printing data
        //  printer.addImage(context, 0, 0, canvas.width , canvas.height, printer.COLOR_1);
        //  //printer.print(canvas, cut, mode);
        //  send();
        //}

        function disconnect(){
          //Discard the Printer object
          $timeout(function(){
            $log.log('[epos] disconnect');
            ePosDev.deleteDevice(printer, callback_deleteDevice);
          }, 10);
          
        }

        function callback_deleteDevice(){
          //Disconnect to device ePosDev.disconnect();
          $log.log('[epos] delete printer', ePosDev.isConnected());
          ePosDev.disconnect();
          $timeout(function() {
              scope.isProcessing = false;
            })
          $log.log('[epos] end print:', new Date())
          scope.$apply(function(){scope.isProcessing = false;});
          //scope.isProcessing = false;  // Not work.....
          $timeout(function(){
            scope.$parent.close();
          }, 100);
        }

        function printSuccessfully(){
          //toastr.success('Print successfully.');
          $log.log('success');
          // $timeout(function(){
          //   scope.isProcessing = false;
          //   scope.$parent.close();
          // }, 500);
          disconnect();
        }


        function printError(errmsg){
          if (errmsg) {
            toastr.error(errmsg);
          }else{
            toastr.error('Failed to print.');
          }
          scope.isProcessing = false;
          disconnect();
        }
      }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:enterToTab
 * @description
 * # enterToTab
 */
angular.module('mpos')
  .directive('enterToTab', function ($document) {
    return {
      restrict: 'A',
      link: function(scope, element) {

        element.bind('keydown keypress', function(e){
          if (event.which === 13 || event.which === 10) {
            e.preventDefault();
            var pageElems = $document.find('input, select, textarea'),
                focusNext = false,
                len = pageElems.length;
            for (var i = 0; i < len; i++) {
              var pe = pageElems[i];
              if (focusNext) {
                if (pe.style.display !== 'none') {
                  pe.focus();
                  break;
                }
              } else if (pe === this) {
                focusNext = true;
              }
            }
          }
        });

        scope.$on('$destroy', function(){
          element.unbind('keydown keypress');
        });
      }
    };
  });

'use strict';
/**
 * @ngdoc directive
 * @name mpos.directive:rewardList
 * @description
 * # rewardList
 */
angular.module('mpos')
  .directive('depositList', function ($log, toastr, NgTableParams, depositFactory) {
    return {
      templateUrl: 'app/depositList/depositList.html',
      restrict: 'E',
      scope: {
        items: '=',
        add: '=',
        remove: '=',
        delete: '=',
        callback: '&'
      },
      link: function(scope) {

        scope.tableParams = new NgTableParams({
            page: 1,
            count: 10, //initial page size
            noPager: true // hides pager
          }, {
            counts: [],
            paginationMaxBlocks: 10,
            getData: function() {
              var data = angular.copy(scope.items);
              return data;
            }

        });

        scope.actions = {
          add: scope.add || false,
          remove: scope.remove || false,
          delete: scope.delete || false
        }

        scope.addItem = function(item) {
          var deposit = angular.copy(item);
          deposit.qty = 1;
          depositFactory.setDepositItem(deposit);
          scope.rewardItems = depositFactory.getDepositItem();
          //var depositTo = depositFactory.getDepositTo();
          //var depositPoints = depositFactory.getDepositPoints();
          
          reloadTable();

        }

        scope.removeItem = function(item, clearAll) {
          var deposit = angular.copy(item);
          depositFactory.removeDepositItem(deposit, clearAll);
          reloadTable();
        }

        function reloadTable() {
          $log.debug('[depositList]reload ', scope.items);
          scope.depositItems = depositFactory.getDepositItem();

          scope.tableParams.count(scope.depositItems.length);
          scope.tableParams.total(scope.depositItems.length);
          scope.tableParams.reload();

          if (scope.callback) scope.callback();
        }

        var unbindWatch = scope.$watch('depositItems', function(){
          $log.debug('[depositlist]:', scope.items);
          reloadTable();
        });

        scope.$on('destroy', function(){
          unbindWatch();
        });



      }
    };
  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.rewards
 * @description
 * # rewards
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('depositFactory', function ($log, $q, $localStorage, apiFactory, helperFactory) {
    var depositItems = [];
    var toWhom = null;
    var enableMultipleItems = true;
    var service = {
      getDepositList: getDepositList,
      setEnableMultipleItems: setEnableMultipleItems,
      getEnableMultipleItems: getEnableMultipleItems,
      setDepositItem: setDepositItem,
      getDepositItem: getDepositItem,
      removeDepositItem: removeDepositItem,
      clearDepositItems: clearDepositItems,
      getDepositPoints: getDepositPoints,
      getDepositPurchase: getDepositPurchase,
      clear: clear,
      setDepositTo: setDepositTo,
      getDepositTo: getDepositTo
    };

    return service;

    function getDepositList() {
      var deferred = $q.defer();
      var refreshDuration = 60 * 60 * 1000;
      var currentTime = new Date().getTime();
      var diff;

      if ($localStorage.depositItems && $localStorage.depositItems_timestamp) {
        diff = currentTime - $localStorage.depositItems_timestamp;
      } else {
        diff = null;
      }

      if (diff && diff <= refreshDuration && $localStorage.depositItems.length > 0) {
        deferred.resolve($localStorage.depositItems);
      }else {
        apiFactory.getDepositList({dynamic:false}, function(result){
          $log.log('get deposit list success');
          $localStorage.depositItems = result;
          $localStorage.depositItems_timestamp = new Date().getTime();
          deferred.resolve(result);
        }, function(err){
          $log.error('get deposit list failed:', err);
          if ($localStorage.depositItems) {
            deferred.resolve($localStorage.depositItems);
          }else {
            deferred.reject(err);
          }

        });
      }
       return deferred.promise;
    }

    function getEnableMultipleItems() {
      return enableMultipleItems;
    }

    function setEnableMultipleItems(enabled) {
      enableMultipleItems = enabled;
      if (enableMultipleItems === false) {
        clearDepositItems();
      }
    }

    function getDepositItem() {
      return depositItems;
    }

    function setDepositItem(deposit){
      $log.debug('[DepositFactory] Add deposit item');
      if (angular.isUndefined(deposit.qty)) {
        deposit.qty = 1;
      }

      var isExist = false;
      for (var i = 0, len = depositItems.length; i < len; i++) {
        if (depositItems[i].id === deposit.id) {
          isExist = true;
          depositItems[i].qty += 1;
          break;
        }
      }

      if (!isExist)
        depositItems = helperFactory.unshiftArray(depositItems, deposit);

    }

    function removeDepositItem(deposit, clearAll){
      $log.debug('[DepositFactory] Remove deposit');
      for (var i = 0, len = depositItems.length; i < len; i++) {
        if (depositItems[i].id === deposit.id) {
          if (clearAll) {
            depositItems = helperFactory.spliceOne(depositItems, i);
          } else {
            if (depositItems[i].qty > 1) {
              depositItems[i].qty -= 1;
            }else {
              depositItems = helperFactory.spliceOne(depositItems, i);
            }
          }

          break;
        }
      }
    }

    function clearDepositItems(){
      $log.debug('[DepositFactory] Clear deposit items');
      depositItems.length = 0;
    }

    function getDepositPoints() {
      var sum = 0;
      for (var i=0, len=depositItems.length; i<len; i++) {
        sum += depositItems[i].points * depositItems[i].qty;

      }
      return sum;
    }
    
    function getDepositPurchase() {
      var sum = 0;
      for (var i=0, len=depositItems.length; i<len; i++) {
        sum += depositItems[i].purchase * depositItems[i].qty;

      }
      return sum;
    }

    function clear() {
      $log.debug('[DepositFactory] Clear deposit item and member');
      depositItems = [];
      toWhom = null;
    }

    function getDepositTo() {
      return toWhom;
    }

    function setDepositTo(member){
      toWhom = member;
    }

  });

(function() {
  'use strict';

  angular
      .module('mpos')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

'use strict';
/**
 * @ngdoc service
 * @name mpos.counter
 * @description
 * # counter
 * Service in the mpos.
 */
angular.module('mpos')
  .service('counterService', function ($log, $q, $localStorage, apiFactory) {
    var counter = null;
    var counters = [];
    var service = {
      getCounterList: getCounterList,
      getCounter: getCounter,
      setCounter: setCounter,
      clearCounter: clearCounter,
      getCounterId: getCounterId
    };

    return service;

    function getCounterList() {
      var deferred = $q.defer();
      apiFactory.getCounterList(function(result){
        $log.log('Get counter list success:', result);
        counters = result;
        deferred.resolve(result);
      }, function(err){
        $log.error('Get counter list failed:', err)
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getCounter() {
      return counter || $localStorage.counter;
    }

    function setCounter(data) {
      counter = data;
      $localStorage.counter = data;
    }

    function clearCounter() {
      counter = null;
      counters.length = 0;
      delete $localStorage.counter;
    }

    function getCounterId() {
      return counter.appId;
    }


  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.colorTable
 * @description
 * # colorTable
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('colorTableFactory', function () {
    var colors = [
      '#f4dea8',
      '#f9cfb6',
      '#f2dc6d',
      '#fcccff',
      '#ed80e9',
      '#bfb0fc',
      '#bd92dd',
      '#a398ea',
      '#aa7efc',
      '#ccff96',
      '#b7f794',
      '#d8ed74'
    ];
    var current = 0;
    var service = {
      getColor: getColor,
      resetColorIndex: resetColorIndex
    };

    return service;

    function getColor() {
      var color = colors[current];
      current++;
      if (current === colors.length) current = 0;
      return color;
    }

    function resetColorIndex() {
      current = 0;
    }
  });

//'use strict';
///**
// * @ngdoc function
// * @name mpos.controller:dialogrewardshortcutCtrl
// * @description
// * # dialogrewardshortcutCtrl
// * Controller of the mpos
// */
//angular.module('mpos')
//  .controller('dialogrewardshortcutCtrl', function ($scope, $log, $localStorage, $mdBottomSheet, toastr, rewardsFactory, apiFactory) {
//    var vm = this;
//    var enableMultipleReward = rewardsFactory.getEnableMultipleReward();
//    vm.items = [];
//    //$log.debug($scope.rewards.rewardPoints);
//    (function initController() {
//      var refreshDuration = 60 * 60 * 1000;
//      var currentTime = new Date().getTime();
//      var diff;
//
//      if ($localStorage.rewardShortcut && $localStorage.rewardShortcut_timestamp) {
//        diff = currentTime - $localStorage.rewardShortcut_timestamp;
//      } else {
//        diff = null;
//      }
//
//      if (diff && diff <= refreshDuration && $localStorage.rewardShortcut.length > 0) {
//        vm.items = $localStorage.rewardShortcut;
//      }else {
//        apiFactory.getShortcut(getShortcutSuccess, getShortcutError);
//        //rewardsFactory.getShortcut()
//        //  .then(getShortCutSuccess);
//      }
//    })();
//
//    vm.listItemClick = function($index) {
//      //var clickedItem = vm.items[$index];
//      //$mdBottomSheet.hide(clickedItem);
//
//      // Hide if enablemultiplereward is false
//      addRewardItem(vm.items[$index]);
//
//      $scope.rewards.expandMemberInfo = false;
//      $scope.rewards.expandProductInfo = true;
//      if (!enableMultipleReward) {
//        $mdBottomSheet.hide();
//      }
//
//    };
//
//    function removeRewardItem(item, clearAll) {
//      rewardsFactory.removeRewardItem(item, clearAll);
//    }
//
//    function addRewardItem(item) {
//      var reward = angular.copy(item);
//      reward.qty = 1;
//      rewardsFactory.setRewardItem(reward);
//      var rewardTo = rewardsFactory.getRewardTo();
//      //var rewardItems = rewardsFactory.getRewardItem();
//      var rewardPoints = rewardsFactory.getRewardPoints();
//      if (rewardTo.points - rewardPoints < 0) {
//        toastr.warning('點數不足');
//        removeRewardItem(reward);
//      }
//
//      // Set parent rewardItemsCount value
//      // $scope.parentCtrl.property
//      $scope.rewards.rewardCounts = $scope.rewards.getRewardItemsCount();
//      $scope.rewards.refresh();
//    }
//
//
//    function getShortcutSuccess(result) {
//      $log.log('get shortcut success');
//      vm.items = result;
//      $localStorage.rewardShortcut = result;
//      $localStorage.rewardShortcut_timestamp = new Date().getTime();
//
//    }
//
//    function getShortcutError(result) {
//      $log.error('get shortcut error', result);
//      if ($localStorage.rewardShortcut) {
//        vm.items = $localStorage.rewardShortcut;
//      }else {
//        $mdBottomSheet.hide(null, '無法取得快速兌換項目');
//      }
//
//    }
//  });

'use strict';
/**
 * @ngdoc service
 * @name mpos.authInterceptor
 * @description
 * # authInterceptor
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('authInterceptorFactory', authInterceptor);

function authInterceptor($q, $location, $log, $localStorage, $rootScope){

  function removeDuplictedTransactions(){
    var transactions = $localStorage.transactions;
    var newArray = [];
    $log.debug('[authInterceptor] check duplicated transactions:', transactions);
    angular.forEach(transactions, function(value) {
      var duplicated = false;
      angular.forEach(newArray, function(value2) {
        if(angular.equals(value.timestamp, value2.timestamp)){
          duplicated = true;
        }
      });

      if (!duplicated) {
        newArray.push(value);
      }

    });

    if (newArray.length > 0) {
      delete $localStorage.transactions;
      $localStorage.transactions = angular.copy(newArray);
    }
    $log.debug('[authInterceptor] After remove duplicated transactions:', $localStorage.transactions);
    $rootScope.$emit('unhandledTransactions');
  }


  return {

    // This is the responseError interceptor
    responseError: function(rejection) {
      $log.debug('authInterceptor:', rejection);
      if (rejection.status === 401) {
        // redirect to login
        delete $localStorage.user;
        //$location.path('login').search({"businessId": $localStorage.business.id});
        $location.path('login');
      }

      /*
      if (rejection.config.url.match(/\/barcode\/points$/)) {
        if ($localStorage.transactions) {
          for (var i=0, len=rejection.config.data.length; i<len; i++) {
            $localStorage.transactions.push(rejection.config.data[i]);
          }
        }else {
          $localStorage.transactions = rejection.config.data;
        }

        removeDuplictedTransactions();
        //$rootScope.$emit('unhandledTransactions');

      }
      */

      /* If not a 401, do nothing with this error.
      * This is necessary to make a `responseError`
      * interceptor a no-op. */
      return $q.reject(rejection);
    }
  }
}

'use strict';
/**
 * @ngdoc service
 * @name mpos.api
 * @description
 * # api
 * Factory in the mpos.
 */
angular.module('mpos')
  .factory('apiFactory', apiFactory);

apiFactory.$inject = [ '$q', '$log', '$http', '$localStorage', 'config', 'localeService'];

function apiFactory($q, $log, $http, $localStorage, config, localeService) {

  /* Private API */
  var apiCall = function(method, url, params, loading) {
    var defer = $q.defer();
    var lang = localeService.getLocaleName();
    // developer only
    var prefix= '';
    // var prefix = config.apiUrl;
    // var prefix = config.eventApiUrl;
    // var prefix = config.moApiUrl;

    if (params) {
      params.lang = lang;
    } else {
      params = {
        lang: lang
      } 
    }
    
    var httpConfig = {
      method: method,
      url: prefix + url,
      //url: url,
      withCredentials: true,
      header: {
        "Content-Type": "application/json; charset=utf-8"
      },
      params: (method.toLowerCase() === 'get') ? params : null,
      data: (method.toLowerCase() !== 'get') ? params : null,
      ignoreLoadingBar: !loading
      //cache: false
    }

    //$http(httpConfig)
    //.success(function(result){
    //  //$log.debug('[apiFactory] success callback', result);
    //  if (result.error) {
    //    defer.reject(result.error);
    //  } else if (angular.isDefined(result.data)) {
    //    defer.resolve(result.data);
    //  } else {
    //    defer.resolve(result);
    //  }
    //})
    //.error(function(err){
    //  $log.debug('[apiFactory] error callback', err);
    //  defer.reject(err);
    //});

    $http(httpConfig)
    .then(function onSuccess(result){
      //$log.debug('[apiFactory] success callback', result);
      if (result.error) {
        defer.reject(result.error);
      } else if (angular.isDefined(result.data)) {
        defer.resolve(result.data);
      } else {
        defer.resolve(result);
      }
    }, function onError(err){
      $log.debug('[apiFactory] error callback', err);
      defer.reject(err.data);
    });
    return defer.promise;
  };

   /* Public API */

  var service = {};

  /*
   *
   * Business
   *
   */
  service.getBusinesses = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getBusinessProfile = function (params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ params.id, null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getBusinessConfig = function (params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ params.id + '/config', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /*
   *
   * Account
   *
   */
  service.login = function (params, successCallback, errorCallback) {
    //return apiCall('post', '/businesses/'+ $localStorage.business.id + '/signin', params)
    return apiCall('post', '/signin', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.logout = function (successCallback, errorCallback) {
    //return apiCall('post', '/businesses/'+ $localStorage.business.id + '/signout', null)
    return apiCall('post', '/signout', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getAccountProfile = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/account', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /*
   *
   * barcode
   *
   */
  // Distribution represent apple wallet
  service.searchDists= function (params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/barcode/search-dists', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getBarcodeMsg = function (params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/barcode/search', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.handlePoints = function (params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/barcode/points', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.createBarcode = function (params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/barcode/create', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.sendBarcode = function (params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/barcode/send', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /*
   *
   * deposit
   *
   */
  service.getDepositList = function (params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/deposit-items', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  }

  /*
   *
   * rewards
   *
   */
  service.getShortcut = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/rewards/shortcut', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getCategories = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/rewards/categories', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getRewardList = function (params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/rewards', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  }

  service.getDynamicRewardList = function (params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/rewards/dynamic', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  }

  /*
   *
   * events
   *
   */
  service.getEvents = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/events', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  // service.searchEventBarcode = function (eventId, params, successCallback, errorCallback) {
  //   return apiCall('post', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/search', params, true)
  //     .then(function(result){
  //       successCallback(result);
  //     }, function(err){
  //       errorCallback(err);
  //     })
  // };

  // params: {queryString: 'keyword'}
  service.searchEventGuestCandidates = function (eventId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/search', params, true)
      .then(function(result){
        $log.debug('api searchEventGuresCandidates done', result);
        successCallback(result);
      }, function(err){
        errorCallback(err);
      });
  };

  // params: {barcodeMessage: 'barcode'}
  service.checkinEventBarcode = function (eventId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/events/' + eventId + '/checkin', params, true)
      .then(function (result) {
        successCallback(result);
      }, function (err) {
        errorCallback(err);
      });
  };

  // params: {barcodeMessage: 'barcode'}
  service.eventCheckinStatus = function (eventId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/events/' + eventId + '/search-checkin', params, true)
      .then(function (result) {
        successCallback(result);
      }, function (err) {
        errorCallback(err);
      });
  };

  service.sendEventPass = function (eventId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/send', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.updateEventBarcode = function (eventId, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/update', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getEventDashboard = function (eventId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/dashboard', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /* params:
    {
      "cardId": "abcdefg",
      "phoneNumber": "0921345678"
    }
  */
  service.updatePhoneNumber = function (eventId, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/' + $localStorage.business.id + '/events/' + eventId + '/distribution', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /* params:
    {
      "dists": [
        {
          "cardId": "abcdefg",
          "data": {
            "iiotName": "Indiana",
            "iiotCompany": "IIOT"
          }
        }
      ]
    }
  */
  service.updateDistFields = function (eventId, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/' + $localStorage.business.id + '/events/' + eventId + '/distributions', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getDistFields = function (eventId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/events/' + eventId + '/fields', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };



  service.getBadgeDesign = function (eventId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/'+ $localStorage.business.id + '/events/' + eventId + '/badge-design', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  /*
   *
   * Counters
   *
   */
  service.getCounterList = function (successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /*
   *
   * Merchandise checkin
   *
   */
  service.uploadOrder = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/upload', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.searchCheckInOrder = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/search', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.updateCheckInOrder = function (appId, orderId, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/' + orderId, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getAddons = function (appId, orderBarcode, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/barcodes/' + orderBarcode + '/addons', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.resetAddons = function (url, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses' + url, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  /*
   *
   * Merchandise checkout
   *
   */
   service.searchCheckOutOrder = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/search', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.updateCheckOutOrder = function (appId, productSerialNo, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/' + productSerialNo, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getRemarkForm = function (appId, productSerialNo, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/' + productSerialNo + '/remark-form', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.setPayment = function (appId, productSerialNo, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/' + productSerialNo + '/payment', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  // Order Template
  service.getTemplate = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/example-csv', null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.uploadOrder = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkins/' + appId + '/upload', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReturnProducts = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/return-products', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.updateReturnProducts = function (appId, params, successCallback, errorCallback) {
    return apiCall('put', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/return-products', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.deleteReturnProduct = function (appId, sn, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/return-products/' + sn, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.batchDeleteReturnProduct = function (appId, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkouts/' + appId + '/return-products', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getReports = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportReady = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/ready', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportPickup = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/pickup', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getReportTodayPickup = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/today-pickup', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportReturn = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/return', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportAgency = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/agency', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getReportTodayAgency = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/today-agency', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getReportOther = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/other', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportReservation = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/reservation', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportNorecord = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/norecord', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };


  service.getReportStockOut = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/stockout', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportStockIn = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/stockin', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getReportStock = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/reports/stock', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };


  service.getDashBoardStockIn = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/dashboard/stockin', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getDashBoardPickup = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/dashboard/pickup', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getDashBoardTodayPickup = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/dashboard/today-pickup', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getDashBoardReturn = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/dashboard/return', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getDashBoardStock = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/dashboard/stock', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getStockInProducts = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/products', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.updateStockIn = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getStockInHistory = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/history', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  
  
  service.importStockIn = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin-import', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getStockInSN = function (appId, id, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + id, null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getStockInDetail = function (appId, historyId, type, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + historyId + '/' + type, null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.compareStockIn = function (appId, historyId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + historyId + '/compare', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getStockInExcel = function (appId, id, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + id + '/excel', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelReady = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/ready', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelPickup = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/pickup', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getExcelTodayPickup = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/today-pickup', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelReturn = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/return', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelAgency = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/agency', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getExcelTodayAgency = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/today-agency', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getExcelOther = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/other', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelReservation = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/reservation', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelNorecord = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/norecord', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };


  service.getExcelStockOut = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/stockout', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelStockIn = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/stockin', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getExcelStock = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/excel/stock', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.compareStock = function (appId, params, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stock/compare', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getSuppliers = function (appId, params, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/suppliers', params, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.deleteStockIn = function (appId, historyId, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + historyId, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.batchDeleteStockIn = function (appId, historyId, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockin/' + historyId + '/sns', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.deleteStock = function (appId, sn, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stock/' + sn, params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.batchDeleteStock = function (appId, params, successCallback, errorCallback) {
    return apiCall('delete', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stock', params, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };
  
  service.getStockOutHistory = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockout/history', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getStockOutHistoryDetail = function (appId, id, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockout/' + id, null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getStockOutHistoryExcel = function (appId, id, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/stockout/' + id, null, false)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.getOrders = function (appId, successCallback, errorCallback) {
    return apiCall('get', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId + '/orders', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };

  service.confirmPayment = function (appId, orderId, successCallback, errorCallback) {
    return apiCall('post', '/businesses/' + $localStorage.business.id + '/opage_checkios/' + appId  + '/orders/' + orderId + '/confirm-payment', null, true)
      .then(function(result){
        successCallback(result);
      }, function(err){
        errorCallback(err);
      })
  };


  /*
   *
   * app version
   *
   */

  service.getAppVersion = function(successCallback, errorCallback){

    return $http.get('version.json')
      .then(function(result) {
        //$log.debug('version:', result.data);
        successCallback(result.data);
      }, function (err) {
          errorCallback(err);
      })
  }

  return service;
}

'use strict';
/**
 * @ngdoc function
 * @name mpos.controller:modalremarkCtrl
 * @description
 * # modalremarkCtrl
 * Controller of the mpos
 */
angular.module('mpos')
  .controller('modalremarkCtrl', function ($scope, $element, title, close) {
    $scope.title = title;
    $scope.remark = null;

    $scope.close = function() {
      close({
        remark: $scope.remark
      }, 500); // close, but give 500ms for bootstrap to animate
    };

    $scope.cancel = function() {
      //  Manually hide the modal.
      $element.modal('hide');
      //  Now call close, returning control to the caller.
      close({
        remark: null
      }, 500); // close, but give 500ms for bootstrap to animate
    };
  });

//'use strict';
///**
// * @ngdoc function
// * @name mpos.controller:dialogrewarditemCtrl
// * @description
// * # dialogrewarditemCtrl
// * Controller of the mpos
// */
//angular.module('mpos')
//  .controller('dialogrewarditemCtrl', function ($scope, $log, $localStorage, $mdBottomSheet, selectedCategory, apiFactory) {
//    var vm = this;
//    vm.items = [];
//    vm.category = selectedCategory; //get inject parameter
//    (function initController() {
//      var refreshDuration = 60 * 60 * 1000;
//      var currentTime = new Date().getTime();
//      var diff;
//
//      if ($localStorage.rewardItems && $localStorage.rewardItems_timestamp) {
//        diff = currentTime - $localStorage.rewardItems_timestamp;
//      } else {
//        diff = null;
//      }
//
//      //apiFactory.getRewardList({category:vm.category.id}, getRewardListSuccess, getRewardListError);
//      //apiFactory.getRewardList({dynamic: false}, getRewardListSuccess, getRewardListError);
//      if (diff && diff <= refreshDuration && $localStorage.rewardItems.length > 0) {
//        filterList($localStorage.rewardItems);
//      }else {
//        apiFactory.getRewardList({dynamic:false}, getRewardListSuccess, getRewardListError);
//      }
//    })();
//
//    vm.listItemClick = function($index) {
//      var clickedItem = vm.items[$index];
//      $mdBottomSheet.hide(clickedItem);
//    };
//
//    function filterList(lists){
//      vm.items = lists.filter(function (el) {
//          return el.category === vm.category.id;
//
//          // filter dynamic reward item
//          //return el.category === vm.category.id && el.dynamic !== 1;
//      });
//    }
//
//    function getRewardListSuccess(result) {
//      $log.log('get reward list success:', result);
//      filterList(result);
//      $localStorage.rewardItems = result;
//      $localStorage.rewardItems_timestamp = new Date().getTime();
//    }
//
//    function getRewardListError(result) {
//      $log.error('get reward list error', result);
//      if ($localStorage.rewardItems) {
//        filterList($localStorage.rewardItems);
//      }else {
//        $mdBottomSheet.hide();
//      }
//    }
//
//
//  });

(function() {
  'use strict';

  angular
    .module('mpos')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $localStorage, $log, $window, $state,
    $timeout, $mdDialog, toastr, Fullscreen, apiFactory, rewardsFactory, counterService, 
    $mdMedia, $filter, $location, LOCALES) {
    var vm = this;
    var acl = $localStorage.user.acl[0].tpos;
    var timer;
    var _translate = $filter('translate');
    
    vm.eventLabel = null;
    vm.checkLabel = null;
    (function initController() {

      changeDisplayLabel($state.current.name, $state.params);

      //if ($state.current.name === 'home.events.event')
      //  vm.eventLabel = getEventLabel($state.params.eventId);

      if ($window.navigator.onLine && $localStorage.transactions && !timer)
        timer = $timeout(checkTransactions, 10000);
    })();

    vm.$mdMedia = $mdMedia;
    vm.business = $localStorage.business;
    vm.user = $localStorage.user;
    vm.connectionStatus = $window.navigator.onLine ? "green" : "red";
    vm.logout = logout;
    vm.gohome = gohome;
    vm.getAppVersion = getAppVersion;
    //vm.requestFullScreen = requestFullScreen;
    vm.menuClick =  menuClick;
    vm.menulist = [{
      name: 'Language',
      icon: 'lang',
      display: true,
      //display: isLocaleSupport(),
      callback: showSelectLang
    },{
      //name: '全螢幕',
      name: 'Fullscreen',
      icon: 'fullscreen',
      display: true,
      callback: requestFullScreen
    },{
      //name: '重新整理',
      name: 'Refresh',
      icon: 'refresh',
      display: true,
      callback: refreshPage
    }, {
      //name: '更新兌換項目',
      name: 'Update reward list',
      icon: 'refresh',
      display: (acl.indexOf('rewardpoint') > -1),
      callback: refreshRewards
    }, {
      //name: '更新消費金額與點數設定',
      name: 'Update points exchange config',
      icon: 'refresh',
      display: (acl.indexOf('rewardpoint') > -1 || acl.indexOf('memberpoint') > -1),
      callback: refreshConfig
    }, {
      //name: '更新活動項目',
      name: 'Update event list',
      icon: 'refresh',
      display: (acl.indexOf('events') > -1),
      callback: refreshEvents
    }, {
      name: 'Set Printer IP',
      icon: 'print',
      display: (acl.indexOf('events') > -1),
      callback: showPrinterDialog
    }, 
    {
      name: 'Set Websocket Connection',
      icon: 'settings',
      display: (acl.indexOf('events') > -1),
      //display: (acl.indexOf('events') > -1) && ($state.current.name === 'home.events.event' ? true: false ),
      callback: showWebsocketDialog
    }, 
    {
      //name: '版本資訊',
      name: 'About',
      icon: 'info',
      display: true,
      callback: getAppVersion
    }, {
      //name: '登出',
      name: 'Logout',
      icon: 'exit',
      display: true,
      callback: logout
    }]

    var refreshStatus = {
      counter: 0,
      shortcut: false,
      categories: false,
      items: false
    }

    // check unhandled transaction when received event
    var unbindUnhandled = $rootScope.$on('unhandledTransactions', function(){
      $log.debug('unhandledTransactions');
      if (!timer) {
        timer = $timeout(checkTransactions, 10000);
      }
    })

    var unbindStateCheck = $rootScope.$on('stateChange', function(event, data){
      changeDisplayLabel(data.state, data.params);
      //if (data.state == 'home.events.event') {
      //  vm.menulist[7].display = true;
      //}else{
      //  vm.menulist[7].display = false;
      //}     
    })
    
    var unbindUserCheck = $rootScope.$watch(function(){
      return $localStorage.user;
    }, function(newValue){
      if (newValue) {
        vm.user = newValue;
      }
    })
    
     var unbindBizCheck = $rootScope.$watch(function(){
      return $localStorage.business;
    }, function(newValue){
      if (newValue) {
        vm.business = newValue;
      }
    })

    var unbindCounterCheck = $rootScope.$watch(function(){
      return $localStorage.counter;
    }, function(newValue){
      if (newValue) {
        changeDisplayLabel($state.current.name, newValue);
      }
    })
    
    function isLocaleSupport(){
      var host = $location.host();
      if (LOCALES.hosts.indexOf(host) > -1) {
        return true;
      }else {
        return false;
      }
    }
    
    function changeDisplayLabel(route, data){
       switch (route) {
        case 'home.events.event':
          vm.checkLabel = null;
          vm.eventLabel = getEventLabel(data.eventId);
          break;
        case 'home.mocreate':
          setCounterLabel(_translate('title.mocreate'));
          break;
        case 'home.mocheckin':
          setCounterLabel(_translate('title.mocheckin'));
          break;
        case 'home.mocheckout':
          setCounterLabel(_translate('title.mocheckout'));
          break;
        case 'home.mostockin':
          setCounterLabel(_translate('title.mostockin'));
          break;
        case 'home.mostockout':
          setCounterLabel(_translate('title.mostockout'));
          break;
        case 'home.moreport':
          setCounterLabel(_translate('title.moreport'));
          //vm.eventLabel = null;
          //if (angular.isDefined($localStorage.counter))
          //  vm.checkLabel = $localStorage.counter.label;
          //else
          //  vm.checkLabel = '領還系統';
          break;
        default:
          vm.eventLabel = null;
          vm.checkLabel = null;
          if (angular.isDefined($localStorage.counter))
            vm.checkLabel = $localStorage.counter.label;

          $window.document.title =  _translate('title.mpos.header');
          break;

      }

    }

    function setCounterLabel(title){
      $window.document.title = _translate('title.mo.header') + ' - ' + title;
      vm.eventLabel = null;
      if (angular.isDefined($localStorage.counter))
        vm.checkLabel = $localStorage.counter.label;
      else
        vm.checkLabel = _translate('title.mo.header');
    }

    function getEventLabel(id) {

      var event = $localStorage.events.filter(function(el){
        return el.id === id;
      });

    $window.document.title = event[0].label;
      return event[0].label;
    }

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
      unbindUnhandled();
      unbindStateCheck();
      unbindUserCheck();
      unbindBizCheck();
      unbindCounterCheck();
      $window.removeEventListener("online", onlineCallback);
      $window.removeEventListener("offline", offlineCallback);

    });

    // Listen for online/off event for device
    /* some client can detect online/offline event */
    $window.addEventListener("online", onlineCallback, true);

    $window.addEventListener("offline", offlineCallback, true);

    function onlineCallback() {
      $log.debug('online');
      vm.connectionStatus = "green";
      $scope.$apply();

      // check unhandled transactions
      if (!timer) {
        timer = $timeout(checkTransactions, 10000);
      }
    }

    function offlineCallback(){
      $log.debug('offline');
      if (timer) {
        $timeout.cancel(timer);
      }
      vm.connectionStatus = "red";
      $scope.$apply();


    }
    //$window.addEventListener('beforeunload', function () {
    //  $localStorage.$reset();
    //  //delete $localStorage.rewardShortcut;
    //  //delete $localStorage.rewardShortcut_timestamp;
    //  //delete $localStorage.rewardCategories;
    //  //delete $localStorage.rewardCategories_timestamp;
    //  //delete $localStorage.rewardItems;
    //  //delete $localStorage.rewardItems_timestamp;
    //  //delete $localStorage.events;
    //  //delete $localStorage.events_timestamp;
    //  //delete $localStorage.businessConfig;
    //  //delete $localStorage.user;
    //}, true);

    function checkTransactions(){
      var newArray = [];
      $log.debug('check transactions');
      angular.forEach($localStorage.transactions, function(value) {
        var duplicated = false;
        angular.forEach(newArray, function(value2) {
          if(angular.equals(value.timestamp, value2.timestamp)){ duplicated = true }
        });

        if (!duplicated) {
          newArray.push(value);
        }

      });

      if (newArray.length > 0) {
        delete $localStorage.transactions;
        apiFactory.handlePoints(newArray, handlePointsSuccess, handlePointsError);
      }
    }

    function menuClick(cb){
      cb();
    }

    function refreshConfig(){
      $log.info('refresh config');
      apiFactory.getBusinessConfig({id: $localStorage.business.id}, function(result){
        $log.log('refresh business config success:', result)
        $localStorage.businessConfig = result;
        toastr.success(_translate('Update successfully'));
      }, function(err){
        $log.error('refresh business config error:', err);
        toastr.error(_translate('Update failed'));
        //toastr.error('更新失敗');
      });


    }

    function refreshEvents(){
      $log.info('refresh events');
      apiFactory.getEvents(getEventsSuccess, getEventsError);
    }
    
    function showPrinterDialog(){
      $log.info('set printer');
      
      // Appending dialog to document.body to cover sidenav in docs app
      $mdDialog.show({
        templateUrl: "app/main/dialog.printer.html",
        escapeToClose: true,
        clickOutsideToClose: true,
        controller: function($scope, $localStorage){
          $scope.printerIP = $localStorage.printerIP ? $localStorage.printerIP: '192.168.192.168';
          
          $scope.setPrinterIP = function(){
            $localStorage.printerIP = $scope.printerIP;
            $mdDialog.hide();
          }
          
          $scope.close = function(){
            $mdDialog.cancel();
          } 
          var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {

            $scope.$apply(function(){
              $scope.printerIP = $scope.printerIP + data;
            });
          });
          
          var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {

            $scope.$apply(function(){
              $scope.printerIP = $scope.printerIP + data;
            });
          });
          
          var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
            evt.stopPropagation();
            evt.preventDefault();
            //$log.log('press:', obj.keyCode)
            $scope.$apply(function(){
              switch (obj.keyCode) {
                case 8:
                  if (angular.isDefined($scope.printerIP)) {
                    $scope.printerIP = $scope.printerIP.slice(0, -1);
                  }
                  break;
                case 13:
                  break;
                default:

                  if (angular.isDefined($scope.printerIP))
                    $scope.printerIP = $scope.printerIP + key;
                  else
                    $scope.printerIP = key;
                  break;

              }
            });
          });

          $scope.$on('$destroy', function () {

            if (unbindWatchKeyPress) unbindWatchKeyPress();
            if (unbindWatchPaste) unbindWatchPaste();
          });
         
        }  
      })    
    }

    function showWebsocketDialog(){ 
      $mdDialog.show({
        templateUrl: "app/main/dialog.websocket.html",
        escapeToClose: true,
        clickOutsideToClose: true,
        controller: function($scope, $localStorage){
          $scope.ws = $localStorage.ws ? $localStorage.ws: {'id': '', 'enabled': false};
          
          $scope.ok = function(){
            
            //$localStorage.ws = $scope.ws;
            $mdDialog.hide($scope.ws);
          }
          
          $scope.close = function(){
            $mdDialog.cancel();
          } 
          
          var unbindWatchPaste = $scope.$on('pasteEvent', function (evt, data) {

            $scope.$apply(function(){
              $scope.ws.id = $scope.ws.id + data;
            });
          });
          
          
          var unbindWatchKeyPress = $scope.$on('keypressEvents', function (evt, obj, key) {
            evt.stopPropagation();
            evt.preventDefault();
            $log.log('press:', obj.keyCode)
            $scope.$apply(function(){
              switch (obj.keyCode) {
                case 8:
                  if (angular.isDefined($scope.ws.id)) {
                    $scope.ws.id = $scope.ws.id .slice(0, -1);
                  }
                  break;
                case 13:
                  break;
                default:

                  if (angular.isDefined($scope.ws.id ))
                    $scope.ws.id  = $scope.ws.id  + key;
                  else
                    $scope.ws.id  = key;
                  break;

              }
            });
          });

          $scope.$on('$destroy', function () {

            if (unbindWatchKeyPress) unbindWatchKeyPress();
            if (unbindWatchPaste) unbindWatchPaste();
          });
         
        }, 
        //onRemoving: function(){
        //  $rootScope.$emit('websocket', $localStorage.ws);
        //}
      }) 
      .then(function(websocket){
        
        $localStorage.ws = websocket;
        if ($state.current.name === 'home.events.event') {
          $rootScope.$emit('websocket', $localStorage.ws);
        }
      })
    }
    function refreshRewards(){
      $log.info('refresh rewards');
      apiFactory.getShortcut(getShortcutSuccess, getShortcutError);
      apiFactory.getCategories(getCategoriesSuccess, getCategoriesError);
      apiFactory.getRewardList({dynamic: false}, getRewardListSuccess, getRewardListError);
    }

    function refreshPage(){
      $log.info('refresh page');
      $window.location.reload();
    }

    function showSelectLang(){
      $mdDialog.show({
        templateUrl: 'app/main/dialog.language.html',
        escapeToClose: true,
        clickOutsideToClose: true,
        controller: function DialogCtrl($scope, $mdDialog){
            var vm = this;
            vm.close = function() {
              $mdDialog.hide();
            }
        },
        controllerAs: 'langCtrl'
      });
    }
    
    function requestFullScreen(){

      // Fullscreen
      if (Fullscreen.isEnabled()){
        Fullscreen.cancel();
      } else {
        Fullscreen.all();
      }

      // Set Fullscreen to a specific element (bad practice)
      // Fullscreen.enable( document.getElementById('img') )


      //var elem = angular.element( document.querySelector( '#view-container' ) );

      ////elem[0].webkitRequestFullScreen();
      ///*
      // * Need to set width first, otherwise, the width becomes strange value
      // */
      //elem.css('width', $window.innerWidth);
      //document.body.webkitRequestFullScreen();
    }


    function getAppVersion () {
      apiFactory.getAppVersion(getAppVersionSuccess, getAppVersionError);
    }

    function gohome() {
      rewardsFactory.clear();
      $state.go('home.menu');
    }

    function logout() {
      rewardsFactory.clear();
      counterService.clearCounter();
      apiFactory.logout(logoutSuccessCallback, logoutErrorCallback);
    }

    function logoutSuccessCallback(result){
      $log.log('logout success', result);
      if (result.success) {
        $window.localStorage.clear();
        $localStorage.$reset();
        //delete $localStorage.user;
        //delete $localStorage.rewardShortcut;
        //delete $localStorage.rewardShortcut_timestamp;
        //delete $localStorage.rewardCategories;
        //delete $localStorage.rewardCategories_timestamp;
        //delete $localStorage.rewardItems;
        //delete $localStorage.rewardItems_timestamp;
        //delete $localStorage.events;
        //delete $localStorage.events_timestamp;
        //delete $localStorage.businessConfig;
        //$state.go('home');
        //$state.go('login', {"businessId": vm.business.id});
        $state.go('login');

      }
    }

    function logoutErrorCallback(result) {
      $log.error('logout success', result);
    }

    function handlePointsSuccess(result) {
      $log.log('handle points success', result);
    }

    function handlePointsError(result) {
      $log.error('handle points error', result);
      $timeout(checkTransactions, 10000);
    }


    function getShortcutSuccess(result) {
      $log.log('get shortcut success');
      $localStorage.rewardShortcut = result;
      $localStorage.rewardShortcut_timestamp = new Date().getTime();
      checkRefreshStatus('shortcut', true);
    }

    function getShortcutError(result) {
      $log.error('get shortcut error', result);
      checkRefreshStatus('shortcut', false);
    }

    function getCategoriesSuccess(result) {
      $log.log('get category success');
      $localStorage.rewardCategories = result;
      $localStorage.rewardCategories_timestamp = new Date().getTime();
      checkRefreshStatus('categories', true);
    }

    function getCategoriesError(result) {
      $log.error('get category error', result);
      checkRefreshStatus('categories', false);
    }

    function getRewardListSuccess(result) {
      $log.log('get reward list success');
      $localStorage.rewardItems = result;
      $localStorage.rewardItems_timestamp = new Date().getTime();
      checkRefreshStatus('items', true);
    }

    function getRewardListError(result) {
      $log.error('get reward list error', result);
      checkRefreshStatus('items', false);
    }

    function getAppVersionSuccess(result) {
      $log.log('get app version success', result);

      //var myColor = '#ffff80';
      $mdDialog.show({
          templateUrl: 'app/main/dialog.version.html',
          //template:
          //  '<md-dialog aria-label="" style="min-width:300px; min-height:200px; background-color:' + myColor + '">' +
          //  '  <md-dialog-content style="text-align:center; margin-top:20%">'+
          //  '    <div flex class="md-headline"> Version: ' + result.version + '</div>' +
          //  '    <div flex class="md-headline"> Revision: ' + result.revision + '</div>' +
          //  '  </md-dialog-content>' +
          //  '</md-dialog>',
          locals: {
            about: {
              version: result.version,
              revision: result.revision
            }
          },
          escapeToClose: true,
          clickOutsideToClose: true,
          controller: function DialogCtrl($scope, $mdDialog, about){
            var vm = this;
            vm.data = about;
            vm.confirm = function() {
              $mdDialog.hide();
            }
          },
          controllerAs: 'about'
      });

    }

    function getAppVersionError(result) {
      $log.error('get app version error', result);
    }

    function getEventsSuccess(result){
      $log.log('get events success', result);
      $localStorage.events = result;
      $localStorage.events_timestamp = new Date().getTime();
      toastr.success(_translate('Update successfully'));
    }

    function getEventsError(result){
      $log.error('get events error', result);
      toastr.error(_translate('Update failed'));
    }

    function checkRefreshStatus(item, status){

      refreshStatus.counter += 1;
      refreshStatus[item] = status;

      if (refreshStatus.counter === 3) {
        if (refreshStatus.shortcut && refreshStatus.categories && refreshStatus.items) {
          toastr.success(_translate('Update successfully'));
        } else {
          toastr.error(_translate('Update failed'));
        }
        refreshStatus = {
          counter: 0,
          shortcut: false,
          categories: false,
          items: false
        }

      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $window, $rootScope, $localStorage, $location, $stateParams, $state) {

    $log.debug('runBlock end');

    var rs = $rootScope;
    //authenicateFactory.clearCredentials();
    //businessFactory.getProfile({id: '1234'});

    rs.$on('$locationChangeStart', function () {
      // redirect to login page if not logged in and trying to access a restricted page
      var restrictedPage = $window.jQuery.inArray($location.path(), ['/login']) === -1;
      var loggedIn = $localStorage.user && $localStorage.isLogin;

      if (restrictedPage && !loggedIn) {
        $rootScope.isLogin = false;
        // Test only to assign business id
        //$location.path('/login').search({"businessId": "p8D2Wr3MX"});
        $location.path('/login');
      }else {
        $rootScope.isLogin = true;

      }

    });

    rs.$on('$stateChangeStart', function (event, toState, toParams) {
      var loggedIn = $localStorage.user && $localStorage.isLogin;
      if (toState.name === "login" && loggedIn) {
        event.preventDefault();
        $state.go('home.menu');
      }
      if (toState.name === "home") {
        event.preventDefault();
        $state.go('home.menu');
      }

      //check page auth
      var authPages = ['memberpoint', 'rewardpoint', 'redeempoint', 'events',
        'mocheckin', 'mocheckout', 'mocreate', 'mostockout',  'moreport'];
      var acl = angular.isDefined($localStorage.user) ? $localStorage.user.acl[0].tpos : [] ;
      if (authPages.indexOf(toState.url) > -1 && acl.indexOf(toState.url) === -1) {
        event.preventDefault();
        $state.go('home.menu');
      }

      rs.$emit('stateChange', {state: toState.name, params:toParams});
    })

  }

})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        //params: {
        //  businessId: ''
        //},
        controller: 'loginCtrl',
        controllerAs: 'login'
      })
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('home.menu', {
        //url: '/menu',
        views: {
          'content': {
            templateUrl: 'app/main/menu.html',
            controller: 'menuCtrl',
            controllerAs: 'menu'
          }
        }
      })
      .state('home.memberpoint', {
        url: 'memberpoint',
        views: {
          'content': {
            templateUrl: 'app/main/memberpoint.html',
            controller: 'pointsCtrl',
            controllerAs: 'points'
          }
        }
      })
      .state('home.refundpoint', {
        url: 'refundpoint',
        views: {
          'content': {
            templateUrl: 'app/main/refundpoint.html',
            controller: 'pointsCtrl',
            controllerAs: 'refund'
          }
        }
      })
      .state('home.redeempoint', {
        url: 'redeempoint',
        views: {
          'content': {
            templateUrl: 'app/main/redeempoint.html',
            controller: 'pointsCtrl',
            controllerAs: 'redeem'
          }
        }
      })
      .state('home.deposit', {
        url: 'deposit',
        views: {
          'content': {
            templateUrl: 'app/main/deposit.html',
            controller: 'pointsCtrl',
            controllerAs: 'deposit'
          }
        }
      })
      .state('home.rewardpoint', {
        url: 'rewardpoint',
        views: {
          'content': {
            templateUrl: 'app/main/rewardpoint.html',
            controller: 'pointsCtrl',
            controllerAs: 'rewards'
          }
        }
      })
      //.state('home.rewardpoint.category', {
      //  url: '/:barcode',
      //  views: {
      //    'content@home': {
      //      templateUrl: 'app/main/rewardcategory.html',
      //      controller: 'rewardsCtrl',
      //      controllerAs: 'reward',
      //      params: {
      //        barcode: ''
      //      }
      //    }
      //  }
      //})
      .state('home.events', {
        url: 'events',
        views: {
          'content': {
            templateUrl: 'app/main/events.html',
            controller: 'eventsCtrl',
            controllerAs: 'events'
          }
        }
      })
      .state('home.events.event', {
        url: '/:eventId',
        views: {
          'content@home': {
            templateUrl: 'app/main/event.html',
            controller: 'eventsCtrl',
            controllerAs: 'event'
          }
        }
      })
      .state('home.mocheckin', {
        url: 'mocheckin',
        views: {
          'content': {
            templateUrl: 'app/main/mo.checkin.html',
            controller: 'mocheckinCtrl',
            controllerAs: 'cin'
          }
        }
      })
      .state('home.mocheckout', {
        url: 'mocheckout',
        views: {
          'content': {
            templateUrl: 'app/main/mo.checkout.html',
            controller: 'mocheckoutCtrl',
            controllerAs: 'cout'
          }
        }
      })
      //.state('home.mocreate', {
      //  url: 'mocreate',
      //  views: {
      //    'content': {
      //      templateUrl: 'app/main/mo.create.html',
      //      controller: 'mocreateCtrl',
      //      controllerAs: 'mo'
      //    }
      //  }
      //})
      .state('home.mostockin', {
        url: 'mostockin',
        views: {
          'content': {
            templateUrl: 'app/main/mo.stockin.html',
            controller: 'mostockCtrl',
            controllerAs: 'stock'
          }
        }
      })
      .state('home.mostockout', {
        url: 'mostockout',
        views: {
          'content': {
            templateUrl: 'app/main/mo.stockout.html',
            controller: 'mostockoutCtrl',
            controllerAs: 'stock'
          }
        }
      })
      .state('home.moreport', {
        url: 'moreport',
        views: {
          'content': {
            templateUrl: 'app/main/mo.report.html',
            controller: 'moreportCtrl',
            controllerAs: 'report'
          }
        }
      })
      .state('home.moorder', {
        url: 'moorder',
        views: {
          'content': {
            templateUrl: 'app/main/mo.order.html',
            controller: 'moorderCtrl',
            controllerAs: 'orders'
          }
        }
      });


    $urlRouterProvider.otherwise('/');
  }


})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('mpos')
    .constant('config', {
      appName: 'MPOS',
      //apiUrl: 'https://private-872dc-iiotcloudmpos.apiary-mock.com'
      apiUrl: 'https://mpos-dev.iiot.io',
      eventApiUrl: 'https://event-dev.iiot.io',
      // 請 Kay 建立新的測試環境 instance 時，除了 url 位址要改，也要請他回傳正確的 domain type，例如：event
      // eventApiUrl: 'https://iiot-mpos-prod-test.us-west-2.elasticbeanstalk.com',
      moApiUrl: 'https://pr-dev.iiot.io'
    })
    .constant('LOCALES', {
      'locales': {
        'en-us': 'English',
        'zh-tw': '繁體中文',
        'ja': '日本語'
      },
      'preferredLocale': 'zh-tw',
      'hosts': ['localhost', 'pr-dev.iiot.io', 'pr.iiot.io', 'pr-kay.iiot.io',
        'lease-maya.wifiotg.com', 'pr-maya.wifiotg.com', 'pr.jproaming.com',
        'LRS.jetfi.jp']
    })
    .constant('iiotWebsocket', {
      'devUrl': 'wss://code-ws.iiot.io/dev',
      'releaseUrl': 'wss://code-ws.iiot.io/prod',
      'devHosts': ['localhost', 'event-dev.iiot.io']
    })
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('mpos')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $localStorageProvider, $mdIconProvider, $httpProvider, 
    tagsInputConfigProvider, cfpLoadingBarProvider, tmhDynamicLocaleProvider, $translateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    cfpLoadingBarProvider.includeSpinner = false;

    // i18n
    tmhDynamicLocaleProvider.localeLocationPattern('locales/angular-locale_{{locale}}.js');
    //tmhDynamicLocaleProvider.defaultLocale('en-us');
    
    //Flash of untranslated content
    //To get around this, you could provide at least one language 
    //with your app without having to load it asynchronously.
    $translateProvider.translations('zh-tw', {
      "directives.language-select.Language": "語言",
      "btn.ok": "確定",
      "btn.cancel": "取消",
      "btn.reset": "重設",
      "btn.remove": "移除 ",
      "btn.close": "關閉",
      "btn.delete": "刪除",
      "btn.return": "歸還",
      "btn.stockin.return": "退回",
      "btn.refresh": "重新整理",
      "btn.stockin": "入庫",
      "btn.detail": "查看明細",
      "btn.analyze": "分析",
      "btn.upload": "上傳",
      "btn.download": "下載",
      "btn.downloadDetails": "下載明細",
      "btn.goPrevious": "回上頁",
      "btn.product.status": "設備狀態",
      "btn.scanMode": "掃碼模式",
      "btn.searchMode": "查詢模式",
      "btn.stockout": "出庫",
      "btn.autoStockin": "出庫轉入庫",
      "btn.print.invoice": "列印繳款單",
      "btn.shipments": "入倉管並出貨",
      "title.business": "商店編號",
      "title.counter": "櫃台名稱",
      "title.employee": "員工編號",
      "title.selectLang": "請選擇語系",
      "title.memberpoint": "會員積點",
      "title.rewardpoint": "項目核銷",
      "title.redeempoint": "動態核銷",
      "title.refundpoint": "動態退點",
      "title.deposit": "項目儲值",
      "title.events": "活動報到",
      "title.eventdashboard": "即時報表",
      "title.mocheckin": "領機服務",
      "title.mocheckout": "還機服務",
      "title.mostockin": "設備入庫",
      "title.mocreate": "出貨清單",
      "title.mostockout": "出庫服務",
      "title.moreport": "即時統計",
      "title.moorder": "訂單作業",
      "title.mpos.header": "MPOS",
      "title.event.header": "MPOS",
      "title.mo.header": "領還系統",
      "title.table.mocheckin": "領機",
      "title.table.mocheckout": "還機",
      "title.table.productInfo": "產品資訊",
      "title.mocheckin.unreceived": "未領機項目",
      "title.mocheckin.exit": "離開領機畫面",
      "title.stockin.detail": "入庫設備明細",
      "title.stockin.sn.detail": "設備序號明細",
      "title.stockout.list": "還機清單",
      "title.stockin.history.detail": "入庫歷史明細資料",
      "title.moreport.details": "明細資料",
      "title.moreport.reservation": "應領機明細資料",
      "title.moreport.ready": "待領機明細資料",
      "title.moreport.pickup": "已領機明細資料",
      "title.moreport.agency": "換航廈明細資料",
      "title.moreport.today.pickup": "今日總領機明細資料",
      "title.moreport.today.agency": "今日換航廈明細資料",
      "title.moreport.other": "其它領機明細資料",
      "title.moreport.return": "總還機明細資料",
      "title.moreport.norecord": "異常還機明細資料",
      "title.moreport.stockin": "入庫明細資料",
      "title.moreport.stock": "庫存明細資料",
      "title.moreport.stockout": "出庫明細資料",
      "title.moreport.noDetails": "無明細資料",
      "title.remark": "請輸入註解",
      "title.mocreate.upload": "上傳檔案",
      "title.mocreate.error": "錯誤檔案",
      "table.field.voucher": "憑證條碼",
      "table.field.query": "查詢條件",
      "table.field.order": "訂單編號",
      "table.field.applicant.phone": "客戶電話",
      "table.field.applicant.name": "客戶姓名",
      "table.field.orderRemark": "訂單備註",
      "table.field.remark": "備註",
      "table.field.totalProduct": "領取商品總數",
      "table.field.urgentOrder": "急單",
      "table.field.vendor": "廠商",
      "table.field.product": "產品",
      "table.field.quantity": "數量",
      "table.field.quantity.order": "訂單數量",
      "table.field.productType": "商品型態",
      "table.field.productCategory": "產品類別",
      "table.field.productSN": "設備編號",
      "table.field.lastUpdate": "最後更新",
      "table.field.operator": "操作人員",
      "table.field.operator.pickup": "領機人員",
      "table.field.operator.return": "還機人員",
      "table.field.operator.stockin": "入庫人員",
      "table.field.operator.stockout": "出庫人員",
      "table.field.total": "總數",
      "table.field.return.total": "總還機",
      "table.field.return.abnormal": "異常還",
      "table.field.pickup": "領機",
      "table.field.return": "還機",
      "table.field.stock": "庫存",
      "table.field.stockout": "出庫",
      "table.field.return.new": "新退",
      "table.field.status": "狀態",
      "table.field.supplier": "供應商",
      "table.field.departure.time": "起飛時間",
      "table.field.expected": "應領",
      "table.field.received": "已領",
      "table.field.pending": "待領",
      "table.field.stockin.time": "入庫時間",
      "table.field.stockout.time": "出庫時間",
      "table.field.paymentType": "付款方式",
      "table.field.action": "操作",
      "msg.select.business": "請選擇企業",
      "msg.select.counter": "請選擇核銷櫃檯",
      "msg.mocheckin.exit": "尚未送出領機資訊，是否確定離開此畫面",
      "msg.mocheckin.search.nodata": "查無訂單資料",
      "msg.mocheckin.search.error": "無法取得訂單資料",
      "msg.mocheckin.update.success": "領機成功",
      "msg.mocheckin.update.error": "無法更新訂單",
      "msg.mocheckout.search.error": "無法取得訂單資料",
      "msg.mocheckout.update.success": "還機成功",
      "msg.mocheckout.update.overdue": "還機逾期",
      "msg.mocheckout.update.error": "無法更新訂單",
      "msg.mocheckout.payment.success": "還機付款成功",
      "msg.mocheckout.payment.error": "損壞出單失敗",
      "msg.mocheckout.statusForm.error": "無法取得設備狀態表",
      "msg.mostockin.scan": "請掃瞄商品",
      "msg.mostockin.scan.quantity": "已掃瞄設備數量",
      "msg.mostockin.scan.max": "掃瞄設備數量已達上限",
      "msg.mostockin.import": "入庫設備匯入",
      "msg.mostockin.history": "入庫歷史紀錄", 
      "msg.mostockin.compare.step1": "步驟一 : 選擇比對檔案", 
      "msg.mostockin.compare.step2": "步驟二 : 上傳與分析", 
      "msg.mostockin.update.error": "無法更新入庫資料",
      "msg.mostockin.getStockin.error": "無法取得入庫資料",
      "msg.mostockin.getProduct.error": "無法取得商品資料",
      "msg.mostockin.getHistory.error": "取得明細資料失敗",
      "msg.mostockin.getDetail.error": "取得明細資料失敗",
      "msg.mostockin.getDetail.nodata": "無明細資料",
      "msg.mostockin.compare.error": "無法分析差異資料",
      "msg.mostockin.delete.success": "退回成功",
      "msg.mostockin.delete.error": "退回失敗",
      "msg.mostockin.getSN.error": "無法取得設備序號",
      "msg.mostockin.getSN.nodata": "無設備序號",
      "msg.mostockout.delete.success": "刪除成功",
      "msg.mostockout.delete.error": "刪除失敗",
      "msg.mostockout.update.success": "更新還機列表成功",
      "msg.mostockout.update.error": "無法更新還機列表",
      "msg.mostockout.getProduct.success": "取得還機列表成功",
      "msg.mostockout.getProduct.error": "無法取得還機列表",
      "msg.moreport.getDetail.error": "取得明細資料失敗",
      "msg.moreport.getDetail.nodata": "無明細資料",
      "msg.moreport.getTodayPickup.error": "無法取得資料",
      "msg.moreport.getDashboard.error": "無法取得資料",
      "msg.moreport.delete.stock.success": "退回成功",
      "msg.moreport.delete.stock.error": "退回失敗",
      "msg.moreport.delete.norecord.success": "刪除成功",
      "msg.moreport.delete.norecord.errpr": "刪除失敗",
      "msg.file.import.error": "匯入檔案失敗",
      "msg.file.download.url.error": "無法取得下載檔案位置",
      "msg.checkbox.deselectAll": "取消全選",
      "msg.checkbox.selectAll": "全選",
      "msg.report.today.received": "今日總領機",
      "msg.report.today.change": "今日換航廈",
      "msg.file.upload.error": "上傳檔案失敗",
      "msg.file.download.template.error": "無法取得範例表單",
      "Login": "登入",
      "Account": "帳號",
      "User": "使用者",
      "Password": "密碼",
      "Necessary": "必填",
      "Login failed": "登入失敗",
      "Cannot get businesses list": "無法取得企業列表",
      "Language": "語系",
      "Fullscreen": "全螢幕",
      "Refresh": "重新整理",
      "Update reward list": "更新兌換項目",
      "Update points exchange config": "更新消費金額與點數設定",
      "Update event list": "更新活動項目",
      "About": "關於",
      "Logout": "登出",
      "Update successfully": "更新成功",
      "Update failed": "更新失敗",
      "Add machine": "加機器",
      "Change counter": "換櫃檯",
      "Change to": "換成",
      "Please fill in product information": "請填寫產品資料",
      "Status": "狀態",
      "Product status": "設備狀態",
      "Please fill in the machine status form": "請填寫還機狀態表",
      "Select file": "請選擇檔案",
      "No file is selected": "尚未選擇檔案",
      "Download example": "下載範例",
      "Filename": "檔案名稱",
      "Filesize": "檔案大小",
      "Upload progress": "上傳進度",
      "Action": "動作",
      "Result": "結果",
      "Abnormal analysis": "異常分析"
    });
    
    $translateProvider.useStaticFilesLoader({
      prefix: 'locales/',
      suffix: '.json'
    });
    
    // try to find out preferred language by yourself
    //$translateProvider
    //.uniformLanguageTag('bcp47') // enable BCP-47, must be before determinePreferredLanguage!
    //.determinePreferredLanguage();
    
    // is applied on first load
    $translateProvider.preferredLanguage('zh-tw').fallbackLanguage('zh-tw');
    
    //To get warnings in the developer console, regarding forgotten IDs in translations
    //$translateProvider.useMissingTranslationHandlerLog();
    
    // 'sanitize' would render UTF8 chars wrong!
    // 'escape' would not show HTML-tags which are inside our translations!
    $translateProvider.useSanitizeValueStrategy('escape');
    //Need to install angular-translate-storage-local
    $translateProvider.useLocalStorage();// saves selected language to localStorage
    
    //When using a combination of $translateProvider.translations() and 
    // $translateProvider.{{whatever}}Loader, for each language keys declared 
    // using $translateProvider.translations(), the asynchronous loader will not be called.
    //To get around this, you can enable the $translateProvider.forceAsyncReload()
    $translateProvider.forceAsyncReload(true);
    
    //ng-tags-input
    tagsInputConfigProvider.setActiveInterpolation('tagsInput', {
      maxTags: true,
      placeholder: true
    });
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 2500;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    toastrConfig.closeButton = true;

    // for delete with request body
    $httpProvider.defaults.headers.delete = { "Content-Type": "application/json;charset=utf-8" };
    $httpProvider.interceptors.push([
      '$injector',
      function ($injector) {
        return $injector.get('authInterceptorFactory');
      }
    ]);

    // set local storage prefix
    $localStorageProvider
      .setKeyPrefix('mpos.');

    $mdIconProvider
      .icon('home', 'assets/icons/ic_home_48px.svg', 48)
      .icon('fullscreen', 'assets/icons/ic_fullscreen_48px.svg', 48)
      .icon('return', 'assets/icons/ic_keyboard_return_48px.svg', 48)
      .icon('refresh', 'assets/icons/ic_refresh_48px.svg', 48)
      .icon('menu', 'assets/icons/ic_menu_48px.svg', 48)
      .icon('exit', 'assets/icons/ic_exit_to_app_48px.svg', 48)
      .icon('error', 'assets/icons/ic_error_outline_48px.svg', 48)
      .icon('error_circle', 'assets/icons/ic_error_48px.svg', 48)
      .icon('remove_circle', 'assets/icons/ic_remove_circle_48px.svg', 48)
      .icon('add_circle', 'assets/icons/ic_add_circle_48px.svg', 48)
      .icon('check_circle', 'assets/icons/ic_check_circle_48px.svg', 48)
      .icon('warning', 'assets/icons/ic_warning_48px.svg', 48)
      .icon('airplane_active', 'assets/icons/ic_airplanemode_active_48px.svg', 48)
      .icon('airplane_inactive', 'assets/icons/ic_airplanemode_inactive_48px.svg', 48)
      .icon('person', 'assets/icons/ic_person_48px.svg', 48)
      .icon('security', 'assets/icons/ic_security_48px.svg', 48)
      .icon('connection', 'assets/icons/ic_swap_vert_48px.svg', 48)
      .icon('info', 'assets/icons/ic_info_outline_48px.svg', 48)
      .icon('membership', 'assets/icons/ic_card_membership_48px.svg', 48)
      .icon('event', 'assets/icons/ic_event_48px.svg', 48)
      .icon('order', 'assets/icons/ic_event_note_48px.svg', 48)
      .icon('statistic', 'assets/icons/ic_assessment_48px.svg', 48)
      .icon('stockout', 'assets/icons/ic_assignment_turned_in_48px.svg', 48)
      .icon('business', 'assets/icons/business_48px.svg', 48)
      .icon('close', 'assets/icons/close_48px.svg', 48)
      .icon('barcode', 'assets/icons/barcode.svg', 48)
      .icon('upload_file', 'assets/icons/ic_file_upload_48px.svg', 48)
      .icon('remove', 'assets/icons/ic_remove_48px.svg', 48)
      .icon('list', 'assets/icons/ic_list_48px.svg', 48)
      .icon('download_file', 'assets/icons/ic_file_download_48px.svg', 48)
      .icon('cancel', 'assets/icons/ic_block_48px.svg', 48)
      .icon('add', 'assets/icons/add_48.svg', 48)
      .icon('delete', 'assets/icons/delete_48.svg', 48)
      .icon('arrow_up', 'assets/icons/ic_keyboard_arrow_up_48px.svg', 48)
      .icon('arrow_down', 'assets/icons/ic_keyboard_arrow_down_48px.svg', 48)
      .icon('arrow_right', 'assets/icons/ic_keyboard_arrow_right_48px.svg', 48)
      .icon('drop_up', 'assets/icons/ic_arrow_drop_up_48px.svg', 48)
      .icon('drop_down', 'assets/icons/ic_arrow_drop_down_48px.svg', 48)
      .icon('keyboard', 'assets/icons/ic_keyboard_48px.svg', 48)
      .icon('checkin', 'assets/icons/checkin.svg', 48)
      .icon('giftcard', 'assets/icons/ic_card_giftcard_48px.svg', 48)
      .icon('qrcode-scan', 'assets/icons/qrcode-scan.svg', 48)
      .icon('search', 'assets/icons/search.svg', 48)
      .icon('check', 'assets/icons/check_48.svg', 48)
      .icon('lang', 'assets/icons/ic_language_48px.svg', 48)
      .icon('print', 'assets/icons/ic_local_printshop_48px.svg', 48)
      .icon('shipping', 'assets/icons/ic_local_shipping_48px.svg', 48)
      .icon('view_details', 'assets/icons/view_details.svg', 48)
      .icon('assignment_return', 'assets/icons/ic_assignment_return_48px.svg', 48)
      .icon('money', 'assets/icons/ic_attach_money_48px.svg', 48)
      .icon('settings', 'assets/icons/ic_settings_48px.svg', 48)
      .icon('phone', 'assets/icons/phone_48.svg', 48);

 }

})();

angular.module("mpos").run(["$templateCache", function($templateCache) {$templateCache.put("app/depositList/depositList.html","<table ng-table={{tableParams}} class=\"table table-condensed table-bordered table-striped\"><tr ng-repeat=\"item in items track by item.id\"><td data-title=\"\'名稱\'\" style=width:30%>{{item.label}}</td><td data-title=\"\'數量\'\" style=\"width:10%; text-align:center\">{{item.qty}}</td><td data-title=\"\'單價\'\" style=\"width:10%; text-align:center\">{{item.purchase}}</td><td data-title=\"\'小計\'\" style=\"width:10%; text-align:center\">{{item.purchase * item.qty}}</td><td style=text-align:center ng-if=\"actions.add || actions.remove || actions.delete\"><div layout=row layout-fill layout-align=space-around><md-button aria-label=\"add item\" ng-if=actions.add ng-click=addItem(item) class=\"md-raised md-primary my-reward-action-btn\"><md-icon md-svg-icon=add class=my-menu-icon></md-icon></md-button><md-button aria-label=\"remove item\" ng-if=actions.remove ng-click=removeItem(item) class=\"md-raised md-warn my-reward-action-btn\"><md-icon md-svg-icon=remove class=my-menu-icon></md-icon></md-button><md-button aria-label=\"remove all\" ng-if=actions.delete class=\"md-raised md-accent my-reward-action-btn\" ng-click=\"removeItem(item, true)\"><md-icon md-svg-icon=delete aria-hidden=true class=my-menu-icon></md-icon></md-button></div></td></tr></table>");
$templateCache.put("app/epos/epos.html","<div layout=column layout-align=\"center center\" keypress-events><form name=printForm><div layout=row layout-align=\"center center\" style=width:100%><md-input-container md-no-float class=md-block><!-- Use floating label instead of placeholder --><label>Printer IP</label><!--\n        <input id=\"printerIP\" name=\"printerIP\" ng-model=\"printerIP\" type=\"text\" \n          ng-click=\"printerIP = \'\'\"\n          readonly=true\n          ng-pattern=\"/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/\">--> <input id=printerIP name=printerIP ng-model=printerIP type=text readonly ng-pattern=/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/ ><div ng-messages=printForm.printerIP.$error.pattern ng-show=printForm.printerIP.$error.pattern><span>*IP Pattern Wrong.</span></div></md-input-container><md-button class=\"md-raised md-primary\" aria-label=print ng-click=printContent() style=\"float:left; height:50px; font-size:16px\" ng-disabled=\"printForm.$invalid || printerIP === \'\' || isLoading || isProcessing \"><span ng-show=!isProcessing>列印</span><!--<md-icon md-svg-icon=\"print\" style=\"width:48px; height:48px; margin-top:2px\"></md-icon>--></md-button><md-progress-circular md-mode=indeterminate ng-show=isProcessing md-diameter=16 style=display:inline-block></md-progress-circular></div><div layout=row ng-hide=\"printForm.$invalid || printerIP === \'\'\"><div>{{\'Please go to below link first after setting up printer IP, and allow the connection when seeing the warning screen.\' | translate}}<div><div><a target=_blank ng-href=https:\\\\{{printerIP}}><b>https:\\\\{{printerIP}}</b></a></div></div></div></div></form><div><br><div style=\"text-align: center; border:1px solid darkgray\"><canvas id=fabricCanvas></canvas></div><canvas id=printCanvas width=600 height=400 style=display:none></canvas><!--\n    <print-canvas content={{content}} name={{name}} company={{company}} \n      event={{eventLabel}} width=\"{{width}}\" height=\"{{height}}\">\n    </print-canvas>\n  --></div></div>");
$templateCache.put("app/main/deposit.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-margin layout-align-gt-md=center layout-align=space-around ng-cloak><div flex=\"\" flex-sm=100 flex-gt-md=45 flex-order=2 flex-order-gt-sm=1 layout-align=center style=height:100%><div><table keypress-events class=my-table style=width:100%><thead><th colspan=2 style=\"color:white; background-color:CornflowerBlue\" ng-click=deposit.toggleMemberInfo()><md-icon md-svg-icon=arrow_up ng-if=!deposit.expandMemberInfo class=my-menu-icon style=color:white></md-icon><md-icon md-svg-icon=arrow_down ng-if=deposit.expandMemberInfo class=my-menu-icon style=color:white></md-icon><span class=my-table-title>會員資料</span></th></thead><tr height=40><td>會員條碼：</td><td><input id=barcodeMessage type=text class=barcode-readonly ng-show=!deposit.multipleMember style=\"width: 90%\" ng-disabled=!deposit.isRequired.barcodeMessage ng-model=deposit.member.barcodeMessage readonly><md-input-container ng-show=deposit.multipleMember style=\"width: 90%\"><md-select placeholder=請選擇條碼 ng-model=deposit.member md-on-close=deposit.changeSelectedMember() aria-label=\"member selection\" style=\"width: 90%\"><md-option id=memberSelector ng-value=member ng-repeat=\"member in deposit.searchedMember track by $index\">{{member.barcodeMessage}}</md-option></md-select></md-input-container></td><!--\n          <td>\n            <md-progress-circular md-mode=\"{{deposit.isProcessing.barcodeMessage}}\"></md-progress-circular>\n          </td>\n          --></tr><tr height=40 ng-show=deposit.expandMemberInfo><td>會員電話：</td><td><input id=phoneNumber type=text class=phonenumber-readonly style=\"width: 90%\" ng-disabled=!deposit.isRequired.phoneNumber ng-model=deposit.member.phoneNumber readonly></td></tr><tr height=40 ng-repeat=\"item in deposit.displayList track by $index\" ng-show=deposit.expandMemberInfo><td>{{item.label}}：</td><td align=center valign=center style={{item.style}}>{{item.value}}</td></tr><tr height=40><td colspan=2>儲值金額：<span style=color:red> {{deposit.depositPurchase | number}}</span></td></tr><tr height=40><td colspan=2><div layout-align=space-between><span style=width:50%>儲值前點數：<span style=color:blue> {{deposit.member.points | number}}</span> <span style=\"width:50%; float:right\">儲值後點數：<span style=color:red> {{deposit.member.points + deposit.depositPoints | number}}</span></span></span></div></td></tr><tr height=120 ng-show=deposit.expandMemberInfo><td colspan=2><md-button class=md-raised ng-click=\"deposit.changeFocus(\'phoneNumber\')\" ng-disabled=\"deposit.isProcessing.barcodeMessage || deposit.isProcessing.phoneNumber || deposit.isProcessing.points\" style=\"margin-left:0px;min-width:45%; max-width:45%; background-color:orange\">查詢模式</md-button><md-button class=md-raised ng-click=\"deposit.changeFocus(\'barcodeMessage\')\" ng-disabled=\"deposit.isProcessing.barcodeMessage || deposit.isProcessing.phoneNumber || deposit.isProcessing.points\" style=\"float:right;margin-right:0px; min-width:45%; background-color:yellowgreen\">掃碼模式</md-button></td></tr></table></div><div><div style=\"color:white; background-color:CornflowerBlue\" ng-click=deposit.toggleProductInfo()><md-icon md-svg-icon=arrow_up aria-hidden=true ng-if=!deposit.expandProductInfo class=my-menu-icon style=color:white></md-icon><md-icon md-svg-icon=arrow_down aria-hidden=true ng-if=deposit.expandProductInfo class=my-menu-icon style=color:white></md-icon><span class=my-table-title>儲值項目</span> <span ng-if=\"deposit.depositItems.length > 0\" ng-click=deposit.clear() class=my-clear-btn><md-icon md-svg-icon=close aria-hidden=true style=color:white></md-icon>清除全部 ({{deposit.depositCounts || 0}})</span></div></div><div flex-sm=100 style=\"margin-top: 5px; margin-left:0px; height:45%; overflow:scroll\" drag-scroll=true ng-if=\"deposit.expandProductInfo && deposit.depositItems.length > 0\"><deposit-list items=deposit.depositItems add=true remove=true callback=deposit.refresh() ng-if=deposit.enableMultipleItems></deposit-list><deposit-list items=deposit.depositItems add=false remove=false callback=deposit.refresh() ng-show=!deposit.enableMultipleItems></deposit-list></div></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=deposit.toggleRight() ng-hide=\"deposit.scanMode && !deposit.member.phoneNumber\"><md-icon md-svg-icon=\"{{!deposit.member.barcodeMessage || !deposit.member.phoneNumber ? \'keyboard\' : \'money\'}}\"></md-icon></md-button><md-button class=\"md-fab md-accent md-fab-top-left hide-gt-sm\" style=\"left: 80px; top:50px\" ng-click=\"deposit.confirmAction(\'ADD\')\" ng-disabled=deposit.isProcessing.points ng-show=\"deposit.depositItems.length > 0\"><md-icon md-svg-icon=check></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=100 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout-padding style=\"background-color:lavender; height:90%\"><div flex=\"\" layout=column style=min-width:400px ng-show=\"!deposit.member.barcodeMessage || !deposit.member.phoneNumber\"><md-whiteframe style=\"height:90px;max-height:90px; width:100%\" class=md-whiteframe-10dp layout=row layout-align=space-between><div flex layout=row layout-align=space-between ng-if=deposit.keyboard.label><span style=min-height:50px;font-size:20px>{{deposit.keyboard.label}}</span> <span numeric-keyboard-input=\"\" init=deposit.keyboard.value ng-model=deposit.keyboard.value ng-if=!deposit.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{deposit.keyboard.value}}</h2></span><span style=\"min-height:50px; color:blue\" ng-if=deposit.depositPoints><h2>{{deposit.depositPoints | number}}</h2></span></div></md-whiteframe><br><numeric-keyboard callback=\"deposit.confirmAction(\'ADD\')\"></numeric-keyboard><br></div><div flex=\"\" layout=column style=height:90vh ng-show=\"deposit.member.barcodeMessage && deposit.member.phoneNumber\"><div style=height:75%><ul><li ng-repeat=\"item in deposit.depositOptions\n            | startFrom:deposit.currentPage*deposit.pageSize\n            | limitTo:deposit.pageSize\" ng-click=deposit.addDeposit(item) class=reward-item ng-style=\"{\'width\':deposit.itemWidth,\n                   \'height\':deposit.itemHeight,\n                   \'background-color\':deposit.getBackgroundColor(item)}\"><div layout-align=\"center center\" layout-margin><md-icon md-svg-icon=money aria-hidden=true style=width:36px;height:36px></md-icon><p class=\"text-overflow my-reward-label\">{{item.label}}</p></div></li></ul></div><div layout=row layout-margin><table style=width:100%><tr><td style=width:60%><div layout=row style=width:100%><md-button class=md-raised ng-click=\"deposit.currentPage=deposit.currentPage-1\" ng-disabled=\"deposit.currentPage === 0\" aria-label=previous style=\"width:30%; height: 70px; font-weight: bold; font-size:2.5vw\"><md-icon md-svg-icon=drop_up style=\"width:72px;height:72px; color:black\"></md-icon></md-button><md-button class=md-raised ng-click=\"deposit.currentPage=deposit.currentPage+1\" aria-label=next ng-disabled=\"deposit.currentPage >= deposit.depositOptions.length/deposit.pageSize - 1\" style=\"width:30%; height: 70px; font-weight: bold; font-size:2.5vw\"><md-icon md-svg-icon=drop_down style=width:72px;height:72px;color:black></md-icon></md-button><span class=mylabel style=\"font-weight:bold;\n                  text-align:center; margin-top: 1em\">{{deposit.currentPage + 1}}/{{deposit.numberOfPages()}}</span></div></td><td rowspan=2 style=height:100%><md-button class=md-raised ng-click=\"deposit.confirmAction(\'ADD\')\" style=\"width: 100%;height: 70px; margin:auto; font-weight: bold; font-size: 2.5vw;\n                  color:white; background-color:#0E9B2E\"><span class=mylabel>確定儲值<span></span></span></md-button></td></tr></table></div></div><!--</div>--></md-sidenav></div>");
$templateCache.put("app/main/dialog.abnormal.html","<md-dialog class=font-mo style=min-width:60%><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-weight:bold; font-size:24px\">異常還機 - 設備編號 : {{ctrl.productSN}}</h2><md-button class=md-icon-button ng-click=ctrl.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column layout-align=center keypress-events><div layout-align=\"center center\" ng-if=ctrl.isProcessing><md-progress-linear md-mode={{ctrl.isProcessing}} md-diameter=160px></md-progress-linear></div><form class=md-no-momentum name=myForm layout-padding layout=column ng-hide=ctrl.isProcessing><div><label>請選擇廠商</label><md-radio-group class=md-primary ng-model=ctrl.selectedSupplier required><md-radio-button aria-label=supplier ng-value=item ng-repeat=\"item in ctrl.suppliers track by $index\">{{item}}</md-radio-button></md-radio-group></div><div><label>註解</label><textarea id=remark ng-model=ctrl.remark style=\"padding:5px; height:80px; width:90%\">\n                </textarea></div><span style=\"color:red; font-size:24px\">{{ctrl.errmsg}}</span><div flex layout=row layout-align=\"space-between center\" style=\"position:absolute; right:0px; width:50%\"><md-button class=\"md-raised md-warn\" type=button style=\"width:45%; height: 70px; font-size:24px\" ng-disabled=\"remarkForm.$invalid || ctrl.isUpdateing !== \'\'\" aria-label=\"cancel remark form\" ng-click=ctrl.cancel()>取消</md-button><md-button class=\"md-raised md-primary\" type=button ng-if=!ctrl.errmsg style=\"width:45%; height: 70px; font-size:24px\" ng-disabled=\"remarkForm.$invalid || ctrl.isUpdateing !== \'\'\" aria-label=\"Save remark form\" ng-click=ctrl.updateCheckOutOrder()>歸還</md-button><!--<md-progress-circular md-mode=\"{{ctrl.isUpdateing}}\"></md-progress-circular>--></div></form><br></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.addons.html","<md-dialog class=font-mo style=min-width:60%><md-dialog-content layout-padding><div layout=column layout-align=center><div style=min-height:150px><div ng-repeat=\"item in notice.formSchema track by $index\"><div ng-show=\"item.type==\'htmlelement\'\" ng-bind-html=item.content></div><div ng-if=\"item.type==\'reset\'\">{{item.label}}<md-button class=\"md-raised md-warn\" type=button style=min-width:40% ng-click=notice.reset(item) ng-disabled=notice.isReset>{{\'btn.reset\' | translate}}</md-button></div></div><!--\n          <div style=\"min-height:150px\" ng-bind-html=\"notice.myHtml\">\n          </div>\n          --><div layout=row style=padding-top:30px><span flex></span><md-button class=\"md-raised md-primary\" type=button style=\"min-width:40%; height: 70px; font-size:26px\" ng-click=notice.close()><!--確認-->{{\'btn.ok\' | translate}}</md-button></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.businessId.html","<md-dialog aria-label=\"\" style=\"min-width:50%; min-height:200px\" class=font-mo><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">{{\'msg.select.business\' | translate}}：</h2></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline><md-select aria-label=business ng-model=biz.selectedBusiness style=\"min-width: 300px\" required><md-optgroup><md-option ng-repeat=\"business in biz.businesses\" ng-value=business.id>{{business.name}}</md-option></md-optgroup></md-select><div layout=row><md-button class=\"md-raised md-primary\" ng-click=biz.getBusinessInfo() style=\"width: 45%; font-size:24px; height: 50px\" ng-disabled=biz.disableBtn>{{\'btn.ok\' | translate}}</md-button><md-button class=\"md-raised md-warn\" ng-click=biz.close() style=\"width: 45%; font-size:24px; height: 50px\" ng-disabled=biz.disableBtn>{{\'btn.cancel\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.compare.html","<md-dialog class=font-mo style=\"width: 100%; max-width:100%; max-height: 100%\"><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-weight:bold; font-size:24px\">異常分析</h2><md-button class=md-icon-button ng-click=diff.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column layout=center><div><h2>步驟一 : 選擇比對檔案<md-button class=md-primary aria-label=\"Download template\" style=margin:auto href=https://s3-us-west-2.amazonaws.com/iiot-temp/compare-sn-example.xlsx><md-icon md-svg-icon=download_file style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>範例下載</span></md-button></h2><label class=md-button style=\"background-color:burlywood; font-size:30px\">請選擇檔案 <input type=file nv-file-select uploader=diff.uploader ng-hide=true ng-click=diff.uploader.clearQueue()></label><!--<span>{{diff.uploader.queue[0].file.name}}</span>--></div><div><h2>步驟二 : 上傳與分析</h2><table class=table style=width:95vw><thead><tr style=background-color:lightblue><th>檔案名稱</th><th ng-show=diff.uploader.isHTML5>檔案大小</th><!--\n                  <th ng-show=\"mo.uploader.isHTML5\">上傳進度</th>\n                  --><th>狀態</th><th style=text-align:center>動作</th></tr></thead><tbody><tr ng-repeat=\"item in diff.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"diff.uploader.isHTML5 && item.file.size/1024/1024 > 1\" nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"diff.uploader.isHTML5 && item.file.size/1024/1024 < 1\" nowrap>{{ item.file.size/1024|number:2 }} KB</td><!--\n                  <td ng-show=\"mo.uploader.isHTML5\" style=\"vertical-align:middle\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{item.progress}}\"></md-progress-linear>\n                  </td>\n                  --><td class=text-center><span ng-show=item.isSuccess><md-icon md-svg-icon=check_circle style=color:green;width:36px;height:36px></md-icon></span><span ng-show=item.isCancel><md-icon md-svg-icon=cancel style=color:orange;width:36px;height:36px></md-icon></span><span ng-show=item.isError><md-icon md-svg-icon=error_circle style=color:red;width:36px;height:36px></md-icon></span></td><td nowrap><md-button class=\"md-primary md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=diff.uploadFile(item) ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><md-icon md-svg-icon=upload_file style=width:24px;height:24px></md-icon>上傳</md-button><md-button class=\"md-warn md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.cancel() ng-disabled=!item.isUploading><md-icon md-svg-icon=cancel style=width:24px;height:24px></md-icon>取消</md-button><md-button class=\"md-accent md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.remove()><md-icon md-svg-icon=close style=width:24px;height:24px></md-icon>移除</md-button></td></tr></tbody></table><md-progress-linear md-mode=indeterminate ng-if=\"diff.isProcessing === true\"></md-progress-linear></div><div ng-show=diff.showResult><h2><strong>分析結果</strong></h2><table ng-table-dynamic=\"diff.tableParams with diff.cols\" class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"row in $data\" ng-class-even=\"\'even\'\"><td flex ng-repeat=\"col in $columns\" ng-bind-html=\"col.getValue(this, row, $parent.$parent.$index)\"></td></tr></table></div><div><md-button class=\"md-raised md-warn\" style=\"float:right; font-size:24px; height: 70px\" ng-click=diff.cancel()>回即時統計資料</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.confirm.html","<md-dialog aria-label=\"\" style=\"min-height:200px; min-width:50%\"><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">{{title}}</h2></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline layout-padding layout-margin><p>{{msg}}</p><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-disabled=isProcessing style=\"width:40%; height:50px; font-size:24px\" ng-click=confirm()>{{\'btn.ok\' | translate}}</md-button><md-button class=\"md-raised md-warn\" ng-disabled=isProcessing style=\"width:40%; height:50px; font-size:24px\" ng-click=cancel()>{{\'btn.cancel\' | translate}}</md-button><md-progress-circular flex md-mode=indeterminate ng-show=isProcessing></md-progress-circular></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.confirmAutoStockin.html","<md-dialog aria-label=\"\" style=\"min-height:200px; min-width:50%\"><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">出庫轉入庫</h2></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline layout-padding layout-margin><!--\n      <div>\n        <md-select placeholder=\"請選擇產品品項\" ng-model=\"selectedProduct\" style=\"min-width: 300px;\" required>\n           <md-optgroup label=\"產品品項\">\n             <md-option ng-repeat=\"item in products\" ng-value=\"item\">{{item.supplier}}-{{item.product}}</md-option>\n           </md-optgroup>\n        </md-select>\n      </div>\n      --><p>是否確定執行出庫轉入庫</p><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"width:45%; height:50px; font-size:24px\" ng-click=confirm()>確定</md-button><md-button class=\"md-raised md-warn\" style=\"width:45%; height:50px; font-size:24px\" ng-click=cancel()>取消</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.confirmExit.html","<md-dialog aria-label=\"\" style=\"min-height:200px; min-width:50%\"><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">{{\'title.mocheckin.exit\' | translate}}</h2></div></md-toolbar><md-dialog-content><div class=md-headline layout-padding layout-margin><p>{{\'msg.mocheckin.exit\' | translate}}</p><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"width:45%; height:50px; font-size:24px\" ng-click=confirm()>{{\'btn.ok\' | translate}}</md-button><md-button class=\"md-raised md-warn\" style=\"width:45%; height:50px; font-size:24px\" ng-click=cancel()>{{\'btn.cancel\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.confirmRefund.html","<md-dialog aria-label=\"\" style=min-height:200px><md-toolbar><div class=md-toolbar-tools><h2>退還點數</h2></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline layout-padding layout-margin><p>請確認是否退還點數 {{ refund }} 點</p><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"width:45%; height:50px; font-size:24px\" ng-click=confirm()>退還</md-button><md-button class=\"md-raised md-warn\" style=\"width:45%; height:50px; font-size:24px\" ng-click=cancel()>取消</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.counters.html","<md-dialog class=font-mo style=min-width:50%><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\">{{counter.placeholder | translate}}：</h2><!--\n        <md-button class=\"md-icon-button\" ng-click=\"counter.cancel()\">\n          <md-icon md-svg-icon=\"close\" aria-label=\"Close dialog\"></md-icon>\n        </md-button>\n        --></div></md-toolbar><md-dialog-content layout-padding layout-align=\"center center\"><form class=md-no-momentum name=counterForm ng-submit=counter.answer() layout=column><md-input-container><md-select placeholder=counter.placeholder ng-model=counter.selectedCounter aria-label=\"counter selection\" required><md-option ng-value=item ng-repeat=\"item in counter.counters track by $index\">{{item.label}}</md-option></md-select></md-input-container><div layout=row><md-button class=\"md-raised md-primary\" type=submit style=\"width: 45%; font-size:24px; height: 50px\" ng-disabled=counterForm.$invalid aria-label=\"Save counter\" translate=btn.ok></md-button><md-button class=\"md-raised md-warn\" style=\"width: 45%; font-size:24px; height: 50px\" ng-click=counter.cancel() translate=btn.cancel></md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.create.html","<md-dialog aria-label=\"\" style=\"min-height:200px; min-width:50%\"><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">加入會員與發卡確認</h2></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline layout-padding layout-margin><p>目前不是會員，是否要加入會員並發卡？</p><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"width:45%; height:50px; font-size:24px\" ng-click=confirm()>確定</md-button><md-button class=\"md-raised md-warn\" style=\"width:45%; height:50px; font-size:24px\" ng-click=cancel()>取消</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.detail.html","<md-dialog class=font-mo style=\"width: 100%; max-width:100%; max-height: 100%\"><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-weight:bold; font-size:24px\">{{\'title.moreport.details\' | translate}}</h2><md-button class=md-icon-button ng-click=detail.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column><div layout=row layout-padding><span style=float:left><h2 style=font-weight:bold ng-if=\"detail.type !== \'stock\' && detail.type !== \'norecord\'\">{{detail.title}}</h2></span><span style=float:left><h2 style=font-weight:bold ng-if=\"detail.type === \'stock\' || detail.type === \'norecord\'\">{{detail.title}} ({{detail.selected.length}}/{{detail.orderedTableData.length}})</h2></span><!--\n            <span style=\"float:left\" ng-if=\"detail.type === \'stock\' || detail.type === \'norecord\'\">\n              <md-checkbox aria-label=\"Select All\"\n                ng-checked=\"detail.isChecked()\"\n                md-indeterminate=\"detail.isIndeterminate()\"\n                ng-click=\"detail.toggleAll()\">\n                  <span ng-if=\"detail.isChecked()\">取消</span>全選\n              </md-checkbox>\n            </span>\n           --><md-button class=md-button ng-disabled=\"! detail.downloadUrl\" href={{detail.downloadUrl}} style=\"font-size:24px; color:blue\"><md-icon md-svg-icon=download_file style=\"width:48px; height:48px; color: blue\" ng-if=detail.downloadUrl></md-icon><md-icon md-svg-icon=download_file style=\"width:48px; height:48px; color: gray\" ng-if=!detail.downloadUrl></md-icon>{{\'btn.download\' | translate}}</md-button><span flex></span><md-select aria-label=\"Current page size\" ng-model=detail.selectedPageSize md-on-close=detail.changePageSize() style=\"float: right\"><md-optgroup label=\"Page Size\"><md-option ng-repeat=\"size in detail.availablePageSizes\" ng-value=size>{{size}}</md-option></md-optgroup></md-select></div><div><md-progress-linear md-mode=indeterminate ng-if=\"detail.isProcessing === true\"></md-progress-linear><table ng-table-dynamic=\"detail.tableParams with detail.cols\" class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"row in $data\" ng-class-even=\"\'even\'\"><td flex ng-repeat=\"col in $columns\" ng-if=\"col.field!==\'deleteProduct\'\" ng-bind-html=\"col.getValue(this, row, $parent.$parent.$index, detail.tableParams.page(), detail.selectedPageSize)\"></td><!--\n                <td flex ng-repeat=\"col in $columns\" ng-if=\"col.field===\'deleteProduct\'\">\n                  <md-button class=\"md-raised md-accent\" style=\"font-size:26px; height:50px\"\n                    ng-click=\"detail.showDeleteDialog(row, $parent.$parent.$index)\"\n                    ng-disabled=\"detail.isProcessing\">\n                    設備退回\n                  </md-button>\n                </td>\n                --><td flex ng-repeat=\"col in $columns\" ng-if=\"col.field===\'deleteProduct\'\"><!--<md-checkbox aria-label=\"checkbox\" ng-checked=\"detail.exists(detail.tableData[$parent.$parent.$index])\"\n                    ng-click=\"detail.toggle(detail.tableData[$parent.$parent.$index])\">\n                  </md-checkbox>--><md-checkbox aria-label=checkbox ng-checked=detail.exists(row) ng-click=detail.toggle(row)></md-checkbox></td></tr></table></div><div><md-button class=\"md-raised md-accent\" ng-if=\"detail.type === \'norecord\'\" style=\"float:right; font-size:24px; height:50px\" aria-label=hidden ng-click=detail.showDeleteDialog() ng-disabled=detail.isProcessing><!--<span ng-if=\"detail.type === \'stock\'\">設備退回</span>--> <span ng-if=\"detail.type === \'norecord\'\">{{\'btn.delete\' | translate}}</span></md-button><md-button class=\"md-raised md-warn\" style=\"float:right; font-size:24px; height: 50px\" ng-click=detail.cancel()>{{\'btn.close\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.diff.html","<md-dialog class=font-mo style=\"width: 100%; max-width:100%; max-height: 100%\"><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-weight:bold; font-size:24px\" translate>Abnormal analysis</h2><md-button class=md-icon-button ng-click=diff.close()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column layout=center><div><h2>{{\'msg.mostockin.compare.step1\' | translate}}<md-button class=md-primary aria-label=\"Download template\" style=margin:auto href=https://s3-us-west-2.amazonaws.com/iiot-temp/compare-sn-example.xlsx><md-icon md-svg-icon=download_file style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px translate>Download example</span></md-button></h2><label class=\"md-button md-raised md-warn\" style=font-size:30px>{{\'Select file\' | translate}} <input type=file nv-file-select uploader=diff.uploader ng-hide=true ng-click=diff.uploader.clearQueue() multiple></label><!--<span>{{diff.uploader.queue[0].file.name}}</span>--></div><div><h2>{{\'msg.mostockin.compare.step2\' | translate}}</h2><table class=table style=width:95vw><thead><tr style=background-color:lightblue><th>{{\'Filename\' | translate}}</th><th ng-show=diff.uploader.isHTML5>{{\'Filesize\' | translate}}</th><!--\n                  <th ng-show=\"mo.uploader.isHTML5\">上傳進度</th>\n                  --><th>{{\'Status\' | translate}}</th><th style=text-align:center>{{\'Action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in diff.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"diff.uploader.isHTML5 && item.file.size/1024/1024 > 1\" nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"diff.uploader.isHTML5 && item.file.size/1024/1024 < 1\" nowrap>{{ item.file.size/1024|number:2 }} KB</td><!--\n                  <td ng-show=\"mo.uploader.isHTML5\" style=\"vertical-align:middle\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{item.progress}}\"></md-progress-linear>\n                  </td>\n                  --><td class=text-center><span ng-show=item.isSuccess><md-icon md-svg-icon=check_circle style=color:green;width:36px;height:36px></md-icon></span><span ng-show=item.isCancel><md-icon md-svg-icon=cancel style=color:orange;width:36px;height:36px></md-icon></span><span ng-show=item.isError><md-icon md-svg-icon=error_circle style=color:red;width:36px;height:36px></md-icon></span></td><td nowrap><md-button class=\"md-primary md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=diff.uploadFile(item) ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><md-icon md-svg-icon=upload_file style=width:24px;height:24px></md-icon>{{\'btn.upload\' | translate}}</md-button><md-button class=\"md-warn md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.cancel() ng-disabled=!item.isUploading><md-icon md-svg-icon=cancel style=width:24px;height:24px></md-icon>{{\'btn.cancel\' | translate}}</md-button><md-button class=\"md-accent md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.remove()><md-icon md-svg-icon=close style=width:24px;height:24px></md-icon>{{\'btn.remove\' | translate}}</md-button></td></tr></tbody></table><md-progress-linear md-mode=indeterminate ng-if=\"diff.isProcessing === true\"></md-progress-linear></div><div ng-show=diff.showResult><h2><strong>分析結果</strong></h2><table ng-table-dynamic=\"diff.tableParams with diff.cols\" class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"row in $data\" ng-class-even=\"\'even\'\"><td flex ng-repeat=\"col in $columns\" ng-bind-html=\"col.getValue(this, row, $parent.$parent.$index)\"></td></tr></table></div><div><md-button class=\"md-raised md-warn\" style=\"float:right; font-size:24px; height: 70px\" ng-click=diff.close()>回入庫明細資料</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.dynamicReward.html","<md-dialog style=min-width:50%><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2>請選擇消費(核銷)扣點項目：</h2></div></md-toolbar><md-dialog-content layout-padding layout-align=\"center center\"><div layout-align=\"center center\" ng-if=dCtrl.isProcessing style=\"width:100%; height:100%\"><md-progress-linear md-mode={{dCtrl.isProcessing}} style=margin:auto></md-progress-linear></div><form class=md-no-momentum name=dCtrlForm ng-submit=dCtrl.answer() layout=column ng-show=\"dCtrl.isProcessing === \'\'\"><md-input-container><md-select placeholder=消費(核銷)扣點項目 ng-model=dCtrl.selectedItem aria-label=\"DR selection\" required style=font-size:24px><md-option ng-value=item ng-repeat=\"item in dCtrl.items track by $index\">{{item.label}}</md-option></md-select></md-input-container><div layout=row><md-button class=\"md-raised md-primary\" type=submit ng-disabled=dCtrlForm.$invalid aria-label=Save style=\"font-size:24px; height:50px; width:45%\">確定</md-button><md-button class=\"md-raised md-warn\" ng-click=dCtrl.cancel() style=\"font-size:24px; height:50px; width:45%\">取消</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.language.html","<md-dialog aria-label=\"\" style=\"min-width:50%; min-height:200px\" class=font-mo><md-toolbar><div class=md-toolbar-tools layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\">{{\'title.selectLang\' | translate}}</h2><md-button class=md-icon-button ng-click=langCtrl.close()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=text-align:center><div layout=row class=md-headline layout-align=\"center center\"><span flex></span><div language-select></div><span flex></span></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.message.event.html","<md-dialog aria-label=\"\" style=\"min-width:300px; min-height:200px;box-shadow:0 0 5px 0 rgba(0, 0, 0, 0.3);background-color:{{msgCtrl.myColor}}\"><!--\n     <md-toolbar ng-if=\"msgCtrl.enableCloseBtn\" \n      style=\"background-color:{{msgCtrl.myColor}}\">\n      <div layout layout-align=\"end end\">\n        <md-button class=\"md-icon-button\" ng-click=\"msgCtrl.close()\">\n          <md-icon md-svg-icon=\"close\" aria-label=\"Close dialog\" style=\"fill:black\"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n    --><md-dialog-content style=\"text-align:center; margin:auto\"><md-button class=md-icon-button ng-click=msgCtrl.close() ng-if=msgCtrl.enableCloseBtn style=\"position:absolute; right:0px; top:0px\"><md-icon md-svg-icon=close aria-label=\"Close dialog\" style=fill:black></md-icon></md-button><div layout=row layout-padding layout-margin layout-align=\"center center\"><md-icon md-svg-icon={{msgCtrl.icon}} aria-hidden=true style=\"width:96px; height:96px\"></md-icon><div layout=column><div flex class=md-display-1 ng-bind-html=msgCtrl.msg style=margin-bottom:10px></div><!--<span class=\"md-display-1\" style=\"float:center;background-color:\'+ myColor +\'\">{{msgCtrl.msg}}</span>--><div flex layout=column ng-if=\"msgCtrl.parent.enableBarcodeUpdate && msgCtrl.parent.isRequired.newBarcode && msgCtrl.type===\'success\'\"><!-- 透過 parent scope 同步原本的換碼 input ng-model --><div flex layout=row><input flex autofocus id=newBarcode style=\"height:50px; font-size:20px; padding: 2px 6px; margin: 5px; border: 1px solid #CCC; -webkit-border-radius: 5px; border-radius: 5px\" type=text ng-model=msgCtrl.parent.newBarcode ng-disabled=msgCtrl.parent.isProcessing.newBarcode?true:false placeholder=請掃瞄配對條碼 readonly><md-progress-circular md-mode={{msgCtrl.parent.isProcessing.newBarcode}} ng-show=msgCtrl.parent.isProcessing.newBarcode></md-progress-circular></div><!--如果設並必須換碼，就一定要換碼後才能把限制名單搬到 pass2u-checkout--><!--<span layout=\"row\" layout-align=\"start center\">\n              <md-button flex=\"initial\" layout=\"row\"\n                         ng-disabled=\"msgCtrl.parent.isProcessing.newBarcode?true:false\"\n                         layout-align=\"center center\" class=\"md-raised md-warn\"\n                         aria-label=\"IgnoreUpdateBarcode\" ng-click=\"msgCtrl.close()\"\n                         style=\"height:48px;font-size:20px;\">\n                <i class=\"material-icons\">clear</i> <span>略過配對條碼</span>\n              </md-button>\n            </span>--></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.message.html","<md-dialog aria-label=\"\" style=\"min-width:300px; min-height:200px;box-shadow:0 0 5px 0 rgba(0, 0, 0, 0.3);background-color:{{msgCtrl.myColor}}\"><!--<md-toolbar ng-if=\"msgCtrl.enableCloseBtn\" \n    style=\"background-color:{{msgCtrl.myColor}}\">\n    <div layout layout-align=\"end end\">--><md-button class=md-icon-button ng-click=msgCtrl.close() style=\"position:absolute; right:0px; top:0px\"><md-icon md-svg-icon=close aria-label=\"Close dialog\" style=fill:black></md-icon></md-button><!--</div>\n  </md-toolbar>--><md-dialog-content style=\"text-align:center; margin:auto\"><md-button class=md-icon-button ng-click=msgCtrl.close() ng-if=msgCtrl.enableCloseBtn style=\"position:absolute; right:0px; top:0px\"><md-icon md-svg-icon=close aria-label=\"Close dialog\" style=fill:black></md-icon></md-button><div layout=row layout-padding layout-margin layout-align=\"center center\"><md-icon md-svg-icon={{msgCtrl.icon}} aria-hidden=true style=\"width:96px; height:96px\"></md-icon><div class=md-display-1 ng-bind-html=msgCtrl.msg></div><!--<span class=\"md-display-1\" style=\"float:center;background-color:\'+ myColor +\'\">{{msgCtrl.msg}}</span>--></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.newProduct.html","<md-dialog id=DialogRemarkForm class=font-mo style=min-width:50%><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\" translate>Please fill in product information</h2><md-button class=md-icon-button ng-click=prod.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding layout-margin><div layout=column layout-align=center keypress-events><form class=md-no-momentum name=newProductForm layout=column><div flex layout-align=\"space-between center\"><table><tr height=50><td>{{\'table.field.vendor\' | translate}}：</td><td><md-select aria-label=vendor ng-model=prod.productProvider style=\"min-width: 300px\" required><md-optgroup><md-option ng-repeat=\"supplier in prod.suppliers\" ng-value=supplier>{{supplier}}</md-option></md-optgroup></md-select><!--\n                      <input id=\"productProvider\" style=\"width: 250px;\" type=\"text\"\n                        readonly-focus=\"prod.isFocus.productProvider\"\n                        ng-model=\"prod.productProvider\" readonly=\"true\" required>\n                      </input>\n                      --></td></tr><tr height=50><td>{{\'table.field.product\' | translate}}：</td><td><!--\n                      <div>\n                        <label ng-if=\"!prod.resetLabel\" style=\"width: 250px;\" \n                            ng-bind-html=\"prod.trustAsHtml(prod.productLabel)\">\n                        </label>\n                        <textarea id=\"productLabel\" ng-if=\"prod.resetLabel\" \n                          style=\"padding:5px; width:250px; height:40px\"\n                          ng-model=\"prod.productLabel\" read-only=false required>\n                        </textarea>\n                      \n                        <md-button class=\"md-raised md-primary\" type=\"button\"\n                          style=\"height:50px; font-size:26px\"\n                          aria-label=\"Update product label\"\n                          ng-click=\"prod.resetProductLabel()\">\n                          修改\n                        </md-button>\n                        \n                      </div>\n                      --><!--\n                      <input id=\"productLabel\" style=\"width: 250px;\" type=\"text\"\n                        readonly-focus=\"prod.isFocus.productLabel\"\n                        ng-model=\"prod.productLabel\" readonly=\"false\" required>\n                      </input> --><textarea id=productLabel style=\"padding:5px; width:250px; height:40px\" ng-model=prod.productLabel read-only=false required>\n                      </textarea></td></tr><tr height=50><td>{{\'table.field.productSN\' | translate}}：</td><td><input id=productSerialNo style=\"width: 250px\" type=text readonly-focus=prod.isFocus.productSerialNo ng-model=prod.productSerialNo readonly required></td></tr></table></div><br><div flex layout=row layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" type=button aria-label=\"cancel form\" style=\"width:30%; height:50px; font-size:26px\" ng-click=prod.cancel()>{{\'btn.cancel\' | translate}}</md-button><md-button class=\"md-raised md-accent\" type=button style=\"width:30%; height:50px; font-size:26px\" aria-label=reset ng-click=prod.reset()>{{\'btn.reset\' | translate}}</md-button><md-button class=\"md-raised md-primary\" type=button style=\"width:30%; height:50px; font-size:26px\" ng-disabled=newProductForm.$invalid aria-label=\"Save new prodcut form\" ng-click=prod.addProduct()>{{\'btn.ok\' | translate}}</md-button></div></form><br></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.notice.html","<md-dialog class=font-mo style=min-width:50%><md-dialog-content layout-padding><div layout=column layout-align=center><div style=min-height:150px ng-bind-html=notice.content></div><div layout=row><span flex></span><md-button class=\"md-raised md-primary\" type=button style=\"min-width:40%; height: 70px; font-size:26px\" ng-click=notice.close()><!--確認-->{{\'btn.ok\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.printBadge.html","<md-dialog aria-label=print style=min-width:350px><md-toolbar><div class=md-toolbar-tools layout-align=\"space-between center\"><h2>列印識別證</h2><md-button class=md-icon-button ng-click=close()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-margin layout-padding><epos content={{content}} name={{name}} company={{company}} event={{event}} badge={{badge}} auto-print={{autoPrint}} width=600 height=400></epos></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.printer.html","<div layout=column layout-align=\"center center\" keypress-events style=min-width:30vw><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">{{\'Set Printer IP\' | translate}}</h2></div></md-toolbar><md-dialog-content><form name=printForm><div layout=row layout-align=\"center center\" style=width:100%><md-input-container md-no-float class=md-block><!-- Use floating label instead of placeholder --><label>Printer IP</label><input id=printerIP name=printerIP ng-model=printerIP type=text ng-click=\"printerIP = \'\'\" readonly ng-pattern=/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/ ><div ng-messages=printForm.printerIP.$error.pattern ng-show=printForm.printerIP.$error.pattern><span>*IP Pattern Wrong.</span></div></md-input-container></div><div layout=row style=\"margin:10px 10px 10px 10px\" ng-hide=\"printForm.$invalid || printerIP === \'\'\"><div>{{\'Please go to below link first after setting up printer IP, and allow the connection when seeing the warning screen.\' | translate}}<div><div><a target=_blank ng-href=https:\\\\{{printerIP}}><b>https:\\\\{{printerIP}}</b></a></div></div><br><div layout=row layout-align=\"center center\" style=width:100%><md-button class=\"md-raised md-primary\" aria-label=print ng-click=setPrinterIP() style=\"float:left; height:50px; font-size:16px\" ng-disabled=\"printForm.$invalid || printerIP === \'\'\"><span>{{\'btn.ok\' | translate}}</span><!--<md-icon md-svg-icon=\"print\" style=\"width:48px; height:48px; margin-top:2px\"></md-icon>--></md-button><md-button class=\"md-raised md-warn\" aria-label=print ng-click=close() style=\"float:left; height:50px; font-size:16px\"><span>{{\'btn.cancel\' | translate}}</span><!--<md-icon md-svg-icon=\"print\" style=\"width:48px; height:48px; margin-top:2px\"></md-icon>--></md-button></div></div></div></form><md-dialog-content></md-dialog-content></md-dialog-content></div>");
$templateCache.put("app/main/dialog.product.html","<md-dialog><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\">{{\'title.mocheckin.unreceived\' | translate}}</h2><md-button class=md-icon-button ng-click=unpicked.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column><table><tr height=50 style=background-color:lightgrey><td style=\"min-width:8vw; padding:3px\">{{\'table.field.supplier\' | translate}}</td><td style=\"min-width:32vw; padding:3px\">{{\'table.field.product\' | translate}}</td><td style=padding:3px>{{\'table.field.expected\' | translate}}</td><td style=padding:3px>{{\'table.field.received\' | translate}}</td><td style=padding:3px>{{\'table.field.pending\' | translate}}</td></tr><tr height=50 ng-repeat=\"product in unpicked.products track by $index\"><td>{{product.provider}}</td><td ng-bind-html=unpicked.trustAsHtml(product.label)></td><td style=text-align:center>{{product.amount}}</td><td style=text-align:center>{{product.serialNos.length}}</td><td style=\"text-align:center; color:red\">{{product.amount - product.serialNos.length}}</td></tr></table><br><div><md-button class=\"md-raised md-primary\" style=float:right ng-click=unpicked.confirm()>{{\'btn.ok\' | translate}}</md-button><md-button class=\"md-raised md-warn\" style=float:right ng-click=unpicked.cancel()>{{\'btn.cancel\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.remarkForm.html","<md-dialog class=font-mo style=min-width:70%><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\" translate>Please fill in the machine status form</h2><md-button class=md-icon-button ng-click=ctrl.cancel()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column layout-align=center keypress-events><h3 style=font-weight:bold>{{\'table.field.mocheckout.productSN\' | translate}} : {{ctrl.product.productSerialNo}}</h3><br><div layout-align=\"center center\" ng-if=ctrl.isProcessing><md-progress-linear md-mode={{ctrl.isProcessing}} md-diameter=160px></md-progress-linear></div><form class=md-no-momentum name=remarkForm layout=column ng-hide=ctrl.isProcessing><div ng-repeat=\"item in ctrl.list track by $index\"><md-checkbox ng-if=\"item.type === \'checkbox\'\" ng-checked=ctrl.exists(item) ng-click=ctrl.toggle(item)>{{item.label}}</md-checkbox><br><div ng-if=\"item.type === \'text\'\">{{item.label}}：<textarea id={{item.name}} ng-model=ctrl[item.name] style=\"height:80px; width:80%\">\n                  </textarea></div><div ng-if=\"item.type === \'email\'\">{{item.label}}： <input type=email id={{item.name}} ng-model=ctrl[item.name] ng-init=\"ctrl[item.name]=ctrl.email\" style=width:70%></div></div><br><span style=\"color:red; font-size:24px\">{{ctrl.errmsg}}</span><div flex layout=row layout-align=\"center center\"><md-button class=\"md-raised md-warn\" type=button style=\"min-width:30%; height: 70px; font-size:26px\" ng-disabled=\"remarkForm.$invalid || ctrl.isUpdateing !== \'\'\" aria-label=\"cancel remark form\" ng-click=ctrl.cancel()>{{\'btn.cancel\' | translate}}</md-button><md-button class=\"md-raised md-accent\" type=button ng-if=\"!ctrl.errmsg && ctrl.payment\" style=\"min-width:35%; height: 70px; font-size:26px\" ng-disabled=\"remarkForm.$invalid || ctrl.isUpdateing !== \'\'\" aria-label=\"Save remark form and send payment link\" ng-click=ctrl.updateCheckOutOrder(true)>{{\'btn.returnAndSenPaymentLink\' | translate}}</md-button><md-button class=\"md-raised md-primary\" type=button ng-if=!ctrl.errmsg style=\"min-width:30%; height: 70px; font-size:26px\" ng-disabled=\"remarkForm.$invalid || ctrl.isUpdateing !== \'\'\" aria-label=\"Save remark form\" ng-click=ctrl.updateCheckOutOrder()>{{\'btn.return\' | translate}}</md-button><!--\n                <md-button class=\"md-raised md-accent\" type=\"button\" ng-if=\"!ctrl.errmsg\" style=\"min-width:30%; height: 70px; font-size:26px\"\n                        ng-disabled=\"!ctrl.isProductDamage || ctrl.isUpdateing !== \'\'\" aria-label=\"Payment\"\n                        ng-click=\"ctrl.updateCheckOutPayment()\">\n                    付款\n                </md-button>\n                --></div><div flex layout=row layout-padding ng-if=ctrl.isUpdateing><md-progress-linear md-mode={{ctrl.isUpdateing}}></md-progress-linear></div></form><br></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.rewardList.html","<md-dialog flex><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2>兌換清單：</h2></div></md-toolbar><md-dialog-content layout-padding layout-align=\"center center\"><form class=md-no-momentum name=dCtrlForm ng-submit=dCtrl.answer() layout=column><table ng-table=rCtrl.tableParams class=\"table table-condensed table-bordered table-striped\"><tr ng-repeat=\"item in $data track by item.id\"><td data-title=\"\'名稱\'\" style=min-width:30vw>{{item.label}}</td><td data-title=\"\'數量\'\" style=text-align:center>{{item.qty}}</td><td data-title=\"\'單價\'\" style=text-align:center>{{item.points}}</td><td data-title=\"\'小計\'\" style=text-align:center>{{item.points * item.qty}}</td><td style=text-align:center><md-button aria-label=\"add item\" ng-click=rCtrl.addRewardItem(item) class=\"md-raised md-primary\"><md-icon md-svg-icon=add style=\"width:48px; height:48px\"></md-icon></md-button><md-button aria-label=\"remove item\" ng-click=rCtrl.removeRewardItem(item) class=\"md-raised md-warn\"><md-icon md-svg-icon=remove style=\"width:48px; height:48px\"></md-icon></md-button><md-button aria-label=\"remove all\" class=\"md-raised md-accent\" ng-click=\"rCtrl.removeRewardItem(item, true)\"><md-icon md-svg-icon=delete aria-hidden=true style=width:48px;height:48px></md-icon></md-button></td></tr></table><div layout=\"center center\"><md-button class=\"md-raised md-primary\" aria-label=Save style=\"margin: 0 auto; width:30vw\" ; ng-click=rCtrl.save()>確定</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.stockinDetail.html","<md-dialog aria-label=\"\" flex class=font-mo><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-size:24px; font-weight:bold\">{{\'title.stockin.detail\' | translate}}</h2><md-button class=md-icon-button ng-click=detail.close()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=text-align:center><div class=md-headline><md-list flex=100><md-list-item class=md-3-line ng-repeat=\"sn in detail.serialNos track by $index\" ng-if=$even><span></span><md-icon md-svg-icon=barcode class=md-avatar></md-icon><div class=md-list-item-text layout=column><span>{{ sn }}</span></div><span flex></span><md-icon md-svg-icon=barcode class=md-avatar></md-icon><div class=md-list-item-text layout=column><span>{{ detail.serialNos[$index+1] }}</span></div><md-divider></md-divider></md-list-item><md-list><md-button class=\"md-raised md-primary\" ng-click=detail.close() style=\"width: 45%; font-size:24px; height: 50px\">{{\'btn.close\' | translate}}</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"! detail.downloadUrl\" style=\"width: 45%; font-size:24px; height: 50px\"><a href={{detail.downloadUrl}}>{{\'btn.downloadDetails\' | transalte}}</a></md-button></md-list></md-list></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.stockinHistory.html","<md-dialog class=font-mo style=\"width: 100%; max-width:100%; max-height: 100%\"><md-toolbar><div class=md-toolbar-tools layout layout-align=\"space-between center\"><h2 style=\"font-weight:bold; font-size:24px\">{{\'title.stockin.history.detail\' | translate}}</h2><md-button class=md-icon-button ng-disabled=history.isProcessing ng-click=\"history.showProductDetail || history.showCompare?history.toggleShowProductDetail():history.cancel()\"><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding><div layout=column ng-if=\"! (history.showProductDetail || history.showCompare)\"><div layout=row layout-padding><span flex></span><md-select aria-label=\"Current page size\" ng-model=history.selectedPageSize md-on-close=history.changePageSize() style=\"float: right\"><md-optgroup label=\"Page Size\"><md-option ng-repeat=\"size in history.availablePageSizes\" ng-value=size>{{size}}</md-option></md-optgroup></md-select></div><div><md-progress-linear md-mode=indeterminate ng-if=\"history.isProcessing === true\"></md-progress-linear><table ng-table=history.tableParams class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td data-title=\"\'#\'\">{{$index + 1}}</td><td data-title=\"\'table.field.vendor\' | translate\" sortable filter=\"{\'supplier\': \'select\'}\" filter-data=\"history.getFilterDataAsync(\'supplier\')\">{{item.supplier}}</td><td data-title=\"\'table.field.productType\' | translate\" sortable filter=\"{\'product\': \'select\'}\" filter-data=\"history.getFilterDataAsync(\'product\')\" ng-bind-html=history.trustAsHtml(item.product)></td><td data-title=\"\'table.field.operator\' | translate\" sortable filter=\"{\'operator\': \'select\'}\" filter-data=\"history.getFilterDataAsync(\'operator\')\">{{item.operator}}</td><td data-title=\"\'table.field.total\' | translate\" sortable style=text-align:center><a ng-click=history.getDetail(item)>{{item.count}}</a></td><td data-title=\"\'table.field.pickup\' | translate\" sortable style=text-align:center><a ng-click=\"history.getStockInDetail(item, \'pickup\')\">{{item.pickup}}</a></td><td data-title=\"\'table.field.stock\' | translate\" sortable style=text-align:center><a ng-click=\"history.getStockInDetail(item, \'stock\')\">{{item.stock}}</a></td><td data-title=\"\'table.field.return.new\' | translate\" sortable style=text-align:center><a ng-click=\"history.getStockInDetail(item, \'back\')\">{{item.back}}</a></td><td data-title=\"\'table.field.lastUpdate\' | translate\" sortable>{{item.updatedTs * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td data-title=\"\'\'\"><div layout=row layout-align=\"space-around center\"><md-button aria-label=delete class=\"md-raised md-accent\" style=\"font-size:26px; height:50px\" ng-disabled=\"history.isProcessing === true \" ng-click=history.showDeleteDialog(item)>{{\'btn.stockin.return\' | translate}}</md-button><md-button aria-label=download class=\"md-raised md-warn\" style=\"font-size:26px; height:50px\" ng-disabled=\"history.isProcessing === true \" ng-click=history.downloadDetail(item.id)>{{\'btn.download\' | translate}}</md-button><md-button aria-label=download class=\"md-raised md-primary\" style=\"font-size:26px; height:50px\" ng-disabled=\"history.isProcessing === true \" ng-click=history.showCompareDialog(item)>{{\'btn.analyze\' | translate}}</md-button></div></td></tr></table></div><div><md-button class=\"md-raised md-primary\" style=\"float:right; font-size:24px; height: 50px\" ng-click=history.cancel()>{{\'btn.close\' | translate}}</md-button></div></div><!--end of div for hitory--><div layout=column ng-if=history.showProductDetail><div layout=row layout-padding><span flex></span> <span style=float:righ ng-if=history.showCheckbox><md-checkbox aria-label=\"Select All\" ng-checked=history.isChecked() md-indeterminate=history.isIndeterminate() ng-click=history.toggleAll()><span ng-if=history.isChecked()>{{\'msg.checkbox.deselectAll\' | translate}}</span> <span ng-if=!history.isChecked()>{{\'msg.checkbox.selectAll\' | translate}}</span></md-checkbox></span></div><div><md-progress-linear md-mode=indeterminate ng-if=\"history.isProcessing === true\"></md-progress-linear><table ng-table=history.detailTableParams class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td data-title=\"\'#\'\">{{$index + 1}}</td><td data-title=\"\'table.field.vendor\' | translate\" sortable>{{item.supplier}}</td><td data-title=\"\'table.field.productType\' | translate\" sortable ng-bind-html=history.trustAsHtml(item.product)></td><td data-title=\"\'table.field.productSN\' | translate\" sortable filter=\"{\'productSerialNo\': \'text\'}\">{{item.productSerialNo}}</td><td data-title=\"\'table.field.operator\' | translate\" sortable filter=\"{\'operator\': \'select\'}\" filter-data=history.operatorFilter>{{item.operator}}</td><td data-title=\"\'table.field.lastUpdate\' | translate\" sortable>{{item.ts * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td ng-if=history.showCheckbox><md-checkbox aria-label=checkbox ng-checked=history.exists(item) ng-click=history.toggle(item)></md-checkbox></td></tr></table></div><div><md-button type=button ng-click=history.toggleShowProductDetail() class=\"md-raised md-primary\" data-dismiss=modal style=\"font-size:26px; height:50px; float:right\" ng-disabled=history.isProcessing>{{\'btn.goPrevious\' | translate}}</md-button><md-button class=\"md-raised md-accent\" ng-if=history.showCheckbox style=\"float:right; font-size:24px; height:50px; float:right\" aria-label=hidden ng-click=history.showBatchDeleteDialog() ng-disabled=history.isProcessing>{{\'btn.stockin.return\' | translate}}</md-button></div></div><div layout=column ng-if=history.showCompare><div><h2>{{\'msg.mostockin.compare.step1\' | translate}}<md-button class=md-primary aria-label=\"Download template\" style=margin:auto href=https://s3-us-west-2.amazonaws.com/iiot-temp/compare-sn-example.xlsx><md-icon md-svg-icon=download_file style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px translate>Download example</span></md-button></h2><label class=\"md-button md-raised md-warn\" style=font-size:30px ng-disabled=history.isProcessing>{{\'Select file\' | translate}} <input type=file nv-file-select uploader=history.uploader ng-hide=true ng-click=history.uploader.clearQueue() multiple></label></div><div><h2>{{\'msg.mostockin.compare.step2\' | translate}}</h2><table class=table style=width:95vw><thead><tr style=background-color:lightblue><th>{{\'Filename\' | translate}}</th><th ng-show=history.uploader.isHTML5>{{\'Filesize\' | translate}}</th><!--\n                    <th ng-show=\"mo.uploader.isHTML5\">上傳進度</th>\n                    --><th>{{\'Status\' | translate}}</th><th style=text-align:center>{{\'Action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in history.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"history.uploader.isHTML5 && item.file.size/1024/1024 > 1\" nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"history.uploader.isHTML5 && item.file.size/1024/1024 < 1\" nowrap>{{ item.file.size/1024|number:2 }} KB</td><td class=text-center><span ng-show=item.isSuccess><md-icon md-svg-icon=check_circle style=color:green;width:36px;height:36px></md-icon></span><span ng-show=item.isCancel><md-icon md-svg-icon=cancel style=color:orange;width:36px;height:36px></md-icon></span><span ng-show=item.isError><md-icon md-svg-icon=error_circle style=color:red;width:36px;height:36px></md-icon></span></td><td nowrap><md-button class=\"md-primary md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=history.uploadFile(item) ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><md-icon md-svg-icon=upload_file style=width:24px;height:24px></md-icon>{{\'btn.upload\' | translate}}</md-button><md-button class=\"md-warn md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.cancel() ng-disabled=!item.isUploading><md-icon md-svg-icon=cancel style=width:24px;height:24px></md-icon>{{\'btn.cancel\' | translate}}</md-button><md-button class=\"md-accent md-raised\" style=\"font-size:24px; width:30%; height:50px\" ng-click=item.remove()><md-icon md-svg-icon=close style=width:24px;height:24px></md-icon>{{\'btn.remove\' | translate}}</md-button></td></tr></tbody></table><md-progress-linear md-mode=indeterminate ng-if=\"history.isProcessing === true\"></md-progress-linear></div><div ng-show=history.showResult><h2><strong>{{\'Result\' | translate}}</strong></h2><table ng-table-dynamic=\"history.diffTableParams with history.diffTableCols\" class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"row in $data\" ng-class-even=\"\'even\'\"><td flex ng-repeat=\"col in $columns\" ng-bind-html=\"col.getValue(this, row, $parent.$parent.$index)\"></td></tr></table></div><div><md-button class=\"md-raised md-primary\" style=\"float:right; font-size:24px; height: 70px\" ng-disabled=history.isProcessing ng-click=history.toggleShowProductDetail()>{{\'btn.goPrevious\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.version.html","<md-dialog aria-label=\"\" style=min-height:200px><md-toolbar><div class=md-toolbar-tools layout-align=\"space-between center\"><h2>{{\'About\' | translate}}</h2><md-button class=md-icon-button ng-click=about.confirm()><md-icon md-svg-icon=close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=text-align:center layout-margin layout-padding><div layout=column flex class=md-display-1 layout-margin><span>Version: {{about.data.version }} </span><span>Revision: {{about.data.revision}}</span></div><div layout=row layout-align=\"center center\"><md-button class=\"md-raised md-primary\" style=\"width:100%; height:50px; font-size:24px\" ng-click=about.confirm()>{{\'btn.close\' | translate}}</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialog.websocket.html","<div layout=column layout-align=\"center center\" keypress-events style=min-width:30vw><md-toolbar><div class=md-toolbar-tools><h2 style=\"font-size:24px; font-weight:bold\">{{\'Set Websocket Connection\' | translate}}</h2></div></md-toolbar><md-dialog-content><form name=wsForm><div layout=row style=\"width:100%; padding: 20px 20px 20px 20px; font-size:16px\"><md-input-container md-no-float class=md-block><label>WebSocket ID</label><input id=wsID name=wsID ng-model=ws.id type=text ng-click=\"printerIP = \'\'\" readonly><div ng-messages=wsForm.printerIP.$error.pattern ng-show=wsForm.wsID.$error.pattern><span>*IP Pattern Wrong.</span></div></md-input-container><!--\n        <div>\n          <label>WebSocket ID</label> &nbsp; \n          <input id=\"wsID\" name=\"wsID\" ng-model=\"ws.id\" type=\"text\" \n            ng-click=\"printerIP = \'\'\"\n            readonly=true>\n            \n          <div ng-messages=\"wsForm.printerIP.$error.pattern\" ng-show=\"wsForm.wsID.$error.pattern\">\n            <span> *IP Pattern Wrong.</span>\n          </div>\n\n        </div>\n        --></div><div style=\"font-size: 16px; padding: 20px 20px 20px 20px\"><md-checkbox ng-model=ws.enabled aria-label=\"Enable websocket connection\" ng-true-value=true ng-false-value=false class=\"md-warn md-align-top-left\" flex>連線開啓<br><br><span>此功能主要是針對人臉報到，如果您選擇開啓連線，在活動報到頁面會自動接收伺服器端傳來的報到資訊，並自動列印識別證，反之則否。</span><br></md-checkbox></div><div style=float:right><md-button class=\"md-raised md-primary\" aria-label=set ng-click=ok() style=\"float:left; height:50px; font-size:16px\" ng-disabled=\"wsForm.$invalid || ws.id === \'\'\"><span>{{\'btn.ok\' | translate}}</span></md-button><md-button class=\"md-raised md-warn\" aria-label=cancel ng-click=close() style=\"float:left; height:50px; font-size:16px\"><span>{{\'btn.cancel\' | translate}}</span></md-button></div></form><md-dialog-content></md-dialog-content></md-dialog-content></div>");
$templateCache.put("app/main/event.html","<div flex layout=column layout-gt-sm=row layout-margin layout-align=center style=height:100% ng-cloak><div flex=50 flex-gt-sm=50 flex-order=2 flex-order-gt-sm=1 layout-align=center layout=column style=min-height:500px><div style=\"margin-bottom: 10px\"><table flex class=md-title border=1 style=\"width:100%;border:1px #cccccc solid\"><tr ng-if=event.member.profile.iiotSn><td width=200px class=table-label>報到序號：</td><td class=table-content>{{event.member.profile.iiotSn}}</td></tr><tr><td class=table-label>票卡編號：</td><td class=table-content><div layout=row layout-align=\"start center\"><span>{{event.member.barcodeMessage}}</span> <span ng-if=\"event.member.barcodeMessage && event.selectedEvent.changeBarcodeOn\" style=\"font-size:16px; margin-left:10px\"><span class=\"label label-success\" ng-if=event.member.isBarcodeChanged>已配對</span> <span class=\"label label-danger\" ng-if=!event.member.isBarcodeChanged>未配對</span></span><md-button id=printBtn aria-label=print ng-if=event.member.barcodeMessage ng-click=event.printBadge(event.member) class=\"md-icon-button md-primary\"><md-icon md-svg-icon=print style=\"width:24px; height:24px\"></md-icon></md-button></div></td></tr><tr><td class=table-label>報到時間：</td><td class=table-content><div layout=row layout-align=\"space-between center\"><span>{{event.member.checkinTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</span> <span ng-show=event.member.order>[第 {{event.member.order}} 位]</span></div></td></tr><tr><td class=table-label>電話：</td><td class=table-content><!-- <span ng-if=\"event.member.profile.phoneNumber\">{{event.member.profile.phoneNumber}}</span> --><div layout=row><input id=newPhoneNumber ng-class=\"{\'defocus\': !event.isRequired.newPhoneNumber, \'barcode-blue-readonly\': event.isRequired.newPhoneNumber}\" ng-click=\"event.changeFocus(\'newPhoneNumber\')\" numeric-keyboard-input=\"\" placeholder=+886922889889 ng-model=event.newPhoneNumber ng-disabled=\"!event.member.profile || event.isProcessing.newPhoneNumber\"><md-button class=\"md-raised md-primary\" aria-label=addPhone ng-disabled=\"event.isProcessing.newPhoneNumber || !event.newPhoneNumber || (event.newPhoneNumber === event.member.profile.phoneNumber)\" ng-click=event.addPhoneNumber()><div layout=row layout-align=\"center center\"><span ng-if=!event.isProcessing.newPhoneNumber>更新</span><md-progress-circular md-mode={{event.isProcessing.newPhoneNumber}} ng-if=event.isProcessing.newPhoneNumber md-diameter=10></md-progress-circular></div></md-button><md-button class=\"md-raised md-accent\" aria-label=sendPass ng-disabled=\"event.isProcessing.newBarcode || !event.member || !event.member.profile.phoneNumber\" ng-click=event.sendPass(event.member)>重新發卡</md-button></div></td></tr><tr ng-repeat=\"item in event.member.fields\"><td class=table-label>{{item.label}}：</td><td class=table-content><span ng-if=item.value>{{item.value}}</span> <span ng-if=\"!item.value && item.key===\'iiotCompany\' && event.member.profile.company\">{{event.member.profile.company}}</span></td></tr><tr ng-if=event.member.profile.iiotVip><td class=table-label>VIP：</td><td class=table-content>{{event.member.profile.iiotVip}}</td></tr><tr ng-if=event.member.profile.iiotVegetarian><td class=table-label>葷/素食：</td><td class=table-content>{{event.member.profile.iiotVegetarian}}</td></tr><tr ng-repeat=\"(key, value) in event.member.profile\" ng-if=\"event.isPrefix(key, \'mpos\')\"><td class=table-label>{{event.distFields[key]}}：</td><td class=table-content><div layout=row><input id={{key}} ng-class=\"{\'defocus\': event.isRequired.query || event.isRequired.newBarcode || event.isRequired.newPhoneNumber, \'barcode-blue-readonly\': event.isRequired[key]}\" ng-click=event.changeFocus(key) ng-model=event.mposFields[key] ng-disabled=\"!event.member.profile || event.isProcessing[key]\"><md-button class=\"md-raised md-primary\" ng-disabled=\"event.isProcessing[key] || !event.mposFields[key] || (event.mposFields[key] === event.member.profile[key])\" ng-click=\"event.updateProfile(key, event.mposFields[key])\"><div layout=row layout-align=\"center center\"><span ng-if=!event.isProcessing[key]>更新</span><md-progress-circular md-mode={{event.isProcessing[key]}} ng-if=event.isProcessing[key] md-diameter=10></md-progress-circular></div></md-button></div></td></tr><!--<tr ng-if=\"event.isRequired.newBarcode\">\n          <td class=\"table-label\">配對條碼：</td>\n          <td class=\"table-content\">{{event.member.newBarcode}}</td>\n        </tr>--></table><md-progress-linear md-mode=determinate value={{event.toggleCounter}} class=md-warn hide-gt-sm ng-disabled=\"!(event.toggleCounter>0 || event.toggleCounter<100)\"></md-progress-linear></div><div flex class=scrollbar-style2 style=\"min-height:300px; max-height:100%; overflow:scroll\" drag-scroll=true><md-content><div style=color:white;text-align:center ng-style=\"{\'background-color\': (event.listType!==\'candidate\')?\'CornflowerBlue\':\'orangered\'}\"><span ng-show=\"event.listType!==\'candidate\'\" style=\"text-align:center; margin:auto; font-size:26px; font-weight:bold\">最近 {{event.memberList.length ? event.memberList.length : 0}} 筆報到資料</span> <span ng-show=\"event.listType===\'candidate\'\" style=\"text-align:center; margin:auto; font-size:26px; font-weight:bold\"><i class=material-icons>search</i> 搜尋到 {{event.memberList.length}} 筆符合資料</span></div><md-subheader><div layout=row layout-fill><div flex=20>序號</div><div flex=20>姓名</div><div flex=20>公司</div><div flex=20 ng-if=\"event.listType===\'candidate\'\">手機號碼</div><div flex=20 ng-if=\"event.listType!==\'candidate\'\">報到時間</div><div flex=20></div></div></md-subheader><md-list><md-list-item ng-repeat=\"member in event.memberList\" ng-click=event.showMemberInfo(member)><div layout=row layout-fill layout-align=\"center center\" class=md-list-item-text style=\"border-top:1px solid #ddd\"><!--<div flex=\"10\">{{member.order}}</div>--><div flex=20>{{member.profile.iiotSn}}</div><div flex=20>{{member.displayName}}</div><div flex=20>{{(member.fields | filter:{\'key\':\'iiotCompany\'}:true)[0].value || member.profile.company}}</div><div flex=20 ng-if=\"event.listType===\'candidate\'\">{{member.profile.phoneNumber}}</div><div flex=20 ng-if=\"event.listType!==\'candidate\'\">{{member.checkinTime | date:\'HH:mm:ss\'}}</div><div flex=20><md-button class=\"md-raised md-accent\" aria-label=sendPass ng-disabled=event.isProcessing.newBarcode ng-click=event.sendPass(member)>重新發卡</md-button><md-button class=md-raised aria-label=printBadge ng-style=\"event.isProcessing.newBarcode ? {\'background-color\':\'#e6e6e6\', \'color\':\'#bfbfbf\'}: {\'background-color\':\'orange\', \'color\':\'white\'}\" ng-disabled=event.isProcessing.newBarcode ng-click=event.printBadge(member)>列印識別證</md-button></div></div></md-list-item></md-list></md-content></div></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=event.toggleRight()><md-icon md-svg-icon=keyboard></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=50 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout=column layout-padding style=\"background-color:lavender; min-height:500px\"><div layout=row layout-align=\"space-between center\" style=width:100%><div layout=column style=\"width:90%; padding-right:20px\" layout-align=\"center start\"><div flex style=\"display: table-cell; vertical-align: text-bottom\"><md-icon md-svg-icon=person show-xs hide-gt-xs></md-icon><span style=\"font-size: 20px; text-align: left\" hide-xs>報到人數：</span> <span style=\"font-size: 48px; text-align: right\">{{event.dashboard.checkins.total}}</span> <span style=\"font-size: 20px; text-align: left\">/{{event.dashboard.dists.total}}</span></div><div flex style=\"display: table-cell; vertical-align: text-bottom\"><md-icon md-svg-icon=clock show-xs hide-gt-xs></md-icon><span style=\"font-size: 20px; text-align: left\" hide-xs>更新時間： </span><span style=\"font-size: 20px; text-align: left\"><span show-xs hide-gt-xs>{{event.updateTime | date:\'HH:mm:ss\'}}</span> <span hide-xs show-gt-xs>{{event.updateTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</span></span></div></div><div layout-align=\"space-around center\"><!--\n        <div flex class=\"onoffswitch\" style=\"min-width:165px;>\n          <input type=\"checkbox\" name=\"websocketSwitch\" class=\"onoffswitch-checkbox\"\n              id=\"websocketSwitch\" ng-model=\"event.enableWS\" ng-change=\"event.toggleWebsocket()\">\n          <label class=\"onoffswitch-label\" for=\"websocketSwitch\">\n            <span class=\"onoffswitch-inner onoffswitch-inner-orange\" data-text-on=\"連線開啓\" data-text-off=\"連線關閉\"></span>\n            <span class=\"onoffswitch-switch\"></span>\n          </label>\n        </div> \n        --><div flex class=onoffswitch style=min-width:165px ng-hide=event.enableBarcodeUpdate><input type=checkbox name=autoPrintSwitch class=onoffswitch-checkbox id=autoPrintSwitch ng-model=event.autoPrint><label class=onoffswitch-label for=autoPrintSwitch><span class=\"onoffswitch-inner onoffswitch-inner-orange\" data-text-on=自動列印 data-text-off=手動列印></span> <span class=onoffswitch-switch></span></label></div><div flex class=onoffswitch style=min-width:165px><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=myonoffswitch ng-model=event.enablePhoneSearch ng-change=event.toggleSearch()><label class=onoffswitch-label for=myonoffswitch><span class=\"onoffswitch-inner onoffswitch-inner-orange\" data-text-on=查詢模式 data-text-off=掃描票卡模式></span> <span class=onoffswitch-switch></span></label></div><br><!--<div flex class=\"onoffswitch\" style=\"min-width:165px\" ng-if=\"event.selectedEvent.changeBarcodeOn\">\n          <input type=\"checkbox\" name=\"pairOnOff\" class=\"onoffswitch-checkbox\"\n              id=\"pairOnOff\" ng-model=\"event.enableBarcodeUpdate\" ng-change=\"event.togglePairing()\">\n          <label class=\"onoffswitch-label\" for=\"pairOnOff\">\n            <span class=\"onoffswitch-inner\" data-text-on=\"配對已開啓\" data-text-off=\"配對已關閉\"></span>\n            <span class=\"onoffswitch-switch\"></span>\n          </label>\n        </div>--><p style=color:#aaa>報到需要配對識別證： {{event.selectedEvent.changeBarcodeOn?\'是\':\'否\'}}</p></div></div><div keypress-events layout=row layout-align=\"space-between center\"><!--<i class=\"material-icons\" style=\"color:#aaa; margin-right:5px\">barcode</i>--><div><md-icon md-svg-icon=\"{{event.enablePhoneSearch ? \'search\' : \'qrcode-scan\'}}\" style=\"margin-right: 10px\" hide-xs></md-icon><input id=query style=\"height:50px;\n              font-size:20px;\n              padding: 2px 6px;\n              border: 1px solid #CCC;\n              -webkit-border-radius: 5px;\n              border-radius: 5px\" type=text ng-class=\"{\'barcode-green-readonly\' : event.enablePhoneSearch === false, \n              \'phonenumber-readonly\': event.enablePhoneSearch === true, \'defocus\': !event.isRequired.query}\" numeric-keyboard-input=\"\" ng-model=event.query ng-disabled=\"event.isProcessing.newBarcode || event.isProcessing.query\" placeholder=\"{{event.enablePhoneSearch ? (event.searchType===\'all\'?\'姓名、公司或Email\':\'報到序號\') : \'請掃描票卡\'}}\" ng-click=\"event.changeFocus(\'query\')\"><!--  ng-readonly=\"!event.enablePhoneSearch\">--></div><md-progress-circular md-mode=\"{{event.isProcessing.newBarcode || event.isProcessing.query}}\" ng-show=\"event.isProcessing.newBarcode || event.isProcessing.query\" md-diameter=20></md-progress-circular><md-radio-group layout=row ng-model=event.searchType ng-show=event.enablePhoneSearch><md-radio-button value=all class=md-primary>個人資料</md-radio-button><md-radio-button value=sn>報到序號</md-radio-button></md-radio-group></div><numeric-keyboard flex callback=event.searchBarcode() clear-callback=event.reset() type=\"{{event.enablePhoneSearch?\'full\':\'fn\'}}\"></numeric-keyboard></md-sidenav></div>");
$templateCache.put("app/main/events.html","<div flex flex-gt-lg=70 flex-offset-gt-lg=15 layout-gt-sm=row layout-padding layout-fill layout-margin layout-align-gt-md=\"center center\" layout-align=space-around ng-cloak><div layout=row layout-fill layout-margin layout-padding layout-align=space-around><md-grid-list flex md-cols-xs=2 md-cols-sm=2 md-cols-md=4 md-cols-lg=8 md-cols-gt-lg=12 md-row-height=1:1 md-gutter=12px><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=2 ng-repeat=\"event in events.eventList track by event.id\" ng-click=events.redirect(event)><md-icon md-svg-icon=event aria-hidden=true style=\"width:96px; height:96px\"></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=2 layout-align=\"center center\"><span style=\"font-weight: bold;font-size:20px\">{{event.label}}</span></md-grid-tile-footer></md-grid-tile></md-grid-list></div></div>");
$templateCache.put("app/main/home.html","<div ui-view=header></div><div ui-view=content></div>");
$templateCache.put("app/main/main.html","<div layout=column style=min-height:100%><div style=\"width:100%; min-height:80px; border-bottom: 1px solid #eee; top:0; left:0; position:fixed\"><md-toolbar style=\"background-color:white; color:black\"><div layout=row loyout-margin class=\"md-toolbar-tools mytoolbar\" layout-align=space-around style=min-height:80px><div flex=auto layout layout-align=\"center center\" style=\"margin:10px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis\"><img ng-src={{main.business.logo}} style=\"max-width: 150px; max-height:100%\"> <span hide-xs hide-sm style=\"max-width:40vw; font-size:32px\">{{main.business.name}}</span></div><div flex=auto layout layout-align=\"center center\" style=\"margin:10px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; position: relative; top: 50%; transform: translateY(-50%); font-weight: bold; color:royalblue\" ng-if=main.eventLabel>{{main.eventLabel}}</div><div flex=noshrink layout=column layout-align=\"center start\"><span ng-if=\"! (main.eventLabel || main.checkLabel)\"><span>{{\'title.business\' | translate}} : </span><span>{{main.user.displayName}}</span> </span><span ng-if=main.checkLabel><span>{{\'title.counter\' | translate}} : </span><span>{{main.checkLabel}}</span> </span><span><span>{{\'title.employee\' | translate}} : </span><span>{{main.user.username}}</span></span></div><!--<span flex></span>--><div layout=row layout-align=\"center center\"><md-icon md-svg-icon=connection class=\"md-fab md-raised my-menu-icon\" ng-class=\"{{main.$mdMedia(\'gt-xs\')? \'\' :\'md-mini\'}}\" style=fill:{{main.connectionStatus}}></md-icon><!--\n          <md-button aria-label=\"network\" class=\"md-fab md-raised\" \n            ng-class=\"{{main.$mdMedia(\'gt-sm\')? \'\' :\'md-mini\'}}\">\n            <md-icon md-svg-icon=\"connection\" class=\"my-menu-icon\" style=\"fill:{{main.connectionStatus}};\"> </md-icon>\n          </md-button>\n          --><md-button id=gohomeBtn aria-label=home ng-click=main.gohome() class=\"md-fab md-raised md-ink-ripple\" ng-class=\"{{main.$mdMedia(\'gt-xs\')? \'\' :\'md-mini\'}}\"><md-icon md-svg-icon=home class=my-menu-icon style=fill:blue></md-icon></md-button><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Open menu\" class=\"md-fab md-raised\" ng-class=\"{{main.$mdMedia(\'gt-xs\')? \'\' :\'md-mini\'}}\" ng-click=$mdMenu.open()><md-icon md-menu-origin md-svg-icon=menu class=my-menu-icon style=fill:black></md-icon></md-button><md-menu-content width=4><md-menu-item ng-repeat=\"item in main.menulist | filter: {\'display\': true}\"><md-button ng-click=main.menuClick(item.callback)><md-icon md-menu-origin md-svg-icon={{item.icon}}></md-icon><span md-menu-align-target translate>{{item.name}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar></div><div flex style=\"width:100%; margin-top:80px; position:relatvie; overflow:scroll\" ui-view=content></div></div>");
$templateCache.put("app/main/memberpoint.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-margin layout-align-gt-md=center layout-align=space-around ng-cloak><div flex=\"\" flex-sm=100 flex-gt-md=45 flex-order=2 flex-order-gt-sm=1 layout-align=center><table keypress-events flex class=my-table style=width:100%><tr height=40><td>會員條碼：</td><td><input id=barcodeMessage style=\"width: 90%\" type=text class=barcode-readonly ng-show=!points.multipleMember ng-disabled=!points.isRequired.barcodeMessage ng-model=points.member.barcodeMessage readonly><md-input-container ng-show=points.multipleMember style=\"width: 90%\"><md-select placeholder=請選擇條碼 ng-model=points.member md-on-close=points.changeSelectedMember() aria-label=\"member selection\" style=\"width: 90%\"><md-option id=memberSelector ng-value=member ng-repeat=\"member in points.searchedMember track by $index\">{{member.barcodeMessage}}</md-option></md-select></md-input-container></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{points.isProcessing.barcodeMessage}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=40><td>會員電話：</td><td><input id=phoneNumber style=\"width: 90%\" type=text class=phonenumber-readonly ng-disabled=!points.isRequired.phoneNumber ng-model=points.member.phoneNumber readonly></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{points.isProcessing.phoneNumber}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=40 ng-repeat=\"item in points.displayList track by $index\"><td>{{item.label}}：</td><td align=center valign=center style={{item.style}}>{{item.value}}</td></tr><tr height=40><td>會員點數：</td><td style=color:blue align=center valign=center>{{points.member.points}}</td></tr><tr height=40><td colspan=2><div layout-align=space-between><!--<span style=\"width:50%\">點數：<span style=\"color:blue\">{{points.member.points | number}} </span></span>--> <span>消費：<span style=color:red> <input id=exchange style=\"width: 40%; text-align: center; color:red\" type=number readonly-focus=points.isFocus.exchange ; ng-disabled=\"!points.member.phoneNumber || !points.member.barcodeMessage\" ng-model=points.money readonly></span><span layout-margin>本次點數：<span style=\"color:red; text-align: center\">{{points.newPoints | number}}</span></span></span></div></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{points.isProcessing.points}}\"></md-progress-circular>\n        </td>\n        --></tr><!--\n      <tr height=\"50\">\n        <td>消費金額：</td>\n        <td>\n          <input id=\"exchange\" style=\"width: 250px; text-align: center; color:red\" type=\"number\"\n            readonly-focus=\"points.isFocus.exchange\";\n            ng-disabled=\"!points.member.phoneNumber || !points.member.barcodeMessage\"\n            ng-model=\"points.money\"\n            readonly=\"true\">\n          </input>\n        </td>\n      </tr>\n      <tr height=\"50\">\n        <td>本次點數：</td>\n        <td style=\"color:red\" align=\"center\" valign=\"center\"> {{points.newPoints}}</td>\n        <td>\n          <md-progress-circular md-mode=\"{{points.isProcessing.points}}\"></md-progress-circular>\n        </td>\n      </tr>\n      --><tr height=50 ng-show=\"points.member.barcodeMessage && points.member.phoneNumber\"><td>註解：</td><td><textarea id=remark ng-model=points.remark style=\"height:80px; width:90%\" readonly-focus=redeem.isFocus.remark selectonclick>\n          </textarea></td></tr><tr height=120><td colspan=2><md-button class=md-raised ng-click=\"points.changeFocus(\'phoneNumber\')\" ng-disabled=\"points.isProcessing.barcodeMessage || points.isProcessing.phoneNumber || points.isProcessing.points\" style=\"margin-left:0px;min-width:45%; background-color:orange\">查詢模式</md-button><md-button class=md-raised ng-click=\"points.changeFocus(\'barcodeMessage\')\" ng-disabled=\"points.isProcessing.barcodeMessage || points.isProcessing.phoneNumber || points.isProcessing.points\" style=\"float:right;margin-right:0px; min-width:45%; background-color:yellowgreen\">掃碼模式</md-button></td></tr><tr height=80 ng-if=\"points.member.barcodeMessage && points.member.phoneNumber\"><td colspan=2><md-button class=\"md-raised md-primary\" ng-click=\"points.resendBarcode(\'phoneNumber\')\" ng-disabled=points.isProcessing.points style=\"margin-left:0px; width:100%\">重新發卡</md-button></td></tr></table></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=points.toggleRight() ng-hide=\"points.scanMode && !points.member.phoneNumber\"><md-icon md-svg-icon=keyboard></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=100 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout-padding style=\"background-color:lavender; height:90%\"><!--<div flex=\"\" flex-gt-md=\"45\" layout=\"row\" flex-order=\"1\" flex-order-gt-sm=\"2\" >--><div flex=\"\" layout=column><!--<div layout=\"column\" layout-padding hide-gt-sm ng-show=\"points.member.barcodeMessage && points.member.phoneNumber\" >\n        <span class=\"mylabel\"> 條碼：{{points.member.barcodeMessage}}</span>\n        <span class=\"mylabel\" style=\"float:right\"> 點數：{{points.member.points | number}}</span>  \n      </div>--><div layout=column layout-gt-xs=row layout-padding hide-gt-sm ng-show=\"points.member.barcodeMessage && points.member.phoneNumber\"><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel>條碼：<span style=color:blue>{{points.member.barcodeMessage}}</span></span> <span class=mylabel style=float:right>姓名：<span style=color:blue>{{points.member.displayName}}</span></span> </span><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel style=float:right>電話：<span style=color:blue>{{points.member.phoneNumber}}</span></span> <span class=mylabel style=float:right>點數：<span style=color:blue>{{points.member.points | number}}</span></span></span></div><!--\n      <label class=\"mylabel\" hide-gt-sm \n        ng-show=\"points.member.barcodeMessage && points.member.phoneNumber\"> \n        {{points.member.barcodeMessage}} ({{points.member.points | number}}) \n      </label>\n      --><br hide-gt-sm><md-whiteframe flex=\"\" style=height:90px;max-height:90px class=md-whiteframe-10dp layout=row layout-align=space-between><div flex layout=row layout-align=space-between ng-if=points.keyboard.label><span style=min-height:50px;font-size:20px>{{points.keyboard.label}}</span> <span numeric-keyboard-input=\"\" ng-model=points.keyboard.value ng-if=points.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{points.keyboard.value | number}}</h2></span><span numeric-keyboard-input=\"\" ng-model=points.keyboard.value ng-if=!points.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{points.keyboard.value}}</h2></span></div></md-whiteframe><br><numeric-keyboard callback=\"points.confirmAction(\'ADD\')\"></numeric-keyboard><br><div layout-padding style=width:100%><label class=mylabel style=width:100% hide-gt-sm ng-show=\"points.member.barcodeMessage && points.member.phoneNumber\">註解<textarea id=remark md-select-on-focus ng-model=points.remark style=\"height:100px; width:100%\">\n          </textarea></label></div></div><!--</div>--></md-sidenav></div>");
$templateCache.put("app/main/menu.html","<div flex flex-gt-lg=70 flex-offset-gt-lg=15 layout=row layout-margin layout-align=\"center center\" ng-cloak><div layout=row flex layout-margin layout-padding layout-align=\"center center\"><md-grid-list flex=100 flex-gt-md={{menu.gridItems.flex}} md-cols-xs=2 md-cols-sm=2 md-cols=4 md-cols-md={{menu.gridItems.md}} md-cols-lg={{menu.gridItems.lg}} md-row-height=1:1 md-gutter=12px><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'memberpoint\')\" ng-click=\"menu.redirect(\'home.memberpoint\')\"><md-icon md-svg-icon=membership aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.memberpoint\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:#f7a3a0 md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'deposit\')\" ng-click=\"menu.redirect(\'home.deposit\')\"><md-icon md-svg-icon=money aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.deposit\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'rewardpoint\')\" ng-click=\"menu.redirect(\'home.rewardpoint\')\"><md-icon md-svg-icon=giftcard aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.rewardpoint\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'redeempoint\')\" ng-click=\"menu.getDynamicRewardList(\'home.redeempoint\')\"><md-icon md-svg-icon=checkin aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.redeempoint\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:#d2d39e md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'refundpoint\')\" ng-click=\"menu.redirect(\'home.refundpoint\')\"><md-icon md-svg-icon=checkin aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.refundpoint\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'events\')\" ng-click=\"menu.redirect(\'home.events\')\"><md-icon md-svg-icon=event aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.events\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'eventdashboard\')\" ng-click=menu.openPpos()><md-icon md-svg-icon=event aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.eventdashboard\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:wheat md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'mocheckin\')\" ng-click=\"menu.redirect(\'home.mocheckin\')\"><md-icon md-svg-icon=order aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel style=color:tomato>{{\'title.mocheckin\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:#f2dc6d md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'mocheckout\')\" ng-click=\"menu.redirect(\'home.mocheckout\')\"><md-icon md-svg-icon=order aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel style=color:maroon>{{\'title.mocheckout\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'mostockin\')\" ng-click=\"menu.redirect(\'home.mostockin\')\"><md-icon md-svg-icon=stockout aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.mostockin\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'mocreate\')\" ng-click=\"menu.redirect(\'home.mocreate\')\"><md-icon md-svg-icon=order aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.mocreate\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'mostockout\')\" ng-click=\"menu.redirect(\'home.mostockout\')\"><md-icon md-svg-icon=stockout aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.mostockout\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'moreport\')\" ng-click=\"menu.redirect(\'home.moreport\')\"><md-icon md-svg-icon=statistic aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.moreport\' | translate}}</span></md-grid-tile-footer></md-grid-tile><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-if=\"menu.checkAuth(\'moorder\')\" ng-click=\"menu.redirect(\'home.moorder\')\"><md-icon md-svg-icon=order aria-hidden=true class=myicon></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\"><span class=mylabel>{{\'title.moorder\' | translate}}</span></md-grid-tile-footer></md-grid-tile></md-grid-list></div></div>");
$templateCache.put("app/main/mo.checkin.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-padding layout-align-gt-md=center layout-align=space-around ng-cloak class=font-mo><div class=no-print flex=\"\" flex-sm=100 flex-gt-sm=45 layout-align=\" center\"><table keypress-events style=width:95%><tr height=40 class=md-headline style=background-color:gold data-fittext><td colspan=2 style=\"color:blue; text-align:center\"><strong>-- {{\'title.table.mocheckin\' | translate}} --</strong></td></tr><tr height=50 ng-show=!cin.order.merchantOrderNo><td>{{\'table.field.voucher\' | translate}}：</td><td style=text-align:left><input id=barcodeMessage style=\"width: 220px\" type=text class=barcode-readonly ng-disabled=!cin.isRequired.barcodeMessage ng-model=cin.order.barcodeMessage readonly></td></tr><tr height=50 ng-hide=cin.order.merchantOrderNo><td>{{\'table.field.query\' | translate}}：</td><td style=text-align:left><input id=queryString style=\"width: 220px\" type=text class=phonenumber-readonly ng-disabled=!cin.isRequired.queryString ng-model=cin.queryString></td></tr><tr height=50><td>{{\'table.field.order\' | translate}}：</td><td ng-show=!cin.multipleOrders style=text-align:left>{{cin.order.merchantOrderNo}}<md-icon ng-if=cin.order.agency md-svg-icon=error_circle aria-hidden=true style=\"width:48px; height:48px; color:red\"></md-icon></td><td ng-show=cin.multipleOrders style=text-align:left><md-input-container><md-select ng-model=cin.selectedOrder md-on-close=cin.changeSelectedOrder() md-on-open=cin.setLastOrder() ng-disabled=cin.isProcessing.confirmOrder aria-label=\"order selection\" style=\"width: 220px\"><md-option id=orderSelector ng-value=order ng-repeat=\"order in cin.orders track by $index\"><span ng-bind-html=cin.getOrderListInfo(order.listInfos)></span></md-option></md-select></md-input-container><md-icon ng-if=cin.order.agency md-svg-icon=error_circle aria-hidden=true style=\"width:48px; height:48px; color:red\"></md-icon></td><td ng-if=cin.order.agency></td></tr><tr height=50><td>{{\'table.field.applicant.phone\' | translate}}：</td><td style=\"color:blue; text-align:left\">{{cin.order.phoneNumber}}</td></tr><tr height=50><td>{{\'table.field.applicant.name\' | translate}}：</td><td style=\"color:blue; text-align:left\">{{cin.order.displayName}}</td></tr><tr height=50 ng-repeat=\"item in cin.order.infos track by $index\"><td style=\"max-width:60px; word-wrap:break-word\">{{item.label}}</td><!-- <td style=\"color:blue; text-align:center\" >{{item.value}}</td> --><td style=\"color:blue; text-align:left\" ng-bind-html=cin.trustAsHtml(item.value)></td></tr><tr height=50 ng-show=cin.order.others><td>{{\'table.field.orderRemark\' | translate}}：</td><td style=text-align:left><textarea id=others readonly style=\"width: 220px\" ng-model=cin.order.others>\n          </textarea></td></tr><tr height=120><td colspan=2><div layout=row layout-align=\"center center\"><md-button class=md-raised ng-click=\"cin.showConfirmExitDialog(\'queryString\')\" ng-disabled=\"cin.isProcessing.barcodeMessage !== \'\'  || cin.isProcessing.queryString !== \'\' || cin.isProcessing.confirmOrder\" style=\"margin-left:0px;min-width:45%;height: 70px; background-color:orange\"><h1>{{\'btn.searchMode\' | translate}}</h1></md-button><md-button class=md-raised ng-click=\"cin.showConfirmExitDialog(\'barcodeMessage\')\" ng-disabled=\"cin.isProcessing.barcodeMessage !== \'\'  || cin.isProcessing.queryString !== \'\' || cin.isProcessing.confirmOrder\" style=\"float:right;margin-right:0px;min-width:45%;height: 70px; background-color:yellowgreen\"><h1>{{\'btn.scanMode\' | translate}}</h1></md-button></div></td></tr></table></div><!-- order item --><div class=no-print flex data-fittext style=\"max-height:100vh;overflow: scroll\"><table style=width:100%><tr height=40 class=md-headline style=background-color:gold><td colspan=3 align=center valign=center style=color:blue><strong>-- {{\'title.table.productInfo\' | translate}} --</strong></td></tr><tr height=50 style=background-color:lightgrey><td style=min-width:8vw>{{\'table.field.vendor\' | translate}}</td><td style=\"min-width:32vw; padding:5px\">{{\'table.field.product\' | translate}}</td><td>{{\'table.field.quantity\' | translate}}</td></tr><tr height=50 ng-repeat-start=\"product in cin.order.products track by $index\"><td>{{product.provider}}</td><td style=padding:5px ng-bind-html=cin.trustAsHtml(product.label)></td><td style=text-align:center>{{product.amount}}</td></tr><tr ng-repeat-end><td><md-icon md-svg-icon=barcode aria-hidden=true style=\"width:48px; height:48px\"></md-icon><md-button aria-label=\"show new product dialog\" class=\"md-icon-button md-primary\" ng-show=\"cin.order.products[$index].addOnType && cin.order.products[$index].addOnType===\'IP\'\" ng-click=cin.showAddonDialog(cin.order.products[$index].serialNos[0].serialNo) ng-disabled=\"cin.order.products[$index].serialNos.length === 0\"><md-icon md-svg-icon=phone aria-hidden=true style=\"width:24px; height:24px; color:blue\"></md-icon></md-button></td><td><md-chips ng-model=cin.order.products[$index].serialNos name=products_{{$index}} md-max-chips={{product.amount}} md-transform-chip=cin.transformChip($chip) md-add-on-blur=true md-on-remove=cin.removeChip() md-on-add=cin.addChip($chip) md-chip-append-delay=10><input type=text id=product_{{$parent.$index}} pindex={{$parent.$index}} style=font-size:24px ng-model=cin.productCodeBuffer[$parent.$index] readonly><md-chip-template><strong style=font-size:24px>{{$chip.serialNo}}</strong></md-chip-template></md-chips></td><td ng-show=\"$index === cin.order.products.length - 1\"><md-button aria-label=\"show new product dialog\" class=\"md-icon-button md-primary\" ng-click=cin.showNewProductDialog()><md-icon md-svg-icon=add aria-hidden=true style=\"width:36px; height:36px; color:blue\"></md-icon></md-button></td></tr></table><div ng-show=cin.displayRemark><md-checkbox ng-model=cin.urgent ng-change=\"cin.addRemark(\'urgent\')\" style=\"color:red; font-size:24px; margin:5px\" aria-label=Urgent>{{\'table.field.urgentOrder\' | translate}}</md-checkbox><md-button aria-label=\"delete all\" class=\"md-raised md-button md-accent\" ng-disabled=\"cin.hasPairing === false\" ng-click=cin.removeAll()>{{\'btn.cancelAllPairing\' | translate}}</md-button><span style=\"float:right; margin:5px 20px; font-weight:bold\">{{\'table.field.totalProduct\' | translate}}：{{cin.totalProduct}}</span></div><table style=width:100% ng-show=cin.displayRemark><tr height=120><td colspan=2>{{\'table.field.remark\' | translate}}：<textarea id=remark style=\"width:70%; height:70px\" ng-model=cin.order.remark read-only=false ng-disabled=!cin.displayRemark>\n          </textarea></td><!--\n        <td>\n          <md-button class=\"md-raised\" ng-click=\"cin.confirmOrder()\" ng-disabled=\"cin.isProcessing.confirmOrder === \'\' ? false : true\" \n            style=\"width:20%;height: 70px; background-color:yellowgreen\"><h1>{{\'btn.ok\' | translate}}</h1></md-button>\n        </td>\n        --></tr><tr><td colspan=2><md-button class=md-raised ng-click=cin.print() ng-disabled=\"cin.isProcessing.confirmOrder === \'\' ? false : true\" style=\"width:45%;height: 70px; background-color:orange\"><h1>{{\'Match & Print IMEI\' | translate}}</h1></md-button><md-button class=md-raised ng-click=cin.confirmOrder() ng-disabled=\"cin.isProcessing.confirmOrder === \'\' ? false : true\" style=\"width:45%;height: 70px; background-color:yellowgreen\"><h1>{{\'btn.ok\' | translate}}</h1></md-button></td></tr></table></div><page size=A4 class=print-content><!--\n    <div layout=\"column\" layout-align=\"center center\" style=\"width:100%;\">\n      <div layout=\"col-sm-4\" layout-align=\"center center\">\n        <img ng-src=\"{{cin.business.logo}}\" style=\"max-height:60px;\"></img>\n      </div>\n      <div layout=\"col-sm-6\" layout-align=\"center center\">\n        <h3>{{cin.business.name}}</h3>\n      <div>\n    </div>\n    --><div layout=row layout-align=\"center center\" style=width:100%><div style=margin-bottom:10px><table style=\"width:100%; table-layout:fixed\"><tr stytle=height:60px><td style=width:30%><img ng-src={{cin.business.logo}} style=max-height:80px></td><td style=\"vertical-align:bottom; text-align:left\"><h1>{{cin.business.name}}</h1></td></tr></table><div><table class=payment-table style=\"width:100%; table-layout:fixed\"><tr style=min-height:260px><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap; margin-bottom:20px\"><div style=\"width: 50%\"><h3>{{\'title.counter\' | translate}}：{{cin.counterName}}</h3></div><div style=\"width: 50%\"><h3>{{\'table.field.order\'|translate}}：{{cin.order.merchantOrderNo}}</h3></div><div style=\"width: 50%\"><h3>{{\'table.field.applicant.name\'|translate}}：{{cin.order.displayName}}</h3></div><div style=\"width: 50%\"><h3>{{\'table.field.applicant.phone\'|translate}}：{{cin.order.phoneNumber}}</h3></div><div ng-repeat=\"item in cin.order.infos track by $index\" style=\"width: 50%\"><h3>{{item.label}}{{item.value}}</h3></div></div><!--\n            <div>\n                <ul class=\"columns\" style=\"list-style-type: none; margin-top:0; padding-left: 0; columns: 2; -webkit-columns: 2; -moz-columns: 2;\">\n                    <li><h3>{{\'title.counter\' | translate}}：{{cin.counterName}}</h3></li>\n                    <li><h3>{{\'table.field.order\'|translate}}：{{cin.order.merchantOrderNo}}</h3></li>\n                    <li><h3>{{\'table.field.applicant.name\'|translate}}：{{cin.order.displayName}}</h3></li>\n                    <li><h3>{{\'table.field.applicant.phone\'|translate}}：{{cin.order.phoneNumber}}</h3></li>\n                    <li ng-repeat=\"item in cin.order.infos track by $index\"><h3>{{item.label}}{{item.value}}</h3></li>\n                </ul>\n            </div>\n            --></td></tr><tr style=height:60px><!--\n          <td style=\"text-align:center; width:10%\">\n            <span class=\"title-main\"><h3>#</h3> </span>\n          </td>\n          <td style=\"text-align:center; width:30% \">\n            <span class=\"title-main\" ><h3>{{\'table.field.vendor\' | translate}}</h3> </span>\n          </td>\n          \n          <td style=\"text-align:center; width:30% \">\n            <span class=\"title-main\" ><h3>{{\'Product Name\'|translate}}</h3> </span>\n          </td>\n          <td style=\"text-align:center; width:30%\">\n            <span class=\"title-main\" ><h3>{{\'table.field.mocheckout.productSN\'|translate}}</h3> </span>\n          </td>\n          --><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap\"><div style=\"width: 10%; height:60px; padding-left:5px\"><h3>#</h3></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"><h3>{{\'table.field.vendor\' | translate}}</h3></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"><h3>{{\'Product Name\'|translate}}</h3></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"><h3>{{\'Product Name\'|translate}}</h3></div></div></td></tr><tr ng-repeat=\"product in cin.order.products track by $index\" style=height:60px><!--\n          <td style= \"width:10%\"><h3>{{$index+1}}</h3></td>\n          <td style=\"padding:5px; width:30%\"><h3>{{product.provider}}</h3></td>\n          <td style=\"padding:5px; width:30%\"><h3>{{product.label}}</h3></td>\n          <td style=\"padding:5px; width:30%\"><h3>{{product.serialNos[0].serialNo}}</h3></td>\n          --><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap\"><div style=\"width: 10%; min-height:60px; padding-left:5px\"><h3>{{$index+1}}</h3></div><div style=\"width: 30%; min-height:60px; padding-left:5px; border-left: 1px solid black; word-break: break-word\"><h3>{{product.provider}}</h3></div><div style=\"width: 30%; min-height:60px; padding-left:5px; border-left: 1px solid black; word-break: break-word\"><h3>{{product.label}}</h3></div><div style=\"width: 30%; min-height:60px; padding-left:5px; border-left: 1px solid black; word-break: break-word\"><h3>{{product.serialNos[0].serialNo}}</h3></div></div></td></tr><tr ng-repeat=\"i in [1, 2, 3] track by $index\" style=height:70px><!--\n          <td style=\"width:10%\"><h3>{{cin.order.products.length + i}}</h3></td>\n          <td style=\"width:30%\"></td>\n          <td style=\"width:30%\"></td>\n          <td style=\"width:30%\"></td>\n          --><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap\"><div style=\"width: 10%;  height:60px; padding-left:5px\"><h3>{{cin.order.products.length + i}}</h3></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"></div><div style=\"width: 30%; height:60px; padding-left:5px; border-left: 1px solid black\"></div></div></td></tr><tr><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap\"><div style=\"width: 100%; height:80px\"><h3>{{\'Pick up signature\'|translate}}</h3></div></div></td></tr><tr><td><div style=\"display: flex; justify-content: space-between; flex-flow: row wrap\"><div style=\"width: 100%; height:80px\"><h3>{{\'Return signature\'|translate}}</h3></div></div></td></tr></table></div></div></div></page></div>");
$templateCache.put("app/main/mo.checkout.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-padding layout-align-gt-md=center layout-align=space-around ng-cloak class=font-mo><div flex=\"\" flex-sm=100 flex-gt-sm=45 layout-align=\" center\"><table keypress-events style=width:95%><tr height=40 style=background-color:lightblue class=md-headline><td colspan=2 style=\"color:red; text-align:center\"><strong>-- {{\'title.table.mocheckout\' | translate}} --</strong></td></tr><!--\n      <tr height=\"50\" ng-hide=\"cout.product.merchantOrderNo\">\n        <td>憑證條碼：</td>\n        <td style=\"text-align:center\">\n          <input id=\"barcodeMessage\" style=\"width: 220px;\" type=\"text\"\n            ng-disabled=\"true\"\n            ng-model=\"cout.product.barcodeMessage\"\n            readonly=\"true\">\n          </input>\n        </td>\n      </tr>\n      --><tr height=50><td>{{\'table.field.mocheckout.productSN\' | translate}}：</td><td ng-show=!cout.multipleProducts style=text-align:left><input id=productCode style=\"width: 220px; text-align:center\" type=text class=barcode-readonly ng-disabled=!cout.isRequired.productCode ng-model=cout.product.productSerialNo readonly></td><td ng-show=cout.multipleProducts style=text-align:left><md-input-container><md-select id=productCodes ng-model=cout.product ng-change=cout.showRemarkFormDialog() aria-label=\"product selection\" style=\"width: 220px\" required><md-optgroup><md-option ng-value=product ng-repeat=\"product in cout.products track by $index\">{{product.productSerialNo}}{{product.displayName ? \' - \' + product.displayName : \'\'}}</md-option></md-optgroup></md-select></md-input-container></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{cout.isProcessing.productCode}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=50 ng-hide=cout.product.merchantOrderNo><td>{{\'table.field.query\' | translate}}：</td><td style=text-align:left><input id=queryString style=\"width: 220px\" type=text class=phonenumber-readonly ng-disabled=!cout.isRequired.queryString ng-model=cout.queryString></td></tr><tr height=50><td>{{\'table.field.order\' | translate}}：</td><td style=\"color:blue; text-align:left\">{{cout.product.merchantOrderNo}}<md-icon ng-if=\"cout.product.merchantOrderNo === null\" md-svg-icon=error_circle aria-hidden=true style=\"width:48px; height:48px; color:red\"></md-icon></td></tr><tr height=50><td>{{\'table.field.applicant.phone\' | translate}}：</td><td style=\"color:blue; text-align:left\">{{cout.product.phoneNumber}}</td></tr><tr height=50><td>{{\'table.field.applicant.name\' | translate}}：</td><td style=color:blue;text-align:left>{{cout.product.displayName}}</td></tr><tr height=50 ng-repeat=\"item in cout.product.infos track by $index\"><td style=\"max-width:60px; word-wrap:break-word\">{{item.label}}</td><td align=left valign=left style=color:blue>{{item.value}}</td></tr><tr height=50 ng-show=cout.product.others><td>{{\'table.field.orderRemark\' | translate}}：</td><td style=text-align:left><div ng-bind-html=cout.getRemark(cout.product.others) style=\"text-align:left; vertical-align:left; min-width:220px; max-width:80%; max-height:100px; overflow:auto\"></div><!--\n          <textarea id=\"others\" readonly=\"true\" style=\"width: 220px;\"\n            ng-model=\"cout.product.others\">\n          </textarea>\n          --></td></tr><tr height=120><td colspan=2><div layout=row layout-align=\"center center\"><md-button class=md-raised ng-click=\"cout.changeFocus(\'queryString\')\" ng-disabled=\"cout.isProcessing.queryString !== \'\' || cout.isProcessing.productCode !== \'\' || cout.isProcessing.confirmProduct !== \'\'\" style=\"margin-left:0px;min-width:45%;height: 70px; background-color:orange\"><h1>{{\'btn.searchMode\' | translate}}</h1></md-button><md-button class=md-raised ng-click=\"cout.changeFocus(\'productCode\')\" ng-disabled=\"cout.isProcessing.queryString !== \'\' || cout.isProcessing.productCode !== \'\' || cout.isProcessing.confirmProduct !== \'\'\" style=\"float:right;margin-right:0px;min-width:45%;height: 70px; background-color:yellowgreen\"><h1>{{\'btn.scanMode\' | translate}}</h1></md-button><!--<md-progress-circular style=\"float:right\" md-diameter=\"50\" md-mode=\"{{cout.isProcessing.productCode + cout.isProcessing.queryString}}\"></md-progress-circular>--></div></td></tr></table></div><!-- order item --><div flex layout-align=\"top top\" data-fittext><table style=\"width:100%; padding:3p\"><tr height=40 class=md-headline style=background-color:lightblue><td colspan=2 align=center valign=center style=color:red><strong>-- {{\'title.table.productInfo\' | translate}} --</strong></td></tr><tr height=50 ng-show=cout.product.merchantOrderNo><td>{{\'table.field.vendor\' | translate}}：</td><td>{{cout.product.productProvider}}</td></tr><tr height=50 ng-show=cout.product.merchantOrderNo><td>{{\'table.field.product\' | translate}}：</td><td ng-bind-html=cout.trustAsHtml(cout.product.productLabel)></td></tr><tr height=50 ng-show=cout.product.merchantOrderNo><td>{{\'table.field.mocheckout.productSN\' | translate}}：</td><td>{{cout.product.productSerialNo}}</td></tr><tr height=50 ng-show=cout.product.merchantOrderNo><td>{{\'Status\' | translate}}：</td><td>{{cout.product.status}}</td><!--\n        <td>\n          <md-icon md-svg-icon=\"check_circle\" aria-hidden=\"true\"\n              style=\"width:36px; height:36px; color:blue\"\n              ng-if=\"cout.product.status === \'READY\'\"></md-icon>\n          <md-icon md-svg-icon=\"airplane_active\" aria-hidden=\"true\"\n              style=\"width:36px; height:36px; color:orange\"\n              ng-if=\"cout.product.status === \'PICKUP\'\"></md-icon>\n          <md-icon md-svg-icon=\"check_circle\" aria-hidden=\"true\"\n              style=\"width:36px; height:36px; color:green\"\n              ng-if=\"cout.product.status === \'RETURN\' || cout.product.status === \'RETUN_OVERDUE\'\"></md-icon>\n          <md-icon md-svg-icon=\"error_circle\" aria-hidden=\"true\"\n              style=\"width:36px; height:36px; color:red\"\n              ng-if=\"cout.product.status === \'DAMAGE\'\"></md-icon>\n        </td>\n        --></tr><tr height=120 ng-show=cout.product.merchantOrderNo><td>{{\'Product status\' | translate}}：</td><td><div ng-bind-html=cout.getRemark(cout.product.remark) style=\"text-align:left; vertical-align:center; min-width:220px; max-width:75%; max-height:100px; overflow:auto\"></div><!--\n          <textarea id=\"remarkForm\" style=\"width:90%; height:120px\"\n            ng-model=\"cout.product.remark\" readonly=\"true\">\n          </textarea>\n          --></td></tr><tr height=50 ng-show=cout.product.merchantOrderNo><td>{{\'table.field.lastUpdate\' | translate}}：</td><td>{{cout.product.checkoutSubscriberId}}</td></tr><tr height=120 ng-show=cout.product.merchantOrderNo><td colspan=2 align=right><!--<md-button class=\"md-raised\" ng-disabled=\"cout.product.status === \'READY\'\"\n              ng-click=\"cout.confirmDamageProduct()\" style=\"width:40%;height: 70px; background-color:red\"><h1>損壞出單</h1></md-button>\n              --><div flex=80 layout=row layout-align=space-around><md-button class=\"md-raised md-warn\" ng-disabled=\"!cout.product.status || cout.isProcessing.confirmProduct !== \'\'\" ng-click=cout.showProductStatus() style=\"min-width:40%;height: 70px\"><h1>{{\'btn.product.status\' | translate}}</h1></md-button><md-button class=md-raised ng-disabled=\"!cout.product.status || cout.isProcessing.confirmProduct !== \'\'\" ng-click=cout.confirmProduct() style=\"width:30%;height: 70px; background-color:yellowgreen\"><h1>{{\'btn.ok\' | translate}}</h1></md-button><!--<md-progress-circular md-mode=\"{{cout.isProcessing.confirmProduct}}\" md-diameter=\"70\"></md-progress-circular>--></div></td></tr></table></div></div>");
$templateCache.put("app/main/mo.create.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=row layout-padding layout-align-gt-md=\"center center\" class=font-mo ng-cloak><div layout=column><br><input type=file nv-file-select multiple uploader=mo.uploader><br><span><strong>{{\'title.mocreate.upload\' | translate}}</strong></span><table class=table style=width:95vw><thead><tr style=background-color:lightblue><th>{{\'Filename\' | translate}}</th><th ng-show=mo.uploader.isHTML5>{{\'Filesize\' | translate}}</th><th ng-show=mo.uploader.isHTML5>{{\'Upload progress\' | translate}}</th><th>{{\'Status\' | translate}}</th><th style=text-align:center>{{\'Action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in mo.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"mo.uploader.isHTML5 && item.file.size/1024/1024 > 1\" nowrap>{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"mo.uploader.isHTML5 && item.file.size/1024/1024 < 1\" nowrap>{{ item.file.size/1024|number:2 }} KB</td><td ng-show=mo.uploader.isHTML5 style=vertical-align:middle><md-progress-linear md-mode=determinate value={{item.progress}}></md-progress-linear></td><td class=text-center><span ng-show=item.isSuccess><md-icon md-svg-icon=check_circle style=color:green;width:36px;height:36px></md-icon></span><span ng-show=item.isCancel><md-icon md-svg-icon=cancel style=color:orange;width:36px;height:36px></md-icon></span><span ng-show=item.isError><md-icon md-svg-icon=error_circle style=color:red;width:36px;height:36px></md-icon></span></td><td nowrap><md-button class=\"md-primary md-raised\" style=font-size:24px ng-click=mo.uploadFile(item) ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><md-icon md-svg-icon=upload_file style=width:24px;height:24px></md-icon>{{\'btn.upload\' | translate}}</md-button><md-button class=\"md-warn md-raised\" style=font-size:24px ng-click=item.cancel() ng-disabled=!item.isUploading><md-icon md-svg-icon=cancel style=width:24px;height:24px></md-icon>{{\'btn.cancel\' | translate}}</md-button><md-button class=\"md-accent md-raised\" style=font-size:24px ng-click=item.remove()><md-icon md-svg-icon=close style=width:24px;height:24px></md-icon>{{\'btn.remove\' | translate}}</md-button></td></tr></tbody></table><div ng-show=\"mo.errorItems.length > 0\"><hr><span><strong>{{\'title.mocreate.error\' | translate}}</strong></span><table class=table style=width:95vw><thead><tr style=background-color:lightcoral><th width=40%>Name</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in mo.errorItems\"><td><strong>{{ item.name }}</strong></td><td><span>{{ item.message }}</span></td><td class=text-center><md-button class=md-raised style=\"font-size:24px; height:70px\" ng-click=mo.removeErrorItem($index)><md-icon md-svg-icon=close style=width:24px;height:24px></md-icon>{{\'btn.remove\' | translate}}</md-button></td></tr></tbody></table></div><br><md-button style=\"width:20vw;font-size:24px; height:70px\" class=\"md-raised md-primary\" aria-label=\"Download example csv file\" ng-click=mo.getTemplate()><md-icon md-svg-icon=download_file></md-icon>{{\'Download example\' | translate }}</md-button></div></div>");
$templateCache.put("app/main/mo.order.html","<div flex layout=row layout-padding layout-align-gt-md=center layout-align=\"center center\" ng-cloak class=font-mo><div flex layout=column layout-align=\"center center\" style=width:100%><div flex layout=row class=no-print layout-margin layout-align=\"center center\" style=min-width:100%><span flex>{{\'table.field.quantity.order\' | translate}}：{{orders.tableData.length | number}}</span><md-select aria-label=\"Current page size\" ng-model=orders.selectedPageSize md-on-close=orders.changePageSize()><md-optgroup label=\"Page Size\"><md-option ng-repeat=\"size in orders.availablePageSizes\" ng-value=size>{{size}}</md-option></md-optgroup></md-select><md-button class=md-primary aria-label=refresh ng-click=orders.getOrders() style=float:right ng-disabled=\"orders.isProcessing === true\"><md-icon md-svg-icon=refresh style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.refresh\' | translate}}</span></md-button></div><div class=no-print layout-padding layout-margin style=width:100%><table ng-table=orders.tableParams class=\"table table-condensed table-bordered table-striped\" style=width:100%><tbody><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td data-title=\"\'#\'\"><span ng-bind-html=orders.getIndex($index)></span></td><td data-title=\"\'table.field.applicant.name\' | translate\" sortable>{{item.displayName}}</td><td data-title=\"\'table.field.order\' | translate\" sortable>{{item.merchantOrderNo}}</td><td data-title=\"\'table.field.applicant.phone\' | translate\" sortable>{{item.phoneNumber}}</td><td data-title=\"\'table.field.status\' | translate\" sortable>{{item.status}}</td><td data-title=\"\'table.field.paymentType\' | translate\" sortable>{{item.payment}}</td><!--\n            <td data-title=\"\'訂購產品\'\" sortable=\"\'campaignName\'\">{{item.campaignName }}</td>\n            \n            <td data-title=\"\'領機時間\'\" sortable=\"\'departureDate\'\">{{item.departureDate }}</td>\n            --><td data-title=\"\'table.field.action\' | translate\" style=text-align:center><md-button class=\"md-raised md-primary\" aria-label=print ng-click=orders.print(item)>{{\'btn.print.invoice\' | translate}}</md-button><md-button class=\"md-raised md-accent\" aria-label=shipping ng-disabled=!item.showConfirmButton ng-click=orders.confirmPayment(item.merchantOrderNo)>{{\'btn.shipments\' | translate}}</md-button></td></tr></tbody></table><!--<md-progress-linear md-mode=\"indeterminate\" ng-if=\"report.isProcessing === true\"></md-progress-linear>--></div><page size=A4 class=print-content style=\"top: -110px; transform: scale(0.9, 0.8)\"><div layout=column layout-align=\"center center\" style=width:100%><table cstyle=\"width:100%; table-layout:fixed;\"><tr><td style=width:30%><img ng-src={{orders.selectedOrder.logo}} style=max-height:60px></td><td style=\"width:40%; vertical-align:center; text-align:center\"><h4 class=title-main>無線網路分享器租借說明</h4><span class=title-sub style=margin-top:0px>Wifi Router Rental Details</span></td><td style=\"width:30%; vertical-align:bottom\"><h5 flex class=title-main>編號 No.：{{orders.selectedOrder.merchantOrderNo}}</h5></td></tr></table><!--\n          <div layout-margin style=\"display:table; width:100%;\">            \n            <div layout-aling=\"center center\" style=\"display:table-cell; text-align:center;\">\n              <img ng-src=\"{{orders.selectedOrder.logo}}\" \n                style=\"display:table-cell; float:left; max-height:60px;\"></img>\n              <div>\n                <h4 class=\"title-main\">無線網路分享器租借說明</h4>\n                <span class=\"title-sub\" style=\"margin-top:0px\">Wifi Router Rental Details</span>\n              </div>\n            </div>\n          </div>\n          <h5 flex class=\"title-main\" style=\"display:block; text-align:right; margin-left:60%;\">\n             編號 No.：{{orders.selectedOrder.merchantOrderNo}}\n          </h5>\n          --><table class=payment-table style=\"width:100%; table-layout:fixed; height:13cm\"><tr><th style=text-align:center><span class=title-main>付款日</span> <span class=title-sub>Date</span></th><th colspan=2 style=text-align:center><span class=title-main>姓名</span> <span class=title-sub>Name</span></th><th colspan=2 style=text-align:center><span class=title-main>電話</span> <span class=title-sub>Phone No.</span></th><th colspan=4 style=text-align:center><span class=title-main>電子信箱</span> <span class=title-sub>Email</span></th></tr><tr><td>{{orders.selectedOrder.paymentTime}}</td><td colspan=2>{{orders.selectedOrder.displayName}}</td><td colspan=2>{{orders.selectedOrder.phoneNumber}}</td><td colspan=4><span ng-if=orders.selectedOrder.email>{{orders.selectedOrder.email}}</span> <span ng-if=!orders.selectedOrder.email>___________ @ ______________________</span></td></tr><tr><td style=text-align:center><span class=title-main>押金</span> <span class=title-sub>Deposit</span></td><td colspan=4><span ng-if=orders.selectedOrder.deposit>{{orders.selectedOrder.deposit}} </span><!--\n                <div style=\"display: table-cell; padding:10px\"\n                  ng-if=\"orders.selectedOrder.deposit2\"\n                  ng-repeat=\"item in orders.selectedOrder.deposit2\">\n                  <md-checkbox ng-checked=\"item.checked\">{{item.label}}</md-checkbox>\n                </div>  \n                --></td><td colspan=4 rowspan=2><span ng-if=!orders.selectedOrder.invoiceType2>{{orders.selectedOrder.invoiceType}}</span><div layout=column ng-if=orders.selectedOrder.invoiceType2 ng-repeat=\"item in orders.selectedOrder.invoiceType2\"><md-checkbox ng-checked=item.checked>{{item.label}}</md-checkbox></div><div layout=column ng-if=\"!orders.selectedOrder || \n                  (!orders.selectedOrder.invoiceType2 && !orders.selectedOrder.invoiceType)\"><md-checkbox>電子發票 <span>E-invoice</span></md-checkbox><md-checkbox>發票捐贈 <span>Donate Invoice</span></md-checkbox></div></td></tr><tr><td style=text-align:center><span class=title-main>付款</span> <span class=title-sub>Payment</span></td><td colspan=4><span ng-if=!orders.selectedOrder.paymentType2>{{orders.selectedOrder.paymentType}}</span><div ng-if=orders.selectedOrder.paymentType2 style=\"display: table-cell; padding:10px\" ng-repeat=\"item in orders.selectedOrder.paymentType2\"><md-checkbox ng-checked=item.checked>{{item.label}}</md-checkbox></div><div ng-if=!orders.selectedOrder><md-checkbox>刷卡 Credit Card $_______(____台Qty*____天Day)</md-checkbox><br><md-checkbox>現金 Cash $________(____台Qty*____天Day)</md-checkbox></div></td></tr><tr><td colspan=5 style=text-align:center><span class=title-main>航班資訊</span> <span class=title-sub>Flight Schedule</span></td><td colspan=2 rowspan=4 style=vertical-align:top><span class=title-main>設備編號</span> <span class=title-sub>Router No.</span><div ng-if=orders.selectedOrder.serialNos ng-repeat=\"item in orders.selectedOrder.serialNos\"><span>{{item}}</span></div></td><td colspan=2 rowspan=4 style=vertical-align:top><span class=title-main>租用人簽名</span> <span class=title-sub>Applicant\'s Signuature</span></td></tr><tr><td></td><td style=text-align:center><span class=title-main>日期</span> <span class=title-sub>Date</span></td><td style=text-align:center><span class=title-main>航班</span> <span class=title-sub>Flight</span></td><td style=text-align:center><span class=title-main>時間</span> <span class=title-sub>Time</span></td><td style=text-align:center><span class=title-main>航廈</span> <span class=title-sub>Terminal</span></td></tr><tr><td style=text-align:center><span class=title-main>領機</span> <span class=title-sub>Pick-up</span></td><td>{{orders.selectedOrder.departureDate}}</td><td>{{orders.selectedOrder.departureFlightNo}}</td><td>{{orders.selectedOrder.departureTime}}</td><td>{{orders.selectedOrder.pickupMethod}}</td></tr><tr><td style=text-align:center><span class=title-main>還機</span> <span class=title-sub>Return</span></td><td>{{orders.selectedOrder.arrivalDate}}</td><td>{{orders.selectedOrder.arrivalFlightNo}}</td><td>{{orders.selectedOrder.arrivalTime}}</td><td>{{orders.selectedOrder.returnMethod}}</td></tr><tr><td style=text-align:center><span class=title-main>備註</span> <span class=title-sub>Note</span></td><td colspan=8><div layout=row layout-align=space-between><div flex=30 layout=column><span>統編：{{orders.selectedOrder.buyerUBN}}</span> <span>抬頭：{{orders.selectedOrder.buyerName}}</span></div><div flex=70>{{orders.selectedOrder.comment}}</div></div></td></tr><tr><td colspan=9><span class=title-main>&#167;本服務係由寶島數碼股份有限公司所提供，並依中華民國稅法規定開立發票。</span> <span class=title-sub style=color:red>&nbsp;This service is provided by Digital Taiwan Co., LTD. The receipt will be issued after the rental device is returned.</span></td></tr></table><table layout=column style=min-width:100%><tr><td><span class=title-sub style=\"float:left; width:200px\">第一聯：財務部</span></td><td rowspan=2><span class=title-sub style=\"float:left; width:200px\">財務部：</span> <span class=title-sub style=float:left>接待員：</span></td></tr><tr><td><span class=title-sub style=float:left>第二聯：租用人</span></td></tr></table></div><!-- 第二聯 --><br><br><hr style=\"border-top: dotted 3px\"><div layout=column layout-align=\"center center\" style=width:100%><!--\n          <h4 class=\"title-main\">無線網路分享器租借說明</h4>\n          <span class=\"title-sub\" style=\"margin-top:0px\">Wifi Router Rental Details</span>\n          <h5 flex class=\"title-main\" style=\"display:block; text-align:right; margin-left:60%;\">\n            編號 No.：{{orders.selectedOrder.merchantOrderNo}}\n          </h5>\n          --><table cstyle=\"width:100%; table-layout:fixed;\"><tr><td style=width:30%><img ng-src={{orders.selectedOrder.logo}} style=max-height:60px></td><td style=\"width:40%; vertical-align:center; text-align:center\"><h4 class=title-main>無線網路分享器租借說明</h4><span class=title-sub style=margin-top:0px>Wifi Router Rental Details</span></td><td style=\"width:30%; vertical-align:bottom\"><h5 flex class=title-main>編號 No.：{{orders.selectedOrder.merchantOrderNo}}</h5></td></tr></table><table class=payment-table style=\"width:100%;table-layout:fixed; height:13cm\"><tr><th style=text-align:center><span class=title-main>付款日</span> <span class=title-sub>Date</span></th><th colspan=2 style=text-align:center><span class=title-main>姓名</span> <span class=title-sub>Name</span></th><th colspan=2 style=text-align:center><span class=title-main>電話</span> <span class=title-sub>Phone No.</span></th><th colspan=4 style=text-align:center><span class=title-main>電子信箱</span> <span class=title-sub>Email</span></th></tr><tr><td>{{orders.selectedOrder.paymentTime}}</td><td colspan=2>{{orders.selectedOrder.displayName}}</td><td colspan=2>{{orders.selectedOrder.phoneNumber}}</td><td colspan=4><span ng-if=orders.selectedOrder.email>{{orders.selectedOrder.email}}</span> <span ng-if=!orders.selectedOrder.email>___________ @ ______________________</span></td></tr><tr><td style=text-align:center><span class=title-main>押金</span> <span class=title-sub>Deposit</span></td><td colspan=4><span ng-if=orders.selectedOrder.deposit>{{orders.selectedOrder.deposit}} </span><!--\n                <div style=\"display: table-cell; padding:10px\"\n                  ng-if=\"orders.selectedOrder.deposit2\"\n                  ng-repeat=\"item in orders.selectedOrder.deposit2\">\n                  <md-checkbox ng-checked=\"item.checked\">{{item.label}}</md-checkbox>\n                </div>  \n                --></td><td colspan=4 rowspan=2><span ng-if=!orders.selectedOrder.invoiceType2>{{orders.selectedOrder.invoiceType}}</span><div layout=column ng-if=orders.selectedOrder.invoiceType2 ng-repeat=\"item in orders.selectedOrder.invoiceType2\"><md-checkbox ng-checked=item.checked>{{item.label}}</md-checkbox></div><div layout=column ng-if=\"!orders.selectedOrder || \n                  (!orders.selectedOrder.invoiceType2 && !orders.selectedOrder.invoiceType)\"><md-checkbox>電子發票 <span>E-invoice</span></md-checkbox><md-checkbox>發票捐贈 <span>Donate Invoice</span></md-checkbox></div></td></tr><tr><td style=text-align:center><span class=title-main>付款</span> <span class=title-sub>Payment</span></td><td colspan=4><span ng-if=!orders.selectedOrder.paymentType2>{{orders.selectedOrder.paymentType}}</span><div ng-if=orders.selectedOrder.paymentType2 style=\"display: table-cell; padding:10px\" ng-repeat=\"item in orders.selectedOrder.paymentType2\"><md-checkbox ng-checked=item.checked>{{item.label}}</md-checkbox></div><div ng-if=!orders.selectedOrder><md-checkbox>刷卡 Credit Card $_______(____台Qty*____天Day)</md-checkbox><br><md-checkbox>現金 Cash $________(____台Qty*____天Day)</md-checkbox></div></td></tr><tr><td colspan=5 style=text-align:center><span class=title-main>航班資訊</span> <span class=title-sub>Flight Schedule</span></td><td colspan=2 rowspan=4 style=vertical-align:top><span class=title-main>設備編號</span> <span class=title-sub>Router No.</span><div ng-if=orders.selectedOrder.serialNos ng-repeat=\"item in orders.selectedOrder.serialNos\"><span>{{item}}</span></div></td><td colspan=2 rowspan=4 style=vertical-align:top><span class=title-main>租用人簽名</span> <span class=title-sub>Applicant\'s Signuature</span></td></tr><tr><td></td><td style=text-align:center><span class=title-main>日期</span> <span class=title-sub>Date</span></td><td style=text-align:center><span class=title-main>航班</span> <span class=title-sub>Flight</span></td><td style=text-align:center><span class=title-main>時間</span> <span class=title-sub>Time</span></td><td style=text-align:center><span class=title-main>航廈</span> <span class=title-sub>Terminal</span></td></tr><tr><td style=text-align:center><span class=title-main>領機</span> <span class=title-sub>Pick-up</span></td><td>{{orders.selectedOrder.departureDate}}</td><td>{{orders.selectedOrder.departureFlightNo}}</td><td>{{orders.selectedOrder.departureTime}}</td><td>{{orders.selectedOrder.pickupMethod}}</td></tr><tr><td style=text-align:center><span class=title-main>還機</span> <span class=title-sub>Return</span></td><td>{{orders.selectedOrder.arrivalDate}}</td><td>{{orders.selectedOrder.arrivalFlightNo}}</td><td>{{orders.selectedOrder.arrivalTime}}</td><td>{{orders.selectedOrder.returnMethod}}</td></tr><tr><td style=text-align:center><span class=title-main>備註</span> <span class=title-sub>Note</span></td><td colspan=8><div layout=row layout-align=space-between><div flex=30 layout=column><span>統編：{{orders.selectedOrder.buyerUBN}}</span> <span>抬頭：{{orders.selectedOrder.buyerName}}</span></div><div flex=70>{{orders.selectedOrder.comment}}</div></div></td></tr><tr><td colspan=9><span class=title-main>&#167;本服務係由寶島數碼股份有限公司所提供，並依中華民國稅法規定開立發票。</span> <span class=title-sub style=color:red>&nbsp;This service is provided by Digital Taiwan Co., LTD. The receipt will be issued after the rental device is returned.</span></td></tr></table><table layout=column style=min-width:100%><tr><td><span class=title-sub style=\"float:left; width:200px\">第一聯：財務部</span></td><td rowspan=2><span class=title-sub style=\"float:left; width:200px\">財務部：</span> <span class=title-sub style=float:left>接待員：</span></td></tr><tr><td><span class=title-sub style=float:left>第二聯：租用人</span></td></tr></table></div></page></div></div>");
$templateCache.put("app/main/mo.report.html","<div flex layout=row layout-padding layout-align-gt-md=center layout-align=\"center center\" ng-cloak class=font-mo><div flex layout=column layout-align=\"center center\" style=width:100%><md-content flex=100 style=top:0><md-tabs id=dashboard md-selected=report.selectedIndex md-dynamic-height md-align-tabs=top md-center-tabs=true md-no-pagination=true md-stretch-tabs=always md-tab-mouse-event ng-model=isTabChanged><!--\n            <md-tab id=\"stockinTab\" ng-click=\"report.onTabChanges(0)\">\n                <md-tab-label><span style=\"font-size:26px\">進</span></md-tab-label>\n            </md-tab>\n            --><md-tab id=pickupTab ng-click=report.onTabChanges(0)><md-tab-label><span style=font-size:26px>{{\'table.field.pickup\' | translate}}</span></md-tab-label></md-tab><md-tab id=returnTab ng-click=report.onTabChanges(1)><md-tab-label><span style=font-size:26px>{{\'table.field.return\' | translate}}</span></md-tab-label></md-tab><md-tab id=stockTab ng-click=report.onTabChanges(2)><md-tab-label><span style=font-size:26px>{{\'table.field.stock\' | translate}}</span></md-tab-label></md-tab></md-tabs></md-content><div flex layout=row layout-margin layout-align=\"center center\" style=min-width:100%><!--\n       <md-button class=\"md-primary\" aria-label=\"Download template\"\n         style=\"float:left\"\n         href=\"https://s3-us-west-2.amazonaws.com/iiot-temp/compare-sn-example.xlsx\"\n         ng-if=\"report.selectedIndex===3\">\n         <md-icon md-svg-icon=\"download_file\" style=\"width:48px; height:48px; margin-top:2px\"></md-icon>\n         <span style=\"font-size:24px\">範例下載</span>\n       </md-button>\n      --> <span ng-if=\"report.selectedIndex===0\" style=float:left>{{\'msg.report.today.received\' | translate}}： <a ng-click=\"report.getDetail(\'today-pickup\', null)\"><strong>{{report.todayPickup.pickup}}</strong></a> &nbsp;&nbsp; {{\'msg.report.today.change\' | translate}}： <a ng-click=\"report.getDetail(\'today-agency\', null)\"><strong>{{report.todayPickup.agency}}</strong></a> </span><span flex></span><md-select aria-label=\"Current page size\" ng-model=report.selectedPageSize md-on-close=report.changePageSize()><md-optgroup label=\"Page Size\"><md-option ng-repeat=\"size in report.availablePageSizes\" ng-value=size>{{size}}</md-option></md-optgroup></md-select><md-button class=md-primary aria-label=refresh ng-click=report.getDashBoard() style=float:right ng-disabled=\"report.isProcessing === true\"><md-icon md-svg-icon=refresh style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.refresh\' | translate}}</span></md-button></div><div layout-padding layout-margin style=width:100%><table ng-table=report.tableParams class=\"table table-condensed table-bordered table-striped\" style=width:100%><tbody><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td data-title=\"\'#\'\"><span ng-bind-html=report.getIndex($index)></span></td><td data-title=\"\'table.field.supplier\' | translate\" sortable filter=\"{supplier: \'select\'}\" filter-data=\"report.getFilterDataAsync(\'supplier\')\">{{item.supplier}}</td><td data-title=\"\'table.field.product\' | translate\" sortable filter=\"{product: \'select\'}\" ng-if=\"report.selectedIndex===2\" filter-data=\"report.getFilterDataAsync(\'product\')\" ng-bind-html=report.trustAsHtml(item.product)></td><td data-title=\"\'table.field.departure.time\' | translate\" sortable ng-if=\"report.selectedIndex===0\">{{item.departureDate}}</td><!--\n            <td data-title=\"\'數量\'\" sortable=\"\'stockin\'\"  style=\"text-align:center\" ng-if=\"report.selectedIndex===0\">\n              <a ng-click=\"report.getDetail(\'stockin\', item)\">{{item.stockin}}</a>\n            </td>\n            --><td data-title=\"\'table.field.expected\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===0\"><a ng-click=\"report.getDetail(\'reservation\', item)\">{{item.reservation}}</a></td><td data-title=\"\'table.field.pending\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===0\"><a ng-click=\"report.getDetail(\'ready\', item)\">{{item.ready}}</a></td><td data-title=\"\'table.field.received\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===0\"><a ng-click=\"report.getDetail(\'pickup\', item)\">{{item.pickup}}</a></td><!--\n            <td data-title=\"\'其它\'\" sortable=\"\'other\'\"  style=\"text-align:center\" ng-if=\"report.selectedIndex===0\">\n              <a ng-click=\"report.getDetail(\'other\', item)\">{{item.other}}</a>\n            </td>\n            --><!--\n            <td data-title=\"\'換航廈\'\" sortable=\"\'agency\'\"  style=\"text-align:center\" ng-if=\"report.selectedIndex===0\">\n              <a ng-click=\"report.getDetail(\'agency\', item)\">{{item.agency}}</a>\n            </td>\n            --><td data-title=\"\'table.field.return.total\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===1\"><a ng-click=\"report.getDetail(\'return\', item)\">{{item.return}}</a></td><td data-title=\"\'table.field.return.abnormal\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===1\"><a ng-click=\"report.getDetail(\'norecord\', item)\">{{item.norecord}}</a></td><td data-title=\"\'table.field.stockout\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===1\"><a ng-click=\"report.getDetail(\'stockout\', item)\">{{item.stockout}}</a></td><td data-title=\"\'table.field.quantity\' | translate\" sortable style=text-align:center ng-if=\"report.selectedIndex===2\"><a ng-click=\"report.getDetail(\'stock\', item)\">{{item.stock}}</a></td><!--\n            <td data-title=\"\'異常分析\'\" sortable=\"\'stock\'\"  style=\"text-align:center\" ng-if=\"report.selectedIndex===2\">\n                <md-button class=\"md-raised md-primary\" aria-label=\"Upload\"\n                  ng-click=\"report.showCompareDialog(item.supplier, item.product)\">\n                  <span style=\"font-size:24px\">異常分析</span>\n                </md-button>\n              </div>\n            </td>\n            --></tr></tbody></table><!--<md-progress-linear md-mode=\"indeterminate\" ng-if=\"report.isProcessing === true\"></md-progress-linear>--></div></div></div>");
$templateCache.put("app/main/mo.stockin.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=row layout-padding layout-align-gt-md=center layout-align=\"space-around center\" ng-cloaks class=font-mo><div flex layout=column><fieldset><legend style=\"color:darkblue; font-weight:bold; font-size:26px\">{{\'title.mostockin\' | translate}}</legend><div flex=100 layout=row layout-align=\"none center\"><form name=productForm layout-margin style=width:100%><div layout=row flex=100 layout-align=\"space-around center\"><label flex=65>{{\'table.field.productType\' | translate}}：<md-input-container><md-select ng-model=stock.selectedProduct md-on-close=stock.changeProduct() aria-label=\"product type selection\" style=\"min-width: 350px; font-size:30px\" autofocus><md-option id=productSelector ng-value=item ng-repeat=\"item in stock.products track by $index\">{{item.supplier}} - {{item.product}}</md-option></md-select></md-input-container></label><label flex=35>{{\'table.field.quantity\' | translate}}：<md-input-container><input type=number select-on-click ng-model=stock.qty aria-label=\"product quantity\" ng-change=stock.changeQty() style=\"text-align:center; width:100px; font-size:30px\" required></md-input-container></label></div><div layout=row layout-align=\"space-between center\"><div flex=50><label>{{\'msg.mostockin.scan.quantity\' | translate}}</label><span style=\"min-width:50px; text-align:center; font-size:28px; font-weight:bold;\n              px; font-weight:bold;\n                padding: 5px; background-color:crimson; color:white; border-radius:5px\">{{stock.productSerialNos.length || 0}}</span><tags-input ng-model=stock.productSerialNos name=productSerialNos class=ti-input-lg text=productSN ng-class=\"{\'has-tags\': stock.qty>0 && stock.productSerialNos.length === stock.qty }\" placeholder=\"{{\'msg.mostockin.scan\' | translate}}\" min-length=1 max-tags={{stock.qty}} on-tag-adding=stock.tagToUpperCase($tag) on-tag-added=stock.checkTag($tag) on-invalid-tag=\"productSN=null\" style=font-size:30px></tags-input><p style=\"color: #dd2c00; margin-top: 10px\" ng-if=\"stock.qty>0 && stock.productSerialNos.length === stock.qty\">{{\'msg.mostockin.scan.max\' | translate}}</p></div><span flex></span><div flex=45><label>{{\'msg.mostockin.import\' | translate}}</label><label class=\"md-button md-warn md-raised\" style=\"font-size:26px; \n                  vertical-align:bottom; right:5px\" ng-disabled=stock.isProcessing>{{\'Select file\' | translate}} <input type=file nv-file-select uploader=stock.uploader ng-hide=true ng-click=stock.uploader.clearQueue() multiple></label><div style=min-height:40px><table class=table><tbody><tr ng-repeat=\"item in stock.uploader.queue\"><td ng-if=\"stock.uploader.queue.length === 0\" translate>No file is selected</td><td style=vertical-align:bottom ng-if=\"stock.uploader.queue.length > 0\">{{ item.file.name }}</td><td nowrap><md-button class=\"md-primary md-raised\" style=font-size:24px ng-click=stock.uploadFile(item) ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><md-icon md-svg-icon=upload_file style=width:24px;height:24px></md-icon>{{\'btn.upload\' | translate}}</md-button></td></tr></tbody></table></div></div></div><!--\n          <div>\n            <label> 已掃瞄設備數量</label>\n            <span style=\"min-width:50px; text-align:center; font-size:28px; font-weight:bold;\n            px; font-weight:bold;\n              padding: 5px; background-color:crimson; color:white; border-radius:5px\"> {{stock.productSerialNos.length || 0}}</span>\n            <tags-input ng-model=\"stock.productSerialNos\"\n              name=\"productSerialNos\"\n              class=\"ti-input-lg\"\n              text=\"productSN\"\n              ng-class=\"{\'has-tags\': stock.qty>0 && stock.productSerialNos.length === stock.qty }\"\n              placeholder=\"請掃瞄商品\"\n              min-length=\"1\"\n              max-tags=\"{{stock.qty}}\"\n              on-tag-adding=\"stock.tagToUpperCase($tag)\"\n              on-tag-added=\"stock.checkTag($tag)\"\n              on-invalid-tag=\"productSN=null\"\n              style=\"font-size:30px\"\n            >\n            </tags-input>\n            <p style=\"color: #dd2c00; margin-top: 10px;\"\n              ng-if=\"stock.qty>0 && stock.productSerialNos.length === stock.qty\">\n              掃瞄設備數量已達上限</p>\n          </div>\n          --></form></div></fieldset><div flex=100 layout=row layout-align=center style=\"max-height:65px; top:0px\"><md-button class=md-warn aria-label=stockout ng-click=stock.updateStockIn() style=float:left ng-disabled=\"stock.productSerialNos.length === 0 ||\n          stock.productSerialNos.length !== stock.qty ||\n          stock.isProcessing === true \"><md-icon md-svg-icon=stockout style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.stockin\' | translate}}</span></md-button><span flex></span><md-button class=md-primary aria-label=refresh ng-click=stock.getStockInHistory() style=float:left ng-disabled=\"stock.isProcessing === true \"><md-icon md-svg-icon=refresh style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.refresh\' | translate}}</span></md-button></div><!--<md-progress-linear md-mode=\"indeterminate\" ng-if=\"stock.isProcessing === true\"></md-progress-linear>--><div ng-show=\"stock.stocks.length >0 \"><fieldset><legend style=\"color:darkblue; font-weight:bold; font-size:26px\">{{\'msg.mostockin.history\' | translate}}</legend><table ng-table=stock.tableParams class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td data-title=\"\'#\'\">{{$index + 1}}</td><td data-title=\"\'table.field.vendor\' | translate\" sortable filter=\"{\'supplier\': \'select\'}\" filter-data=\"stock.getFilterDataAsync(\'supplier\')\">{{item.supplier}}</td><td data-title=\"\'table.field.productCategory\' | translate\" sortable filter=\"{\'type\': \'select\'}\" filter-data=\"stock.getFilterDataAsync(\'type\')\">{{item.type}}</td><td data-title=\"\'table.field.operator\' | translate\" sortable filter=\"{\'operator\': \'select\'}\" filter-data=\"stock.getFilterDataAsync(\'operator\')\">{{item.operator}}</td><td data-title=\"\'table.field.quantity\' | translate\" sortable style=text-align:center>{{item.count}}</td><td data-title=\"\'table.field.lastUpdate\' | translate\" sortable>{{item.updatedTs * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td data-title=\"\'\'\"><div layout=row layout-align=\"space-around center\"><md-button aria-label=delete class=\"md-raised md-accent\" style=\"font-size:26px; height:50px\" ng-disabled=\"stock.isProcessing === true \" ng-click=stock.showHistoryByBatchId(item.batchId)>{{\'btn.detail\' | translate}}</md-button></div></td></tr></table><!--\n        <table ng-table=\"stock.tableParams\" class=\"table table-condensed table-bordered table-striped\"  style=\"min-width:60%\">\n\n         <tr ng-repeat=\"item in $data\"  ng-class-even=\"\'even\'\" >\n            <td data-title=\"\'#\'\" >{{$index + 1}}</td>\n            <td data-title=\"\'廠商\'\" sortable=\"\'supplier\'\" filter=\"{\'supplier\': \'select\'}\"\n              filter-data=\"stock.getFilterDataAsync(\'supplier\')\" >\n               {{item.supplier}}</td>\n            <td data-title=\"\'產品品項\'\" sortable=\"\'product\'\" filter=\"{\'product\': \'select\'}\"\n              filter-data=\"stock.getFilterDataAsync(\'product\')\" ng-bind-html=\"stock.trustAsHtml(item.product)\"></td>\n            <td data-title=\"\'操作人員\'\" sortable=\"\'operator\'\" filter=\"{\'operator\': \'select\'}\"\n               filter-data=\"stock.getFilterDataAsync(\'operator\')\">{{item.operator}}</td>\n            <td data-title=\"\'數量\'\" sortable=\"\'count\'\" style=\"text-align:center\">\n             <a ng-click=\"stock.getDetail(item.id)\">{{item.count}}</a>\n            </td>\n            <td data-title=\"\'更新時間\'\" sortable=\"\'updatedTs\'\" >{{item.updatedTs * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n            <td data-title=\"\'\'\" >\n              <div layout=\"row\" layout-align=\"space-around center\">\n                <md-button aria-label=\"delete\" class=\"md-raised md-accent\"\n                  style=\"font-size:26px; height:50px\"\n                  ng-disabled=\"stock.isProcessing === true \"\n                  ng-click=\"stock.showDeleteDialog(item.id)\">\n                   設備退回\n                </md-button>\n                <md-button aria-label=\"download\" class=\"md-raised md-warn\"\n                  style=\"font-size:26px; height:50px\"\n                  ng-disabled=\"stock.isProcessing === true \"\n                  ng-click=\"stock.downloadDetail(item.id)\">\n                  下載明細\n                </md-button>\n              </div>\n            </td>\n          </tr>\n        </table>\n        --></fieldset></div></div></div>");
$templateCache.put("app/main/mo.stockout.html","<div flex layout=row layout-padding layout-align-gt-md=center layout-align=\"space-around center\" ng-cloaks class=font-mo><div flex><div flex layout=row layout-align=\"center center\" style=min-width:60%><span style=\"float:left; left:0px\"><h2 style=font-weight:bold>{{\'title.stockout.list\' | translate}}({{stock.selected.length}}/{{stock.orderedProducts.length}})</h2></span><span style=float:left><md-checkbox aria-label=\"Select All\" ng-checked=stock.isChecked() md-indeterminate=stock.isIndeterminate() ng-click=stock.toggleAll()><span ng-if=stock.isChecked()>{{\'msg.checkbox.deselectAll\' | translate}}</span> <span ng-if=!stock.isChecked()>{{\'msg.checkbox.selectAll\' | translate}}</span></md-checkbox></span><span flex></span><md-select aria-label=\"Current page size\" ng-model=stock.selectedPageSize md-on-close=stock.changePageSize()><md-optgroup label=\"Page Size\"><md-option ng-repeat=\"size in stock.availablePageSizes\" ng-value=size>{{size}}</md-option></md-optgroup></md-select><md-button class=md-warn aria-label=stockout ng-click=stock.returnProducts(false) style=float:right ng-disabled=\"stock.selected.length === 0 || stock.isProcessing === true\"><md-icon md-svg-icon=stockout style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.stockout\' | translate}}</span></md-button><md-button class=md-accent aria-label=stockout ng-click=stock.showConfirmDialog() style=float:right ng-disabled=\"stock.selected.length === 0 || stock.isProcessing === true\"><md-icon md-svg-icon=exit style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.autoStockin\' | translate}}</span></md-button><md-button class=md-primary aria-label=refresh ng-click=stock.getReturnProducts() style=float:right ng-disabled=\"stock.isProcessing === true\"><md-button class=md-primary aria-label=refresh ng-click=stock.getReturnProducts() style=float:right ng-disabled=\"stock.isProcessing === true\"><md-icon md-svg-icon=refresh style=\"width:48px; height:48px; margin-top:2px\"></md-icon><span style=font-size:24px>{{\'btn.refresh\' | translate}}</span></md-button></md-button></div><div flex><table ng-table=stock.tableParams class=\"table table-condensed table-bordered table-striped\" style=min-width:60%><tr ng-repeat=\"item in $data\" ng-class-even=\"\'even\'\"><td style=text-align:center><md-checkbox aria-label=checkbox ng-checked=stock.exists(item) ng-click=stock.toggle(item)></md-checkbox></td><td data-title=\"\'#\'\"><span ng-bind-html=stock.getIndex($index)></span></td><!--<td data-title=\"\'產品品項\'\" sortable=\"\'product\'\" filter=\"{\'product\': \'select\'}\"\n            filter-data=\"stock.getFilterDataAsync(\'product\')\">{{item.product}}</td>--><td data-title=\"\'table.field.vendor\' | translate\" sortable filter=\"{\'supplier\': \'select\'}\" filter-data=\"stock.getFilterDataAsync(\'supplier\')\">{{item.supplier}}</td><td data-title=\"\'table.field.productSN\' | translate\" sortable filter=\"{\'productSerialNo\': \'text\'}\">{{item.productSerialNo}}</td><td data-title=\"\'table.field.order\' | translate\" sortable filter=\"{\'merchantOrderNo\': \'text\'}\">{{item.merchantOrderNo}}</td><td data-title=\"\'table.field.operator.return\' | translate\" sortable filter=\"{\'operator\': \'select\'}\" filter-data=\"stock.getFilterDataAsync(\'operator\')\">{{item.operator}}</td><td data-title=\"\'table.field.lastUpdate\' | translate\" sortable>{{item.updatedTs * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td data-title=\"\'\'\"><div layout=row layout-align=\"space-around center\"><md-button aria-label=delete class=\"md-raised md-accent\" style=\"font-size:26px; height:50px\" ng-disabled=\"item.norecord !== 1 || stock.isProcessing === true \" ng-click=stock.showDeleteDialog(item.id)>{{\'btn.delete\' | translate}}</md-button></div></td></tr></table></div><!--<md-progress-linear md-mode=\"indeterminate\" ng-if=\"stock.isProcessing === true\"></md-progress-linear>--><!--\n    <table ng-table=\"stock.tableParams\" class=\"table table-condensed table-bordered table-striped\"  style=\"min-width:60%\">\n     <thead >\n       <tr>\n         <td>\n           <md-checkbox aria-label=\"Select All\"\n             ng-checked=\"stock.isChecked()\"\n             md-indeterminate=\"stock.isIndeterminate()\"\n             ng-click=\"stock.toggleAll()\">\n               <span ng-if=\"stock.isChecked()\">取消</span>全選\n            </md-checkbox>\n          </td>\n          <td>產品品項</td>\n          <td>產品序號</td>\n          <td>訂單編號</td>\n          <td>廠商</td>\n          <td>還機人員</td>\n          <td>更新時間</td>\n        </tr>\n      </thead>\n      <tr ng-repeat=\"item in $data\" >\n       <td style=\"text-align:center\">\n         <md-checkbox aria-label=\"checkbox\" ng-checked=\"stock.exists(item)\"\n           ng-click=\"stock.toggle(item)\">\n         </md-checkbox>\n       </td>\n       <td>{{item.productLabel}}</td>\n       <td>{{item.productSerialNo}}</td>\n       <td>{{item.merchantOrderNo}}</td>\n       <td>{{item.vendor}}</td>\n       <td>{{item.checkoutAccount}}</td>\n       <td>{{item.updatedTs | date:\'yyyy-MM-dd HH:mm:ss Z\'}}</td>\n      </tr>\n    </table>\n    --><!--\n    <table>\n      <thead style=\"background-color:lightblue; text-align:center\">\n        <td>\n         <md-checkbox aria-label=\"Select All\"\n           ng-checked=\"stock.isChecked()\"\n           md-indeterminate=\"stock.isIndeterminate()\"\n           ng-click=\"stock.toggleAll()\">\n             <span ng-if=\"stock.isChecked()\">取消</span>全選\n          </md-checkbox>\n        </td>\n        <td>產品品項</td>\n        <td>產品序號</td>\n        <td>訂單編號</td>\n        <td filter=\"{vendor: \'select\'}\">廠商</td>\n        <td>還機人員</td>\n        <td>更新時間</td>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in stock.items\" ng-class-even=\"\'even\'\">\n         <td>\n           <md-checkbox aria-label=\"checkbox\" ng-checked=\"stock.exists(item)\"\n             ng-click=\"stock.toggle(item)\">\n           </md-checkbox>\n         </td>\n         <td>{{item.productLabel}}</td>\n         <td style=\"text-align:center\">{{item.productSerialNo}}</td>\n         <td style=\"text-align:center\">{{item.merchantOrderNo}}</td>\n         <td style=\"text-align:center\">{{item.vendor}}</td>\n         <td style=\"text-align:center\">{{item.checkoutAccount}}</td>\n         <td style=\"text-align:center\">{{item.updatedTs | date:\'yyyy-MM-dd HH:mm:ss Z\'}}</td>\n        </tr>\n      </tbody>\n    </table>\n    --></div></div>");
$templateCache.put("app/main/modal.notice.html","<div layout-padding class=\"font-mo modal fade\"><div layout-padding class=\"modal-dialog modal-lg\" style=top:20%><div layout-padding class=modal-content><div layout-padding class=modal-body><div><h2>{{content}}</h2></div><div layout-padding class=modal-footer><md-button type=button ng-click=close() class=\"md-raised md-primary\" data-dismiss=modal style=\"width:45%; font-size:26px; height:50px\">確認</md-button></div></div></div></div></div>");
$templateCache.put("app/main/modal.remark.html","<div layout-padding class=\"font-mo modal fade\"><div layout-padding class=\"modal-dialog modal-lg\"><div layout-padding class=modal-content><div layout-padding class=modal-header><button type=button class=close ng-click=close() data-dismiss=modal aria-hidden=true>&times;</button><h4 class=modal-title style=font-size:24px><strong>{{title}}</strong></h4></div><div layout-padding class=modal-body><form class=form-horizontal role=form><div class=form-group><textarea class=form-control id=name style=font-size:24px placeholder=\"\" ng-model=remark autofocus></textarea></div></form></div><div layout-padding class=modal-footer><md-button type=button ng-click=close() class=\"md-raised md-primary\" data-dismiss=modal ng-disabled=!remark style=\"width:45%; font-size:26px; height:50px\">{{\'btn.ok\' | translate}}</md-button><md-button type=button ng-click=cancel() class=\"md-raised md-warn\" style=\"width:45%; font-size:26px; height:50px\">{{\'btn.cancel\' | translate}}</md-button></div></div></div></div>");
$templateCache.put("app/main/modal.stockinDetail.html","<div class=\"font-mo modal fade\"><div layout-padding class=\"modal-dialog modal-lg\"><div layout-padding class=modal-content><div layout-padding class=modal-header><button type=button class=close ng-click=close() data-dismiss=modal aria-hidden=true>&times;</button><h4 class=modal-title style=font-size:24px><strong>{{\'title.stockin.sn.detail\' | translate}}</strong></h4></div><div layout-padding class=modal-body><md-list flex=100><md-list-item class=md-3-line ng-repeat=\"sn in serialNos track by $index\" ng-if=$even><span></span><md-icon md-svg-icon=barcode class=md-avatar></md-icon><div class=md-list-item-text layout=column><span>{{ sn }}</span></div><span flex></span><md-icon md-svg-icon=barcode class=md-avatar></md-icon><div class=md-list-item-text layout=column><span>{{ serialNos[$index+1] }}</span></div><!--<md-divider ></md-divider>--></md-list-item><md-list></md-list></md-list></div><div layout-padding class=modal-footer><md-button type=button ng-click=close() class=\"md-raised md-primary\" data-dismiss=modal style=\"width:100%; font-size:26px; height:50px\">{{\'btn.close\' | translate}}</md-button></div></div></div></div>");
$templateCache.put("app/main/redeempoint.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-margin layout-align-gt-md=center layout-align=space-around ng-cloak><div flex=\"\" flex-sm=100 flex-gt-md=45 flex-order=2 flex-order-gt-sm=1 layout-align=center><table keypress-events flex class=my-table style=width:100%><tr height=40 ng-if=redeem.dynamicReward><td colspan=2 style=\"text-align:center; font-weight:bold; color: white; background-color:CornflowerBlue\">-- {{redeem.dynamicReward.label}} --</td></tr><tr height=40><td>會員條碼：</td><td><input id=barcodeMessage style=\"width: 90%\" type=text class=barcode-readonly ng-show=!redeem.multipleMember ng-disabled=!redeem.isRequired.barcodeMessage ng-model=redeem.member.barcodeMessage readonly><md-input-container ng-show=redeem.multipleMember style=\"width: 90%\"><md-select placeholder=請選擇條碼 ng-model=redeem.member md-on-close=redeem.changeSelectedMember() aria-label=\"member selection\" style=\"width: 90%\"><md-option id=memberSelector ng-value=member ng-repeat=\"member in redeem.searchedMember track by $index\">{{member.barcodeMessage}}</md-option></md-select></md-input-container></td></tr><tr height=40><td>會員電話：</td><td><input id=phoneNumber style=\"width: 90%\" type=text class=phonenumber-readonly ng-disabled=!redeem.isRequired.phoneNumber ng-model=redeem.member.phoneNumber readonly></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{redeem.isProcessing.phoneNumber}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=40 ng-repeat=\"item in redeem.displayList track by $index\"><td>{{item.label}}：</td><td align=center valign=center style={{item.style}}>{{item.value}}</td></tr><tr height=40><td colspan=2><div layout-align=space-between><span>點數：<span style=color:blue> {{redeem.member.points | number}}</span></span> <span flex></span> <span style=\"float:right; width:45%\">消費： <input id=exchange style=\"width: 50% ; text-align: center; color:red\" type=number readonly-focus=redeem.isFocus.exchange ng-disabled=\"!redeem.member.phoneNumber || !redeem.member.barcodeMessage\" ng-model=redeem.redeemPoints readonly></span></div></td></tr><!--\n      <tr height=\"50\">\n        <td>會員點數：</td>\n        <td style=\"color:blue\" align=\"center\" valign=\"center\"> {{redeem.member.points}}</td>\n      </tr>\n      <tr height=\"50\">\n        <td>兌換點數：</td>\n        <td>\n          <input id=\"exchange\" style=\"width: 250px; text-align: center; color:red\" type=\"number\"\n            readonly-focus=\"redeem.isFocus.exchange\"\n            ng-disabled=\"!redeem.member.phoneNumber || !redeem.member.barcodeMessage\"\n            ng-model=\"redeem.redeemPoints\"\n            readonly=\"true\">\n          </input>\n        </td>\n        <td>\n          <md-progress-circular md-mode=\"{{redeem.isProcessing.points}}\"></md-progress-circular>\n        </td>\n      </tr>\n      --><tr ng-show=\"redeem.member.barcodeMessage && redeem.member.phoneNumber\"><td>註解：</td><td colspan=2><textarea id=remark ng-model=redeem.remark style=\"height:80px; width:90%\" readonly-focus=redeem.isFocus.remark selectonclick>\n          </textarea></td></tr><tr height=120><td colspan=2><md-button class=md-raised ng-click=\"redeem.changeFocus(\'phoneNumber\')\" ng-disabled=\"redeem.isProcessing.barcodeMessage || redeem.isProcessing.phoneNumber || redeem.isProcessing.points\" style=margin-left:0px;min-width:45%;background-color:orange>查詢模式</md-button><md-button class=md-raised ng-click=\"redeem.changeFocus(\'barcodeMessage\')\" ng-disabled=\"redeem.isProcessing.barcodeMessage || redeem.isProcessing.phoneNumber || redeem.isProcessing.points\" style=\"float:right;margin-right:0px;min-width:45%; background-color:yellowgreen\">掃碼模式</md-button></td></tr></table></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=redeem.toggleRight() ng-hide=\"redeem.scanMode && !redeem.member.phoneNumber\"><md-icon md-svg-icon=keyboard></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=100 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout-padding style=\"background-color:lavender; height:90%\"><!--<div flex=\"\" flex-gt-md=\"45\" flex-gt-lg=\"30\" flex-order=\"1\" flex-order-gt-sm=\"2\">--><div flex=\"\" layout=column><div layout=column layout-gt-xs=row layout-padding hide-gt-sm ng-show=\"redeem.member.barcodeMessage && redeem.member.phoneNumber\"><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel>條碼：<span style=color:blue>{{redeem.member.barcodeMessage}}</span></span> <span class=mylabel style=float:right>姓名：<span style=color:blue>{{redeem.member.displayName}}</span></span> </span><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel style=float:right>電話：<span style=color:blue>{{redeem.member.phoneNumber}}</span></span> <span class=mylabel style=float:right>點數：<span style=color:blue>{{redeem.member.points | number}}</span></span></span></div><br hide-gt-sm><md-whiteframe flex=\"\" style=height:90px;max-height:90px class=md-whiteframe-10dp layout=row layout-align=space-between><div flex layout=row layout-align=space-between ng-if=redeem.keyboard.label><span style=min-height:50px;font-size:20px>{{redeem.keyboard.label}}</span> <span numeric-keyboard-input=\"\" ng-model=redeem.keyboard.value ng-if=redeem.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{redeem.keyboard.value | number}}</h2></span><span numeric-keyboard-input=\"\" ng-model=redeem.keyboard.value ng-if=!redeem.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{redeem.keyboard.value}}</h2></span></div></md-whiteframe><br><numeric-keyboard callback=\"redeem.confirmAction(\'REDEEM\')\"></numeric-keyboard><br><div layout-padding style=width:100%><label class=mylabel style=width:100% hide-gt-sm ng-show=\"redeem.member.barcodeMessage && redeem.member.phoneNumber\">註解<textarea id=remark md-select-on-focus ng-model=redeem.remark style=\"height:100px; width:100%\">\n          </textarea></label></div></div><!--</div>--></md-sidenav></div>");
$templateCache.put("app/main/refundpoint.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout-gt-sm=row layout=column layout-margin layout-align-gt-md=center layout-align=space-around ng-cloak><div flex=\"\" flex-sm=100 flex-gt-md=45 flex-order=2 flex-order-gt-sm=1 layout-align=center><table keypress-events flex class=my-table style=width:100%><tr height=40 style=background-color:lightskyblue><td colspan=2 style=\"color:red; text-align:center\"><strong>-- 退回核銷點數 --</strong></td></tr><tr height=40><td>會員條碼：</td><td><input id=barcodeMessage style=\"width: 90%\" type=text class=barcode-readonly ng-show=!refund.multipleMember ng-disabled=!refund.isRequired.barcodeMessage ng-model=refund.member.barcodeMessage readonly><md-input-container ng-show=refund.multipleMember style=\"width: 90%\"><md-select placeholder=請選擇條碼 ng-model=refund.member md-on-close=refund.changeSelectedMember() aria-label=\"member selection\" style=\"width: 90%\"><md-option id=memberSelector ng-value=member ng-repeat=\"member in refund.searchedMember track by $index\">{{member.barcodeMessage}}</md-option></md-select></md-input-container></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{refund.isProcessing.barcodeMessage}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=40><td>會員電話：</td><td><input id=phoneNumber style=\"width: 90%\" type=text class=phonenumber-readonly ng-disabled=!refund.isRequired.phoneNumber ng-model=refund.member.phoneNumber readonly></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{refund.isProcessing.phoneNumber}}\"></md-progress-circular>\n        </td>\n        --></tr><tr height=40 ng-repeat=\"item in refund.displayList track by $index\"><td>{{item.label}}：</td><td align=center valign=center style={{item.style}}>{{item.value}}</td></tr><tr height=40><td colspan=2><div layout-align=space-between><span>點數：<span style=color:blue> {{refund.member.points | number}}</span></span> <span flex></span> <span style=\"float:right; width:45%\">退點：<span style=color:red> <input id=exchange style=\"width: 50%; text-align: center; color:red\" type=number readonly-focus=refund.isFocus.exchange ng-disabled=\"!refund.member.phoneNumber || !refund.member.barcodeMessage\" ng-model=refund.refundPoints readonly></span></span></div></td><!--\n        <td>\n          <md-progress-circular md-mode=\"{{refund.isProcessing.points}}\"></md-progress-circular>\n        </td>\n        --></tr><!--\n      <tr height=\"50\">\n        <td>會員點數：</td>\n        <td style=\"color:blue\" align=\"center\" valign=\"center\"> {{refund.member.points}}</td>\n      </tr>\n      <tr height=\"50\">\n        <td>退還點數：</td>\n        <td>\n          <input id=\"exchange\" style=\"width: 250px; text-align: center; color:red\" type=\"number\"\n            readonly-focus=\"refund.isFocus.exchange\"\n            ng-disabled=\"!refund.member.phoneNumber || !refund.member.barcodeMessage\"\n            ng-model=\"refund.refundPoints\"\n            readonly=\"true\">\n          </input>\n        </td>\n        <td>\n          <md-progress-circular md-mode=\"{{refund.isProcessing.points}}\"></md-progress-circular>\n        </td>\n      </tr>\n      --><tr height=50 ng-show=\"refund.member.barcodeMessage && refund.member.phoneNumber\"><td>註解：</td><td><textarea id=remark ng-model=refund.remark style=\"height:80px; width:90%\" readonly-focus=refund.isFocus.remark selectonclick>\n          </textarea></td></tr><tr height=120><td colspan=2><md-button class=md-raised ng-click=\"refund.changeFocus(\'phoneNumber\')\" ng-disabled=\"refund.isProcessing.barcodeMessage || refund.isProcessing.phoneNumber || refund.isProcessing.points\" style=\"margin-left:0px;min-width:45%; background-color:orange\">查詢模式</md-button><md-button class=md-raised ng-click=\"refund.changeFocus(\'barcodeMessage\')\" ng-disabled=\"refund.isProcessing.barcodeMessage || refund.isProcessing.phoneNumber || refund.isProcessing.points\" style=\"float:right;margin-right:0px;min-width:45%; background-color:yellowgreen\">掃碼模式</md-button></td></tr></table></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=refund.toggleRight() ng-hide=\"refund.scanMode && !refund.member.phoneNumber\"><md-icon md-svg-icon=keyboard></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=100 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout-padding style=\"background-color:lavender; height:90%\"><!--<div flex=\"\" flex-gt-md=\"45\" flex-gt-lg=\"30\" flex-order=\"1\" flex-order-gt-sm=\"2\">--><div flex=\"\" layout=column><!--<div layout=\"column\" layout-padding hide-gt-sm ng-show=\"refund.member.barcodeMessage && refund.member.phoneNumber\" >\n        <span class=\"mylabel\"> 條碼：{{refund.member.barcodeMessage}}</span>\n        <span class=\"mylabel\" style=\"float:right\"> 點數：{{refund.member.points | number}}</span>  \n      </div>--><div layout=column layout-gt-xs=row layout-padding hide-gt-sm ng-show=\"refund.member.barcodeMessage && refund.member.phoneNumber\"><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel>條碼：<span style=color:blue>{{refund.member.barcodeMessage}}</span></span> <span class=mylabel style=float:right>姓名：<span style=color:blue>{{refund.member.displayName}}</span></span> </span><span layout=column style=\"padding-top:0px; padding-bottom:0px\"><span class=mylabel style=float:right>電話：<span style=color:blue>{{refund.member.phoneNumber}}</span></span> <span class=mylabel style=float:right>點數：<span style=color:blue>{{refund.member.points | number}}</span></span></span></div><br hide-gt-sm><md-whiteframe flex=\"\" style=height:90px;max-height:90px class=md-whiteframe-10dp layout=row layout-align=space-between><div flex layout=row layout-align=space-between ng-if=refund.keyboard.label><span style=min-height:50px;font-size:20px>{{refund.keyboard.label}}</span> <span numeric-keyboard-input=\"\" ng-model=refund.keyboard.value ng-if=refund.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{refund.keyboard.value | number}}</h2></span><span numeric-keyboard-input=\"\" ng-model=refund.keyboard.value ng-if=!refund.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{refund.keyboard.value}}</h2></span></div></md-whiteframe><br><numeric-keyboard callback=\"refund.confirmAction(\'REFUND\')\"></numeric-keyboard><br><div layout-padding style=width:100%><label class=mylabel style=width:100% hide-gt-sm ng-show=\"refund.member.barcodeMessage && refund.member.phoneNumber\">註解<textarea id=remark md-select-on-focus ng-model=refund.remark style=\"height:100px; width:100%\">\n          </textarea></label></div></div><!--</div>--></md-sidenav></div>");
$templateCache.put("app/main/rewardcategory.html","<div flex layout=column layout-padding layout-fill layout-margin layout-align=space-around ng-cloak><div layout=row layout-fill layout-margin layout-align=\"space-between center\"><span flex=30>會員條碼：{{reward.barcode}}</span> <span flex=30>兌換點數：{{reward.rewardPoints | number}}</span> <span flex=\"\"><a class=\"md-raised md-button md-primary\" ui-sref=home.rewardpoint>確認 </a></span><span flex=\"\"><md-checkbox ng-model=reward.enableMultipleReward aria-label=\"Multiple rewards\" ng-change=reward.setEnableMultipleReward()>多筆兌換</md-checkbox></span></div><div layout=row layout-fill layout-margin layout-padding layout-align=\"space-between center\" style=\"max-height:30vh; overflow:scroll;margin-top:10px\" ng-if=\"reward.rewardItems.length>0\"><reward-list reward-items=reward.rewardItems add=true remove=true delete=true callback=reward.refresh() style=width:100%;margin:auto></reward-list><!--\n      <table ng-table=\"reward.tableParams\" class=\"table table-condensed table-bordered table-striped\" style=\"margin:auto\">\n        <tr ng-repeat=\"item in $data track by item.id\">\n          <td data-title=\"\'名稱\'\" style=\"min-width:30vw\"> {{item.label}} </td>\n          <td data-title=\"\'數量\'\" style=\"text-align:center\"> {{item.qty}}</td>\n          <td data-title=\"\'單價\'\" style=\"text-align:center\">\n            {{item.points}}\n          </td>\n          <td data-title=\"\'小計\'\" style=\"text-align:center\">\n            {{item.points * item.qty}}\n          </td>\n          <td style=\"text-align:center\">\n             <md-button aria-label=\"add item\" ng-click=\"reward.addRewardItem(item)\" class=\"md-raised md-primary\">\n               <md-icon md-svg-icon=\"add\"\n                 style=\"width:48px; height:48px\"></md-icon>\n             </md-button>\n\n             <md-button aria-label=\"remove item\" ng-click=\"reward.removeRewardItem(item)\" class=\"md-raised md-warn\">\n               <md-icon md-svg-icon=\"remove\"\n                 style=\"width:48px;height:48px\"></md-icon>\n             </md-button>\n           <md-button aria-label=\"remove all\" class=\"md-raised md-accent\" ng-click=\"reward.removeRewardItem(item, true)\">\n              <md-icon md-svg-icon=\"delete\" aria-hidden=\"true\" style=\"width:48px; height:48px\"></md-icon>\n            </md-button>\n          </td>\n        </tr>\n      </table>\n      --></div><div layout=row layout-fill layout-margin layout-padding layout-align=space-around><md-grid-list flex md-cols-xs=2 md-cols-sm=2 md-cols-md=4 md-cols-lg=8 md-cols-gt-lg=12 md-row-height=1:1 md-gutter=12px><md-grid-tile style=background-color:lightblue md-rowspan=1 md-colspan=1 ng-repeat=\"category in reward.categories track by category.id\" ng-click=reward.showCategoryItems(category)><md-icon md-svg-icon=giftcard aria-hidden=true style=\"width:96px; height:96px\"></md-icon><md-grid-tile-footer md-rowspan=1 md-colspan=1 layout-align=\"center center\" data-fittext>{{category.label}}</md-grid-tile-footer></md-grid-tile></md-grid-list></div></div>");
$templateCache.put("app/main/rewarditem-template.html","<div class=disable-transform><md-bottom-sheet class=\"md-grid md-has-header scrollbar-lg\" layout=column ng-cloak style=overflow-y:scroll stop-touch-event drag-scroll=true><md-subheader style=font-size:20px><h3>兌換品項：{{rewardlist.category.label}}</h3></md-subheader><md-list flex layout-gt-sm=row layout-align=\"\"><md-list-item ng-repeat=\"item in rewardlist.items track by item.id\"><md-button style=\"width:200px; height:120px; white-space: normal;word-wrap:break-word\" ng-click=rewardlist.listItemClick($index) class=md-list-item-content><md-icon md-svg-src=giftcard style=width:48px;height:48px></md-icon><div class=md-title>{{ item.label }}</div></md-button></md-list-item></md-list><div ng-if=\"rewardlist.items.length === 0\" class=md-headline>No items found</div></md-bottom-sheet></div>");
$templateCache.put("app/main/rewardpoint.html","<div flex flex-gt-md=90 flex-offset-gt-md=5 layout=column layout-gt-sm=row layout-margin layout-align-gt-md=center layout-align=space-around ng-cloak><div flex=\"\" flex-sm=100 flex-gt-md=45 flex-order=2 flex-order-gt-sm=1 layout-align=center style=height:100%><div><table keypress-events class=my-table style=width:100%><thead><th colspan=2 style=\"color:white; background-color:CornflowerBlue\" ng-click=rewards.toggleMemberInfo()><md-icon md-svg-icon=arrow_up ng-if=!rewards.expandMemberInfo class=my-menu-icon style=color:white></md-icon><md-icon md-svg-icon=arrow_down ng-if=rewards.expandMemberInfo class=my-menu-icon style=color:white></md-icon><span class=my-table-title>會員資料</span></th></thead><tr height=40><td>會員條碼：</td><td><input id=barcodeMessage type=text class=barcode-readonly ng-show=!rewards.multipleMember style=\"width: 90%\" ng-disabled=!rewards.isRequired.barcodeMessage ng-model=rewards.member.barcodeMessage readonly><md-input-container ng-show=rewards.multipleMember style=\"width: 90%\"><md-select placeholder=請選擇條碼 ng-model=rewards.member md-on-close=rewards.changeSelectedMember() aria-label=\"member selection\" style=\"width: 90%\"><md-option id=memberSelector ng-value=member ng-repeat=\"member in rewards.searchedMember track by $index\">{{member.barcodeMessage}}</md-option></md-select></md-input-container></td><!--\n          <td>\n            <md-progress-circular md-mode=\"{{rewards.isProcessing.barcodeMessage}}\"></md-progress-circular>\n          </td>\n          --></tr><tr height=40 ng-show=rewards.expandMemberInfo><td>會員電話：</td><td><input id=phoneNumber type=text class=phonenumber-readonly style=\"width: 90%\" ng-disabled=!rewards.isRequired.phoneNumber ng-model=rewards.member.phoneNumber readonly></td></tr><tr height=40 ng-repeat=\"item in rewards.displayList track by $index\" ng-show=rewards.expandMemberInfo><td>{{item.label}}：</td><td align=center valign=center style={{item.style}}>{{item.value}}</td></tr><tr height=40><td colspan=2><div layout-align=space-between><span style=width:50%>點數：<span style=color:blue> {{rewards.member.points | number}}</span></span> <span style=\"width:50%; float:right\">本次消費：<span style=color:red> {{rewards.rewardPoints | number}}</span></span></div></td><!--\n          <td>兌換前：<span style=\"color:blue\"> {{rewards.member.points | number}}</span></td>\n          <td style=\"text-align:center;float:center\">兌換後：\n            <span style=\"color:red\"> {{rewards.member.points - rewards.rewardPoints | number}}</span>\n          </td>\n          --><!--\n          <td>\n            <md-progress-circular md-mode=\"{{rewards.isProcessing.points}}\"></md-progress-circular>\n          </td>\n          --></tr><tr height=120 ng-show=rewards.expandMemberInfo><td colspan=2><md-button class=md-raised ng-click=\"rewards.changeFocus(\'phoneNumber\')\" ng-disabled=\"rewards.isProcessing.barcodeMessage || rewards.isProcessing.phoneNumber || rewards.isProcessing.points\" style=\"margin-left:0px;min-width:45%; max-width:45%; background-color:orange\">查詢模式</md-button><md-button class=md-raised ng-click=\"rewards.changeFocus(\'barcodeMessage\')\" ng-disabled=\"rewards.isProcessing.barcodeMessage || rewards.isProcessing.phoneNumber || rewards.isProcessing.points\" style=\"float:right;margin-right:0px; min-width:45%; background-color:yellowgreen\">掃碼模式</md-button></td></tr></table></div><div><div style=\"color:white; background-color:CornflowerBlue\" ng-click=rewards.toggleProductInfo()><md-icon md-svg-icon=arrow_up aria-hidden=true ng-if=!rewards.expandProductInfo class=my-menu-icon style=color:white></md-icon><md-icon md-svg-icon=arrow_down aria-hidden=true ng-if=rewards.expandProductInfo class=my-menu-icon style=color:white></md-icon><span class=my-table-title>商品清單</span> <span ng-if=\"rewards.rewardItems.length > 0\" ng-click=rewards.clear() class=my-clear-btn><md-icon md-svg-icon=close aria-hidden=true style=color:white></md-icon>清除全部 ({{rewards.rewardCounts || 0}})</span></div></div><div flex-sm=100 style=\"margin-top: 5px; margin-left:0px; height:45%; overflow:scroll\" drag-scroll=true ng-if=\"rewards.expandProductInfo && rewards.rewardItems.length > 0\"><reward-list reward-items=rewards.rewardItems add=true remove=true callback=rewards.refresh() ng-if=rewards.enableMultipleReward></reward-list><reward-list reward-items=rewards.rewardItems callback=rewards.refresh() ng-if=!rewards.enableMultipleReward style=width:100%></reward-list></div></div><md-button class=\"md-fab md-warn md-fab-top-left hide-gt-sm\" style=top:50px ng-click=rewards.toggleRight() ng-hide=\"rewards.scanMode && !rewards.member.phoneNumber\"><md-icon md-svg-icon=\"{{!rewards.member.barcodeMessage || !rewards.member.phoneNumber ? \'keyboard\' : \'giftcard\'}}\"></md-icon></md-button><md-button class=\"md-fab md-accent md-fab-top-left hide-gt-sm\" style=\"left: 80px; top:50px\" ng-disabled=rewards.isProcessing.points ng-click=\"rewards.confirmAction(\'REDEEM\')\" ng-show=\"rewards.rewardItems.length > 0\"><md-icon md-svg-icon=check></md-icon></md-button><md-sidenav class=\"md-sidenav-right md-whiteframe-1dp\" md-component-id=right md-is-locked-open=\"$mdMedia(\'gt-sm\')\" flex=100 flex-gt-sm=50 flex-order=1 flex-order-gt-sm=2 layout-padding style=\"background-color:lavender; height:90%\"><!--<div flex=\"\" flex-gt-md=\"45\" flex-gt-lg=\"30\" flex-order=\"1\" flex-order-gt-sm=\"2\">--><div flex=\"\" layout=column style=min-width:400px ng-show=\"!rewards.member.barcodeMessage || !rewards.member.phoneNumber\"><md-whiteframe style=\"height:90px;max-height:90px; width:100%\" class=md-whiteframe-10dp layout=row layout-align=space-between><div flex layout=row layout-align=space-between ng-if=rewards.keyboard.label><span style=min-height:50px;font-size:20px>{{rewards.keyboard.label}}</span><!--<span numeric-keyboard-input=\"\" init=\"rewards.keyboard.value\" ng-model=\"rewards.keyboard.value\" ng-if=\"rewards.keyboard.numeric\"  style=\"min-height:50px; color:blue\"><h2>{{rewards.keyboard.value | number}}</h2></span>--> <span numeric-keyboard-input=\"\" init=rewards.keyboard.value ng-model=rewards.keyboard.value ng-if=!rewards.keyboard.numeric style=\"min-height:50px; color:blue\"><h2>{{rewards.keyboard.value}}</h2></span><!--<span style=\"min-height:50px; color:blue\" ng-if=\"rewards.reward.points\" ><h2>{{rewards.reward.points | number}}</h2></span>--> <span style=\"min-height:50px; color:blue\" ng-if=rewards.rewardPoints><h2>{{rewards.rewardPoints | number}}</h2></span><!--<span style=\"color:blue\" ng-show=\"!rewards.enableMultipleReward\">{{rewards.rewardItems[0].label}}</span>--></div></md-whiteframe><br><numeric-keyboard callback=\"rewards.confirmAction(\'REDEEM\')\"></numeric-keyboard><br></div><div flex=\"\" layout=column style=height:90vh ng-show=\"rewards.member.barcodeMessage && rewards.member.phoneNumber\"><div style=height:65%><ul><li ng-repeat=\"item in rewards.rewardOptions\n            | startFrom:rewards.currentPage*rewards.pageSize\n            | limitTo:rewards.pageSize\" ng-click=rewards.addReward(item) class=reward-item ng-style=\"{\'width\':rewards.itemWidth,\n                   \'height\':rewards.itemHeight,\n                   \'background-color\':rewards.getBackgroundColor(item)}\"><div layout-align=\"center center\" layout-margin><md-icon md-svg-icon=giftcard aria-hidden=true style=width:36px;height:36px></md-icon><p class=\"text-overflow my-reward-label\">{{item.label}}</p></div></li></ul></div><div layout=row layout-margin><table style=width:100%><tr><td style=width:60%><div layout=row style=width:100%><md-button class=md-raised ng-click=\"rewards.currentPage=rewards.currentPage-1\" ng-disabled=\"rewards.currentPage === 0\" aria-label=previous style=\"width:30%; height: 70px; font-weight: bold; font-size:2.5vw\"><md-icon md-svg-icon=drop_up style=\"width:72px;height:72px; color:black\"></md-icon></md-button><md-button class=md-raised ng-click=\"rewards.currentPage=rewards.currentPage+1\" aria-label=next ng-disabled=\"rewards.currentPage >= rewards.rewardOptions.length/rewards.pageSize - 1\" style=\"width:30%; height: 70px; font-weight: bold; font-size:2.5vw\"><md-icon md-svg-icon=drop_down style=width:72px;height:72px;color:black></md-icon></md-button><span class=mylabel style=\"font-weight:bold;\n                  text-align:center; margin-top: 1em\">{{rewards.currentPage + 1}}/{{rewards.numberOfPages()}}</span></div></td><td rowspan=2 style=height:100%><md-button class=md-raised ng-click=\"rewards.confirmAction(\'REDEEM\')\" style=\"width: 100%; min-height:100px; height: 98%; margin:auto; font-weight: bold; font-size: 2.5vw;\n                  color:white; background-color:#0E9B2E\"><span class=mylabel>確定兌換<span></span></span></md-button></td></tr><tr><td><div layout=row layout-margin layout-align=\"start center\"><div flex class=onoffswitch style=width:90%><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=myonoffswitch ng-model=rewards.showRewardShortcut ng-change=rewards.getRewardSelectOptions(rewards.showRewardShortcut)><label class=onoffswitch-label for=myonoffswitch><span class=onoffswitch-inner data-text-on=快速選單 data-text-off=所有選項></span> <span class=onoffswitch-switch></span></label></div></div></td></tr></table></div></div><!--</div>--></md-sidenav></div>");
$templateCache.put("app/main/rewardshortcut-template.html","<div class=disable-transform><md-bottom-sheet class=\"md-grid bottom-sheet-right scrollbar-lg\" layout=column layout-align=space-between style=\"height:100%; overflow:scroll\" ng-cloak stop-touch-event drag-scroll=true><md-list><md-list-item ng-repeat=\"item in shortcut.items track by item.id\" style=\"min-width:200px;min-height:180px; white-space:normal;word-wrap:break-word\"><md-button style=width:200px;top:0px class=md-grid-item-content ng-click=shortcut.listItemClick($index)><md-icon md-svg-icon=giftcard style=width:48px;height:48px></md-icon><div class=md-title style=white-space:normal;word-wrap:break-word>{{ item.label }}</div></md-button></md-list-item></md-list><div ng-if=\"shortcut.items.length === 0\" class=md-headline>No items found</div></md-bottom-sheet></div><!--\n<div>\n  <md-bottom-sheet class=\"md-list bottom-sheet-right\" ng-cloak>\n    <md-list>\n      <md-list-item ng-repeat=\"item in shortcut.items track by item.id\"\n          style=\"min-height:80px;padding:2; ;white-space:normal;word-wrap:break-word;\">\n          <md-button style=\"width:100%;white-space:normal;word-wrap:break-word; \"\n           class=\"md-list-item-content\" ng-click=\"shortcut.listItemClick($index)\">\n            <md-icon md-svg-icon=\"giftcard\" style=\"float:left;width:48px;height:48px\"></md-icon>\n            <span class=\"md-inline-list-icon-label md-title\" style=\"width: 85%;float:left; margin-left:10px;\n            %;float:left; margin-left:10px;\n              text-align:left;white-space:normal;word-wrap:break-word;\">{{ item.label }}</span>\n          </md-button>\n      </md-list-item>\n    </md-list>\n  <div ng-if=\"shortcut.items.length === 0\" class=\"md-headline\">No items found</div>\n  </md-bottom-sheet>\n</div>\n\n-->");
$templateCache.put("app/login/login.html","<div layout-md=row layout=row layout-align=\"center center\" ng-cloak><div flex-gt-sm=50 flex-xs=\"\" layout-fill><md-toolbar style=\"margin-top:10px; background-color: white; color: black\"><div class=md-toolbar-tools><span class=md-headline translate>Login</span> <span flex></span><div ng-show=login.isLocaleSupport() style=right:0px layout-padding language-select></div></div></md-toolbar><hr><form name=loginForm ng-submit=login.authenicate() style=width:85%><md-input-container md-no-float class=md-block><label translate>Account</label><md-icon md-svg-icon=business class=name></md-icon><input id=account name=account type=text enter-to-tab select-on-click ng-model=login.user.account required autofocus ng-virtual-keyboard=\"{relative: false, size: 5, imageURI: \'./assets/images/keyboard.png\'}\"><div ng-messages=loginForm.account.$error><div ng-message=required translate>Necessary</div></div></md-input-container><md-input-container md-no-float class=md-block><label translate>User</label><md-icon md-svg-icon=person class=name></md-icon><input id=username name=username type=text enter-to-tab select-on-click ng-model=login.user.username required ng-virtual-keyboard=\"{relative: false, size: 5, imageURI: \'./assets/images/keyboard.png\'}\"><div ng-messages=loginForm.username.$error><div ng-message=required translate>Necessary</div></div></md-input-container><md-input-container md-no-float class=md-block><label translate>Password</label><md-icon md-svg-icon=security class=name></md-icon><input type=password name=password select-on-click ng-model=login.user.password required ng-virtual-keyboard=\"{relative: false, size: 5, imageURI: \'./assets/images/keyboard.png\'}\"><div ng-messages=loginForm.password.$error><div ng-message=required translate>Necessary</div></div></md-input-container><md-button type=submit style=\"width: 30%; font-size:24px; height: 50px\" ng-disabled=\"loginForm.$invalid || login.isProcessing\" class=\"md-raised md-primary\"><span translate>Login</span></md-button><!--<md-progress-circular md-mode=\"indeterminate\" style=\"float:right\" ng-disabled=\"biz.disableBtn\" ng-if=\"login.isProcessing\"></md-progress-circular>--></form></div></div>");
$templateCache.put("app/numericKeyboard/numericKeyboard.html","<div class=keyboard layout=row layout-fill flex=\"\"><div class=keyboard-content flex=\"\" layout=column ng-click=stopPropagation($event) style=min-width:300px ng-show=\"type!==\'fn\'\"><div flex=\"\" layout=row style=min-height:280px><md-whiteframe flex=\"\" layout=column class=md-whiteframe-10dp layout-align=space-between><div flex layout=row layout-align=space-around style=min-height:25%><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'7\')\">7</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'8\')\">8</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'9\')\">9</md-button></div><div flex layout=row layout-align=space-around style=min-height:25%><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'4\')\">4</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'5\')\">5</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'6\')\">6</md-button></div><div flex layout=row layout-align=space-around style=min-height:25%><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'1\')\">1</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'2\')\">2</md-button><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 40px; font-size: 32px\" ng-click=\"append(\'3\')\">3</md-button></div><div flex layout=row layout-align=space-around style=min-height:25%><md-button class=md-raised md-no-ink style=\"width: 33%; min-width: 50px;font-size: 32px\" ng-click=\"append(\'00\')\">00</md-button><md-button class=md-raised md-no-ink style=\"width: 66%; min-width: 40px;font-size: 32px\" ng-click=\"append(\'0\')\">0</md-button></div></md-whiteframe><md-whiteframe class=md-whiteframe-10dp flex-md=25 flex-lg=30 flex-gt-lg=30 layout=column layout-align=space-between style=min-width:50px><md-button class=md-raised md-no-ink style=\"height: 30%; background-color:teal; color:white\" ng-click=remove()><h1><i class=material-icons>keyboard_backspace</i> <span hide-xs>修改</span></h1></md-button><md-button class=md-raised md-no-ink style=\"height: 30%; background-color:crimson; color:white\" ng-click=clear()><h1><i class=material-icons>clear</i> <span hide-xs>重設</span></h1></md-button><md-button class=md-raised md-no-ink style=\"height: 30%; background-color:forestgreen; color:white\" ng-click=done()><h1><i class=material-icons>check</i> <span hide-xs>確認</span></h1></md-button></md-whiteframe></div></div><div class=keyboard-content flex=\"\" layout=column ng-click=stopPropagation($event) style=min-width:300px ng-show=\"type===\'fn\'\"><div flex=\"\" layout=row style=min-height:280px><md-whiteframe class=md-whiteframe-10dp flex layout=row layout-align=space-between style=min-width:50px><md-button class=md-raised md-no-ink flex style=\"height: 30%; background-color:teal; color:white\" ng-click=remove()><h1><i class=material-icons>keyboard_backspace</i> <span hide-xs>修改</span></h1></md-button><md-button class=md-raised md-no-ink flex style=\"height: 30%; background-color:crimson; color:white\" ng-click=clear()><h1><i class=material-icons>clear</i> <span hide-xs>重設</span></h1></md-button><md-button class=md-raised md-no-ink flex style=\"height: 30%; background-color:forestgreen; color:white\" ng-click=done()><h1><i class=material-icons>check</i> <span hide-xs>確認</span></h1></md-button></md-whiteframe></div></div></div>");
$templateCache.put("app/printCanvas/printCanvas.html","<div style=text-align:center><canvas id=myCanvas height={{height}} width={{width}} style=\"border:1px solid #d3d3d3\"></canvas></div>");
$templateCache.put("app/rewardList/rewardList.html","<table ng-table={{tableParams}} class=\"table table-condensed table-bordered table-striped\"><tr ng-repeat=\"item in rewardItems track by item.id\"><td data-title=\"\'名稱\'\" style=width:30%>{{item.label}}</td><td data-title=\"\'數量\'\" style=\"width:10%; text-align:center\">{{item.qty}}</td><td data-title=\"\'單價\'\" style=\"width:10%; text-align:center\">{{item.points}}</td><td data-title=\"\'小計\'\" style=\"width:10%; text-align:center\">{{item.points * item.qty}}</td><td style=text-align:center ng-if=\"actions.add || actions.remove || actions.delete\"><div layout=row layout-fill layout-align=space-around><md-button aria-label=\"add item\" ng-if=actions.add ng-click=addRewardItem(item) class=\"md-raised md-primary my-reward-action-btn\"><md-icon md-svg-icon=add class=my-menu-icon></md-icon></md-button><md-button aria-label=\"remove item\" ng-if=actions.remove ng-click=removeRewardItem(item) class=\"md-raised md-warn my-reward-action-btn\"><md-icon md-svg-icon=remove class=my-menu-icon></md-icon></md-button><md-button aria-label=\"remove all\" ng-if=actions.delete class=\"md-raised md-accent my-reward-action-btn\" ng-click=\"removeRewardItem(item, true)\"><md-icon md-svg-icon=delete aria-hidden=true class=my-menu-icon></md-icon></md-button></div></td></tr></table>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row layout-align=\"center center\"><md-button href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</md-button><section flex layout=row layout-align=\"left center\"><md-button href=# class=md-raised>Home</md-button><md-button href=# class=md-raised>About</md-button><md-button href=# class=md-raised>Contact</md-button></section><md-button class=acme-navbar-text>Application was created {{ vm.relativeDate }}.</md-button></md-toolbar>");}]);